webpackJsonp([1],{

/***/ "+LjU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-autocomplete kiwi-theme-bg"},_vm._l((_vm.filteredAndLimitedItems),function(item){return _c('div',{key:item.type+item.text,class:{
            'kiwi-autocomplete-item': true,
            'kiwi-autocomplete-item--selected': item.idx === _vm.selected_idx},on:{"click":function($event){_vm.selected_idx = item.idx; _vm.selectCurrentItem()}}},[(item.type === 'user')?[_c('span',{staticClass:"kiwi-autocomplete-item-value"},[_vm._v(_vm._s(item.text))]),_vm._v(" "),_c('span',{staticClass:"u-link kiwi-autocomplete-item-action",on:{"click":function($event){$event.stopPropagation();return _vm.openQuery(item.text)}}},[_vm._v("\n                "+_vm._s(_vm.$t('send_message'))+"\n            ")])]:(item.type === 'command')?[_c('span',{staticClass:"kiwi-autocomplete-item-value"},[_vm._v(_vm._s(item.text))]),_vm._v(" "),_c('span',{staticClass:"u-link kiwi-autocomplete-item-description"},[_vm._v("\n                "+_vm._s(item.description)+"\n            ")])]:[_c('span',{staticClass:"kiwi-autocomplete-item-value"},[_vm._v(_vm._s(item.text))])]],2)}),0)}
var staticRenderFns = []


/***/ }),

/***/ "+QZa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServerView_vue__ = __webpack_require__("YT+L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServerView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServerView_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServerView_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServerView_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3de7c231_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServerView_vue__ = __webpack_require__("H5XI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("4GHs")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServerView_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3de7c231_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServerView_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3de7c231_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServerView_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "+z04":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserBox_vue__ = __webpack_require__("kyKn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserBox_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserBox_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserBox_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69a66416_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserBox_vue__ = __webpack_require__("hnVO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("CjhL")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserBox_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69a66416_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserBox_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69a66416_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserBox_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "/1JH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotConnected_vue__ = __webpack_require__("4Ost");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotConnected_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotConnected_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotConnected_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotConnected_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_611dfd0f_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotConnected_vue__ = __webpack_require__("LS2E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("kQCM")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotConnected_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_611dfd0f_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotConnected_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_611dfd0f_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotConnected_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "/5ya":
/***/ (function(module, exports) {

module.exports = {"locales":["af-za","ar-sa","bg-bg","bs-ba","ca-es","cs-cz","da-dk","de-de","dev","el-gr","en-us","es-ar","es-em","es-es","es-us","eu-es","fi-fi","fr-fr","gl-es","he-il","hu-hu","id-id","it-it","ja-jp","ko-kr","nl-nl","no-no","pl-pl","pt-br","pt-pt","ro-ro","ru-ru","sl-si","sq-al","sr-sp","sv-se","tr-tr","uk-ua","vi-vn","zh-cn","zh-tw"]}

/***/ }),

/***/ "/GFh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-customserver",class:[_vm.is_connecting ? 'kiwi-customserver--connecting' : '']},[_c('div',{staticClass:"kiwi-customserver-container"},[(!_vm.is_connecting)?_c('h2',{domProps:{"innerHTML":_vm._s(_vm.title)}}):_c('h2',[_vm._v("\n            "+_vm._s(_vm.$t('connecting'))+"\n            "),_c('a',{staticClass:"u-link",on:{"click":_vm.infoClick}},[_c('i',{staticClass:"fa fa-info-circle",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('transition',{attrs:{"name":"kiwi-connectingloader"}},[(!_vm.is_connecting)?_c('form',{staticClass:"u-form u-form--big kiwi-customserver-form",on:{"submit":function($event){$event.preventDefault();return _vm.startUp($event)}}},[(_vm.network && _vm.network.state_error)?_c('div',{staticClass:"kiwi-customserver-error"},[_vm._v("\n                    We couldn't connect to the server :(\n                    "),_c('span',[_vm._v(_vm._s(_vm.readableStateError(_vm.network.state_error)))])]):_vm._e(),_vm._v(" "),(_vm.server_type === 'default')?[_c('input-text',{attrs:{"label":_vm.$t('server')},model:{value:(_vm.server),callback:function ($$v) {_vm.server=$$v},expression:"server"}},[_c('span',{staticClass:"fa-stack fa-lg kiwi-customserver-tls",class:[_vm.tls ? 'kiwi-customserver-tls--enabled' : ''],on:{"click":function($event){_vm.tls=!_vm.tls}}},[_c('i',{staticClass:"fa fa-lock fa-stack-1x kiwi-customserver-tls-lock"}),_vm._v(" "),(!_vm.tls)?_c('i',{staticClass:"fa fa-times fa-stack-1x kiwi-customserver-tls-minus"}):_vm._e()])]),_vm._v(" "),_c('input-text',{staticClass:"kiwi-customserver-nick",attrs:{"label":_vm.$t('nick')},model:{value:(_vm.nick),callback:function ($$v) {_vm.nick=$$v},expression:"nick"}}),_vm._v(" "),_c('label',{staticClass:"kiwi-customserver-have-password"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.show_password_box),expression:"show_password_box"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.show_password_box)?_vm._i(_vm.show_password_box,null)>-1:(_vm.show_password_box)},on:{"change":function($event){var $$a=_vm.show_password_box,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.show_password_box=$$a.concat([$$v]))}else{$$i>-1&&(_vm.show_password_box=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.show_password_box=$$c}}}}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t('password_have'))+" ")])]),_vm._v(" "),(_vm.show_password_box)?_c('input-text',{directives:[{name:"focus",rawName:"v-focus"}],attrs:{"label":_vm.$t('password'),"show-plain-text":true,"type":"password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}):_vm._e(),_vm._v(" "),_c('input-text',{attrs:{"label":_vm.$t('channel')},model:{value:(_vm.channel),callback:function ($$v) {_vm.channel=$$v},expression:"channel"}})]:_vm._e(),_vm._v(" "),(_vm.server_type === 'default_simple')?[_c('input-text',{staticClass:"kiwi-customserver-nick",attrs:{"label":_vm.$t('nick')},model:{value:(_vm.nick),callback:function ($$v) {_vm.nick=$$v},expression:"nick"}}),_vm._v(" "),_c('label',{staticClass:"kiwi-customserver-have-password"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.show_password_box),expression:"show_password_box"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.show_password_box)?_vm._i(_vm.show_password_box,null)>-1:(_vm.show_password_box)},on:{"change":function($event){var $$a=_vm.show_password_box,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.show_password_box=$$a.concat([$$v]))}else{$$i>-1&&(_vm.show_password_box=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.show_password_box=$$c}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('password_have')))])]),_vm._v(" "),(_vm.show_password_box)?_c('input-text',{directives:[{name:"focus",rawName:"v-focus"}],attrs:{"label":_vm.$t('password'),"type":"password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}):_vm._e(),_vm._v(" "),_c('input-text',{staticClass:"kiwi-customserver-channel",attrs:{"label":_vm.$t('channel')},model:{value:(_vm.channel),callback:function ($$v) {_vm.channel=$$v},expression:"channel"}})]:_vm._e(),_vm._v(" "),(_vm.server_type === 'znc')?[_c('input-text',{attrs:{"label":_vm.$t('server')},model:{value:(_vm.server),callback:function ($$v) {_vm.server=$$v},expression:"server"}},[_c('span',{staticClass:"fa-stack fa-lg kiwi-customserver-tls",class:[_vm.tls ? 'kiwi-customserver-tls--enabled' : ''],on:{"click":function($event){_vm.tls=!_vm.tls}}},[_c('i',{staticClass:"fa fa-lock fa-stack-1x kiwi-customserver-tls-lock"}),_vm._v(" "),(!_vm.tls)?_c('i',{staticClass:"fa fa-times fa-stack-1x kiwi-customserver-tls-minus"}):_vm._e()])]),_vm._v(" "),_c('input-text',{staticClass:"kiwi-customserver-nick",attrs:{"label":_vm.$t('username')},model:{value:(_vm.nick),callback:function ($$v) {_vm.nick=$$v},expression:"nick"}}),_vm._v(" "),(_vm.znc_network_support)?_c('input-text',{attrs:{"label":_vm.$t('network')},model:{value:(_vm.znc_network),callback:function ($$v) {_vm.znc_network=$$v},expression:"znc_network"}}):_vm._e(),_vm._v(" "),_c('input-text',{attrs:{"label":_vm.$t('password'),"type":"password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})]:_vm._e(),_vm._v(" "),_c('button',{staticClass:"u-button u-button-primary u-submit",attrs:{"type":"submit"}},[_vm._v("\n                    "+_vm._s(_vm.buttonText)+"\n                ")]),_vm._v(" "),(_vm.show_type_switcher)?_c('div',{staticClass:"kiwi-customserver-server-types"},[_c('a',{staticClass:"u-link",on:{"click":function($event){_vm.server_type = 'default'}}},[_vm._v(_vm._s(_vm.$t('network')))]),_vm._v(" "),_c('a',{staticClass:"u-link",on:{"click":function($event){_vm.server_type = 'znc'}}},[_vm._v(_vm._s(_vm.$t('znc')))])]):_vm._e()],2):_c('div',{staticClass:"kiwi-customserver-loader"},[_c('i',{staticClass:"fa fa-spin fa-spinner",attrs:{"aria-hidden":"true"}})])])],1)])}
var staticRenderFns = []


/***/ }),

/***/ "/YbC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContainerHeader_vue__ = __webpack_require__("NG5i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContainerHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContainerHeader_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContainerHeader_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContainerHeader_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b20a8ff_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContainerHeader_vue__ = __webpack_require__("LHti");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("mfvC")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContainerHeader_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b20a8ff_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContainerHeader_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b20a8ff_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContainerHeader_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "/k/S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StartupError_vue__ = __webpack_require__("VfBa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StartupError_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StartupError_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StartupError_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StartupError_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3613e78a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StartupError_vue__ = __webpack_require__("o60X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("NxSI")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StartupError_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3613e78a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StartupError_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3613e78a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StartupError_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "/xsI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _AwayStatusIndicator = __webpack_require__("vV7l");

var _AwayStatusIndicator2 = _interopRequireDefault(_AwayStatusIndicator);

var _TypingStatusIndicator = __webpack_require__("Qf21");

var _TypingStatusIndicator2 = _interopRequireDefault(_TypingStatusIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        AwayStatusIndicator: _AwayStatusIndicator2.default,
        TypingStatusIndicator: _TypingStatusIndicator2.default
    },
    props: ['network', 'user', 'nicklist'],
    computed: {
        userColour: function userColour() {
            if (this.nicklist.useColouredNicks) {
                return this.user.getColour();
            }
            return '';
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["NicklistUser"]
window._kiwi_exports.components.NicklistUser = exports.default ? exports.default : exports;


/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("SCKt");
__webpack_require__("kL8B");
__webpack_require__("d4Wg");
__webpack_require__("5flq");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "03Ga":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarState_vue__ = __webpack_require__("g1je");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarState_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarState_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarState_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarState_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarState_vue___default.a,
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "03v1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "04gU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "05ce":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageListMessageInline_vue__ = __webpack_require__("wy/0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageListMessageInline_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageListMessageInline_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageListMessageInline_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageListMessageInline_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0b6502a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageListMessageInline_vue__ = __webpack_require__("J5qk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("pnnM")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageListMessageInline_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0b6502a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageListMessageInline_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0b6502a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageListMessageInline_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "0MsN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0R7g":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

exports.requestPermission = requestPermission;
exports.show = show;
exports.listenForNewMessages = listenForNewMessages;

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isEnabled = false;

function requestPermission() {
    if (!('Notification' in window)) {
        isEnabled = false;
        return;
    }

    if (Notification.permission === 'granted') {
        isEnabled = true;
    }

    if (Notification.permission !== 'denied') {
        Notification.requestPermission(function (permission) {
            if (permission === 'granted') {
                isEnabled = true;
            } else {
                isEnabled = false;
            }
        });
    }
}

function show(title, body, opts) {
    if (!isEnabled) {
        return false;
    }

    var notify = new Notification(title, {
        body: body,
        icon: opts.icon
    });

    if (opts.ttl) {
        setTimeout(notify.close.bind(notify), opts.ttl);
    }

    return notify;
}

var throttledShow = _lodash2.default.throttle(show, 2000);

function listenForNewMessages(state) {
    state.$on('notification.show', function (message, _opts) {
        if (!isEnabled) {
            return;
        }

        var opts = (0, _assign2.default)({
            title: 'Kiwi IRC',
            message: message,
            icon: '',
            onclick: null,
            ttl: 10000
        }, _opts);

        if (!opts.message) {
            return;
        }

        var notification = throttledShow(opts.title, opts.message, {
            ttl: opts.ttl
        });

        if (notification && typeof opts.onclick === 'function') {
            notification.onclick = opts.onclick;
        }
    });
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["Notifications"]
window._kiwi_exports.libs.Notifications = exports.default ? exports.default : exports;


/***/ }),

/***/ "0WfI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0YW4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Nicklist_vue__ = __webpack_require__("MMNQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Nicklist_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Nicklist_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Nicklist_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Nicklist_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_551b1d96_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Nicklist_vue__ = __webpack_require__("yQGf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("cyd1")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Nicklist_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_551b1d96_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Nicklist_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_551b1d96_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Nicklist_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "10Te":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _state = __webpack_require__("LnP8");

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {},
    props: ['buffer', 'message'],
    data: function data() {
        return {
            requestingInput: false
        };
    },
    computed: {},
    methods: {
        urlPreview: function urlPreview(url) {
            _state2.default.$emit('mediaviewer.show', url);
        },
        areWeAnOp: function areWeAnOp() {
            var ourNick = this.buffer.getNetwork().nick;
            return this.buffer.isUserAnOp(ourNick);
        },
        isSelf: function isSelf() {
            var user = this.$state.getUser(this.buffer.getNetwork().id, this.message.nick);
            return this.buffer.getNetwork().ircClient.user.nick === user.nick;
        },
        onBan: function onBan(reason) {
            var network = this.buffer.getNetwork();
            network.ircClient.mode(this.buffer.name, '+b', this.message.nick);
        },
        onKick: function onKick(promptedReason) {
            var network = this.buffer.getNetwork();
            var defaultReason = _state2.default.setting('buffers.default_kick_reason');
            var reason = promptedReason || defaultReason;
            network.ircClient.raw('KICK', this.buffer.name, this.message.nick, reason);
        },
        openQuery: function openQuery() {
            var network = this.buffer.getNetwork();
            var buffer = _state2.default.addBuffer(network.id, this.message.nick);
            _state2.default.setActiveBuffer(network.id, buffer.name);
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["MessageInfo"]
window._kiwi_exports.components.MessageInfo = exports.default ? exports.default : exports;


/***/ }),

/***/ "15gS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.channelRegex = exports.urlRegex = undefined;

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

exports.linkifyChannels = linkifyChannels;
exports.createNickColour = createNickColour;
exports.hexVal = hexVal;
exports.mapRange = mapRange;
exports.formatAndT = formatAndT;
exports.formatUser = formatUser;
exports.formatUserFull = formatUserFull;
exports.formatText = formatText;
exports.formatDuration = formatDuration;
exports.formatNumber = formatNumber;
exports.t = t;

var _state = __webpack_require__("LnP8");

var _state2 = _interopRequireDefault(_state);

var _ThemeManager = __webpack_require__("j/A4");

var _ThemeManager2 = _interopRequireDefault(_ThemeManager);

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _ipRegex = __webpack_require__("eA2o");

var ipRegex = _interopRequireWildcard(_ipRegex);

var _i18next = __webpack_require__("QCdE");

var _i18next2 = _interopRequireDefault(_i18next);

var _Colours = __webpack_require__("3piF");

var Colours = _interopRequireWildcard(_Colours);

var _Md = __webpack_require__("f866");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var urlRegex = exports.urlRegex = new RegExp(/(([A-Za-z][A-Za-z0-9-]*:\/\/)|(www\.))/.source + '(' + /([\w\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF.-]+\.[a-zA-Z]{2,63})/.source + '|' + ipRegex.v4().source + '|' + '(\\[?' + ipRegex.v6().source + '\\]?)' + ')' + /(:[0-9]+)?/.source + /(\/[\w\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF!:.?$'()[\]*,;~+=&%@!\-/]*)?/.source + /(#.*)?/.source, 'i');

var channelRegex = exports.channelRegex = /(^|\s)([@+~&%}]*)([#&][^ .,\007<>\n\r]+?)([:;.,<>\n\r]+)?$/i;

function linkifyChannels(word) {
    return word.replace(channelRegex, function (match, mLead, mPrefix, mChannel, mSuffix) {
        var chan = _lodash2.default.escape(mChannel.trim());
        var lead = _lodash2.default.escape(mLead);
        var prefix = _lodash2.default.escape(mPrefix);
        var suffix = _lodash2.default.escape(mSuffix);

        var link = '<a class="u-link kiwi-channel" data-channel-name="' + chan + '">' + chan + '</a>';
        return '' + lead + prefix + link + suffix;
    });
}

function createNickColour(nick) {
    var nickLower = nick.toLowerCase();

    var startingColour = '#36809B';

    var hash = (0, _Md.md5)(nickLower);
    var hueOffset = mapRange(hexVal(hash, 14, 3), 0, 4095, 0, 359);
    var satOffset = hexVal(hash, 17);
    var baseColour = Colours.rgb2hsl(Colours.hex2rgb(startingColour));
    baseColour.h = (baseColour.h * 360 - hueOffset + 360) % 360 / 360;

    if (satOffset % 2 === 0) {
        baseColour.s = Math.min(1, (baseColour.s * 100 + satOffset) / 100);
    } else {
        baseColour.s = Math.max(0, (baseColour.s * 100 - satOffset) / 100);
    }

    var themeMngr = _ThemeManager2.default.instance();
    var brightness = themeMngr.themeVar('nick-brightness');
    if (brightness) {
        baseColour.l = parseInt(brightness, 10) / 100;
    }

    var rgb = Colours.hsl2rgb(baseColour);
    var nickColour = Colours.rgb2hex(rgb);

    return nickColour;
}

function hexVal(hash, index, len) {
    return parseInt(hash.substr(index, len || 1), 16);
}

function mapRange(value, vMin, vMax, dMin, dMax) {
    var vValue = parseFloat(value);
    var vRange = vMax - vMin;
    var dRange = dMax - dMin;

    return (vValue - vMin) * dRange / vRange + dMin;
}

function formatAndT(formatId, formatParams, localeId, localeParams) {
    var body = t(localeId, localeParams);
    if (formatParams) {
        formatParams.text = body;
        body = formatText(formatId, formatParams);
    } else {
        body = formatText(formatId, { text: body });
    }

    return body;
}

function formatUser(fNick) {
    var nick = fNick;

    if ((typeof nick === 'undefined' ? 'undefined' : (0, _typeof3.default)(nick)) === 'object') {
        nick = nick.nick;
    }

    return formatText('user', { nick: nick });
}

function formatUserFull(fNick, fUsername, fHost) {
    var nick = '';
    var username = '';
    var host = '';

    if ((typeof fNick === 'undefined' ? 'undefined' : (0, _typeof3.default)(fNick)) === 'object') {
        var user = fNick;
        nick = user.nick;
        username = user.username || user.ident;
        host = user.hostname || user.host;
    } else {
        nick = fNick;
        username = fUsername;
        host = fHost;
    }

    return formatText('user_full', { nick: nick, username: username, host: host });
}

function formatText(formatId, formatParams) {
    var format = _state2.default.setting('textFormats.' + formatId);
    var params = formatParams;

    if (typeof params === 'string') {
        params = { text: params };
    }

    if (params.user) {
        params.nick = params.user.nick || '';
        params.username = params.user.username || '';
        params.host = params.user.hostname || '';
        params.prefix = params.user.prefix || '';
    }

    var result = format.replace(/%([A-Z]{2,})/ig, function (match, key) {
        var ret = '';
        if (typeof params[key] !== 'undefined') {
            ret = params[key];
        }

        return ret;
    });

    return result;
}

function formatDuration(timeSeconds) {
    var seconds = timeSeconds;

    var weeks = Math.floor(seconds / (3600 * 24 * 7));
    seconds -= weeks * 3600 * 24 * 7;

    var days = Math.floor(seconds / (3600 * 24));
    seconds -= days * 3600 * 24;

    var hours = Math.floor(seconds / 3600);
    seconds -= hours * 3600;

    var minutes = Math.floor(seconds / 60);
    seconds -= minutes * 60;

    var tmp = [];
    weeks && tmp.push(t('week', { count: weeks }));
    (weeks || days) && tmp.push(t('day', { count: days }));
    (days || hours) && tmp.push(t('hour', { count: hours }));
    (days || hours || minutes) && tmp.push(t('minute', { count: minutes }));
    tmp.push(t('second', { count: seconds }));

    return tmp.join(' ');
}

function formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

function t(key, options) {
    var val = _i18next2.default.t(key, options);
    if (!val) {
        var opts = options || {};
        opts.lng = 'en-us';
        val = _i18next2.default.t(key, opts);
    }
    return val;
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["helpers"]) window._kiwi_exports["helpers"] = {};
window._kiwi_exports["helpers"]["TextFormatting"]
window._kiwi_exports.helpers.TextFormatting = exports.default ? exports.default : exports;


/***/ }),

/***/ "15pG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputConfirm_vue__ = __webpack_require__("1crt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputConfirm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputConfirm_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputConfirm_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputConfirm_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c5c2d47_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputConfirm_vue__ = __webpack_require__("KETo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("dy/S")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputConfirm_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c5c2d47_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputConfirm_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c5c2d47_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputConfirm_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "1a7T":
/***/ (function(module, exports) {

module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}

/***/ }),

/***/ "1crt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var Vue = __webpack_require__("I3G/");

exports.default = Vue.component('input-confirm', {
    props: ['label', 'flip_connotation'],
    data: function data() {
        return {
            state: 'pre'
        };
    },
    computed: {
        connoteCss: function connoteCss() {
            return {
                yes: this.flip_connotation ? 'warning' : 'primary',
                no: this.flip_connotation ? 'primary' : 'warning'
            };
        }
    },
    created: function created() {
        if (!this.$slots.default) {
            this.state = 'prompt';
        }
    },

    methods: {
        prompt: function prompt() {
            this.state = 'prompt';
        },
        complete: function complete(val) {
            this.$emit('submit', val);
            this.$emit(val ? 'ok' : 'cancel');
            this.state = 'pre';
        }
    }
});
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["utils"]) window._kiwi_exports["components"]["utils"] = {};
window._kiwi_exports["components"]["utils"]["InputConfirm"]
window._kiwi_exports.components.utils.InputConfirm = exports.default ? exports.default : exports;


/***/ }),

/***/ "1gJW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.supportsHalfOp = supportsHalfOp;
exports.isAChannelModeAdmin = isAChannelModeAdmin;
exports.isQChannelModeOwner = isQChannelModeOwner;
exports.extbanAccount = extbanAccount;
function supportsHalfOp(network) {
    var ircdType = network.ircd.toLowerCase();
    var notSupported = ['ircd-seven', 'charybdis'];

    for (var i = 0; i < notSupported.length; i++) {
        if (ircdType.indexOf(notSupported[i]) > -1) {
            return false;
        }
    }

    return true;
}

function isAChannelModeAdmin(network) {
    var ircdType = network.ircd.toLowerCase();
    var notAdmin = ['ircd-seven', 'charybdis'];

    for (var i = 0; i < notAdmin.length; i++) {
        if (ircdType.indexOf(notAdmin[i]) > -1) {
            return false;
        }
    }

    return true;
}

function isQChannelModeOwner(network) {
    var ircdType = network.ircd.toLowerCase();
    var notOwner = ['ircd-seven', 'charybdis'];

    for (var i = 0; i < notOwner.length; i++) {
        if (ircdType.indexOf(notOwner[i]) > -1) {
            return false;
        }
    }

    return true;
}

function extbanAccount(network) {
    var ircdType = network.ircd.toLowerCase();

    var extban = network.ircClient.network.supports('EXTBAN') || '';
    if (!extban) {
        return '';
    }

    var prefix = extban.split(',')[0];
    var type = 'a';

    if (ircdType.indexOf('inspircd') > -1) {
        type = 'R';
    }

    return prefix + type;
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["helpers"]) window._kiwi_exports["helpers"] = {};
window._kiwi_exports["helpers"]["IrcdDiffs"]
window._kiwi_exports.helpers.IrcdDiffs = exports.default ? exports.default : exports;


/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "29nj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var configTemplates = exports.configTemplates = {

    default: {
        plugins: [],
        windowTitle: 'Kiwi IRC - The web IRC client',
        useMonospace: false,
        language: '',
        theme: 'Default',
        themes: [{ name: 'Default', url: 'static/themes/default' }],

        restricted: true,

        startupScreen: 'customServer',

        kiwiServer: '/webirc/kiwiirc/',

        bnc: {
            active: false,
            server: '',
            port: 6667,
            tls: false,
            path: '',
            username: '',
            password: ''
        },
        warnOnExit: true,

        buffers: {
            messageLayout: 'modern',
            alert_on: 'highlight',
            timestamp_format: '%H:%M:%S',

            timestamp_full_format: '',
            show_timestamps: true,
            scrollback_size: 250,
            show_hostnames: false,
            show_joinparts: true,
            show_topics: true,
            show_nick_changes: true,
            show_mode_changes: true,
            traffic_as_activity: false,
            coloured_nicklist: true,
            colour_nicknames_in_messages: true,
            block_pms: false,
            show_emoticons: true,
            extra_formatting: true,
            mute_sound: false,
            hide_message_counts: false,
            show_realnames: false,
            default_ban_mask: '*!%i@%h',
            default_kick_reason: 'Your behaviour is not conducive to the desired environment.',
            shared_input: false,
            show_message_info: true,
            who_loop: true,
            share_typing: true,

            flash_title: 'message'
        },

        startupOptions: {
            server: '',
            port: 6667,
            tls: false,
            channel: '',
            nick: 'kiwi_?',
            direct: false,
            state_key: 'kiwi-state',
            nick_format: ''
        },
        disconnectOnSaslFail: true,
        allowRegisterProtocolHandler: false,
        noticeActiveBuffer: true,
        showChanlistModes: false,
        showAutocomplete: true,
        showEmojiPicker: true,
        showColorPicker: false,
        showSendButton: false,
        showAwayStatusIndicators: true,
        sidebarDefault: 'nicklist',
        showRaw: false,
        hideSettings: null,
        highlights: '',
        teamHighlights: false,
        aliases: '\n# General aliases\n/p /part $1+\n/me /action $destination $1+\n/j /join $1+\n/q /query $1+\n/w /whois $1+\n/raw /quote $1+\n/connect /server $1+\n/cycle $channel? /lines /part $channel | /join $channel\n/active /back $1+\n/umode /mode $nick $1+\n\n# Op related aliases\n/op /quote mode $channel +o $1+\n/deop /quote mode $channel -o $1+\n/hop /quote mode $channel +h $1+\n/dehop /quote mode $channel -h $1+\n/voice /quote mode $channel +v $1+\n/devoice /quote mode $channel -v $1+\n/k /kick $channel $1+\n/bans /mode $channel +b\n/ban /quote mode $channel +b $1+\n/unban /quote mode $channel -b $1+\n\n# Misc aliases\n/slap /me slaps $1 around a bit with a large trout\n/tick /msg $channel \u2714',
        embedly: {
            Key: ''
        },

        emojis: {
            '-___-': '1f611',
            ':\'-)': '1f602',
            '\':-)': '1f605',
            '\':-D': '1f605',
            '>:-)': '1f606',
            '\':-(': '1f613',
            '>:-(': '1f620',
            ':\'-(': '1f622',
            'O:-)': '1f607',
            '0:-3': '1f607',
            '0:-)': '1f607',
            '0;^)': '1f607',
            'O;-)': '1f607',
            '0;-)': '1f607',
            'O:-3': '1f607',
            '-__-': '1f611',
            ':-Þ': '1f61b',
            '<3': '2764',
            '</3': '1f494',
            ':\')': '1f602',
            ':-D': '1f603',
            '\':)': '1f605',
            '\'=)': '1f605',
            '\':D': '1f605',
            '\'=D': '1f605',
            '>:)': '1f606',
            '>;)': '1f606',
            '>=)': '1f606',
            'XD': '1f606',
            ';-)': '1f609',
            '*-)': '1f609',
            ';-]': '1f609',
            ';^)': '1f609',
            '\':(': '1f613',
            '\'=(': '1f613',
            ':-*': '1f618',
            ':^*': '1f618',
            '>:P': '1f61c',
            'X-P': '1f61c',
            '>:[': '1f61e',
            ':-(': '1f61e',
            ':-[': '1f61e',
            '>:(': '1f620',
            ':\'(': '1f622',
            ';-(': '1f622',
            '>.<': '1f623',
            '#-)': '1f635',
            '%-)': '1f635',
            'X-)': '1f635',
            '\\0/': '1f646',
            '\\O/': '1f646',
            '0:3': '1f607',
            '0:)': '1f607',
            'O:)': '1f607',
            'O=)': '1f607',
            'O:3': '1f607',
            'B-)': '1f60e',
            '8-)': '1f60e',
            'B-D': '1f60e',
            '8-D': '1f60e',
            '-_-': '1f611',
            '>:\\': '1f615',
            '>:/': '1f615',
            ':-/': '1f615',
            ':-.': '1f615',
            ':-P': '1f61b',
            ':Þ': '1f61b',
            ':-b': '1f61b',
            ':-O': '1f62e',
            'O_O': '1f62e',
            '>:O': '1f62e',
            ':-X': '1f636',
            ':-#': '1f636',
            ':-)': '1f642',
            '(y)': '1f44d',
            ':D': '1f603',
            '=D': '1f603',
            ';)': '1f609',
            '*)': '1f609',
            ';]': '1f609',
            ';D': '1f609',
            ':*': '1f618',
            '=*': '1f618',
            ':(': '1f61e',
            ':[': '1f61e',
            '=(': '1f61e',
            ':@': '1f620',
            ';(': '1f622',
            'D:': '1f628',
            ':$': '1f633',
            '=$': '1f633',
            '#)': '1f635',
            '%)': '1f635',
            'X)': '1f635',
            'B)': '1f60e',
            '8)': '1f60e',
            ':/': '1f615',
            ':\\': '1f615',
            '=/': '1f615',
            '=\\': '1f615',
            ':L': '1f615',
            '=L': '1f615',
            ':P': '1f61b',
            ':p': '1f61b',
            '=P': '1f61b',
            ':b': '1f61b',
            ':O': '1f62e',
            ':X': '1f636',
            ':#': '1f636',
            '=X': '1f636',
            '=#': '1f636',
            ':)': '1f642',
            '=]': '1f642',
            '=)': '1f642',
            ':]': '1f642'
        },
        emojiLocation: 'https://kiwiirc.com/shared/emoji/',
        textFormats: {
            user: '%nick',
            user_full: '%nick (%username@%host)',
            channel_join: '→ %text',
            channel_part: '← %text (%reason)',
            channel_quit: '← %text (%reason)',
            channel_kicked: '← %text (%reason)',
            channel_selfkick: '× %text (%reason)',
            channel_badpassword: '× %text',
            channel_topic: 'ⓘ %text',
            channel_banned: '× %text',
            channel_badkey: '⚠ %text',
            channel_inviteonly: '⚠ %channel %text',
            channel_alreadyin: '⚠ %nick %text',
            channel_limitreached: '⚠ %channel %text',
            channel_invalid_name: '⚠ %channel %text',
            channel_topic_setby: 'ⓘ %text',
            channel_has_been_invited: 'ⓘ %nick %text',
            server_connecting: '%text',
            server_connecting_error: '%text',
            mode: 'ⓘ %text',
            selfmode: 'ⓘ %nick %text',
            nickname_alreadyinuse: '⚠ %text',
            network_disconnected: '%text',
            network_connected: '%text',
            whois_channels: '%text',
            whois_idle_and_signon: '%text',
            whois_away: '%text',
            whois_server: '%text',
            whois_idle: '%text',
            whois_notfound: 'ⓘ %text',
            nick_changed: 'ⓘ %text',
            applet_notfound: '⚠ %text',
            encoding_changed: 'ⓘ %text',
            encoding_invalid: '⚠ %text',
            settings_saved: 'ⓘ %text',
            ignore_title: '%text:',
            ignore_none: '%text',
            ignore_nick: '%text',
            ignore_stop_notice: '%text',
            ignore_stopped: '%text',
            chanop_privs_needed: '⚠ %text',
            no_such_nick: 'ⓘ %nick: %text',
            unknown_command: 'ⓘ %text',
            motd: '%text',
            ctcp_response: '[CTCP %nick reply] %message',
            ctcp_request: '[CTCP %nick] %message',
            privmsg: '%text',
            notice: '%text',
            action: '* %nick %text',
            whois_ident: '%nick [%nick!%ident@%host] * %text',
            whois_error: '[%nick] %text',
            whois: '%text',
            whowas_ident: 'was [%nick!%ident@%host] * %name',
            whowas_server: 'using %server (%info)',
            whowas_error: '[%nick] %text',
            who: '%nick [%nick!%ident@%host] * %realname',
            quit: '%text',
            rejoin: '%text',
            set_setting: 'ⓘ %text',
            list_aliases: 'ⓘ %text',
            ignored_pattern: 'ⓘ %text',
            wallops: '[WALLOPS] %text',
            message_nick: '%prefix%nick',
            general_error: '%text'
        },
        presetNetworks: []
    },

    irc: {
        showEmojiPicker: false,
        sidebarDefault: 'nicklist',
        buffers: {
            messageLayout: 'inline',
            show_hostnames: true,
            coloured_nicklist: false,
            colour_nicknames_in_messages: false,
            show_emoticons: false,
            show_message_info: false,
            share_typing: false
        }
    },

    team: {
        teamHighlights: true,
        buffers: {
            messageLayout: 'modern',
            show_joinparts: false,
            show_nick_changes: true,
            show_mode_changes: true,
            show_realnames: true
        }
    }

};

/***/ }),

/***/ "2SpE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _create = __webpack_require__("OvRC");

var _create2 = _interopRequireDefault(_create);

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _state = __webpack_require__("LnP8");

var _state2 = _interopRequireDefault(_state);

var _Logger = __webpack_require__("XNCV");

var _Logger2 = _interopRequireDefault(_Logger);

var _CommonLayout = __webpack_require__("evl8");

var _CommonLayout2 = _interopRequireDefault(_CommonLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = _Logger2.default.namespace('Startup/kiwiBnc');

exports.default = {
    components: {
        StartupLayout: _CommonLayout2.default
    },
    data: function data() {
        return {
            loading: false,
            username: '',
            password: '',
            statusMessage: ''
        };
    },
    computed: {
        greetingText: function greetingText() {
            var greeting = _state2.default.settings.startupOptions.greetingText;
            return typeof greeting === 'string' ? greeting : this.$t('start_greeting');
        },
        buttonText: function buttonText() {
            if (this.loading) {
                return '';
            }

            var greeting = _state2.default.settings.startupOptions.buttonText;
            return typeof greeting === 'string' ? greeting : this.$t('start_button');
        }
    },
    methods: {
        startUp: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                var _this = this;

                var bncnet, cleanUpEvents, onRegistered, onError, onClose;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                this.statusMessage = this.$t('logging_in');
                                this.loading = true;

                                bncnet = this.getBncNetwork();

                                cleanUpEvents = function cleanUpEvents() {
                                    bncnet.ircClient.off('registered', onRegistered);
                                    bncnet.ircClient.off('irc error', onError);
                                    bncnet.ircClient.off('close', onClose);
                                };

                                onRegistered = function () {
                                    var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                                        var bncNetworks, i, network, buffers;
                                        return _regenerator2.default.wrap(function _callee$(_context) {
                                            while (1) {
                                                switch (_context.prev = _context.next) {
                                                    case 0:
                                                        cleanUpEvents();

                                                        _context.next = 3;
                                                        return bncnet.ircClient.bnc.getNetworks();

                                                    case 3:
                                                        bncNetworks = _context.sent;
                                                        i = 0;

                                                    case 5:
                                                        if (!(i < bncNetworks.length)) {
                                                            _context.next = 22;
                                                            break;
                                                        }

                                                        network = bncNetworks[i];

                                                        network.buffers = [];
                                                        _context.prev = 8;
                                                        _context.next = 11;
                                                        return bncnet.ircClient.bnc.getBuffers(network.name);

                                                    case 11:
                                                        buffers = _context.sent;

                                                        network.buffers = buffers;
                                                        _context.next = 18;
                                                        break;

                                                    case 15:
                                                        _context.prev = 15;
                                                        _context.t0 = _context['catch'](8);

                                                        log.error(_context.t0);

                                                    case 18:

                                                        _this.addNetworkToState(network);

                                                    case 19:
                                                        i++;
                                                        _context.next = 5;
                                                        break;

                                                    case 22:

                                                        _this.monitorNetworkChanges(bncnet, bncNetworks);
                                                        _this.$refs.layout.close();

                                                    case 24:
                                                    case 'end':
                                                        return _context.stop();
                                                }
                                            }
                                        }, _callee, _this, [[8, 15]]);
                                    }));

                                    return function onRegistered() {
                                        return _ref2.apply(this, arguments);
                                    };
                                }();

                                onError = function onError(event) {
                                    cleanUpEvents();
                                    _this.statusMessage = _this.$t('invalid_login');
                                    _this.loading = false;
                                };

                                onClose = function onClose(event) {
                                    cleanUpEvents();
                                    _this.statusMessage = _this.$t('invalid_login');
                                    _this.loading = false;
                                };

                                bncnet.ircClient.once('registered', onRegistered);
                                bncnet.ircClient.once('irc error', onError);
                                bncnet.ircClient.once('close', onClose);
                                bncnet.ircClient.connect();

                            case 11:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function startUp() {
                return _ref.apply(this, arguments);
            }

            return startUp;
        }(),

        getBncNetwork: function getBncNetwork() {
            var bnc = _state2.default.setting('bnc');

            if (bnc.network) {
                bnc.username = this.username;
                bnc.password = this.password;
                return bnc.network;
            }

            var options = _state2.default.settings.startupOptions;

            bnc.active = true;
            bnc.server = options.server || '';
            bnc.port = options.port || 6667;
            bnc.tls = !!options.tls;
            bnc.username = this.username;
            bnc.password = this.password;

            var bncnet = _state2.default.addNetwork('bnccontrol', this.username, {
                server: bnc.server,
                port: bnc.port,
                tls: bnc.tls
            });

            bnc.network = bncnet;

            return bncnet;
        },

        addNetworkToState: function addNetworkToState(network) {
            var net = _state2.default.addNetwork(network.name, network.nick, {
                server: network.host,
                port: network.port,
                tls: network.tls,
                password: network.password,
                bncname: network.name,
                username: network.user
            });

            network.buffers.forEach(function (buffer) {
                var newBuffer = _state2.default.addBuffer(net.id, buffer.name);
                if (buffer.joined) {
                    newBuffer.enabled = true;
                }
                if (buffer.seen) {
                    newBuffer.last_read = new Date(buffer.seen).getTime();
                }
            });
        },

        monitorNetworkChanges: function monitorNetworkChanges(bncNet, bncNetworks) {
            var existingNets = (0, _create2.default)(null);
            function rememberNetworks() {
                _state2.default.networks.forEach(function (network) {
                    if (!network.connection.bncname) {
                        return;
                    }

                    existingNets[network.connection.bncname] = {
                        name: network.connection.bncname,
                        host: network.connection.server,
                        port: network.connection.port,
                        tls: network.connection.tls,
                        password: network.password,
                        nick: network.nick,
                        username: network.username
                    };
                });
            }

            rememberNetworks();

            var saveState = function saveState(newVal) {
                _state2.default.networks.forEach(function (network) {
                    if (network.name === 'bnccontrol') {
                        return;
                    }

                    var bncName = network.connection.bncname;
                    var current = existingNets[bncName] || {};
                    var tags = {};

                    if (network.connection.server !== current.host) {
                        tags.host = network.connection.server;
                    }
                    if (network.connection.port !== current.port) {
                        tags.port = network.connection.port;
                    }
                    if (network.connection.tls !== current.tls) {
                        tags.tls = network.connection.tls;
                    }
                    if (network.password !== current.password) {
                        tags.password = network.password;
                    }
                    if (network.nick !== current.nick) {
                        tags.nick = network.nick;
                    }
                    if (network.username !== current.username) {
                        tags.user = network.username;
                    }

                    if (!current.name && tags.host) {
                        network.connection.bncname = network.name;
                        bncNet.ircClient.bnc.addNetwork(network.name, tags.host, tags.port, tags.tls, tags.nick, tags.user, tags.password);
                    } else if (current.name) {
                        bncNet.ircClient.bnc.saveNetwork(bncName, tags);
                    }
                });

                rememberNetworks();
            };

            var debouncedSaveState = _lodash2.default.debounce(saveState, 2000);

            _state2.default.$watch('networks', debouncedSaveState, { deep: true });

            _state2.default.$on('network.connecting', function (event) {
                saveState();

                var netName = event.network.connection.bncname;
                var networkFromBnc = _lodash2.default.find(bncNetworks, { name: netName });
                if (networkFromBnc && !networkFromBnc.connected) {
                    bncNet.ircClient.raw('BOUNCER connect ' + netName);
                }
            });

            _state2.default.$on('network.new', function (event) {
                var currentNum = 1;
                var existingNet = true;
                while (existingNet) {
                    existingNet = _lodash2.default.find(_state2.default.networks, { name: 'Network' + currentNum });
                    if (!existingNet) {
                        event.network.name = 'Network' + currentNum;
                    }

                    currentNum++;
                }
            });

            _state2.default.$on('network.removed', function (event) {
                bncNet.ircClient.bnc.removeNetwork(event.network.connection.bncname);
            });

            _state2.default.$on('buffer.close', function (event) {
                var buffer = event.buffer;
                var network = event.buffer.getNetwork();
                var bncName = network.connection.bncname;

                if (bncName) {
                    bncNet.ircClient.bnc.closeBuffer(bncName, buffer.name);
                }
            });
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["startups"]) window._kiwi_exports["components"]["startups"] = {};
window._kiwi_exports["components"]["startups"]["KiwiBnc"]
window._kiwi_exports.components.startups.KiwiBnc = exports.default ? exports.default : exports;


/***/ }),

/***/ "2Uqc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user && _vm.status !== '')?_c('span',{staticClass:"kiwi-typingstatusindicator",class:{ 'kiwi-typingstatusindicator--paused': _vm.status === 'paused' }},[_vm._v("…")]):_vm._e()}
var staticRenderFns = []


/***/ }),

/***/ "2aDa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-statebrowser kiwi-theme-bg"},[(!_vm.$state.setting('hideSettings'))?_c('div',{staticClass:"kiwi-statebrowser-appsettings",attrs:{"title":_vm.$t('kiwi_settings')},on:{"click":_vm.clickAppSettings}},[_c('i',{staticClass:"fa fa-cog",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.isPersistingState)?_c('state-browser-usermenu',{attrs:{"network":_vm.getNetwork}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"kiwi-statebrowser-tools"},_vm._l((_vm.pluginUiElements),function(plugin){return _c('div',{directives:[{name:"rawElement",rawName:"v-rawElement",value:(plugin.el),expression:"plugin.el"}],key:plugin.id,staticClass:"kiwi-statebrowser-tool"})}),0),_vm._v(" "),(Object.keys(_vm.provided_networks).length > 0)?_c('div',{staticClass:"kiwi-statebrowser-availablenetworks"},[_c('div',{staticClass:"kiwi-statebrowser-availablenetworks-toggle",on:{"click":function($event){_vm.show_provided_networks=!_vm.show_provided_networks}}},[_vm._v("\n            ↪ "+_vm._s(_vm.$t('state_available'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"kiwi-statebrowser-availablenetworks-networks",class:{
                'kiwi-statebrowser-availablenetworks-networks--open': _vm.show_provided_networks
            }},_vm._l((_vm.provided_networks),function(pNets,pNetTypeName){return _c('div',{key:pNetTypeName,staticClass:"kiwi-statebrowser-availablenetworks-type"},[_c('div',{staticClass:"kiwi-statebrowser-availablenetworks-name"},[_vm._v(_vm._s(pNetTypeName))]),_vm._v(" "),_vm._l((pNets),function(pNet){return _c('div',{key:pNet.name,staticClass:"kiwi-statebrowser-availablenetworks-link",class:[
                        pNet.connected?'kiwi-statebrowser-availablenetworks-link--connected':''
                    ]},[_c('a',{on:{"click":function($event){return _vm.connectProvidedNetwork(pNet)}}},[_vm._v(_vm._s(pNet.name))]),_c('br')])})],2)}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"kiwi-statebrowser-scrollarea"},[_c('div',{staticClass:"kiwi-statebrowser-networks"},_vm._l((_vm.networksToShow),function(network){return _c('state-browser-network',{key:network.id,attrs:{"network":network,"sidebar-state":_vm.sidebarState}})}),1)]),_vm._v(" "),(!_vm.isRestrictedServer)?_c('div',{staticClass:"kiwi-statebrowser-newnetwork"},[_c('a',{staticClass:"u-button u-button-primary",on:{"click":_vm.clickAddNetwork}},[_vm._v("\n            "+_vm._s(_vm.$t('add_network'))+"\n            "),_c('i',{staticClass:"fa fa-plus",attrs:{"aria-hidden":"true"}})])]):_vm._e()],1)}
var staticRenderFns = []


/***/ }),

/***/ "2j2C":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

exports.default = bouncerMiddleware;

var _ircFramework = __webpack_require__("k4vc");

var _Misc = __webpack_require__("uN9+");

var Misc = _interopRequireWildcard(_Misc);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function bouncerMiddleware() {
    var networks = [];
    var buffers = {};

    return function middleware(client, rawEvents, parsedEvents) {
        client.requestCap('bouncer');
        addFunctionsToClient(client);
        rawEvents.use(theMiddleware);
    };

    function theMiddleware(command, message, rawLine, client, next) {
        if (command !== 'BOUNCER') {
            next();
            return;
        }

        var params = message.params;

        if (params[0] === 'listnetworks' && ['end', 'RPL_OK'].indexOf(params[1]) > -1) {
            client.emit('bouncer networks', networks);
            networks = [];
        } else if (params[0] === 'listnetworks') {
            var tags = _ircFramework.MessageTags.decode(params[1]);
            networks.push({
                name: tags.network,
                host: tags.host,
                port: parseInt(tags.port, 10),
                tls: tags.tls === '1',
                connect: tags.state === 'connected',
                nick: tags.nick,
                currentNick: tags.currentNick,
                password: tags.password || ''
            });
        } else if (params[0] === 'listbuffers' && ['end', 'RPL_OK'].indexOf(params[2]) > -1) {
            var netName = (params[1] || '').toLowerCase();
            var detectedBuffers = buffers[netName] || [];
            delete buffers[netName];

            client.emit('bouncer buffers', detectedBuffers);
            client.emit('bouncer buffers ' + netName, detectedBuffers);
        } else if (params[0] === 'listbuffers') {
            var _netName = (params[1] || '').toLowerCase();
            var _tags = _ircFramework.MessageTags.decode(params[2]);
            buffers[_netName] = buffers[_netName] || [];
            buffers[_netName].push({
                network: _tags.network,
                name: _tags.buffer,
                topic: _tags.topic,
                joined: _tags.joined === '1',
                seen: _tags.seen
            });
        }

        if (params[0] === 'addnetwork' && params[2].substr(0, 4) === 'ERR_') {
            var _netName2 = (params[1] || '').toLowerCase();
            var eventObj = {
                error: params[2],
                reason: params[3] || ''
            };
            client.emit('bouncer addnetwork error', eventObj);
            client.emit('bouncer addnetwork error ' + _netName2, eventObj);
        } else if (params[0] === 'addnetwork' && ['end', 'RPL_OK'].indexOf(params[2]) > -1) {
            var _netName3 = (params[1] || '').toLowerCase();
            var _eventObj = {
                network: params[2]
            };
            client.emit('bouncer addnetwork ok', _eventObj);
            client.emit('bouncer addnetwork ok ' + _netName3, _eventObj);
        }
    }
}

function addFunctionsToClient(client) {
    var bnc = client.bnc = {};

    bnc.tags = function tags() {
        var token = client.network.supports('bouncer');
        return !token || typeof token !== 'string' ? {} : _ircFramework.MessageTags.decode(token) || {};
    };

    bnc.hasNetwork = function hasNetwork() {
        var token = client.network.supports('bouncer');
        if (!token || token === true) {
            return false;
        }

        var tags = _ircFramework.MessageTags.decode(token);
        return tags && !!tags.network;
    };

    bnc.getNetworks = function getNetworks() {
        return new _promise2.default(function (resolve, reject) {
            client.raw('BOUNCER listnetworks');
            client.once('bouncer networks', function (networks) {
                resolve(networks);
            });
        });
    };

    bnc.getBuffers = function getBuffers(netName) {
        return new _promise2.default(function (resolve, reject) {
            client.raw('BOUNCER listbuffers ' + netName);
            client.once('bouncer buffers ' + netName.toLowerCase(), function (buffers) {
                resolve(buffers);
            });
        });
    };

    bnc.closeBuffer = function closeBuffer(netName, bufferName) {
        return new _promise2.default(function (resolve, reject) {
            client.raw('BOUNCER delbuffer ' + netName + ' ' + bufferName);
        });
    };

    bnc.bufferSeen = function bufferSeen(netName, bufferName, seenTime) {
        return new _promise2.default(function (resolve, reject) {
            var timeStr = Misc.dateIso(seenTime);
            client.raw('BOUNCER changebuffer ' + netName + ' ' + bufferName + ' seen=' + timeStr);
        });
    };

    bnc.addNetwork = function addNetwork(netName, host, port, tls, nick, user, password) {
        var tags = {};
        tags.network = netName;
        tags.host = host;
        tags.port = port;
        tags.tls = tls ? 1 : 0;
        tags.nick = nick;
        tags.password = password;

        if (user) {
            tags.user = user;
        }

        var tagString = createTagString(tags);
        return new _promise2.default(function (resolve, reject) {
            client.raw('BOUNCER addnetwork ' + tagString);
            client.once('bouncer addnetwork ok', onOk);
            client.once('bouncer addnetwork error', onError);

            function onOk(event) {
                client.off('bouncer addnetwork error', onError);
                resolve();
            }
            function onError(event) {
                client.off('bouncer addnetwork ok', onOk);
                reject({
                    error: event.error,
                    reason: event.reason
                });
            }
        });
    };

    bnc.removeNetwork = function removeNetwork(netName, bufferName) {
        return new _promise2.default(function (resolve, reject) {
            client.raw('BOUNCER delnetwork ' + netName);
        });
    };

    bnc.saveNetwork = function saveNetwork(netName, opts) {
        var tags = {};

        if (typeof opts.host !== 'undefined') {
            tags.host = opts.host;
        }
        if (typeof opts.port !== 'undefined') {
            tags.port = opts.port;
        }
        if (typeof opts.tls !== 'undefined') {
            tags.tls = opts.tls ? 1 : 0;
        }
        if (typeof opts.nick !== 'undefined') {
            tags.nick = opts.nick;
        }
        if (typeof opts.user !== 'undefined') {
            tags.user = opts.user;
        }
        if (typeof opts.password !== 'undefined') {
            tags.password = opts.password;
        }

        var tagString = createTagString(tags);
        return new _promise2.default(function (resolve, reject) {
            if (tagString.length === 0) {
                resolve();
            } else {
                client.raw('BOUNCER changenetwork ' + netName + ' ' + tagString);
            }
        });
    };
}

function createTagString(tags) {
    var tagParts = [];

    (0, _keys2.default)(tags).forEach(function (tag) {
        var val = tags[tag];
        if (typeof val !== 'undefined') {
            val = val.toString().replace(' ', '\\s').replace(';', '\\:');
            tagParts.push(tag + '=' + val);
        } else {
            tagParts.push(tag);
        }
    });

    return tagParts.join(';');
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["BouncerMiddleware"]
window._kiwi_exports.libs.BouncerMiddleware = exports.default ? exports.default : exports;


/***/ }),

/***/ "2jZO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2xp5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Colours = __webpack_require__("3piF");

var Colours = _interopRequireWildcard(_Colours);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
    props: ['ircinput'],
    data: function data() {
        return {};
    },

    methods: {
        onColourClick: function onColourClick(event) {
            var colour = window.getComputedStyle(event.target, null).getPropertyValue('background-color');

            var m = colour.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
            if (m) {
                var rgbObj = {
                    r: parseInt(m[1], 10),
                    g: parseInt(m[2], 10),
                    b: parseInt(m[3], 10)
                };
                colour = Colours.rgb2hex(rgbObj);
            }

            var code = event.target.dataset.code;
            this.ircinput.setColour(code, colour);
        },
        onResetClick: function onResetClick() {
            this.ircinput.resetStyles();
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["inputtools"]) window._kiwi_exports["components"]["inputtools"] = {};
window._kiwi_exports["components"]["inputtools"]["TextStyle"]
window._kiwi_exports.components.inputtools.TextStyle = exports.default ? exports.default : exports;


/***/ }),

/***/ "3EQ1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _TextFormatting = __webpack_require__("15gS");

var TextFormatting = _interopRequireWildcard(_TextFormatting);

var _Misc = __webpack_require__("uN9+");

var Misc = _interopRequireWildcard(_Misc);

var _state = __webpack_require__("LnP8");

var _state2 = _interopRequireDefault(_state);

var _IPC = __webpack_require__("Y+EK");

var _IPC2 = _interopRequireDefault(_IPC);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var firstRun = true;

exports.default = {
    data: function data() {
        return {
            hasOtherTab: false,
            addedNetworkToExisting: false,
            server: null,
            readyToShowOptions: false
        };
    },
    computed: {
        networks: function networks() {
            return _state2.default.networks;
        },
        hasFragment: function hasFragment() {
            return window.location.hash && window.location.hash.length > 1;
        }
    },
    created: function created() {
        var _this = this;

        this.$state.setting('allowRegisterProtocolHandler', true);

        var server = null;
        if (this.hasFragment) {
            server = this.parseFragment();
            this.server = server;
        }

        if (server) {
            this.findOtherTabs().then(function (hasOtherTab) {
                if (hasOtherTab) {
                    _this.hasOtherTab = true;
                } else {
                    _this.listenForOtherTabs();
                    _this.init();
                }

                _this.readyToShowOptions = true;
            });
        } else {
            this.listenForOtherTabs();
            this.init();
        }
    },
    methods: {
        listenForOtherTabs: function listenForOtherTabs() {
            var _this2 = this;

            _IPC2.default.on('message', function (e) {
                var msg = e.data;
                if (msg.type === 'ping' && _this2.networks.length > 0) {
                    _IPC2.default.send({ type: 'pong' });
                } else if (msg.type === 'addNetwork') {
                    var network = _this2.networks.find(function (n) {
                        return n.name === msg.server;
                    });
                    if (!network) {
                        network = _state2.default.addNetwork(msg.server, msg.nick || 'Guest' + Math.floor(Math.random() * 100), msg);
                    }
                    network.showServerBuffer('settings');
                }
            });
        },
        addEmptyNetwork: function addEmptyNetwork() {
            var nick = 'Guest' + Math.floor(Math.random() * 100);
            var network = _state2.default.addNetwork(TextFormatting.t('new_network'), nick, {});
            network.showServerBuffer('settings');
        },
        findOtherTabs: function findOtherTabs() {
            var _this3 = this;

            return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                return _context.abrupt('return', new _promise2.default(function (resolve, reject) {
                                    var handleIPCMessage = function handleIPCMessage(e) {
                                        var msg = e.data;
                                        if (msg.type === 'pong') {
                                            clearTimeout(timer);
                                            resolve(true);
                                        }
                                    };

                                    var timer = setTimeout(function (e) {
                                        _IPC2.default.removeListener('message', handleIPCMessage);
                                        resolve(false);
                                    }, 200);

                                    _IPC2.default.on('message', handleIPCMessage);
                                    _IPC2.default.send({ type: 'ping' });
                                }));

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this3);
            }))();
        },
        addNetworkToExistingTab: function addNetworkToExistingTab() {
            var nick = 'Guest' + Math.floor(Math.random() * 100);
            var con = this.server;

            _state2.default.addNetwork(TextFormatting.t('new_network'), nick, {});

            _IPC2.default.send({
                nick: nick,
                server: con.server,
                port: con.port,
                tls: con.tls,
                password: con.password || '',
                type: 'addNetwork'
            });

            window.location.hash = '';

            this.addedNetworkToExisting = true;
        },
        addNetwork: function addNetwork() {
            var temporary = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (!this.server) {
                return;
            }

            var con = this.server;

            if (temporary) {
                _state2.default.persistence.storageKey = null;
                _state2.default.persistence.forgetState();

                this.init();
            }

            var network = _state2.default.getNetworkFromAddress(con.server);
            if (!network) {
                network = _state2.default.addNetwork(con.server, con.nick || 'Guest' + Math.floor(Math.random() * 100), {
                    server: con.server,
                    port: con.port,
                    tls: con.tls,
                    password: con.password || ''
                });
            }

            window.location.hash = '';
            network.showServerBuffer('settings');

            this.$emit('start', {
                fallbackComponent: this.constructor
            });
        },
        parseFragment: function parseFragment() {
            if (window.location.hash.substr(1)) {
                var fragment = window.location.hash.substr(1);

                var uriCheck = fragment.substr(0, 7).toLowerCase();
                if (uriCheck === 'ircs%3a' || uriCheck.substr(0, 6) === 'irc%3a') {
                    fragment = decodeURIComponent(fragment);
                }

                var connections = Misc.parseIrcUri(fragment);
                var con = connections[0];
                return con;
            }
            return null;
        },
        toggleStateBrowser: function toggleStateBrowser() {
            _state2.default.$emit('statebrowser.show');
        },
        init: function init() {
            var _this4 = this;

            return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                var persistSetting;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (firstRun) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 2:

                                firstRun = false;

                                persistSetting = _state2.default.settings.startupOptions.remember_buffers;

                                if (typeof persistSetting === 'undefined') {
                                    _state2.default.persistence.includeBuffers = true;
                                } else {
                                    _state2.default.persistence.includeBuffers = !!persistSetting;
                                }

                                _state2.default.persistence.watchStateForChanges();

                                _state2.default.setSetting('settings.restricted', false);

                                _this4.$emit('start', {
                                    fallbackComponent: _this4.constructor
                                });

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this4);
            }))();
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["startups"]) window._kiwi_exports["components"]["startups"] = {};
window._kiwi_exports["components"]["startups"]["Personal"]
window._kiwi_exports.components.startups.Personal = exports.default ? exports.default : exports;


/***/ }),

/***/ "3GM/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

exports.get = get;
exports.set = set;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var supportedCached = null;

function get(name) {
    if (!isSupported()) {
        return _promise2.default.resolve();
    }
    return new _promise2.default(function (resolve) {
        resolve(window.localStorage.getItem(name));
    });
}

function set(name, val) {
    if (!isSupported()) {
        return _promise2.default.resolve();
    }
    return new _promise2.default(function (resolve) {
        resolve(window.localStorage.setItem(name, val));
    });
}

function isSupported() {
    if (supportedCached === null) {
        supportedCached = storageAvailable('localStorage');
    }
    return supportedCached;
}

function storageAvailable(type) {
    var storage = void 0;
    try {
        var x = '__storage_test__';
        storage = window[type];
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return e instanceof DOMException && (e.code === 22 || e.code === 1014 || e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && storage.length !== 0;
    }
}

/***/ }),

/***/ "3nVL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MediaViewer_vue__ = __webpack_require__("hfYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MediaViewer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MediaViewer_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MediaViewer_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MediaViewer_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00a138a1_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MediaViewer_vue__ = __webpack_require__("4W31");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("ZFC3")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MediaViewer_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00a138a1_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MediaViewer_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00a138a1_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MediaViewer_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "3piF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hex2rgb = hex2rgb;
exports.rgb2hex = rgb2hex;
exports.rgb2hsl = rgb2hsl;
exports.hsl2rgb = hsl2rgb;
exports.rgb2rgbString = rgb2rgbString;
function hex2rgb(_hex) {
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    var hex = _hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
    });

    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}

function rgb2hex(rgb) {
    return '#' + ['r', 'g', 'b'].map(function (key) {
        return ('0' + rgb[key].toString(16)).slice(-2);
    }).join('');
}

function rgb2hsl(rgb) {
    var r = rgb.r;
    var g = rgb.g;
    var b = rgb.b;

    r /= 255;
    g /= 255;
    b /= 255;

    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h = 0;
    var s = 0;
    var l = (max + min) / 2;

    if (max === min) {
        h = s = 0;
    } else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        if (max === r) {
            h = (g - b) / d + (g < b ? 6 : 0);
        } else if (max === g) {
            h = (b - r) / d + 2;
        } else if (max === b) {
            h = (r - g) / d + 4;
        }
        h /= 6;
    }

    return { h: h, s: s, l: l };
}

function hsl2rgb(hsl) {
    function hue2rgb(_p, _q, _t) {
        var p = _p;
        var q = _q;
        var t = _t;
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 1 / 2) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
    }

    var h = hsl.h;
    var s = hsl.s;
    var l = hsl.l;
    var r = 0;
    var g = 0;
    var b = 0;

    if (s === 0) {
        r = g = b = l;
    } else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }

    return {
        r: Math.round(r * 255),
        g: Math.round(g * 255),
        b: Math.round(b * 255)
    };
}

function rgb2rgbString(rgb) {
    return 'rgb(' + [rgb.r, rgb.g, rgb.b].join(',') + ')';
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["helpers"]) window._kiwi_exports["helpers"] = {};
window._kiwi_exports["helpers"]["Colours"]
window._kiwi_exports.helpers.Colours = exports.default ? exports.default : exports;


/***/ }),

/***/ "3vWw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-startup-common",class:[
    _vm.closing ? 'kiwi-startup-common--closing' : '',
    _vm.backgroundImage ? '' : 'kiwi-startup-common--no-bg' ],style:(_vm.backgroundStyle)},[_c('div',{staticClass:"kiwi-startup-common-section kiwi-startup-common-section-connection"},[_vm._t("connection")],2),_vm._v(" "),_c('div',{staticClass:"kiwi-startup-common-section kiwi-startup-common-section-info",style:(_vm.backgroundStyle)},[(_vm.infoContent)?_c('div',{staticClass:"kiwi-startup-common-section-info-content",domProps:{"innerHTML":_vm._s(_vm.infoContent)}}):_vm._e()])])}
var staticRenderFns = []


/***/ }),

/***/ "41g1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NicklistUser_vue__ = __webpack_require__("/xsI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NicklistUser_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NicklistUser_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NicklistUser_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NicklistUser_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7711dc34_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NicklistUser_vue__ = __webpack_require__("J3Dr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("6ONy")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NicklistUser_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7711dc34_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NicklistUser_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7711dc34_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NicklistUser_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "4GHs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4Ost":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['buffer', 'network'],
    data: function data() {
        return {
            forceLoader: false
        };
    },

    computed: {
        netStatus: function netStatus() {
            return this.buffer.getNetwork().state;
        },
        shouldShowLoading: function shouldShowLoading() {
            this.maybeForceLoader();

            if (this.network.state !== 'disconnected' || this.forceLoader) {
                return true;
            }

            return false;
        },
        restrictedServer: function restrictedServer() {
            return this.$state.setting('restricted');
        }
    },
    methods: {
        maybeForceLoader: function maybeForceLoader() {
            var _this = this;

            var minimumLoaderViewtime = 2000;
            var networkState = this.network.state;

            if (networkState !== 'disconnected' && !this.forceLoader) {
                this.forceLoader = true;
                setTimeout(function () {
                    _this.forceLoader = false;
                }, minimumLoaderViewtime);
            }
        },
        isChannel: function isChannel() {
            return this.buffer.isChannel();
        },
        isServer: function isServer() {
            return this.buffer.isServer();
        },
        isQuery: function isQuery() {
            return this.buffer.isQuery();
        },
        reconnect: function reconnect() {
            if (this.buffer.isChannel()) {
                this.buffer.enabled = true;
            }
            this.buffer.getNetwork().ircClient.connect();
        },
        showNetworkSettings: function showNetworkSettings() {
            var network = this.buffer.getNetwork();
            network.showServerBuffer('settings');
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["NotConnected"]
window._kiwi_exports.components.NotConnected = exports.default ? exports.default : exports;


/***/ }),

/***/ "4W31":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-mediaviewer"},[_c('div',{staticClass:"kiwi-mediaviewer-controls"},[_c('a',{staticClass:"u-button u-button-warning kiwi-mediaviewer-controls-close",on:{"click":_vm.closeViewer}},[_c('i',{staticClass:"fa fa-window-close",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('div',{key:_vm.url},[(_vm.isIframe)?_c('iframe',{staticClass:"kiwi-mediaviewer-iframe",attrs:{"src":_vm.url}}):(_vm.component)?_c(_vm.component,{tag:"component"}):_c('a',{staticClass:"kiwi-embedly-card",attrs:{"href":_vm.url,"data-card-key":_vm.embedlyKey,"data-card-chrome":"0","data-card-controls":"0","data-card-recommend":"0"}},[_vm._v(_vm._s(_vm.$t('media_loading', {url: _vm.url})))])],1)])}
var staticRenderFns = []


/***/ }),

/***/ "4eMz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
    Element.prototype.closest = function closest(s) {
        var el = this;
        do {
            if (el.matches(s)) {
                return el;
            }
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}

/***/ }),

/***/ "4fNz":
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),

/***/ "4plz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"u-input-prompt",style:({display: _vm.block ? 'block' : 'inline-block'})},[(_vm.state==='pre')?_c('div',{on:{"click":_vm.prompt}},[_vm._t("default")],2):_vm._e(),_vm._v(" "),(_vm.state==='prompt')?_c('form',{staticClass:"u-form",on:{"submit":function($event){$event.preventDefault();return _vm.complete($event)}}},[_c('span',{staticClass:"u-input-prompt-label"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{staticClass:"u-input-prompt-inputs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"u-input",domProps:{"value":(_vm.value)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.cancel($event)},"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}}),_vm._v(" "),_c('a',{staticClass:"u-button u-button-primary",on:{"click":_vm.complete}},[_vm._v(_vm._s(_vm.$t('ok')))]),_vm._v(" "),(!_vm.hideCancel)?_c('a',{staticClass:"u-button u-button-warning",on:{"click":_vm.cancel}},[_vm._v("\n                "+_vm._s(_vm.$t('cancel'))+"\n            ")]):_vm._e()])]):_vm._e()])}
var staticRenderFns = []


/***/ }),

/***/ "4wvX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Bi3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Q5w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5nmk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BufferSettings_vue__ = __webpack_require__("MkT/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BufferSettings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BufferSettings_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BufferSettings_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BufferSettings_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_002ea538_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BufferSettings_vue__ = __webpack_require__("mRrz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("fg1i")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BufferSettings_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_002ea538_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BufferSettings_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_002ea538_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BufferSettings_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "60/t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6ONy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6r9D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-statebrowser-usermenu",class:[_vm.is_usermenu_open?'kiwi-statebrowser-usermenu--open':'']},[_c('div',{staticClass:"kiwi-statebrowser-usermenu-avatar",class:[_vm.isConnected ?
            'kiwi-statebrowser-usermenu-avatar--connected' :
            'kiwi-statebrowser-usermenu-avatar--disconnected'
        ],on:{"click":function($event){_vm.is_usermenu_open=!_vm.is_usermenu_open}}},[_vm._v("\n        "+_vm._s(_vm.userInitial)+"\n        "),(_vm.network && _vm.network.state === 'connected')?_c('away-status-indicator',{attrs:{"network":_vm.network,"user":_vm.getUser,"toggle":false}}):_vm._e()],1),_vm._v(" "),(_vm.is_usermenu_open)?_c('div',{staticClass:"kiwi-statebrowser-usermenu-body"},[_c('p',[_vm._v(" "+_vm._s(_vm.$t('state_remembered'))+" ")]),_vm._v(" "),_c('a',{staticClass:"u-link",on:{"click":_vm.clickForget}},[_vm._v(_vm._s(_vm.$t('state_forget')))]),_vm._v(" "),_c('div',{staticClass:"kiwi-close-icon",on:{"click":function($event){_vm.is_usermenu_open=false}}},[_c('i',{staticClass:"fa fa-times",attrs:{"aria-hidden":"true"}})])]):_c('div',{staticClass:"kiwi-statebrowser-usermenu-network"},[_vm._v("\n        "+_vm._s(_vm.networkName)+"\n    ")])])}
var staticRenderFns = []


/***/ }),

/***/ "6t4W":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _values = __webpack_require__("gRE1");

var _values2 = _interopRequireDefault(_values);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _TypingStatusIndicator = __webpack_require__("Qf21");

var _TypingStatusIndicator2 = _interopRequireDefault(_TypingStatusIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        TypingStatusIndicator: _TypingStatusIndicator2.default
    },
    props: ['buffer'],
    computed: {
        users: function users() {
            if (this.buffer.isQuery()) {
                var network = this.$state.getActiveNetwork();
                var user = this.$state.getUser(network.id, this.buffer.name);
                return user ? (0, _defineProperty3.default)({}, user.nick, user) : {};
            }
            return this.buffer.users;
        },
        typingUsers: function typingUsers() {
            var _this = this;

            var myNick = this.$state.getActiveNetwork().nick;
            return (0, _values2.default)(this.users).filter(function (u) {
                return u.nick !== myNick && u.typingStatus(_this.buffer.name).status;
            });
        }
    },
    methods: {
        userColour: function userColour(user) {
            return user && this.buffer.setting('colour_nicknames_in_messages') ? user.getColour() : '';
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["TypingUsersList"]
window._kiwi_exports.components.TypingUsersList = exports.default ? exports.default : exports;


/***/ }),

/***/ "6vhI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7DgK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.orderBuffers = orderBuffers;
exports.getNextBuffer = getNextBuffer;
exports.getPreviousBuffer = getPreviousBuffer;

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _state = __webpack_require__("LnP8");

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function orderBuffers(buffers) {
    var list = buffers.map(function (b) {
        return b;
    });

    list = _lodash2.default.filter(list, function (buffer) {
        return !buffer.isServer();
    });
    list = list.sort(function (a, b) {
        var order = 0;
        if (a.isChannel() && b.isQuery()) {
            order = -1;
        } else if (a.isQuery() && b.isChannel()) {
            order = 1;
        } else {
            order = a.name.localeCompare(b.name);
        }

        return order;
    });

    return list;
}

function getNextBuffer() {
    return getBufferFromDirection(1);
}

function getPreviousBuffer() {
    return getBufferFromDirection(-1);
}

function getBufferFromDirection(direction) {
    var network = _state2.default.getActiveNetwork();
    var buffer = _state2.default.getActiveBuffer();

    if (!network || !buffer) {
        return null;
    }

    var ordered = orderBuffers(network.buffers);
    var index = _lodash2.default.findIndex(ordered, ['name', buffer.name]) + direction;

    if (index >= ordered.length || index < 0) {
        network = getNetworkFromDirection(direction);
        ordered = orderBuffers(network.buffers);
        buffer = direction === 1 ? ordered[0] : ordered[ordered.length - 1];
    } else {
        buffer = ordered[index];
    }
    return buffer;
}

function getNetworkFromDirection(direction) {
    var network = _state2.default.getActiveNetwork();
    for (var i = 0; i < _state2.default.networks.length; i++) {
        var index = _lodash2.default.findIndex(_state2.default.networks, ['id', network.id]) + direction;

        if (index >= _state2.default.networks.length && _state2.default.networks.length >= 0) {
            network = _state2.default.networks[0];
        } else if (index < 0) {
            network = _state2.default.networks[_state2.default.networks.length - 1];
        } else {
            network = _state2.default.networks[index];
        }
        if (network.buffers.length > 1) {
            return network;
        }
    }
    return network;
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["bufferTools"]
window._kiwi_exports.libs.bufferTools = exports.default ? exports.default : exports;


/***/ }),

/***/ "7Ud/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _state = __webpack_require__("LnP8");

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            closing: false
        };
    },

    computed: {
        backgroundStyle: function backgroundStyle() {
            var style = {};
            var options = _state2.default.settings.startupOptions;

            if (options.infoBackground) {
                style['background-image'] = 'url(' + options.infoBackground + ')';
            }
            return style;
        },
        backgroundImage: function backgroundImage() {
            return _state2.default.settings.startupOptions.infoBackground || '';
        },
        infoContent: function infoContent() {
            return _state2.default.settings.startupOptions.infoContent || '';
        }
    },
    methods: {
        close: function close() {
            var _this = this;

            this.closing = true;
            var startApp = function startApp(event) {
                _this.$el.removeEventListener('transitionend', startApp);
                _state2.default.persistence.watchStateForChanges();

                _this.$parent.$emit('start');
            };

            this.$el.addEventListener('transitionend', startApp, false);
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["startups"]) window._kiwi_exports["components"]["startups"] = {};
window._kiwi_exports["components"]["startups"]["CommonLayout"]
window._kiwi_exports.components.startups.CommonLayout = exports.default ? exports.default : exports;


/***/ }),

/***/ "7hSk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WindowTitle = function () {
    function WindowTitle(state) {
        var _this = this;

        (0, _classCallCheck3.default)(this, WindowTitle);

        this.state = state;
        this.title = state.settings.windowTitle || '';
        this.alert = false;

        if (state.settings.windowTitle) {
            this.updateTitle();
        }

        state.$watch('settings.windowTitle', function (newVal) {
            _this.updateTitle(newVal);
        });

        state.$watch('ui.app_has_focus', function (newVal) {
            if (newVal && _this.alertTmr) {
                _this.stopAlert();
            }
        });

        state.$on('notification.title', function (enable) {
            if (enable) {
                _this.startAlert();
            } else {
                _this.stopAlert();
            }
        });
    }

    (0, _createClass3.default)(WindowTitle, [{
        key: 'startAlert',
        value: function startAlert() {
            var _this2 = this;

            if (this.alertTmr) {
                return;
            }

            this.alertTmr = setInterval(function () {
                _this2.updateTitle();
            }, 1000);
        }
    }, {
        key: 'stopAlert',
        value: function stopAlert() {
            if (this.alertTmr) {
                clearInterval(this.alertTmr);
                this.alertTmr = null;
            }

            this.updateTitle();
        }
    }, {
        key: 'updateTitle',
        value: function updateTitle(newTitle) {
            if (typeof newTitle === 'string') {
                this.title = newTitle;
            }

            if (this.alertTmr && !this.alert) {
                window.document.title = '* ' + this.title;
                this.alert = true;
            } else {
                window.document.title = this.title;
                this.alert = false;
            }
        }
    }]);
    return WindowTitle;
}();

exports.default = WindowTitle;

/***/ }),

/***/ "7p2c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _MessageParser = __webpack_require__("wXH7");

var _MessageParser2 = _interopRequireDefault(_MessageParser);

var _Html = __webpack_require__("Nbm2");

var _Html2 = _interopRequireDefault(_Html);

var _GlobalApi = __webpack_require__("Uvbb");

var _GlobalApi2 = _interopRequireDefault(_GlobalApi);

var _state = __webpack_require__("LnP8");

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var nextId = 0;

var Message = function () {
    function Message(message, user) {
        (0, _classCallCheck3.default)(this, Message);

        this.id = extractMessageId(message) || nextId++;

        this.time = message.time || Date.now();
        this.server_time = message.server_time || this.time;
        this.nick = message.nick;
        this.message = message.message;
        this.tags = message.tags;
        this.type = message.type || 'message';
        this.type_extra = message.type_extra;
        this.ignore = false;
        this.mentioned_urls = [];
        this.html = '';

        this.template = message.template || null;

        this.bodyTemplate = message.bodyTemplate || null;
        this.isHighlight = false;

        Object.defineProperty(this, 'user', { value: user });
    }

    (0, _createClass3.default)(Message, [{
        key: 'render',
        value: function render() {
            _GlobalApi2.default.singleton().emit('message.render', { message: this });
            return this;
        }
    }, {
        key: 'toHtml',
        value: function toHtml(messageList) {
            if (this.html) {
                return this.html;
            }

            var showEmoticons = _state2.default.setting('buffers.show_emoticons') && !messageList.buffer.isSpecial();
            var userList = messageList.buffer.users;
            var useExtraFormatting = !messageList.buffer.isSpecial() && messageList.useExtraFormatting && this.type === 'privmsg';

            var blocks = (0, _MessageParser2.default)(this.message, { extras: useExtraFormatting }, userList);

            _state2.default.$emit('message.prestyle', { message: this, blocks: blocks });

            var content = (0, _Html2.default)(blocks, showEmoticons);

            this.mentioned_urls = blocks.filter(function (block) {
                return block.type === 'url';
            }).map(function (block) {
                return block.meta.url;
            });
            this.html = content;

            _state2.default.$emit('message.poststyle', { message: this, blocks: blocks });
            return this.html;
        }
    }]);
    return Message;
}();

exports.default = Message;


function extractMessageId(message) {
    if (!message.tags) {
        return undefined;
    }

    return message.tags.msgid || message.tags['draft/msgid'] || undefined;
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["Message"]
window._kiwi_exports.libs.Message = exports.default ? exports.default : exports;


/***/ }),

/***/ "8LRQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _state = __webpack_require__("LnP8");

var _state2 = _interopRequireDefault(_state);

var _Misc = __webpack_require__("uN9+");

var Misc = _interopRequireWildcard(_Misc);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            title: 'Where are you connecting today?',
            buttonText: '',
            server_type: 'default',
            server: '',
            tls: false,
            nick: '',
            password: '',
            encoding: 'utf8',
            channel: '',
            znc_network: '',
            znc_network_support: true,
            direct: false,
            direct_path: '',
            show_type_switcher: true,
            show_password_box: false,
            is_connecting: false,
            network: null
        };
    },
    created: function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            var saveThisSessionsState, network, fragment, uriCheck, connections, con;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            saveThisSessionsState = false;

                            if (_state2.default.networks.length > 0) {
                                network = _state2.default.networks[0];

                                _state2.default.setActiveBuffer(network.id, network.serverBuffer().name);
                                saveThisSessionsState = true;
                                this.$emit('start');
                            } else if (window.location.hash.substr(1)) {
                                fragment = window.location.hash.substr(1);
                                uriCheck = fragment.substr(0, 7).toLowerCase();

                                if (uriCheck === 'ircs%3a' || uriCheck.substr(0, 6) === 'irc%3a') {
                                    fragment = decodeURIComponent(fragment);
                                }

                                connections = Misc.parseIrcUri(fragment);

                                if (connections.length === 0) {
                                    saveThisSessionsState = true;
                                    this.applyDefaults();
                                } else if (connections.length === 1) {
                                    saveThisSessionsState = false;
                                    this.server_type = 'default_simple';
                                    this.show_type_switcher = false;

                                    con = connections[0];

                                    this.server = con.server + ':' + con.port;
                                    this.tls = con.tls;
                                    this.nick = this.processNickRandomNumber(con.nick);
                                    this.channel = con.channels.join(',');
                                    this.direct = con.direct;
                                    this.encoding = con.encoding;

                                    if (con.params.type === 'znc') {
                                        if (con.params.network === '_') {
                                            this.znc_network_support = false;
                                        } else {
                                            this.znc_network = con.params.network || '';
                                        }
                                        this.server_type = 'znc';
                                        this.title = 'Enter your password to connect to ZNC';
                                    } else {
                                        this.title = 'Enter a nickname to join';
                                    }
                                } else if (connections.length > 1) {
                                    saveThisSessionsState = false;

                                    connections.forEach(function (con, idx) {
                                        var net = _state2.default.addNetwork(con.server, con.nick, {
                                            server: con.server,
                                            port: con.port,
                                            tls: con.tls,
                                            password: con.password || ''
                                        });

                                        con.channels.forEach(function (channelName) {
                                            var buffer = _state2.default.addBuffer(net.id, channelName);
                                            buffer.enabled = true;
                                        });

                                        if (idx === 0) {
                                            _state2.default.setActiveBuffer(net.id, net.serverBuffer().name);
                                        }
                                    });

                                    this.$emit('start');
                                }
                            } else {
                                saveThisSessionsState = true;
                                this.applyDefaults();
                            }

                            if (_state2.default.settings.startupOptions.greetingText) {
                                this.title = _state2.default.settings.startupOptions.greetingText;
                            }
                            if (_state2.default.settings.startupOptions.buttonText) {
                                this.buttonText = _state2.default.settings.startupOptions.buttonText;
                            } else {
                                this.buttonText = this.$t('connect');
                            }

                            if (saveThisSessionsState) {
                                _state2.default.persistence.watchStateForChanges();
                            }

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function created() {
            return _ref.apply(this, arguments);
        }

        return created;
    }(),
    methods: {
        readableStateError: function readableStateError(err) {
            return Misc.networkErrorMessage(err);
        },

        startUp: function startUp() {
            var _this = this;

            var net = void 0;

            if (!this.nick) {
                this.$el.querySelector('.kiwi-customserver-nick input').focus();
                return;
            }

            var nick = this.nick;

            if (this.server_type === 'znc') {
                var password = nick;
                if (this.znc_network) {
                    password += '/' + this.znc_network;
                }
                password += ':' + this.password;

                net = _state2.default.addNetwork('ZNC', 'ZNC', {
                    server: this.server.split(':')[0],
                    port: parseInt(this.server.split(':')[1] || 6667, 10),
                    tls: this.tls,
                    password: password
                });
            } else {
                net = _state2.default.addNetwork('Network', nick, {
                    server: this.server.split(':')[0],
                    port: parseInt(this.server.split(':')[1] || 6667, 10),
                    tls: this.tls,
                    password: this.password,
                    direct: this.direct,
                    path: this.direct_path,
                    encoding: this.encoding
                });
            }

            if (net) {
                var hasSetActiveBuffer = false;

                var bufferObjs = Misc.extractBuffers(this.channel);
                bufferObjs.forEach(function (bufferObj, idx) {
                    var buffer = _state2.default.addBuffer(net.id, bufferObj.name);
                    buffer.enabled = true;

                    if (bufferObj.key) {
                        buffer.key = bufferObj.key;
                    }

                    if (idx === 0) {
                        _state2.default.setActiveBuffer(net.id, buffer.name);
                        hasSetActiveBuffer = true;
                    }
                });

                if (!hasSetActiveBuffer) {
                    _state2.default.setActiveBuffer(net.id, net.serverBuffer().name);
                }

                this.is_connecting = true;
                this.network = net;
                net.ircClient.connect();

                var onRegistered = function onRegistered() {
                    setTimeout(function () {
                        _this.is_connecting = false;
                    }, 1000);
                    _this.$emit('start');
                    net.ircClient.off('registered', onRegistered);
                    net.ircClient.off('close', onClosed);
                };
                var onClosed = function onClosed() {
                    setTimeout(function () {
                        _this.is_connecting = false;
                    }, 1000);
                    net.ircClient.off('registered', onRegistered);
                    net.ircClient.off('close', onClosed);
                };
                net.ircClient.once('registered', onRegistered);
                net.ircClient.once('close', onClosed);
            }
        },
        processNickRandomNumber: function processNickRandomNumber(nick) {
            var tmp = (nick || '').replace(/\?/g, function () {
                return Math.floor(Math.random() * 100).toString();
            });
            return _lodash2.default.trim(tmp);
        },
        infoClick: function infoClick() {
            if (this.network) {
                var net = this.network;
                _state2.default.setActiveBuffer(net.id, net.serverBuffer().name);
            }
            this.$emit('start');
        },
        applyDefaults: function applyDefaults() {
            this.server = _state2.default.settings.startupOptions.server;
            this.tls = _state2.default.settings.startupOptions.tls;
            this.nick = this.processNickRandomNumber(_state2.default.settings.startupOptions.nick);
            this.channel = _state2.default.settings.startupOptions.channel;
            this.direct = _state2.default.settings.startupOptions.direct;
            this.direct_path = _state2.default.settings.startupOptions.direct_path;
            this.encoding = _state2.default.settings.startupOptions.encoding;

            if (_state2.default.settings.startupOptions.port.toString() !== '6667') {
                this.server += ':' + _state2.default.settings.startupOptions.port.toString();
            }

            this.title = 'Where are you connecting today?';
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["startups"]) window._kiwi_exports["components"]["startups"] = {};
window._kiwi_exports["components"]["startups"]["CustomServer"]
window._kiwi_exports.components.startups.CustomServer = exports.default ? exports.default : exports;


/***/ }),

/***/ "9VuB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageListMessageCompact_vue__ = __webpack_require__("NRRm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageListMessageCompact_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageListMessageCompact_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageListMessageCompact_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageListMessageCompact_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_192fe77e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageListMessageCompact_vue__ = __webpack_require__("SB1V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("0WfI")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageListMessageCompact_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_192fe77e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageListMessageCompact_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_192fe77e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageListMessageCompact_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "9YrO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextStyle_vue__ = __webpack_require__("2xp5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextStyle_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextStyle_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextStyle_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextStyle_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ec228d8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextStyle_vue__ = __webpack_require__("c0Nt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("0MsN")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextStyle_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ec228d8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextStyle_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ec228d8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextStyle_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "9doY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9myz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _create = __webpack_require__("OvRC");

var _create2 = _interopRequireDefault(_create);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _xhr = __webpack_require__("1Xk4");

var _xhr2 = _interopRequireDefault(_xhr);

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _json = __webpack_require__("D1Ni");

var _json2 = _interopRequireDefault(_json);

var _Logger = __webpack_require__("XNCV");

var _Logger2 = _interopRequireDefault(_Logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = _Logger2.default.namespace('ConfigLoader');

var ConfigLoader = function () {
    function ConfigLoader() {
        (0, _classCallCheck3.default)(this, ConfigLoader);

        this.config = (0, _create2.default)(null);
        this.valReplacements = (0, _create2.default)(null);
    }

    (0, _createClass3.default)(ConfigLoader, [{
        key: 'addValueReplacement',
        value: function addValueReplacement(key, value) {
            this.valReplacements[key] = value;
            return this;
        }
    }, {
        key: 'loadFromUrl',
        value: function loadFromUrl(configUrl) {
            var _this = this;

            return new _promise2.default(function (resolve, reject) {
                (0, _xhr2.default)({ url: configUrl }, function (err, response) {
                    if (err) {
                        reject();
                        return;
                    }

                    var configObj = null;
                    try {
                        configObj = _json2.default.parse(response.body);
                    } catch (parseErr) {
                        log.error('Config ' + parseErr.message);
                        var errMsg = 'Config file error: ' + parseErr.message.replace('JSON5: ', '');

                        errMsg = errMsg.replace(/at (\d+):(\d+)/g, function (m, m1, m2) {
                            return 'line ' + m1 + ', position ' + m2;
                        });
                        reject(errMsg);
                        return;
                    }

                    _this.setConfig(configObj);
                    resolve(_this.config);
                });
            });
        }
    }, {
        key: 'loadFromObj',
        value: function loadFromObj(configObj) {
            var _this2 = this;

            return new _promise2.default(function (resolve, reject) {
                _this2.setConfig(configObj);
                resolve(_this2.config);
            });
        }
    }, {
        key: 'setConfig',
        value: function setConfig(confObj) {
            var _this3 = this;

            var walkObject = function walkObject(obj, target) {
                _lodash2.default.each(obj, function (_val, key) {
                    var val = _val;
                    if (typeof val === 'string') {
                        val = _this3.insertReplacements(val);
                        target[key] = val;
                    } else if ((typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)) === 'object') {
                        target[key] = _lodash2.default.isArray(val) ? [] : {};
                        walkObject(val, target[key]);
                    } else {
                        target[key] = val;
                    }
                });
            };

            this.config = (0, _create2.default)(null);
            walkObject(confObj, this.config);
        }
    }, {
        key: 'insertReplacements',
        value: function insertReplacements(input) {
            var _this4 = this;

            var out = input;
            (0, _keys2.default)(this.valReplacements).forEach(function (k) {
                out = out.replace('{{' + k + '}}', _this4.valReplacements[k]);
            });
            return out;
        }
    }]);
    return ConfigLoader;
}();

exports.default = ConfigLoader;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["ConfigLoader"]
window._kiwi_exports.libs.ConfigLoader = exports.default ? exports.default : exports;


/***/ }),

/***/ "9x9Q":
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Acirc":"Â","acirc":"â","acute":"´","AElig":"Æ","aelig":"æ","Agrave":"À","agrave":"à","amp":"&","AMP":"&","Aring":"Å","aring":"å","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","brvbar":"¦","Ccedil":"Ç","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","COPY":"©","curren":"¤","deg":"°","divide":"÷","Eacute":"É","eacute":"é","Ecirc":"Ê","ecirc":"ê","Egrave":"È","egrave":"è","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","GT":">","Iacute":"Í","iacute":"í","Icirc":"Î","icirc":"î","iexcl":"¡","Igrave":"Ì","igrave":"ì","iquest":"¿","Iuml":"Ï","iuml":"ï","laquo":"«","lt":"<","LT":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","Ntilde":"Ñ","ntilde":"ñ","Oacute":"Ó","oacute":"ó","Ocirc":"Ô","ocirc":"ô","Ograve":"Ò","ograve":"ò","ordf":"ª","ordm":"º","Oslash":"Ø","oslash":"ø","Otilde":"Õ","otilde":"õ","Ouml":"Ö","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\"","QUOT":"\"","raquo":"»","reg":"®","REG":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","THORN":"Þ","thorn":"þ","times":"×","Uacute":"Ú","uacute":"ú","Ucirc":"Û","ucirc":"û","Ugrave":"Ù","ugrave":"ù","uml":"¨","Uuml":"Ü","uuml":"ü","Yacute":"Ý","yacute":"ý","yen":"¥","yuml":"ÿ"}

/***/ }),

/***/ "ADMw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _isNan = __webpack_require__("MICi");

var _isNan2 = _interopRequireDefault(_isNan);

var _toConsumableArray2 = __webpack_require__("Gu7T");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _TextFormatting = __webpack_require__("15gS");

var TextFormatting = _interopRequireWildcard(_TextFormatting);

var _Misc = __webpack_require__("uN9+");

var Misc = _interopRequireWildcard(_Misc);

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _AliasRewriter = __webpack_require__("XFo2");

var _AliasRewriter2 = _interopRequireDefault(_AliasRewriter);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var inputCommands = {};

var InputHandler = function () {
    function InputHandler(state) {
        var _this = this;

        (0, _classCallCheck3.default)(this, InputHandler);

        this.state = state;
        this.aliasRewriter = new _AliasRewriter2.default();

        this.aliasRewriter.importFromString(state.setting('aliases'));

        state.$watch('user_settings.aliases', function (newVal) {
            _this.aliasRewriter.importFromString(state.setting('aliases'));
        });

        this.listenForInput();
    }

    (0, _createClass3.default)(InputHandler, [{
        key: 'defaultContext',
        value: function defaultContext() {
            return {
                network: this.state.getActiveNetwork(),
                buffer: this.state.getActiveBuffer()
            };
        }
    }, {
        key: 'validateContext',
        value: function validateContext(context) {
            if ((typeof context === 'undefined' ? 'undefined' : (0, _typeof3.default)(context)) !== 'object' || !Object.prototype.hasOwnProperty.call(context, 'buffer') || !Object.prototype.hasOwnProperty.call(context, 'network') || (0, _typeof3.default)(context.buffer) !== 'object' || (0, _typeof3.default)(context.network) !== 'object') {
                throw new TypeError('context must contain both network and buffer properties');
            }
        }
    }, {
        key: 'listenForInput',
        value: function listenForInput() {
            var _this2 = this;

            this.state.$on('input.raw', function (input) {
                var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this2.defaultContext();

                var lines = input.split('\n');
                lines.forEach(function (line) {
                    return _this2.processLine(line, context);
                });
            });
        }
    }, {
        key: 'processLine',
        value: function processLine(rawLine) {
            var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.defaultContext();

            this.validateContext(context);
            var network = context.network,
                buffer = context.buffer;

            var line = rawLine;
            var stylesStrippedLine = Misc.stripStyles(line);

            var escapedCommand = stylesStrippedLine.substr(0, 2) === '//';
            if (stylesStrippedLine[0] !== '/' || escapedCommand) {
                if (escapedCommand) {
                    line = line.substr(1);
                }

                if (buffer.isServer()) {
                    line = '/quote ' + line;
                } else {
                    line = '/msg ' + buffer.name + ' ' + line;
                }
            } else if (stylesStrippedLine[0] === '/' && line[0] !== '/') {
                line = stylesStrippedLine;
            }

            var aliasVars = {
                network: network.name,
                server: network.connection.server,
                channel: network.isChannelName(buffer.name) ? buffer.name : '',
                query: network.isChannelName(buffer.name) ? '' : buffer.name,
                destination: buffer.name,
                nick: network.nick
            };
            line = this.aliasRewriter.process(line, aliasVars);

            if (!line) {
                return;
            }

            line = line.substr(1);

            var spaceIdx = line.indexOf(' ');
            if (spaceIdx === -1) spaceIdx = line.length;

            var command = line.substr(0, spaceIdx);
            var params = line.substr(spaceIdx + 1);

            var eventObj = {
                handled: false,
                raw: rawLine,
                command: command,
                params: params
            };

            this.state.$emit('input.command.' + command, eventObj, command, params);
            if (eventObj.handled) {
                return;
            }

            if (inputCommands[command.toLowerCase()]) {
                inputCommands[command.toLowerCase()].call(this, eventObj, command, params);
            }

            if (!eventObj.handled) {
                network.ircClient.raw(line);
            }
        }
    }]);
    return InputHandler;
}();

exports.default = InputHandler;

inputCommands.lines = function inputCommandLines(event, command, line) {
    var _this3 = this;

    event.handled = true;

    line.split('|').forEach(function (subLine) {
        _this3.processLine(subLine.trim());
    });
};

function handleMessage(type, event, command, line) {
    event.handled = true;

    var network = this.state.getActiveNetwork();

    var spaceIdx = line.indexOf(' ');
    if (spaceIdx === -1) spaceIdx = line.length;

    var bufferName = line.substr(0, spaceIdx);
    var message = line.substr(spaceIdx + 1);

    if (!message) {
        return;
    }

    var localBuffer = bufferName;
    var extractedTarget = network.ircClient.network.extractTargetGroup(bufferName);
    if (extractedTarget) {
        localBuffer = extractedTarget.target;
    }

    var buffer = localBuffer.length && this.state.getOrAddBufferByName(network.id, localBuffer);
    if (buffer) {
        var textFormatType = 'privmsg';
        if (type === 'action') {
            textFormatType = 'action';
        } else if (type === 'notice') {
            textFormatType = 'notice';
        }

        var messageBody = TextFormatting.formatText(textFormatType, {
            nick: network.nick,
            text: message
        });

        var newMessage = {
            time: Date.now(),
            nick: network.nick,
            message: messageBody,
            type: type
        };

        this.state.addMessage(buffer, newMessage);
    }

    var fnNames = {
        privmsg: 'say',
        action: 'action',
        notice: 'notice'
    };
    var fnName = fnNames[type] || 'say';
    network.ircClient[fnName](bufferName, message);
}

inputCommands.msg = function inputCommandMsg(event, command, line) {
    handleMessage.call(this, 'privmsg', event, command, line);
};
inputCommands.action = function inputCommandMsg(event, command, line) {
    handleMessage.call(this, 'action', event, command, line);
};
inputCommands.notice = function inputCommandMsg(event, command, line) {
    handleMessage.call(this, 'notice', event, command, line);
};
inputCommands.dice = function inputCommandDice(event, command, line) {
    var buffer = this.state.getActiveBuffer();
    var network = this.state.getActiveNetwork();

    var sides = line.replace(/\D/g, '');
    sides = parseInt(sides || '0', 10);
    if (sides <= 0) {
        sides = 6;
    }
    var rndNumber = Math.floor(Math.random() * sides) + 1;

    var msg = TextFormatting.t('dice_roll', {
        sides: TextFormatting.formatNumber(sides),
        number: TextFormatting.formatNumber(rndNumber)
    });
    network.ircClient.action(buffer.name, msg);
    this.state.addMessage(buffer, {
        nick: network.nick,
        message: msg,
        type: 'action'
    });
};

inputCommands.ctcp = function inputCommandCtcp(event, command, line) {
    var _network$ircClient;

    event.handled = true;

    var params = line.split(' ');
    var target = params.shift();
    var ctcpType = params.shift();

    if (!ctcpType || !target) {
        return;
    }

    var network = this.state.getActiveNetwork();
    (_network$ircClient = network.ircClient).ctcpRequest.apply(_network$ircClient, (0, _toConsumableArray3.default)([target, ctcpType].concat(params)));
};

inputCommands.join = function inputCommandJoin(event, command, line) {
    var _this4 = this;

    event.handled = true;

    var network = this.state.getActiveNetwork();
    var bufferObjs = Misc.extractBuffers(line);

    if (bufferObjs.length === 0) {
        var buffer = this.state.getActiveBuffer();

        if (buffer.isChannel() && !buffer.joined) {
            network.ircClient.join(buffer.name, buffer.key);
            return;
        }

        this.state.addMessage(buffer, {
            nick: '*',
            message: TextFormatting.t('error_no_channel_join'),
            type: 'error'
        });
        return;
    }

    var hasSwitchedActiveBuffer = false;
    bufferObjs.forEach(function (bufferObj, idx) {
        if (bufferObj.name === '0') {
            return;
        }

        var chanName = network.isChannelName(bufferObj.name) ? bufferObj.name : '#' + bufferObj.name;

        var newBuffer = _this4.state.addBuffer(network.id, chanName);

        if (newBuffer && !hasSwitchedActiveBuffer) {
            _this4.state.setActiveBuffer(network.id, newBuffer.name);
            hasSwitchedActiveBuffer = true;
        }

        if (bufferObj.key) {
            newBuffer.key = bufferObj.key;
        }

        network.ircClient.join(chanName, bufferObj.key);
    });
};

inputCommands.part = function inputCommandPart(event, command, line) {
    event.handled = true;

    var network = this.state.getActiveNetwork();
    var bufferNames = [];
    var message = '';

    if (line === '') {
        bufferNames = [this.state.getActiveBuffer().name];
    } else {
        var lineParts = line.split(' ');
        if (network.isChannelName(lineParts[0])) {
            bufferNames = _lodash2.default.compact(lineParts[0].split(','));
            message = lineParts.slice(1).join(' ');
        } else {
            bufferNames = [this.state.getActiveBuffer().name];
            message = line;
        }
    }

    bufferNames.forEach(function (bufferName) {
        network.ircClient.part(bufferName, message);
    });
};

inputCommands.quit = function inputCommandQuit(event, command, line) {
    event.handled = true;

    var network = this.state.getActiveNetwork();
    network.ircClient.quit(line);
};

inputCommands.topic = function inputCommandTopic(event, command, line) {
    event.handled = true;

    var network = this.state.getActiveNetwork();
    var bufferName = '';
    var newTopic = '';

    if (line === '') {
        return;
    }

    var lineParts = line.split(' ');
    if (network.isChannelName(lineParts[0])) {
        bufferName = lineParts[0];
        newTopic = lineParts.slice(1).join(' ');
    } else {
        bufferName = this.state.getActiveBuffer().name;
        newTopic = line;
    }

    network.ircClient.setTopic(bufferName, newTopic);
};

inputCommands.kick = function inputCommandKick(event, command, line) {
    event.handled = true;

    var network = this.state.getActiveNetwork();
    var toKick = '';
    var bufferName = '';
    var kickReason = '';

    if (line === '') {
        return;
    }

    var lineParts = line.split(' ');

    if (network.isChannelName(lineParts[0])) {
        bufferName = lineParts.shift();
    }

    toKick = lineParts.shift();
    kickReason = lineParts.join(' ');

    if (!bufferName) {
        bufferName = this.state.getActiveBuffer().name;
    }
    if (!toKick) {
        return;
    }

    network.ircClient.raw('KICK', bufferName, toKick, kickReason);
};

inputCommands.ignore = function inputCommandIgnore(event, command, line) {
    event.handled = true;

    var network = this.state.getActiveNetwork();
    var toIgnore = line.split(' ').shift();

    if (!toIgnore) {
        return;
    }

    var user = this.state.getUser(network.id, toIgnore);
    if (user) {
        user.ignore = true;
        var buffer = this.state.getActiveBuffer();
        this.state.addMessage(buffer, {
            nick: '*',
            message: 'Ignoring ' + user.nick,
            type: 'message'
        });
    }
};

inputCommands.unignore = function inputCommandUnignore(event, command, line) {
    event.handled = true;

    var network = this.state.getActiveNetwork();
    var toUnignore = line.split(' ').shift();

    if (!toUnignore) {
        return;
    }

    var user = this.state.getUser(network.id, toUnignore);
    if (user) {
        user.ignore = false;
        var buffer = this.state.getActiveBuffer();
        this.state.addMessage(buffer, {
            nick: '*',
            message: 'No longer ignoring ' + user.nick,
            type: 'message'
        });
    }
};

inputCommands.close = function inputCommandClose(event, command, line) {
    var _this5 = this;

    event.handled = true;

    var network = this.state.getActiveNetwork();
    var bufferNames = _lodash2.default.compact(line.split(/[, ]/));
    if (bufferNames.length === 0) {
        bufferNames = [this.state.getActiveBuffer().name];
    }

    bufferNames.forEach(function (bufferName) {
        var buffer = network.bufferByName(bufferName);
        if (!buffer) {
            return;
        }

        _this5.state.removeBuffer(buffer);
    });
};

inputCommands.query = function inputCommandQuery(event, command, line) {
    event.handled = true;

    var pos = line.indexOf(' ');
    if (pos === -1) {
        pos = line.length;
    }

    var nick = line.substr(0, pos);
    var message = line.substr(pos + 1);

    var network = this.state.getActiveNetwork();
    var buffer = this.state.getOrAddBufferByName(network.id, nick);

    this.state.setActiveBuffer(network.id, buffer.name);

    if (message) {
        this.state.$emit('input.raw', '/msg ' + buffer.name + ' ' + message);
    }
};

inputCommands.invite = function inputCommandInvite(event, command, line) {
    event.handled = true;

    var network = this.state.getActiveNetwork();
    var buffer = this.state.getActiveBuffer();

    var lineParts = line.split(' ');
    var nick = lineParts.shift();
    var channel = lineParts.shift();

    if (!channel) {
        channel = buffer.name;
    }

    if (!network.isChannelName(channel)) {
        return;
    }

    network.ircClient.raw('INVITE', nick, channel);
    this.state.addMessage(buffer, {
        nick: '*',
        message: 'Invited ' + nick + ' to ' + channel,
        type: 'message'
    });
};

inputCommands.nick = function inputCommandNick(event, command, line) {
    event.handled = true;

    var spaceIdx = line.indexOf(' ');
    if (spaceIdx === -1) spaceIdx = line.length;

    var newNick = line.substr(0, spaceIdx);
    var network = this.state.getActiveNetwork();
    network.ircClient.changeNick(newNick);
};

inputCommands.away = function inputCommandAway(event, command, line) {
    event.handled = true;

    var network = this.state.getActiveNetwork();
    network.ircClient.raw('AWAY', line || 'Currently away');
};

inputCommands.back = function inputCommandAway(event, command, line) {
    event.handled = true;

    var network = this.state.getActiveNetwork();
    network.ircClient.raw('AWAY');
};

inputCommands.quote = function inputCommandQuote(event, command, line) {
    event.handled = true;

    var network = this.state.getActiveNetwork();

    if (line.split(' ')[0].toLowerCase() === 'cap') {
        network.setting('show_raw_caps', true);
    }

    var buffer = this.state.getActiveBuffer();
    if (buffer.isServer()) {
        this.state.addMessage(buffer, {
            time: Date.now(),
            nick: '',
            message: line
        });
    }

    network.ircClient.raw(line);
};

inputCommands.whois = function inputCommandWhois(event, command, line) {
    var _this6 = this;

    event.handled = true;

    var parts = line.split(' ');
    var network = this.state.getActiveNetwork();
    var buffer = this.state.getActiveBuffer();

    network.ircClient.whois(parts[0], parts[0], function (whoisData) {
        if (whoisData.error) {
            var messageBody = TextFormatting.formatText('whois_error', {
                nick: whoisData.nick,
                text: whoisData.error
            });
            _this6.state.addMessage(buffer, {
                time: Date.now(),
                nick: '',
                message: messageBody,
                type: 'error'
            });
            return;
        }

        var out = [];
        var display = function display(message) {
            if (!message) {
                return;
            }

            out.push(message);
        };
        var formats = {
            mask: 'is {{nick}}!{{user}}@{{host}} * ({{real_name}})',
            from: 'is connecting from {{actual_hostname}} {{actual_ip}}',
            channels: 'is on {{channels}}',
            server: 'is using {{server}} ({{server_info}})',
            operator: '{{operator}}',
            modes: '{{modes}}',
            account: 'is logged in as {{account}}',
            registered_nick: '{{registered_nick}}',
            secure: 'is using a secure connection',
            idle: 'has been idle for {{idle}}',
            logon: 'connected on {{logon}}',

            nick: '',
            user: '',
            ident: '',
            hostname: '',
            real_name: '',
            actual_ip: '',
            server_info: '',
            actual_hostname: ''
        };

        if (whoisData.nick && whoisData.hostname) {
            display(formats.mask.replace('{{nick}}', whoisData.nick).replace('{{user}}', whoisData.ident).replace('{{host}}', whoisData.hostname).replace('{{real_name}}', whoisData.real_name));
        }
        if (whoisData.actual_hostname && whoisData.actual_ip) {
            display(formats.from.replace('{{actual_hostname}}', whoisData.actual_hostname).replace('{{actual_ip}}', whoisData.actual_ip));
        }
        if (whoisData.channels) {
            display(formats.channels.replace('{{channels}}', whoisData.channels));
        }
        if (whoisData.server) {
            display(formats.server.replace('{{server}}', whoisData.server).replace('{{server_info}}', whoisData.server_info));
        }
        if (whoisData.operator) {
            display(formats.operator.replace('{{operator}}', whoisData.operator));
        }
        if (whoisData.modes) {
            display(formats.modes.replace('{{modes}}', whoisData.modes));
        }
        if (whoisData.account) {
            display(formats.account.replace('{{account}}', whoisData.account));
        }
        if (whoisData.registered_nick) {
            display(formats.registered_nick.replace('{{registered_nick}}', whoisData.registered_nick));
        }
        if (whoisData.secure) {
            display(formats.secure);
        }
        if (whoisData.idle) {
            var idleSeconds = Math.floor(parseInt(whoisData.idle, 10));
            display(formats.idle.replace('{{idle}}', TextFormatting.formatDuration(idleSeconds)));
        }
        if (whoisData.logon) {
            var logonTime = parseInt(whoisData.logon, 10);
            if (!(0, _isNan2.default)(logonTime)) {
                var logonDate = new Date(logonTime * 1000);
                display(formats.logon.replace('{{logon}}', logonDate));
            }
        }

        _lodash2.default.each(whoisData, function (val, key) {
            if (typeof formats[key] === 'undefined') {
                if (_lodash2.default.isArray(val)) {
                    val.forEach(function (v) {
                        return display(key + ': ' + v);
                    });
                } else {
                    display(key + ': ' + val);
                }
            }
        });

        out.forEach(function (l) {
            _this6.state.addMessage(buffer, {
                nick: parts[0],
                message: l,
                type: 'whois'
            });
        });
    });
};

inputCommands.whowas = function inputCommandWhowas(event, command, line) {
    var _this7 = this;

    event.handled = true;

    var parts = line.split(' ');
    var network = this.state.getActiveNetwork();
    var buffer = this.state.getActiveBuffer();

    network.ircClient.whowas(parts[0], parts[0], function (whowasData) {
        if (whowasData.error) {
            var messageBody = TextFormatting.formatText('whowas_error', {
                nick: whowasData.nick,
                text: whowasData.error
            });
            _this7.state.addMessage(buffer, {
                time: Date.now(),
                nick: '',
                message: messageBody,
                type: 'whowas'
            });
            return;
        }

        ['whowas_ident', 'whowas_server'].forEach(function (prop) {
            var messageBody = TextFormatting.formatText(prop, {
                nick: whowasData.nick,
                ident: whowasData.ident,
                host: whowasData.hostname,
                name: whowasData.real_name,
                server: whowasData.server,
                info: whowasData.server_info
            });

            _this7.state.addMessage(buffer, {
                time: Date.now(),
                nick: whowasData.nick,
                message: messageBody,
                type: 'whowas'
            });
        });
    });
};

inputCommands.mode = function inputCommandMode(event, command, line) {
    event.handled = true;

    var network = this.state.getActiveNetwork();
    var buffer = this.state.getActiveBuffer();
    var target = buffer.isChannel() ? buffer.name : network.nick;

    var parts = _lodash2.default.compact(line.split(' '));

    if (line && line[0] !== '+' && line[0] !== '-') {
        target = parts.shift();
    }

    if (parts[0]) {
        if (parts[0] === '+b' && !parts[1]) {
            buffer.flags.requested_banlist = true;

            setTimeout(function () {
                buffer.flags.requested_banlist = false;
            }, 4000);
        }

        network.ircClient.mode(target, parts[0], parts[1]);
    } else {
        network.ircClient.mode(target);

        if (target === buffer.name) {
            buffer.flags.requested_modes = true;
            setTimeout(function () {
                buffer.flags.requested_modes = false;
            }, 4000);
        }
    }
};

inputCommands.names = function inputCommandNames(event, command, line) {
    event.handled = true;

    var network = this.state.getActiveNetwork();
    var args = line;

    if (!args) {
        args = this.state.getActiveBuffer().name;
    }

    network.ircClient.raw('NAMES ' + args);
};

inputCommands.clear = function inputCommandClear(event, command, line) {
    event.handled = true;

    var buffer = this.state.getActiveBuffer();
    buffer.clearMessages();

    this.state.addMessage(buffer, {
        nick: '*',
        message: 'Scrollback cleared'
    });
};

inputCommands.echo = function inputCommandEcho(event, command, line) {
    event.handled = true;

    var buffer = this.state.getActiveBuffer();

    this.state.addMessage(buffer, {
        nick: '*',
        message: line
    });
};

inputCommands.set = function inputCommandEcho(event, command, line) {
    event.handled = true;

    var buffer = this.state.getActiveBuffer();

    var setting = '';
    var spacePos = line.indexOf(' ');

    if (spacePos > -1) {
        setting = line.substr(0, spacePos);
        var value = line.substr(spacePos + 1).trim();
        switch (value.toLowerCase().trim()) {
            case 'true':
            case 'on':
                value = true;
                break;
            case 'false':
            case 'off':
                value = false;
                break;
            default:
        }

        if (value[0] === '"' && value[value.length - 1] === '"') {
            value = value.substr(1, value.length - 2);
        }

        this.state.setting(setting, value);
    } else {
        setting = line;
    }

    this.state.addMessage(buffer, {
        nick: '*',
        message: setting + ' = ' + this.state.setting(setting)
    });
};

inputCommands.list = function inputCommandList(event, command, line) {
    event.handled = true;

    var network = this.state.getActiveNetwork();
    if (!network.channel_list.length && network.channel_list_state !== 'updating') {
        network.channel_list_state = 'updating';
        network.ircClient.raw('LIST ' + line);
    }

    network.showServerBuffer('channels');
};

inputCommands.server = function inputCommandServer(event, command, line) {
    event.handled = true;

    var parts = line.split(' ');
    var serverAddr = parts[0];
    var serverPort = parts[1] || 6667;
    var serverTls = false;
    var serverPassword = parts[2];
    var nick = parts[3] || 'ircuser';

    if (serverPort[0] === '+') {
        serverTls = true;
        serverPort = parseInt(serverPort.substr(1), 10);
    } else {
        serverTls = false;
        serverPort = parseInt(serverPort, 10);
    }

    this.state.addNetwork(serverAddr, nick, {
        server: serverAddr,
        port: serverPort,
        tls: serverTls,
        password: serverPassword
    });
};

inputCommands.beep = function inputCommandBeep(event, command, line) {
    this.state.$emit('audio.bleep');
};

inputCommands.notify = function inputCommandNotify(event, command, line) {
    this.state.$emit('notification.show', line);
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["InputHandler"]
window._kiwi_exports.libs.InputHandler = exports.default ? exports.default : exports;


/***/ }),

/***/ "AS6v":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("M3Oy");

/***/ }),

/***/ "Aw+L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppSettings_vue__ = __webpack_require__("BTvu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppSettings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppSettings_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppSettings_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppSettings_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96196fc8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppSettings_vue__ = __webpack_require__("KqVi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("gKb+")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppSettings_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96196fc8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppSettings_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96196fc8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppSettings_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "BTvu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _state = __webpack_require__("LnP8");

var _state2 = _interopRequireDefault(_state);

var _ThemeManager = __webpack_require__("j/A4");

var _ThemeManager2 = _interopRequireDefault(_ThemeManager);

var _GlobalApi = __webpack_require__("Uvbb");

var _GlobalApi2 = _interopRequireDefault(_GlobalApi);

var _localesList = __webpack_require__("Lc9z");

var _localesList2 = _interopRequireDefault(_localesList);

var _SettingsAliases = __webpack_require__("oCvS");

var _SettingsAliases2 = _interopRequireDefault(_SettingsAliases);

var _SettingsAdvanced = __webpack_require__("iE6S");

var _SettingsAdvanced2 = _interopRequireDefault(_SettingsAdvanced);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function bindSetting(settingName) {
    return {
        get: function settingGetter() {
            return this.state.setting(settingName);
        },
        set: function settingSetter(newVal) {
            this.state.setting(settingName, newVal);
        }
    };
}

exports.default = {
    components: {
        SettingsAliases: _SettingsAliases2.default,
        SettingsAdvanced: _SettingsAdvanced2.default
    },
    data: function data() {
        return {
            state: _state2.default,
            theme: '',
            customThemeUrl: '',
            pluginUiElements: _GlobalApi2.default.singleton().appSettingsPlugins,
            localesList: _localesList2.default
        };
    },
    computed: {
        themeSupportsMonospace: function themeSupportsMonospace() {
            var themeMgr = _ThemeManager2.default.instance();
            var val = themeMgr.themeVar('supports-monospace');
            return val === '1';
        },
        canRegisterProtocolHandler: function canRegisterProtocolHandler() {
            return !!navigator.registerProtocolHandler && _state2.default.setting('allowRegisterProtocolHandler');
        },
        timestamps_24h: {
            get: function get24Timestamps() {
                return _state2.default.setting('buffers.timestamp_format').substr(0, 2) === '%H';
            },
            set: function set24Timestamps(newVal) {
                var newFormat = newVal ? '%H:%M:%S' : '%l:%M:%S %p';
                _state2.default.setting('buffers.timestamp_format', newFormat);
            }
        },
        settings: function getSettings() {
            return _state2.default.settings;
        },
        settingShowAutoComplete: bindSetting('showAutocomplete'),
        settingUseMonospace: bindSetting('useMonospace'),
        settingHighlights: bindSetting('highlights'),
        settingBufferColourNicknames: bindSetting('buffers.colour_nicknames_in_messages'),
        settingBufferShowTimestamps: bindSetting('buffers.show_timestamps'),
        settingBufferShowEmoticons: bindSetting('buffers.show_emoticons'),
        settingBufferBlockPms: bindSetting('buffers.block_pms'),
        settingBufferScrollbackSize: bindSetting('buffers.scrollback_size'),
        settingBufferExtraFormatting: bindSetting('buffers.extra_formatting'),
        settingBufferTrafficAsActivity: bindSetting('buffers.traffic_as_activity'),
        settingBufferMuteSound: bindSetting('buffers.mute_sound'),
        settingBufferShareTyping: bindSetting('buffers.share_typing'),
        settingDefaultBanMask: bindSetting('buffers.default_ban_mask'),
        settingDefaultKickReason: bindSetting('buffers.default_kick_reason'),
        settingAdvancedEnable: {
            get: function getSettingShowAdvancedTab() {
                return _state2.default.ui.show_advanced_tab;
            },
            set: function setSettingShowAdvancedTab(newVal) {
                _state2.default.ui.show_advanced_tab = newVal;
            }
        },
        settingLanguage: {
            get: function getSettingLanguage() {
                return _state2.default.setting('language') || '';
            },
            set: function setSettingLanguage(newVal) {
                _state2.default.setting('language', newVal || null);
            }
        },
        messageLayouts: function messageLayouts() {
            return {
                traditional: 'compact',
                modern: 'modern',
                inline: 'inline'
            };
        },

        settingMessageLayout: {
            set: function setSettingMessageLayout(newVal) {
                var l = this.messageLayouts;
                _state2.default.setting('buffers.messageLayout', l[newVal] || l.modern);
            },
            get: function get() {
                var s = _state2.default.setting('buffers.messageLayout');
                var l = _lodash2.default.invert(this.messageLayouts);
                return l[s];
            }
        }
    },
    created: function created() {
        this.listenForThemeSettings();
    },
    methods: {
        closeSettings: function closeSettings() {
            _state2.default.$emit('active.component');
        },
        refreshTheme: function refreshTheme() {
            _ThemeManager2.default.instance().reload();
        },
        listenForThemeSettings: function listenForThemeSettings() {
            var _this = this;

            var themeMgr = _ThemeManager2.default.instance();
            var watches = [];

            var updateFn = function updateFn() {
                var theme = themeMgr.currentTheme();
                _this.theme = theme.name;
                _this.customThemeUrl = theme.name === 'custom' ? theme.url : '';
            };

            var watchTheme = function watchTheme(newVal) {
                themeMgr.setTheme(newVal);
            };

            var watchCustomThemeUrl = function watchCustomThemeUrl(newVal) {
                if (themeMgr.currentTheme().name === 'custom') {
                    themeMgr.setCustomThemeUrl(newVal);
                }
            };

            var teardownFn = function teardownFn() {
                _this.state.$off('theme.change', updateFn);
                watches.forEach(function (unwatchFn) {
                    return unwatchFn();
                });
                _this.$off('hook:destroy', teardownFn);
            };

            updateFn();

            this.state.$on('theme.change', updateFn);
            this.$once('hook:destroyed', teardownFn);

            watches = [this.$watch('theme', watchTheme), this.$watch('customThemeUrl', watchCustomThemeUrl)];
        },
        enableAdvancedTab: function enableAdvancedTab() {
            var _this2 = this;

            this.settingAdvancedEnable = true;
            this.$nextTick(function () {
                _this2.$refs.tabs.setActiveByName('advanced');
                _this2.$el.scrollTop = 0;
            });
        },
        makeDefaultProtocolHandler: function makeDefaultProtocolHandler() {
            navigator.registerProtocolHandler('irc', document.location.origin + document.location.pathname + '#%s', 'Kiwi IRC');
            navigator.registerProtocolHandler('ircs', document.location.origin + document.location.pathname + '#%s', 'Kiwi IRC');
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["AppSettings"]
window._kiwi_exports.components.AppSettings = exports.default ? exports.default : exports;


/***/ }),

/***/ "Bt23":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Welcome_vue__ = __webpack_require__("nt8X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Welcome_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Welcome_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Welcome_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Welcome_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4002974_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Welcome_vue__ = __webpack_require__("jc+x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("6vhI")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Welcome_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4002974_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Welcome_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4002974_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Welcome_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "C4uO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CI3C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('startup-layout',{ref:"layout",staticClass:"kiwi-startbnc",scopedSlots:_vm._u([{key:"connection",fn:function(){return [_c('form',{staticClass:"kiwi-startbnc-form",on:{"submit":function($event){$event.preventDefault();return _vm.startUp($event)}}},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.greetingText)}}),_vm._v(" "),_c('div',{staticClass:"kiwi-startbnc-status"},[_vm._v(_vm._s(_vm.statusMessage))]),_vm._v(" "),_c('label',[_c('span',[_vm._v(_vm._s(_vm.$t('username')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],attrs:{"disabled":_vm.loading,"type":"text"},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}})]),_vm._v(" "),_c('label',[_c('span',[_vm._v(_vm._s(_vm.$t('password')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"disabled":_vm.loading,"type":"password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"u-button u-button-primary u-submit",attrs:{"disabled":_vm.loading || !_vm.username || !_vm.password,"type":"submit"}},[(!_vm.loading)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.buttonText)}}):_c('i',{staticClass:"fa fa-spinner fa-spin",attrs:{"aria-hidden":"true"}})])])]},proxy:true}])})}
var staticRenderFns = []


/***/ }),

/***/ "CUIL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-personal"},[_c('h1',[_vm._v(_vm._s(_vm.$t('personal_client')))]),_vm._v(" "),(_vm.server && _vm.server.server && !_vm.readyToShowOptions)?_c('div'):(_vm.server && _vm.server.server)?_c('div',[(_vm.addedNetworkToExisting)?_c('div',[_c('p',[_vm._v("\n                "+_vm._s(_vm.$t('personal_added_to_existing'))+"\n            ")])]):_c('div',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('personal_connect_to', { network: ("<b>" + (_vm.server.server) + "</b>") }))}}),_vm._v(" "),(_vm.hasOtherTab)?_c('button',{staticClass:"u-button u-button-primary",on:{"click":_vm.addNetworkToExistingTab}},[_vm._v("\n                "+_vm._s(_vm.$t('personal_add_existing_tab'))+"\n            ")]):_c('button',{staticClass:"u-button u-button-primary",on:{"click":function($event){return _vm.addNetwork()}}},[_vm._v("\n                Add network to Kiwi\n            ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"u-button u-button-primary",on:{"click":function($event){return _vm.addNetwork(true)}}},[_vm._v("\n                "+_vm._s(_vm.$t('personal_connect_temporary'))+"\n            ")]),_vm._v(" "),_c('br')])]):_c('div',[_c('p',[_vm._v(_vm._s(_vm.$t('personal_addjoin')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('personal_return')))]),_vm._v(" "),_c('button',{staticClass:"u-button u-button-primary",on:{"click":_vm.addEmptyNetwork}},[_vm._v("\n            "+_vm._s(_vm.$t('personal_add'))+"\n        ")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.networks.length>0)?_c('a',{staticClass:"u-link kiwi-personal-existing-networks",on:{"click":function($event){$event.stopPropagation();return _vm.toggleStateBrowser($event)}}},[_vm._v("\n            "+_vm._s(_vm.$t('personal_saved'))+"\n        ")]):_vm._e()])])}
var staticRenderFns = []


/***/ }),

/***/ "CXnl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-container",class:{
    /* 'kiwi-container-' + bufferType: true, */
    'kiwi-container--sidebar-drawn': _vm.sidebarState.isDrawn,
    'kiwi-container--sidebar-open': _vm.sidebarState.isOpen,
    'kiwi-container--no-sidebar': _vm.buffer && !_vm.buffer.isChannel,
}},[(_vm.buffer)?[_c('div',{staticClass:"kiwi-container-toggledraw-statebrowser",on:{"click":function($event){$event.stopPropagation();return _vm.toggleStateBrowser($event)}}},[_c('div',{staticClass:"kiwi-container-toggledraw-statebrowser-messagecount",class:[
                    _vm.unreadMessages.highlight ?
                        'kiwi-container-toggledraw-statebrowser-messagecount--highlight' :
                        '' ]},[_c('span',{staticClass:"kiwi-container-statebrowser-messagecount-alert"},[_vm._v("\n                    "+_vm._s(_vm.unreadMessages.count > 999 ? '999+' : _vm.unreadMessages.count)+"\n                ")]),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('container-header',{attrs:{"buffer":_vm.buffer,"sidebar-state":_vm.sidebarState}}),_vm._v(" "),_vm._t("before"),_vm._v(" "),(_vm.buffer.getNetwork().state !== 'connected' && !_vm.buffer.isServer())?_c('not-connected',{attrs:{"buffer":_vm.buffer,"network":_vm.buffer.getNetwork()}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"kiwi-container-content"},[(_vm.buffer.isServer())?[_c('server-view',{attrs:{"network":_vm.network}})]:[_c('message-list',{attrs:{"buffer":_vm.buffer}}),_vm._v(" "),(_vm.buffer.isChannel() /* There are no sidebars for queries yet */)?_c('sidebar',{attrs:{"network":_vm.network,"buffer":_vm.buffer,"sidebar-state":_vm.sidebarState}}):_vm._e()],_vm._v(" "),_vm._t("after")],2)]:[_c('div',{staticClass:"kiwi-container-empty"},[_c('h4',[_vm._v(_vm._s(_vm.$t('container_welcome')))]),_vm._v(" "),_c('a',{staticClass:"u-button",on:{"click":function($event){$event.stopPropagation();return _vm.toggleStateBrowser($event)}}},[_vm._v("\n                "+_vm._s(_vm.$t('container_statebrowser'))+"\n            ")])])]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kiwi-container-statebrowser-messagecount-close"},[_c('i',{staticClass:"fa fa-times",attrs:{"aria-hidden":"true"}})])}]


/***/ }),

/***/ "CfcS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CjhL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ct1V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D2nl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['message'],
    computed: {
        colour: function colour() {
            return this.message.user ? this.message.user.getColour() : '';
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["MessageListAvatar"]
window._kiwi_exports.components.MessageListAvatar = exports.default ? exports.default : exports;


/***/ }),

/***/ "DFuw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kiwiLoadingLogo.ee10be5.png";

/***/ }),

/***/ "Dfoy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E4HS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"kiwi-loading-logo",attrs:{"src":__webpack_require__("DFuw")}}),_vm._v(" "),_c('canvas',{staticClass:"kiwi-loading-animation"})])}]


/***/ }),

/***/ "EFGa":
/***/ (function(module, exports) {

module.exports = {"0":65533,"128":8364,"130":8218,"131":402,"132":8222,"133":8230,"134":8224,"135":8225,"136":710,"137":8240,"138":352,"139":8249,"140":338,"142":381,"145":8216,"146":8217,"147":8220,"148":8221,"149":8226,"150":8211,"151":8212,"152":732,"153":8482,"154":353,"155":8250,"156":339,"158":382,"159":376}

/***/ }),

/***/ "EKUm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _create = __webpack_require__("OvRC");

var _create2 = _interopRequireDefault(_create);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _eventEmitter = __webpack_require__("zQo6");

var _eventEmitter2 = _interopRequireDefault(_eventEmitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NetworkProvider = function () {
    function NetworkProvider() {
        (0, _classCallCheck3.default)(this, NetworkProvider);

        (0, _eventEmitter2.default)(this);
        this.providers = [];
    }

    (0, _createClass3.default)(NetworkProvider, [{
        key: 'addProvider',
        value: function addProvider(provider) {
            var _this = this;

            this.providers.push(provider);
            provider.on('networks', function (networks) {
                _this.emit('networks', _this.availableNetworks());
            });
        }
    }, {
        key: 'availableNetworks',
        value: function availableNetworks() {
            var networks = (0, _create2.default)(null);

            this.providers.forEach(function (provider) {
                var pType = provider.type;
                if (provider.networks.length > 0) {
                    networks[pType] = networks[pType] || [];
                    networks[pType] = networks[pType].concat(provider.networks);
                }
            });

            return networks;
        }
    }]);
    return NetworkProvider;
}();

exports.default = NetworkProvider;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["NetworkProvider"]
window._kiwi_exports.libs.NetworkProvider = exports.default ? exports.default : exports;


/***/ }),

/***/ "EWfp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("mV8s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_249ec9ad_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("TZJg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("JNJi")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_249ec9ad_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_249ec9ad_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "F/FP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageListMessageModern_vue__ = __webpack_require__("QAaf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageListMessageModern_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageListMessageModern_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageListMessageModern_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageListMessageModern_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cf10158_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageListMessageModern_vue__ = __webpack_require__("kzSW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Dfoy")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageListMessageModern_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cf10158_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageListMessageModern_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cf10158_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageListMessageModern_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "FKBE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _create = __webpack_require__("OvRC");

var _create2 = _interopRequireDefault(_create);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _vue = __webpack_require__("I3G/");

var _vue2 = _interopRequireDefault(_vue);

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _common = __webpack_require__("nlr4");

var _batchedAdd = __webpack_require__("Tddf");

var _batchedAdd2 = _interopRequireDefault(_batchedAdd);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var nextBufferId = 0;

var BufferState = function () {
    function BufferState(name, networkid, state, messageDict) {
        (0, _classCallCheck3.default)(this, BufferState);

        this.id = nextBufferId++;
        this.networkid = networkid;
        this.name = name;
        this.topics = [];
        this.key = '';
        this.joined = false;
        this.enabled = true;
        this.created_at = null;
        this.users = (0, _create2.default)(null);
        this.modes = (0, _create2.default)(null);
        this.flags = {
            unread: 0,
            alert_on: 'default',
            has_opened: false,
            channel_badkey: false,
            chathistory_available: true,
            requested_modes: false,
            requested_banlist: false,
            is_requesting_chathistory: false
        };
        this.settings = {};
        this.last_read = 0;
        this.active_timeout = null;
        this.message_count = 0;
        this.current_input = '';
        this.input_history = [];
        this.input_history_pos = 0;
        this.show_input = true;

        this.chathistory_request_count = 0;

        _vue2.default.observable(this);

        (0, _common.def)(this, 'state', state, false);
        (0, _common.def)(this, 'messageDict', messageDict, false);

        var messagesObj = {
            networkid: this.networkid,
            buffer: this.name,
            messages: [],
            messageIds: (0, _create2.default)(null)
        };
        this.messageDict.push(messagesObj);
        (0, _common.def)(this, 'messagesObj', messagesObj, false);

        (0, _common.def)(this, 'addMessageBatch', createMessageBatch(this), false);
        (0, _common.def)(this, 'addUserBatch', createUserBatch(this), false);

        if (this.isChannel()) {
            maybeStartWhoLoop(this);
        }

        function onNetworkConnecting(event) {
            if (event.network === this.getNetwork()) {
                this.chathistory_request_count = 0;
            }
        }

        function onBufferClose(event) {
            if (event.buffer === this) {
                this.state.$off('network.connecting', onNetworkConnectingBound);
                this.state.$off('buffer.close', onBufferCloseBound);
            }
        }

        var onNetworkConnectingBound = onNetworkConnecting.bind(this);
        var onBufferCloseBound = onBufferClose.bind(this);

        state.$on('network.connecting', onNetworkConnectingBound);
        state.$on('buffer.close', onBufferCloseBound);
    }

    (0, _createClass3.default)(BufferState, [{
        key: 'getNetwork',
        value: function getNetwork() {
            return this.state.getNetwork(this.networkid);
        }
    }, {
        key: 'getMessages',
        value: function getMessages() {
            var bufMessages = _lodash2.default.find(this.messageDict, {
                networkid: this.networkid,
                buffer: this.name
            });

            return bufMessages ? bufMessages.messages : [];
        }
    }, {
        key: 'clearMessages',
        value: function clearMessages() {
            this.messagesObj.messages.splice(0, this.messagesObj.messages.length);
            this.messagesObj.messageIds = (0, _create2.default)(null);
        }
    }, {
        key: 'isServer',
        value: function isServer() {
            return this.name === '*';
        }
    }, {
        key: 'isChannel',
        value: function isChannel() {
            var chanPrefixes = ['#', '&'];
            var ircNetwork = this.getNetwork().ircClient.network;
            if (ircNetwork && ircNetwork.options.CHANTYPES) {
                chanPrefixes = ircNetwork.options.CHANTYPES;
            }

            return chanPrefixes.indexOf(this.name[0]) > -1;
        }
    }, {
        key: 'isQuery',
        value: function isQuery() {
            var chanPrefixes = ['#', '&'];
            var ircNetwork = this.getNetwork().ircClient.network;
            if (ircNetwork && ircNetwork.options.CHANTYPES) {
                chanPrefixes = ircNetwork.options.CHANTYPES;
            }

            return chanPrefixes.indexOf(this.name[0]) === -1 && !this.isSpecial() && !this.isServer();
        }
    }, {
        key: 'isSpecial',
        value: function isSpecial() {
            var name = this.name;
            return name[0] === '*' && name.length > 1;
        }
    }, {
        key: 'isUserAnOp',
        value: function isUserAnOp(nick) {
            var user = this.state.getUser(this.networkid, nick);
            if (!user) {
                return false;
            }

            var userBufferInfo = user.buffers[this.id];
            if (!userBufferInfo) {
                return false;
            }

            var modes = userBufferInfo.modes;
            var opModes = ['Y', 'y', 'q', 'a', 'o', 'h'];
            var hasOp = _lodash2.default.find(modes, function (mode) {
                return opModes.indexOf(mode.toLowerCase()) > -1;
            });

            return !!hasOp;
        }
    }, {
        key: 'userModePrefix',
        value: function userModePrefix(user) {
            if (!user.buffers[this.id]) {
                return '';
            }

            var modes = user.buffers[this.id].modes;
            if (modes.length === 0) {
                return '';
            }

            var network = this.getNetwork();
            var netPrefixes = network.ircClient.network.options.PREFIX;

            var prefix = _lodash2.default.find(netPrefixes, function (p) {
                return modes.indexOf(p.mode) > -1;
            });

            return prefix ? prefix.symbol : '';
        }
    }, {
        key: 'userMode',
        value: function userMode(user) {
            if (!user.buffers[this.id]) {
                return '';
            }

            var modes = user.buffers[this.id].modes;
            if (modes.length === 0) {
                return '';
            }

            var network = this.getNetwork();
            var netPrefixes = network.ircClient.network.options.PREFIX;

            var prefix = _lodash2.default.find(netPrefixes, function (p) {
                return modes.indexOf(p.mode) > -1;
            });

            return prefix ? prefix.mode : '';
        }
    }, {
        key: 'setting',
        value: function setting(name, val) {
            if (typeof val !== 'undefined') {
                this.state.$set(this.settings, name, val);
                return val;
            }

            var result = typeof this.settings[name] !== 'undefined' ? this.settings[name] : this.state.setting('buffers.' + name);

            return result;
        }
    }, {
        key: 'rename',
        value: function rename(newName) {
            var network = this.getNetwork();
            var oldName = this.name;
            var setActive = this.state.getActiveBuffer() === this;

            this.name = newName;
            if (setActive) {
                this.state.setActiveBuffer(network.id, newName);
            }

            var bufferMessages = _lodash2.default.find(this.messageDict, { networkid: network.id, buffer: oldName });
            bufferMessages.buffer = newName;
        }
    }, {
        key: 'flag',
        value: function flag(name, val) {
            if (typeof val !== 'undefined') {
                this.state.$set(this.flags, name, val);
                return val;
            }

            return this.flags[name];
        }
    }, {
        key: 'requestScrollback',
        value: function requestScrollback(_direction) {
            var _this = this;

            var direction = _direction || 'backward';
            var time = '';
            var chathistoryFuncName = 'before';

            if (direction === 'backward') {
                var lastMessage = this.getMessages().reduce(function (earliest, current) {
                    var ignoreTypes = ['traffic', 'topic', 'connection', 'presence'];
                    var validType = ignoreTypes.indexOf(earliest.type) === -1;
                    if (validType && earliest.time && earliest.time < current.time) {
                        return earliest;
                    }
                    return current;
                }, this.getMessages()[0]);

                chathistoryFuncName = 'before';
                time = lastMessage ? new Date(lastMessage.server_time) : new Date();
            } else if (direction === 'forward') {
                var firstMessage = this.getMessages().reduce(function (latest, current) {
                    var ignoreTypes = ['traffic', 'topic', 'connection', 'presence'];
                    var validType = ignoreTypes.indexOf(latest.type) === -1;
                    if (validType && latest.time && latest.time > current.time) {
                        return latest;
                    }
                    return current;
                }, this.getMessages()[0]);

                chathistoryFuncName = 'after';
                time = firstMessage ? new Date(firstMessage.server_time) : new Date();
            } else {
                throw new Error('Invalid direction for requestScrollback(): ' + _direction);
            }

            var ircClient = this.getNetwork().ircClient;
            this.flag('is_requesting_chathistory', true);
            this.chathistory_request_count += 1;
            ircClient.chathistory[chathistoryFuncName](this.name, time).then(function (event) {
                if (!event || event.commands.length === 0) {
                    _this.flag('chathistory_available', false);
                } else {
                    _this.flag('chathistory_available', true);
                }
            }).finally(function () {
                _this.flag('is_requesting_chathistory', false);
            });
        }
    }, {
        key: 'requestLatestScrollback',
        value: function requestLatestScrollback() {
            var _this2 = this;

            var ircClient = this.getNetwork().ircClient;
            this.flag('is_requesting_chathistory', true);
            this.chathistory_request_count += 1;
            ircClient.chathistory.before(this.name, '*').finally(function () {
                _this2.flag('is_requesting_chathistory', false);
            });
        }
    }, {
        key: 'markAsRead',
        value: function markAsRead(delayed) {
            if (this.active_timeout) {
                clearTimeout(this.active_timeout);
                this.active_timeout = null;
            }
            if (delayed) {
                this.active_timeout = setTimeout(this.markAsRead.bind(this), 10000, false);
            } else {
                this.last_read = Date.now();
                this.flag('highlight', false);

                var network = this.getNetwork();
                var allowedUpdate = !network ? false : this.isChannel() || this.isQuery();
                if (allowedUpdate && network.connection.bncname) {
                    network.ircClient.bnc.bufferSeen(network.connection.bncname, this.name, new Date());
                }
            }
        }
    }, {
        key: 'incrementFlag',
        value: function incrementFlag(flagName) {
            this.flags[flagName] = (this.flags[flagName] || 0) + 1;
        }
    }, {
        key: 'addUser',
        value: function addUser(user) {
            this.addUserBatch(user);
        }
    }, {
        key: 'removeUser',
        value: function removeUser(nick) {
            var userObj = this.state.getUser(this.networkid, nick);

            _lodash2.default.pull(this.addUserBatch.queue(), userObj);

            this.state.$delete(this.users, nick.toLowerCase());

            if (userObj) {
                delete userObj.buffers[this.id];
            }
        }
    }, {
        key: 'clearUsers',
        value: function clearUsers() {
            var _this3 = this;

            this.addUserBatch && this.addUserBatch.queue().splice(0);

            _lodash2.default.each(this.users, function (userObj, nick) {
                delete userObj.buffers[_this3.id];
            });

            this.state.$set(this, 'users', {});
        }
    }, {
        key: 'addMessage',
        value: function addMessage(message) {
            this.addMessageBatch(message);
        }
    }, {
        key: 'say',
        value: function say(message) {
            var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var network = this.getNetwork();
            var newMessage = {
                time: Date.now(),
                nick: network.nick,
                message: message,
                type: opts.type || 'privmsg'
            };

            this.state.addMessage(this, newMessage);

            var fnNames = {
                privmsg: 'say',
                action: 'action',
                notice: 'notice'
            };
            var fnName = fnNames[opts.type] || 'say';
            network.ircClient[fnName](this.name, message);
        }
    }, {
        key: 'join',
        value: function join() {
            if (!this.isChannel()) {
                return;
            }

            var network = this.getNetwork();
            network.ircClient.join(this.name, this.key || '');
        }
    }, {
        key: 'part',
        value: function part(reason) {
            if (!this.isChannel()) {
                return;
            }

            var network = this.getNetwork();
            network.ircClient.part(this.name, reason || '');
        }
    }, {
        key: 'scrollToMessage',
        value: function scrollToMessage(id) {
            this.state.$emit('messagelist.scrollto', { id: id });
        }
    }, {
        key: 'getLoadingState',
        value: function getLoadingState() {
            var networkState = this.getNetwork().state;
            var historySupport = !!this.getNetwork().ircClient.chathistory.isSupported();
            var messagesInBatchQueue = this.addMessageBatch.queue().length;

            var messageCount = this.message_count;

            if (networkState === 'disconnected') {
                return 'disconnected';
            } else if (networkState === 'connecting') {
                return 'connecting';
            } else if (networkState === 'connected' && this.joined && this.enabled && historySupport && (this.flags.is_requesting_chathistory || this.chathistory_request_count === 0 || messagesInBatchQueue > 0)) {
                return 'loading';
            }
            return 'done';
        }
    }, {
        key: 'isReady',
        value: function isReady() {
            return this.getLoadingState() === 'done';
        }
    }, {
        key: 'topic',
        get: function get() {
            return this.topics.length === 0 ? '' : this.topics[this.topics.length - 1];
        },
        set: function set(newVal) {
            this.topics.push(newVal);
        }
    }]);
    return BufferState;
}();

exports.default = BufferState;

function createUserBatch(bufferState) {
    var addSingleUser = function addSingleUser(u) {
        bufferState.state.$set(bufferState.users, u.nick.toLowerCase(), u);
    };
    var addMultipleUsers = function addMultipleUsers(users) {
        var o = _lodash2.default.clone(bufferState.users);
        users.forEach(function (u) {
            o[u.nick.toLowerCase()] = u;
        });
        bufferState.users = o;
    };

    return (0, _batchedAdd2.default)(addSingleUser, addMultipleUsers);
}

function createMessageBatch(bufferState) {
    var addSingleMessage = function addSingleMessage(newMessage) {
        if (bufferState.messagesObj.messageIds[newMessage.id]) {
            return;
        }
        bufferState.messagesObj.messages.push(newMessage);
        bufferState.messagesObj.messageIds[newMessage.id] = newMessage;
        trimMessages();
        bufferState.message_count++;
    };
    var addMultipleMessages = function addMultipleMessages(newMessages) {
        var toAdd = newMessages.filter(function (msg) {
            return !bufferState.messagesObj.messageIds[msg.id];
        });
        if (toAdd.length > 0) {
            bufferState.messagesObj.messages = bufferState.messagesObj.messages.concat(toAdd);
            toAdd.forEach(function (msg) {
                bufferState.messagesObj.messageIds[msg.id] = msg;
            });
            trimMessages();
        }

        bufferState.message_count++;
    };
    var trimMessages = function trimMessages() {
        var scrollbackSize = bufferState.setting('scrollback_size');
        var length = bufferState.messagesObj.messages.length;

        if (bufferState.messagesObj.messages.length > scrollbackSize) {
            var removed = bufferState.messagesObj.messages.splice(0, length - scrollbackSize);
            removed.forEach(function (msg) {
                return delete bufferState.messagesObj.messageIds[msg.id];
            });
        }
    };

    return (0, _batchedAdd2.default)(addSingleMessage, addMultipleMessages);
}

function maybeStartWhoLoop(bufferState) {
    var network = bufferState.state.getNetwork(bufferState.networkid);

    if (network.state === 'connected') {
        nextLoop();
    } else {
        var on001 = function on001(command, event, eventNetwork) {
            if (eventNetwork === network) {
                bufferState.state.$off('irc.raw.001', on001);
                nextLoop();
            }
        };
        bufferState.state.$on('irc.raw.001', on001);
    }

    function nextLoop() {
        setTimeout(updateWhoStatusLoop, 30000);
    }

    function updateWhoStatusLoop() {
        network = bufferState.state.getNetwork(bufferState.networkid);

        if (!network) {
            return;
        }

        if (!network.bufferByName(bufferState.name)) {
            return;
        }

        var whoLoop = bufferState.setting('who_loop');
        var isJoined = bufferState.joined;
        var hasAwayNotify = network.ircClient.network.cap.isEnabled('away-notify');
        var networkConnected = network.state === 'connected';

        if (whoLoop && networkConnected && isJoined && !hasAwayNotify) {
            network.ircClient.who(bufferState.name, function () {
                nextLoop();
            });
        } else {
            nextLoop();
        }
    }
}

/***/ }),

/***/ "FlBN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-messagelist-avatar",style:({
        'background-color': _vm.colour
    }),attrs:{"data-nick":_vm.message.nick}},[_vm._v("\n    "+_vm._s(_vm.message.nick[0])+"\n")])}
var staticRenderFns = []


/***/ }),

/***/ "Fqd/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fontawesome-webfont.912ec66.svg";

/***/ }),

/***/ "G7fu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _create = __webpack_require__("OvRC");

var _create2 = _interopRequireDefault(_create);

exports.default = chathistoryMiddleware;

var _Misc = __webpack_require__("uN9+");

var Misc = _interopRequireWildcard(_Misc);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function chathistoryMiddleware() {
    return function middleware(client, rawEvents, parsedEvents) {
        client.requestCap('CHATHISTORY');
        addFunctionsToClient(client);
        parsedEvents.use(theMiddleware);
    };

    function theMiddleware(command, event, client, next) {
        if (command.toLowerCase() === 'batch end chathistory' && client.chathistory) {
            var target = event.params[0];
            client.chathistory.batchCallbacks.resolve(target, event);
        }

        if (command.toLowerCase() === 'fail' && event.params[0].toLowerCase() === 'chathistory') {
            if (event.params[1].toLowerCase() === 'message_error') {
                client.chathistory.batchCallbacks.resolve(event.params[3]);
            }
        }

        next();
    }
}

function addFunctionsToClient(client) {
    var history = client.chathistory = {};

    history.batchCallbacks = {
        callbacks: (0, _create2.default)(null),
        add: function add(target, cb) {
            this.callbacks[target.toLowerCase()] = this.callbacks[target.toLowerCase()] || [];
            this.callbacks[target.toLowerCase()].push(cb);
        },
        resolve: function resolve(target, value) {
            var cbs = this.callbacks[target.toLowerCase()] || [];
            delete this.callbacks[target.toLowerCase()];
            cbs.forEach(function (cb) {
                return cb(value);
            });
        },
        targetCallbacks: function targetCallbacks(target) {
            return this.callbacks[target.toLowerCase()];
        }
    };

    history.isSupported = function () {
        return !!client.network.supports('chathistory');
    };

    history.before = function (target, dateOrTime) {
        return new _promise2.default(function (resolve) {
            if (!history.isSupported()) {
                resolve();
                return;
            }

            client.raw('CHATHISTORY', 'BEFORE', target, messageReference(dateOrTime), '50');
            history.batchCallbacks.add(target, resolve);
        });
    };

    history.after = function (target, dateOrTime) {
        return new _promise2.default(function (resolve) {
            if (!history.isSupported()) {
                resolve();
                return;
            }

            client.raw('CHATHISTORY', 'AFTER', target, messageReference(dateOrTime), '50');
            history.batchCallbacks.add(target, resolve);
        });
    };

    history.latest = function (target, dateOrTime) {
        return new _promise2.default(function (resolve) {
            if (!history.isSupported()) {
                resolve();
                return;
            }

            client.raw('CHATHISTORY', 'LATEST', target, messageReference(dateOrTime), '50');
            history.batchCallbacks.add(target, resolve);
        });
    };

    history.around = function (target, dateOrTime) {
        return new _promise2.default(function (resolve) {
            if (!history.isSupported()) {
                resolve();
                return;
            }

            client.raw('CHATHISTORY', 'AROUND', target, messageReference(dateOrTime), '50');
            history.batchCallbacks.add(target, resolve);
        });
    };

    history.between = function (target, fromDateOrTime, toDateOrTime) {
        return new _promise2.default(function (resolve) {
            if (!history.isSupported()) {
                resolve();
                return;
            }

            var fromRef = messageReference(fromDateOrTime);
            var toRef = messageReference(toDateOrTime);
            client.raw('CHATHISTORY', 'BETWEEN', target, fromRef, toRef, 50);
            history.batchCallbacks.add(target, resolve);
        });
    };

    function messageReference(inp) {
        if ((typeof inp === 'undefined' ? 'undefined' : (0, _typeof3.default)(inp)) === 'object') {
            return 'timestamp=' + Misc.dateIso(inp);
        }

        if (inp === '*') {
            return '*';
        }

        return 'msgid=' + inp;
    }
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["ChathistoryMiddleware"]
window._kiwi_exports.libs.ChathistoryMiddleware = exports.default ? exports.default : exports;


/***/ }),

/***/ "GLlb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BufferKey_vue__ = __webpack_require__("Gx5t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BufferKey_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BufferKey_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BufferKey_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BufferKey_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ff4e774_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BufferKey_vue__ = __webpack_require__("Gj6a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("zsPz")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BufferKey_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ff4e774_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BufferKey_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ff4e774_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BufferKey_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Gj6a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-bufferkey kiwi-warning-block"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.joinChannel($event)}}},[_c('label',[_vm._v(_vm._s(_vm.$t('bufferkey_input')))]),_vm._v(" "),_c('input',{directives:[{name:"focus",rawName:"v-focus"},{name:"model",rawName:"v-model",value:(_vm.buffer.key),expression:"buffer.key"}],attrs:{"type":"password"},domProps:{"value":(_vm.buffer.key)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.buffer, "key", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"kiwi-bufferkey-buttons"},[_c('span',{staticClass:"kiwi-bufferkey-button",on:{"click":_vm.joinChannel}},[_c('i',{staticClass:"fa fa-arrow-circle-o-right",attrs:{"aria-hidden":"true"}}),_vm._v("\n                "+_vm._s(_vm.$t('bufferkey_rejoin', {channel: _vm.buffer.name}))+"\n            ")])])])])}
var staticRenderFns = []


/***/ }),

/***/ "Gx5t":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['buffer', 'network'],
    data: function data() {
        return {};
    },
    methods: {
        joinChannel: function joinChannel() {
            this.buffer.flags.channel_badkey = false;
            this.buffer.join();
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["BufferKey"]
window._kiwi_exports.components.BufferKey = exports.default ? exports.default : exports;


/***/ }),

/***/ "H5XI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-serverview"},[_c('div',{staticClass:"kiwi-serverview-inner"},[_c('tabbed-view',{key:_vm.network.id,ref:"tabs",on:{"changed":_vm.tabChanged}},[_c('tabbed-tab',{attrs:{"header":_vm.$t('messages'),"focus":_vm.hasMessages,"name":"messages"}},[_c('message-list',{attrs:{"buffer":_vm.serverBuffer}})],1),_vm._v(" "),(!_vm.restrictedServer)?_c('tabbed-tab',{attrs:{"header":_vm.$t('settings'),"focus":!_vm.hasMessages,"name":"settings"}},[_c('network-settings',{attrs:{"network":_vm.network}})],1):_vm._e(),_vm._v(" "),(_vm.networkConnected)?_c('tabbed-tab',{attrs:{"header":_vm.$t('channels'),"name":"channels"}},[_c('channel-list',{attrs:{"network":_vm.network}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.pluginUiElements),function(item){return _c('tabbed-tab',{key:item.id,attrs:{"header":item.title}},[_c(item.component,_vm._b({tag:"div"},'div',item.props,false))],1)})],2)],1)])}
var staticRenderFns = []


/***/ }),

/***/ "H64e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-typinguserslist"},[_vm._l((_vm.typingUsers),function(user,idx){return _c('span',{key:user.nick,style:({ color: _vm.userColour(user) })},[_vm._v("\n        "+_vm._s(user.nick)+_vm._s(_vm.typingUsers.length - 1 > idx ? ',' : '')+"\n    ")])}),_vm._v(" "+_vm._s(_vm.typingUsers.length > 0 ? '…' : '')+"\n")],2)}
var staticRenderFns = []


/***/ }),

/***/ "HpWa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            logo: '',
            c: '',
            x: '',
            Y: [],
            t: 0,
            fontSize: 72,
            font: 'bold ' + 72 + 'px verdana',
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce eu arcu ipsum. ',
            animationFrame: null
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.logo = this.$el.querySelector('.kiwi-loading-logo');
        this.c = this.$el.querySelector('.kiwi-loading-animation');
        this.x = this.c.getContext('2d');
        var tmpText = '';
        for (var i = 0; i < 9; i += 1) {
            tmpText += this.text;
        }this.text = String(tmpText).match(/.{1,43}/g);
        this.c.width = 1256;
        this.c.height = 1080;
        for (var _i = 0; _i < this.text.length; _i += 1) {
            this.Y.push(_i * this.fontSize - 1600);
        }
        this.logo.onload = function () {
            _this.draw();
        };
    },
    destroyed: function destroyed() {
        cancelAnimationFrame(this.animationFrame);
    },

    methods: {
        draw: function draw() {
            this.x.clearRect(0, 0, this.c.width, this.c.height);
            this.x.globalCompositeOperation = 'source-over';
            this.x.drawImage(this.logo, 0, 0, this.c.width, this.c.height);
            this.x.globalCompositeOperation = 'xor';
            this.x.fillStyle = '#000';
            this.x.font = this.font;
            for (var i = 0; i < this.text.length; i += 1) {
                if (this.t % 4.5 < 2) {
                    this.Y[i] += (250 + (10 + i) / this.text.length * 4000) / 120;
                    if (this.Y[i] > i * this.fontSize) {
                        this.Y[i] = i * this.fontSize;
                    }
                } else {
                    if (this.text.length - (this.t % 4.5 - 2) / 2.5 * this.text.length * 1.75 < i) {
                        this.Y[i] += 10 + this.Y[i] / 20;
                    }
                    if (this.Y[i] > 1080 || this.Y[i] < 0) {
                        this.Y[i] = -1500 + i * this.fontSize;
                    }
                }
                if (this.Y[i] > -100) {
                    this.x.fillText(this.text[i], 0, this.fontSize + this.Y[i]);
                }
            }
            this.x.globalCompositeOperation = 'source-out';
            this.x.drawImage(this.logo, 0, 0, this.c.width, this.c.height);
            this.x.globalCompositeOperation = 'source-over';
            this.x.globalAlpha = 0.1;
            this.x.drawImage(this.logo, 0, 0, this.c.width, this.c.height);
            this.x.globalAlpha = 1;
            this.animationFrame = requestAnimationFrame(this.draw);
            this.t += 1 / 40;
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["LoadingAnimation"]
window._kiwi_exports.components.LoadingAnimation = exports.default ? exports.default : exports;


/***/ }),

/***/ "IMLV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.b06871f.ttf";

/***/ }),

/***/ "Ig9r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J3Dr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"kiwi-nicklist-user",class:[
        _vm.nicklist.userMode(_vm.user) ? 'kiwi-nicklist-user--mode-' + _vm.nicklist.userMode(_vm.user) : '',
        _vm.user.away ? 'kiwi-nicklist-user--away' : '',
        _vm.user.ignore ? 'kiwi-nicklist-user--ignore' : '' ],attrs:{"data-nick":(_vm.user.nick||'').toLowerCase()},on:{"click":function($event){return _vm.nicklist.openUserbox(_vm.user)}}},[_c('away-status-indicator',{attrs:{"network":_vm.network,"user":_vm.user,"toggle":false}}),_vm._v(" "),_c('span',{staticClass:"kiwi-nicklist-user-prefix"},[_vm._v(_vm._s(_vm.nicklist.userModePrefix(_vm.user)))]),_c('span',{staticClass:"kiwi-nicklist-user-nick",style:({ 'color': _vm.userColour })},[_vm._v(_vm._s(_vm.user.nick)+"\n    ")]),_vm._v(" "),_c('span',{staticClass:"kiwi-nicklist-messageuser",on:{"click":function($event){$event.stopPropagation();return _vm.nicklist.openQuery(_vm.user)}}},[_c('i',{staticClass:"fa fa-comment",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('typing-status-indicator',{attrs:{"user":_vm.user,"buffer":_vm.nicklist.buffer}})],1)}
var staticRenderFns = []


/***/ }),

/***/ "J5qk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-messagelist-message kiwi-messagelist-message--text",class:[
        'kiwi-messagelist-message-' + _vm.message.type,
        _vm.message.type_extra ?
            'kiwi-messagelist-message-' + _vm.message.type + '-' + _vm.message.type_extra :
            '',
        _vm.ml.isMessageHighlight(_vm.message) ?
            'kiwi-messagelist-message--highlight' :
            '',
        _vm.ml.isHoveringOverMessage(_vm.message) ?
            'kiwi-messagelist-message--hover' :
            '',
        _vm.ml.buffer.last_read && _vm.message.time > _vm.ml.buffer.last_read ?
            'kiwi-messagelist-message--unread' :
            '',
        _vm.message.nick.toLowerCase() === _vm.ml.ourNick.toLowerCase() ?
            'kiwi-messagelist-message--own' :
            '',
        _vm.ml.message_info_open === _vm.message ?
            'kiwi-messagelist-message--info-open' :
            '',
        _vm.ml.message_info_open && _vm.ml.message_info_open !== _vm.message ?
            'kiwi-messagelist-message--blur' :
            '',
        (_vm.message.user && _vm.userMode(_vm.message.user)) ?
            'kiwi-messagelist-message--user-mode-'+_vm.userMode(_vm.message.user) :
            ''
    ],attrs:{"data-message-id":_vm.message.id,"data-nick":(_vm.message.nick||'').toLowerCase()},on:{"click":function($event){return _vm.ml.onMessageClick($event, _vm.message, true)},"dblclick":function($event){return _vm.ml.onMessageDblClick($event, _vm.message)}}},[_c('div',[(_vm.ml.bufferSetting('show_timestamps'))?_c('span',{staticClass:"kiwi-messagelist-time"},[_vm._v("\n            "+_vm._s(_vm.ml.formatTime(_vm.message.time))+"\n        ")]):_vm._e(),_vm._v(" "),_c('span',{class:[
                'kiwi-messagelist-nick',
                (_vm.message.user && _vm.userMode(_vm.message.user)) ?
                    'kiwi-messagelist-nick--mode-'+_vm.userMode(_vm.message.user) :
                    ''
            ],style:({ 'color': _vm.userColour }),attrs:{"data-nick":_vm.message.nick},on:{"click":function($event){return _vm.ml.openUserBox(_vm.message.nick)},"mouseover":function($event){_vm.ml.hover_nick=_vm.message.nick.toLowerCase();},"mouseout":function($event){_vm.ml.hover_nick='';}}},[_c('span',{staticClass:"kiwi-messagelist-nick--prefix"},[_vm._v("\n                "+_vm._s(_vm.message.user ? _vm.userModePrefix(_vm.message.user) : '')+"\n            ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.displayNick))])]),_vm._v(" "),(_vm.message.bodyTemplate && _vm.message.bodyTemplate.$el)?_c('div',{directives:[{name:"rawElement",rawName:"v-rawElement",value:(_vm.message.bodyTemplate.$el),expression:"message.bodyTemplate.$el"}],staticClass:"kiwi-messagelist-body"}):_c('div',{staticClass:"kiwi-messagelist-body",domProps:{"innerHTML":_vm._s(_vm.ml.formatMessage(_vm.message))}})]),_vm._v(" "),(_vm.ml.message_info_open===_vm.message)?_c('message-info',{attrs:{"message":_vm.message,"buffer":_vm.ml.buffer},on:{"close":function($event){return _vm.ml.toggleMessageInfo()}}}):_vm._e()],1)}
var staticRenderFns = []


/***/ }),

/***/ "JNJi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JPz/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputText_vue__ = __webpack_require__("vM24");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputText_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputText_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputText_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputText_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f7c1cec_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputText_vue__ = __webpack_require__("Wc5+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("5Bi3")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputText_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f7c1cec_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputText_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f7c1cec_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputText_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "K/tP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-settings-advanced"},[_c('div',{staticClass:"kiwi-settings-advanced-notice"},[_vm._v(_vm._s(_vm.$t('settings_advanced_header')))]),_vm._v(" "),_c('form',{staticClass:"u-form"},[_c('div',{staticClass:"kiwi-settings-advanced-filter-container"},[_c('div',{staticClass:"kiwi-settings-advanced-filter-container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterString),expression:"filterString"}],staticClass:"u-input",attrs:{"placeholder":_vm.$t('settings_advanced_filter')},domProps:{"value":(_vm.filterString)},on:{"input":function($event){if($event.target.composing){ return; }_vm.filterString=$event.target.value}}}),_vm._v(" "),(!_vm.filterString)?_c('i',{staticClass:"fa fa-search",attrs:{"aria-hidden":"true"}}):_c('i',{staticClass:"fa fa-times",attrs:{"aria-hidden":"true"},on:{"click":function($event){_vm.filterString = ''}}})])]),_vm._v(" "),_c('table',{staticClass:"u-table kiwi-settings-advanced-table",attrs:{"cellspacing":"0"}},[(_vm.filteredSettings.length === 0)?_c('tr',[_c('td',{staticClass:"kiwi-settings-advanced-noresult"},[_vm._v("\n                    "+_vm._s(_vm.filterString)+" - "+_vm._s(_vm.$t('not_found'))+"\n                ")])]):_vm._l((_vm.filteredSettings),function(setting){return _c('tr',{key:setting.key,class:{'kiwi-advanced-setting': !setting.modified,
                         'kiwi-advanced-setting--modified': setting.modified,
            }},[_c('td',[_c('label',{attrs:{"for":'setting-' + setting.key}},[_vm._v(_vm._s(setting.key))])]),_vm._v(" "),(setting.modified)?_c('td',[_c('a',{staticClass:"u-link",on:{"click":function($event){return _vm.resetValue($event, setting.key)}}},[_vm._v("\n                        "+_vm._s(_vm.$t('settings_advanced_reset'))+"\n                        "),_c('i',{staticClass:"fa fa-undo",staticStyle:{"margin-left":"10px"}})])]):_c('td'),_vm._v(" "),_c('td',[(setting.type === 'boolean')?_c('input',{attrs:{"id":'setting-' + setting.key,"type":"checkbox"},domProps:{"checked":setting.val},on:{"change":function($event){return _vm.updateSetting($event, setting.key)}}}):(setting.type === 'number')?_c('input',{staticClass:"u-input",attrs:{"id":'setting-' + setting.key,"type":"number"},domProps:{"value":setting.val},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==13){ return null; }return $event.target.blur()},"change":function($event){return _vm.updateSetting($event, setting.key)},"blur":function($event){return _vm.updateSetting($event, setting.key)}}}):_c('input',{staticClass:"u-input",attrs:{"id":'setting-' + setting.key},domProps:{"value":setting.val},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==13){ return null; }return $event.target.blur()},"blur":function($event){return _vm.updateSetting($event, setting.key)}}})])])})],2)])])}
var staticRenderFns = []


/***/ }),

/***/ "KETo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"u-input-confirm kiwi-theme-bg"},[(_vm.state==='pre')?_c('div',{on:{"click":_vm.prompt}},[_vm._t("default")],2):_vm._e(),_vm._v(" "),(_vm.state==='prompt')?[_c('span',{staticClass:"u-input-confirm-label"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('a',{staticClass:"u-button",class:['u-button-'+_vm.connoteCss.yes],on:{"click":function($event){return _vm.complete(true)}}},[_vm._v("\n            "+_vm._s(_vm.$t('yes'))+"\n        ")]),_vm._v(" "),_c('a',{staticClass:"u-button",class:['u-button-'+_vm.connoteCss.no],on:{"click":function($event){return _vm.complete(false)}}},[_vm._v("\n            "+_vm._s(_vm.$t('no'))+"\n        ")])]:_vm._e()],2)}
var staticRenderFns = []


/***/ }),

/***/ "KqVi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-appsettings"},[_c('div',{staticClass:"kiwi-appsettings-title",on:{"click":_vm.closeSettings}},[_c('span',[_vm._v(_vm._s(_vm.$t('close')))]),_vm._v(" "),_c('i',{staticClass:"fa fa-times",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('form',{staticClass:"u-form"},[_c('tabbed-view',{ref:"tabs",staticClass:"kiwi-appsettings-tab-container"},[_c('tabbed-tab',{attrs:{"header":_vm.$t('settings_general'),"focus":true,"name":"general"}},[_c('div',{staticClass:"kiwi-appsettings-block"},[_c('h3',[_vm._v(_vm._s(_vm.$t('settings_general')))]),_vm._v(" "),_c('div',{staticClass:"kiwi-appsettings-section kiwi-appsettings-general"},[_c('label',{staticClass:"kiwi-appsettings-setting-language"},[_c('div',[_c('i',{staticClass:"fa fa-globe"})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.settingLanguage),expression:"settingLanguage"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.settingLanguage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("\n                                    Auto\n                                ")]),_vm._v(" "),_vm._l((_vm.localesList),function(l){return _c('option',{key:l[0],domProps:{"value":l[0]}},[_vm._v("\n                                    "+_vm._s(l[1])+"\n                                ")])})],2)]),_vm._v(" "),_c('label',{staticClass:"kiwi-appsettings-setting-theme"},[_c('span',[_vm._v(_vm._s(_vm.$t('settings_theme'))+" ")]),_vm._v(" "),_c('a',{staticClass:"kiwi-appsettings-theme-reload",attrs:{"title":_vm.$t('refresh_theme')},on:{"click":_vm.refreshTheme}},[_c('i',{staticClass:"fa fa-refresh",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.theme),expression:"theme"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.theme=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.settings.themes),function(t){return _c('option',{key:t.name,domProps:{"value":t.name}},[_vm._v("\n                                    "+_vm._s(t.name)+"\n                                ")])}),0)]),_vm._v(" "),(_vm.theme==='custom')?_c('label',[_c('span',[_vm._v(_vm._s(_vm.$t('settings_themeurl'))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customThemeUrl),expression:"customThemeUrl"}],staticClass:"u-input",domProps:{"value":(_vm.customThemeUrl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.customThemeUrl=$event.target.value}}})]):_vm._e(),_vm._v(" "),_c('label',{staticClass:"u-checkbox-wrapper"},[_c('span',[_vm._v(_vm._s(_vm.$t('settings_show_autocomplete'))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settingShowAutoComplete),expression:"settingShowAutoComplete"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.settingShowAutoComplete)?_vm._i(_vm.settingShowAutoComplete,null)>-1:(_vm.settingShowAutoComplete)},on:{"change":function($event){var $$a=_vm.settingShowAutoComplete,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.settingShowAutoComplete=$$a.concat([$$v]))}else{$$i>-1&&(_vm.settingShowAutoComplete=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.settingShowAutoComplete=$$c}}}})]),_vm._v(" "),(_vm.themeSupportsMonospace)?_c('label',{staticClass:"u-checkbox-wrapper"},[_c('span',[_vm._v(_vm._s(_vm.$t('settings_use_monospace'))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settingUseMonospace),expression:"settingUseMonospace"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.settingUseMonospace)?_vm._i(_vm.settingUseMonospace,null)>-1:(_vm.settingUseMonospace)},on:{"change":function($event){var $$a=_vm.settingUseMonospace,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.settingUseMonospace=$$a.concat([$$v]))}else{$$i>-1&&(_vm.settingUseMonospace=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.settingUseMonospace=$$c}}}})]):_vm._e(),_vm._v(" "),(_vm.canRegisterProtocolHandler)?_c('div',{staticStyle:{"margin-top":"10px","text-align":"center"}},[_c('a',{staticClass:"u-button u-button-primary",on:{"click":function($event){return _vm.makeDefaultProtocolHandler()}}},[_c('i',[_vm._v(_vm._s(_vm.$t('settings_default_handler')))])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"kiwi-appsettings-block"},[_c('h3',[_vm._v(_vm._s(_vm.$t('settings_messages_title')))]),_vm._v(" "),_c('div',{staticClass:"kiwi-appsettings-section kiwi-appsettings-messages"},[_c('label',{staticClass:"kiwi-appsettings-messagelistDisplay"},[_c('span',[_vm._v(_vm._s(_vm.$t('settings_messagelayout'))+" ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.settingMessageLayout),expression:"settingMessageLayout"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.settingMessageLayout=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"traditional"}},[_vm._v("Traditional")]),_vm._v(" "),_c('option',{attrs:{"value":"modern"}},[_vm._v("Modern")]),_vm._v(" "),_c('option',{attrs:{"value":"inline"}},[_vm._v("Inline")])])]),_vm._v(" "),_c('label',{staticClass:"u-checkbox-wrapper"},[_c('span',[_vm._v(_vm._s(_vm.$t('settings_timestamps'))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settingBufferShowTimestamps),expression:"settingBufferShowTimestamps"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.settingBufferShowTimestamps)?_vm._i(_vm.settingBufferShowTimestamps,null)>-1:(_vm.settingBufferShowTimestamps)},on:{"change":function($event){var $$a=_vm.settingBufferShowTimestamps,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.settingBufferShowTimestamps=$$a.concat([$$v]))}else{$$i>-1&&(_vm.settingBufferShowTimestamps=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.settingBufferShowTimestamps=$$c}}}})]),_vm._v(" "),_c('label',{staticClass:"u-checkbox-wrapper"},[_c('span',[_vm._v(_vm._s(_vm.$t('settings_24hour_timestamps'))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.timestamps_24h),expression:"timestamps_24h"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.timestamps_24h)?_vm._i(_vm.timestamps_24h,null)>-1:(_vm.timestamps_24h)},on:{"change":function($event){var $$a=_vm.timestamps_24h,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.timestamps_24h=$$a.concat([$$v]))}else{$$i>-1&&(_vm.timestamps_24h=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.timestamps_24h=$$c}}}})]),_vm._v(" "),_c('label',{staticClass:"u-checkbox-wrapper"},[_c('span',[_vm._v(_vm._s(_vm.$t('settings_emoticons'))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settingBufferShowEmoticons),expression:"settingBufferShowEmoticons"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.settingBufferShowEmoticons)?_vm._i(_vm.settingBufferShowEmoticons,null)>-1:(_vm.settingBufferShowEmoticons)},on:{"change":function($event){var $$a=_vm.settingBufferShowEmoticons,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.settingBufferShowEmoticons=$$a.concat([$$v]))}else{$$i>-1&&(_vm.settingBufferShowEmoticons=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.settingBufferShowEmoticons=$$c}}}})]),_vm._v(" "),_c('label',{staticClass:"u-checkbox-wrapper"},[_c('span',[_vm._v(_vm._s(_vm.$t('settings_block_private'))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settingBufferBlockPms),expression:"settingBufferBlockPms"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.settingBufferBlockPms)?_vm._i(_vm.settingBufferBlockPms,null)>-1:(_vm.settingBufferBlockPms)},on:{"change":function($event){var $$a=_vm.settingBufferBlockPms,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.settingBufferBlockPms=$$a.concat([$$v]))}else{$$i>-1&&(_vm.settingBufferBlockPms=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.settingBufferBlockPms=$$c}}}})]),_vm._v(" "),_c('label',{staticClass:"kiwi-appsettings-full kiwi-appsettings-setting-scrollback"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settingBufferScrollbackSize),expression:"settingBufferScrollbackSize"}],staticClass:"u-input",attrs:{"type":"number"},domProps:{"value":(_vm.settingBufferScrollbackSize)},on:{"input":function($event){if($event.target.composing){ return; }_vm.settingBufferScrollbackSize=$event.target.value}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('settings_scrollback'))+" ")])]),_vm._v(" "),_c('label',{staticClass:"u-checkbox-wrapper"},[_c('span',[_vm._v(_vm._s(_vm.$t('settings_formatting'))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settingBufferExtraFormatting),expression:"settingBufferExtraFormatting"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.settingBufferExtraFormatting)?_vm._i(_vm.settingBufferExtraFormatting,null)>-1:(_vm.settingBufferExtraFormatting)},on:{"change":function($event){var $$a=_vm.settingBufferExtraFormatting,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.settingBufferExtraFormatting=$$a.concat([$$v]))}else{$$i>-1&&(_vm.settingBufferExtraFormatting=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.settingBufferExtraFormatting=$$c}}}})]),_vm._v(" "),_c('label',{staticClass:"u-checkbox-wrapper"},[_c('span',[_vm._v(_vm._s(_vm.$t('settings_nick_colouring'))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settingBufferColourNicknames),expression:"settingBufferColourNicknames"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.settingBufferColourNicknames)?_vm._i(_vm.settingBufferColourNicknames,null)>-1:(_vm.settingBufferColourNicknames)},on:{"change":function($event){var $$a=_vm.settingBufferColourNicknames,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.settingBufferColourNicknames=$$a.concat([$$v]))}else{$$i>-1&&(_vm.settingBufferColourNicknames=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.settingBufferColourNicknames=$$c}}}})]),_vm._v(" "),_c('label',{staticClass:"u-checkbox-wrapper"},[_c('span',[_vm._v(_vm._s(_vm.$t('settings_share_typing'))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settingBufferShareTyping),expression:"settingBufferShareTyping"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.settingBufferShareTyping)?_vm._i(_vm.settingBufferShareTyping,null)>-1:(_vm.settingBufferShareTyping)},on:{"change":function($event){var $$a=_vm.settingBufferShareTyping,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.settingBufferShareTyping=$$a.concat([$$v]))}else{$$i>-1&&(_vm.settingBufferShareTyping=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.settingBufferShareTyping=$$c}}}})])])]),_vm._v(" "),_c('div',{staticClass:"kiwi-appsettings-block"},[_c('h3',[_vm._v(_vm._s(_vm.$t('notifications')))]),_vm._v(" "),_c('div',{staticClass:"kiwi-appsettings-section kiwi-appsettings-notifications"},[_c('label',{staticClass:"kiwi-appsettings-setting-showjoinpart u-checkbox-wrapper"},[_c('span',[_vm._v(_vm._s(_vm.$t('settings_show_joinpart'))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settingBufferTrafficAsActivity),expression:"settingBufferTrafficAsActivity"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.settingBufferTrafficAsActivity)?_vm._i(_vm.settingBufferTrafficAsActivity,null)>-1:(_vm.settingBufferTrafficAsActivity)},on:{"change":function($event){var $$a=_vm.settingBufferTrafficAsActivity,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.settingBufferTrafficAsActivity=$$a.concat([$$v]))}else{$$i>-1&&(_vm.settingBufferTrafficAsActivity=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.settingBufferTrafficAsActivity=$$c}}}})]),_vm._v(" "),_c('label',{staticClass:"u-checkbox-wrapper"},[_c('span',[_vm._v(_vm._s(_vm.$t('settings_mute_sound'))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settingBufferMuteSound),expression:"settingBufferMuteSound"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.settingBufferMuteSound)?_vm._i(_vm.settingBufferMuteSound,null)>-1:(_vm.settingBufferMuteSound)},on:{"change":function($event){var $$a=_vm.settingBufferMuteSound,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.settingBufferMuteSound=$$a.concat([$$v]))}else{$$i>-1&&(_vm.settingBufferMuteSound=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.settingBufferMuteSound=$$c}}}})]),_vm._v(" "),_c('label',{staticClass:"kiwi-appsettings-full"},[_c('span',[_vm._v(_vm._s(_vm.$t('settings_highlight'))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settingHighlights),expression:"settingHighlights"}],staticClass:"u-input",attrs:{"type":"text"},domProps:{"value":(_vm.settingHighlights)},on:{"input":function($event){if($event.target.composing){ return; }_vm.settingHighlights=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"kiwi-appsettings-block"},[_c('h3',[_vm._v(_vm._s(_vm.$t('operator_tools')))]),_vm._v(" "),_c('div',{staticClass:"kiwi-appsettings-section kiwi-appsettings-operator-tools"},[_c('label',[_c('span',[_vm._v(_vm._s(_vm.$t('settings_default_ban_mask'))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settingDefaultBanMask),expression:"settingDefaultBanMask"}],staticClass:"u-input",domProps:{"value":(_vm.settingDefaultBanMask)},on:{"input":function($event){if($event.target.composing){ return; }_vm.settingDefaultBanMask=$event.target.value}}})]),_vm._v(" "),_c('label',[_c('span',[_vm._v(_vm._s(_vm.$t('settings_default_kick_reason')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settingDefaultKickReason),expression:"settingDefaultKickReason"}],staticClass:"u-input",domProps:{"value":(_vm.settingDefaultKickReason)},on:{"input":function($event){if($event.target.composing){ return; }_vm.settingDefaultKickReason=$event.target.value}}})])])]),_vm._v(" "),(!_vm.state.setting('hide_advanced') && !_vm.settingAdvancedEnable)?_c('div',{staticClass:"kiwi-appsettings-block"},[_c('h3',[_vm._v(_vm._s(_vm.$t('settings_advanced_title')))]),_vm._v(" "),_c('div',{staticClass:"kiwi-appsettings-section kiwi-appsettings-advanced-enable"},[_c('div',[_c('span',{staticStyle:{"font-weight":"600"}},[_vm._v("\n                                "+_vm._s(_vm.$t('warning'))+"\n                            ")]),_vm._v("\n                            "+_vm._s(_vm.$t('settings_advanced_warning'))+"\n                        ")]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px","text-align":"center"}},[_c('a',{staticClass:"u-button u-button-warning",on:{"click":function($event){return _vm.enableAdvancedTab()}}},[_c('i',[_vm._v(_vm._s(_vm.$t('settings_advanced_button')))])])])])]):_vm._e()]),_vm._v(" "),_c('tabbed-tab',{attrs:{"header":_vm.$t('settings_aliases'),"name":"aliases"}},[_c('div',{staticClass:"kiwi-appsettings-block kiwi-appsettings-block-aliases"},[_c('h3',[_vm._v(_vm._s(_vm.$t('settings_aliases')))]),_vm._v(" "),_c('div',{staticClass:"kiwi-appsettings-section kiwi-appsettings-aliases"},[_c('settings-aliases')],1)])]),_vm._v(" "),(_vm.settingAdvancedEnable)?_c('tabbed-tab',{attrs:{"header":_vm.$t('settings_advanced'),"name":"advanced"}},[_c('div',{staticClass:"kiwi-appsettings-block kiwi-appsettings-block-advanced"},[_c('div',{staticClass:"kiwi-appsettings-section kiwi-appsettings-advanced"},[_c('settings-advanced')],1)])]):_vm._e(),_vm._v(" "),_vm._l((_vm.pluginUiElements),function(item){return _c('tabbed-tab',{key:item.id,attrs:{"header":item.title,"name":item.title}},[_c(item.component,_vm._b({tag:"div"},'div',item.props,false))],1)})],2)],1)])}
var staticRenderFns = []


/***/ }),

/***/ "L52m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabbedView_vue__ = __webpack_require__("sOme");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabbedView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabbedView_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabbedView_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabbedView_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7423f5a6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabbedView_vue__ = __webpack_require__("U+ER");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("60/t")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabbedView_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7423f5a6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabbedView_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7423f5a6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabbedView_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "LEol":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LHti":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-header kiwi-theme-bg",class:{
        'kiwi-header--showall': _vm.buffer_settings_open,
    },on:{"click":_vm.onHeaderClick}},[(_vm.isChannel())?[_c('div',{staticClass:"kiwi-header-name"},[_vm._v(_vm._s(_vm.buffer.name))]),_vm._v(" "),(_vm.isJoined && _vm.isConnected)?_c('div',{key:_vm.buffer.id,staticClass:"kiwi-header-options"},[_vm._l((_vm.pluginUiChannelElements),function(plugin){return _c('div',{directives:[{name:"rawElement",rawName:"v-rawElement",value:(plugin.el),expression:"plugin.el"}],key:plugin.id,staticClass:"kiwi-header-option"})}),_vm._v(" "),_c('div',{staticClass:"kiwi-header-option kiwi-header-option-about",class:{
                    'kiwi-header-option--active': _vm.sidebarState.sidebarSection === 'about'
                }},[_c('a',{attrs:{"title":_vm.$t('more_information')},on:{"click":function($event){return _vm.sidebarState.toggleAbout()}}},[_c('i',{staticClass:"fa fa-info",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('div',{staticClass:"kiwi-header-option kiwi-header-option-nicklist",class:{
                    'kiwi-header-option--active': _vm.sidebarState.sidebarSection === 'nicklist'
                        || _vm.sidebarState.sidebarSection === 'user'
                }},[_c('a',{attrs:{"title":_vm.$t('person', {count: Object.keys(_vm.buffer.users).length})},on:{"click":function($event){return _vm.sidebarState.toggleNicklist()}}},[_c('i',{staticClass:"fa fa-users",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(Object.keys(_vm.buffer.users).length))])])]),_vm._v(" "),_c('div',{staticClass:"kiwi-header-option kiwi-header-option-settings",class:{
                    'kiwi-header-option--active': _vm.sidebarState.sidebarSection === 'settings'
                }},[_c('a',{attrs:{"title":_vm.$t('channel_settings')},on:{"click":function($event){return _vm.sidebarState.toggleBufferSettings()}}},[_c('i',{staticClass:"fa fa-cog",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),(_vm.sidebarState.isPinned)?_c('div',{staticClass:"kiwi-header-option kiwi-header-option-unpinsidebar"},[_c('a',{on:{"click":function($event){return _vm.sidebarState.unpin()}}},[_c('i',{staticClass:"fa fa-thumb-tack",attrs:{"aria-hidden":"true"}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"kiwi-header-option kiwi-header-option-leave"},[_c('a',{attrs:{"title":_vm.$t('close')},on:{"click":function($event){return _vm.showPrompt('closeChannel')}}},[_c('i',{staticClass:"fa fa-times",attrs:{"aria-hidden":"true"}})])])],2):_vm._e(),_vm._v(" "),(!_vm.isJoined && _vm.isConnected)?_c('div',{staticClass:"kiwi-header-notjoined"},[_c('a',{staticClass:"u-link kiwi-header-join-channel-button",on:{"click":_vm.joinCurrentBuffer}},[_vm._v("\n                "+_vm._s(_vm.$t('container_join'))+"\n            ")])]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"kiwi-header-prompttrans"}},[(_vm.prompts.closeChannel)?_c('input-confirm',{staticClass:"kiwi-header-prompt",attrs:{"label":_vm.$t('prompt_leave_channel'),"flip_connotation":true},on:{"ok":_vm.closeCurrentBuffer,"submit":function($event){_vm.prompts.closeChannel=false}}}):_vm._e()],1)]:(_vm.isServer())?[_c('div',{staticClass:"kiwi-header-name"},[_vm._v("\n            "+_vm._s(_vm.buffer.getNetwork().name)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"kiwi-header-server-connection"},[(_vm.buffer.getNetwork().state === 'disconnected')?_c('a',{staticClass:"u-button u-button-primary",on:{"click":_vm.onConnectButtonClick}},[_vm._v("\n                "+_vm._s(_vm.$t('connect'))+"\n            ")]):(_vm.buffer.getNetwork().state === 'connecting')?_c('span',[_c('i',{staticClass:"fa fa-spin fa-spinner",attrs:{"aria-hidden":"true"}}),_vm._v("\n                "+_vm._s(_vm.$t('connecting'))+"\n            ")]):_vm._e()])]:(_vm.isQuery())?[_c('div',{staticClass:"kiwi-header-name"},[_c('away-status-indicator',{staticClass:"kiwi-header-awaystatus",attrs:{"network":_vm.buffer.getNetwork(),"user":_vm.network.userByName(_vm.buffer.name)}}),_vm._v("\n            "+_vm._s(_vm.buffer.name)+"\n        ")],1),_vm._v(" "),_c('div',{key:_vm.buffer.id,staticClass:"kiwi-header-options"},[_vm._l((_vm.pluginUiQueryElements),function(plugin){return _c('div',{directives:[{name:"rawElement",rawName:"v-rawElement",value:(plugin.el),expression:"plugin.el"}],key:plugin.id,staticClass:"kiwi-header-option"})}),_vm._v(" "),_c('div',{staticClass:"kiwi-header-option kiwi-header-option-leave"},[_c('a',{on:{"click":_vm.closeCurrentBuffer}},[_c('i',{staticClass:"fa fa-times",attrs:{"aria-hidden":"true"}})])])],2)]:(_vm.isSpecial())?[_c('div',{staticClass:"kiwi-header-name"},[_vm._v(_vm._s(_vm.buffer.name))]),_vm._v(" "),_c('div',{staticClass:"kiwi-header-options"},[_c('div',{staticClass:"kiwi-header-option kiwi-header-option-leave"},[_c('a',{on:{"click":_vm.closeCurrentBuffer}},[_c('i',{staticClass:"fa fa-times",attrs:{"aria-hidden":"true"}})])])])]:_vm._e(),_vm._v(" "),(_vm.buffer_settings_open)?_c('div',{staticClass:"kiwi-header-buffersettings",on:{"click":function($event){$event.stopPropagation();}}},[_c('tabbed-view',[_c('tabbed-tab',{attrs:{"header":_vm.$t('settings'),"focus":true}},[_c('channel-info',{attrs:{"buffer":_vm.buffer}})],1),_vm._v(" "),_c('tabbed-tab',{attrs:{"header":_vm.$t('banned')}},[_c('channel-banlist',{attrs:{"buffer":_vm.buffer}})],1),_vm._v(" "),_c('tabbed-tab',{attrs:{"header":_vm.$t('notifications')}},[_c('buffer-settings',{attrs:{"buffer":_vm.buffer}})],1)],1),_vm._v(" "),_c('a',{staticClass:"u-button u-button-secondary kiwi-header-close-buffersettings",on:{"click":function($event){_vm.buffer_settings_open=false}}},[_c('i',{staticClass:"fa fa-caret-up",attrs:{"aria-hidden":"true"}})])],1):_vm._e()],2)}
var staticRenderFns = []


/***/ }),

/***/ "LS2E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-notconnected kiwi-warning-block",class:{ connecting: _vm.shouldShowLoading }},[(!_vm.shouldShowLoading)?[_c('div',{staticClass:"kiwi-notconnected-caption"},[_c('span',[_vm._v(_vm._s(_vm.$t('not_connected')))]),_vm._v(" "),(!_vm.shouldShowLoading)?_c('i',{staticClass:"fa fa-frown-o",attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"kiwi-notconnected-buttons"},[(_vm.isChannel())?[_c('span',{staticClass:"kiwi-notconnected-button",on:{"click":_vm.reconnect}},[_c('i',{staticClass:"fa fa-arrow-circle-o-right",attrs:{"aria-hidden":"true"}}),_vm._v("\n                    "+_vm._s(_vm.$t('reconnect_channel', {channel: _vm.buffer.name}))+"\n                ")])]:(_vm.isServer())?[_c('span',{staticClass:"kiwi-notconnected-button",on:{"click":_vm.reconnect}},[_c('i',{staticClass:"fa fa-arrow-circle-o-right",attrs:{"aria-hidden":"true"}}),_vm._v("\n                    "+_vm._s(_vm.$t('reconnect_network', {network: _vm.buffer.getNetwork().name}))+"\n                ")])]:(_vm.isQuery())?[_c('span',{staticClass:"kiwi-notconnected-button",on:{"click":_vm.reconnect}},[_c('i',{staticClass:"fa fa-arrow-circle-o-right",attrs:{"aria-hidden":"true"}}),_vm._v("\n                    "+_vm._s(_vm.$t('reconnect_query', {user: _vm.buffer.name}))+"\n                ")])]:_vm._e(),_vm._v(" "),(!_vm.restrictedServer)?_c('a',{staticClass:"kiwi-notconnected-button kiwi-notconnected-button-settings",on:{"click":_vm.showNetworkSettings}},[_c('i',{staticClass:"fa fa-cogs",attrs:{"aria-hidden":"true"}})]):_vm._e()],2)]:_c('div',{staticClass:"kiwi-notconnected-caption"},[_vm._v("\n        "+_vm._s(_vm.$t('connecting'))+"\n        "),_c('i',{staticClass:"fa fa-refresh fa-spin kiwi-notconnected-bigicon",attrs:{"aria-hidden":"true"}})])],2)}
var staticRenderFns = []


/***/ }),

/***/ "LSH7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Emoji_vue__ = __webpack_require__("U6GM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Emoji_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Emoji_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Emoji_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Emoji_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_052fde38_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Emoji_vue__ = __webpack_require__("t8YU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("j7Zd")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Emoji_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_052fde38_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Emoji_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_052fde38_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Emoji_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Lc9z":
/***/ (function(module, exports) {

module.exports = [["af-za","Afrikaans (Afrikaans)"],["sq-al","Shqip (Albanian)"],["ar-sa","العربية (Arabic)"],["eu-es","Euskara (Basque)"],["bs-ba","Bosanski (Bosnian)"],["bg-bg","Български (Bulgarian)"],["ca-es","Català (Catalan)"],["zh-cn","中文 (Chinese Simplified)"],["nl-nl","Nederlands (Dutch)"],["en-us","English (English)"],["fr-fr","Français (French)"],["gl-es","Galego (Galician)"],["de-de","Deutsch (German)"],["el-gr","Ελληνικά (Greek)"],["he-il","עברית (Hebrew)"],["id-id","Bahasa Indonesia (Indonesian)"],["it-it","Italiano (Italian)"],["pl-pl","Polski (Polish)"],["pt-pt","Português (Portuguese)"],["pt-br","Português do Brasil (Portuguese, Brazilian)"],["ru-ru","Русский (Russian)"],["es-es","Español (Spanish)"],["es-ar","Español argentino (Spanish, Argentina)"],["es-us","Español mexicano (Spanish, Mexican)"],["uk-ua","Українська (Ukrainian)"]]

/***/ }),

/***/ "LnP8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _create = __webpack_require__("OvRC");

var _create2 = _interopRequireDefault(_create);

var _Misc = __webpack_require__("uN9+");

var Misc = _interopRequireWildcard(_Misc);

var _vue = __webpack_require__("I3G/");

var _vue2 = _interopRequireDefault(_vue);

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _configTemplates = __webpack_require__("29nj");

var _NetworkState = __webpack_require__("ox6C");

var _NetworkState2 = _interopRequireDefault(_NetworkState);

var _BufferState = __webpack_require__("FKBE");

var _BufferState2 = _interopRequireDefault(_BufferState);

var _UserState = __webpack_require__("ecZp");

var _UserState2 = _interopRequireDefault(_UserState);

var _Message = __webpack_require__("7p2c");

var _Message2 = _interopRequireDefault(_Message);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stateObj = {
    persistence: null,

    settings: _configTemplates.configTemplates.default,
    user_settings: {},
    connection: {
        status: 'connected',
        sessionId: ''
    },
    ui: {
        active_network: 0,
        active_buffer: '',
        last_active_buffers: [],
        app_has_focus: true,
        app_width: 0,
        app_height: 0,
        is_touch: false,
        is_narrow: false,
        favicon_counter: 0,
        current_input: '',
        input_history: [],
        input_history_pos: 0,
        show_advanced_tab: false
    },
    networks: []
};

var userDict = new _vue2.default({
    data: function data() {
        return {
            networks: {}
        };
    }
});

var bufferDict = new _vue2.default({
    data: function data() {
        return {
            networks: {}
        };
    }
});

var messages = [];

var availableStartups = (0, _create2.default)(null);

var state = new _vue2.default({
    data: stateObj,
    methods: {
        exportState: function exportState(includeBuffers) {
            var toExport = {};

            if (includeBuffers) {
                toExport.networks = state.networks.map(function (network) {
                    var networkObj = {
                        id: network.id,
                        name: network.name,
                        connection: {
                            nick: network.connection.nick,
                            server: network.connection.server,
                            port: network.connection.port,
                            tls: network.connection.tls,
                            path: network.connection.path,
                            password: network.password,
                            direct: network.connection.direct,
                            encoding: network.connection.encoding
                        },
                        auto_commands: network.auto_commands,
                        settings: _lodash2.default.cloneDeep(network.settings),
                        username: network.username,
                        gecos: network.gecos,
                        password: network.password,
                        buffers: []
                    };

                    networkObj.buffers = network.buffers.map(function (buffer) {
                        var bufferObj = {
                            name: buffer.name,
                            key: buffer.key,
                            enabled: !!buffer.enabled,
                            settings: _lodash2.default.cloneDeep(buffer.settings)
                        };

                        return bufferObj;
                    });

                    return networkObj;
                });
            }

            toExport.user_settings = state.user_settings;

            return (0, _stringify2.default)(toExport);
        },
        importState: function importState(stateStr) {
            var _this = this;

            var importObj = JSON.parse(stateStr);
            if (importObj && importObj.networks) {
                this.resetState();
                importObj.networks.forEach(function (importNetwork) {
                    var network = new _NetworkState2.default(importNetwork.id, state, userDict, bufferDict);
                    network.name = importNetwork.name;
                    network.connection = (0, _extends3.default)({}, network.connection, importNetwork.connection);
                    network.auto_commands = importNetwork.auto_commands || '';
                    network.settings = importNetwork.settings;

                    network.nick = importNetwork.nick || importNetwork.connection.nick;
                    if (!network.connection.nick && importNetwork.nick) {
                        network.connection.nick = importNetwork.nick;
                    }
                    network.username = importNetwork.username;
                    network.gecos = importNetwork.gecos;
                    network.password = importNetwork.password;

                    _this.networks.push(network);

                    importNetwork.buffers.forEach(function (impBuffer) {
                        var buffer = new _BufferState2.default(impBuffer.name, network.id, state, messages);
                        buffer.key = impBuffer.key;
                        buffer.enabled = !!impBuffer.enabled;
                        buffer.settings = impBuffer.settings;

                        network.buffers.push(buffer);
                    });
                });
            }

            if (importObj && importObj.user_settings) {
                this.user_settings = importObj.user_settings;
            }
        },
        resetState: function resetState() {
            this.$set(this.$data, 'user_settings', {});
            this.$set(this.$data, 'networks', []);
            messages.splice(0);
        },
        setting: function setting(name, val) {
            if (typeof val !== 'undefined') {
                if (val === this.getSetting('settings.' + name)) {
                    return this.setSetting('user_settings.' + name, null);
                }

                return this.setSetting('user_settings.' + name, val);
            }

            var userSetting = this.getSetting('user_settings.' + name);
            var result = typeof userSetting !== 'undefined' ? userSetting : this.getSetting('settings.' + name);

            return result;
        },
        getSetting: function getSetting(name) {
            var parts = name.split('.');
            var val = this.$data;

            for (var i = 0; i < parts.length; i++) {
                val = val[parts[i]];
                if (typeof val === 'undefined') {
                    break;
                }
            }

            return val;
        },
        setSetting: function setSetting(name, newVal) {
            var parts = name.split('.');
            var val = this.$data;

            for (var i = 0; i < parts.length; i++) {
                var propName = parts[i];
                var nextVal = val[propName];

                if (i < parts.length - 1 && typeof nextVal === 'undefined') {
                    nextVal = this.$set(val, propName, {});
                } else if (i === parts.length - 1) {
                    if (newVal === null) {
                        this.$delete(val, propName);
                    } else {
                        this.$set(val, propName, newVal);
                    }
                }

                val = nextVal;
            }

            return val;
        },
        getActiveNetwork: function getActiveNetwork() {
            return this.getNetwork(this.ui.active_network);
        },
        getNetwork: function getNetwork(networkid) {
            var network = _lodash2.default.find(this.networks, {
                id: networkid
            });

            return network;
        },
        getNetworkFromAddress: function getNetworkFromAddress(netAddr) {
            return _lodash2.default.find(this.networks, function (net) {
                var isMatch = netAddr.toLowerCase() === net.connection.server.toLowerCase();
                return isMatch;
            });
        },
        getNetworkFromBncName: function getNetworkFromBncName(bncname) {
            return _lodash2.default.find(this.networks, function (net) {
                var isMatch = net.connection.bncname && bncname.toLowerCase() === net.connection.bncname.toLowerCase();
                return isMatch;
            });
        },
        addNetwork: function addNetwork(name, nick, serverInfo) {
            function networkidReduce(currentMax, network) {
                return network.id > currentMax ? network.id : currentMax;
            }
            var networkid = serverInfo.channelId ? parseInt(serverInfo.channelId, 10) : _lodash2.default.reduce(this.networks, networkidReduce, 0) + 1;

            var network = new _NetworkState2.default(networkid, state, userDict, bufferDict);
            network.name = name;
            network.username = serverInfo.username;
            network.gecos = serverInfo.gecos;
            network.password = serverInfo.password;
            network.connection.nick = nick;
            network.connection.server = serverInfo.server || '';
            network.connection.port = serverInfo.port || 6667;
            network.connection.tls = serverInfo.tls || false;
            network.connection.path = serverInfo.path || '';
            network.password = serverInfo.password || '';
            network.connection.direct = !!serverInfo.direct;
            network.connection.path = serverInfo.path || '';
            network.connection.encoding = serverInfo.encoding || 'utf8';
            network.connection.bncname = serverInfo.bncname || '';

            if (serverInfo.services) {
                network.services = serverInfo.services;
            }

            this.networks.push(network);

            this.addBuffer(network.id, '*').joined = true;

            var eventObj = { network: network };
            state.$emit('network.new', eventObj);

            return network;
        },
        removeNetwork: function removeNetwork(networkid) {
            var network = this.getNetwork(networkid);
            if (!network) {
                return;
            }

            if (network.state === 'connected') {
                network.ircClient.quit();
            }

            while (network.buffers.length > 0) {
                this.removeBuffer(network.buffers[0]);
            }

            var findNewNetwork = false;
            if (network === this.getActiveNetwork()) {
                findNewNetwork = true;
            }

            var idx = this.networks.indexOf(network);
            this.networks.splice(idx, 1);

            if (findNewNetwork) {
                this.openLastActiveBuffer();
            }

            var eventObj = { network: network };
            state.$emit('network.removed', eventObj);
        },
        getActiveBuffer: function getActiveBuffer() {
            return this.getBufferByName(this.ui.active_network, this.ui.active_buffer);
        },
        setActiveBuffer: function setActiveBuffer(networkid, bufferName) {
            if (!networkid) {
                this.ui.active_network = 0;
                this.ui.active_buffer = '';
            } else {
                if (this.ui.active_network) {
                    this.ui.last_active_buffers.push({
                        networkid: this.ui.active_network,
                        bufferName: this.ui.active_buffer
                    });

                    var lastActive = this.ui.last_active_buffers;
                    this.ui.last_active_buffers = lastActive.splice(lastActive.length - 20);
                }

                this.ui.active_network = networkid;
                this.ui.active_buffer = bufferName;

                var buffer = this.getBufferByName(networkid, bufferName);
                if (buffer && buffer.flags.unread) {
                    buffer.flags.unread = 0;
                }

                if (buffer) {
                    buffer.markAsRead(true);
                }
            }
        },


        openLastActiveBuffer: function openLastActiveBuffer() {
            var targetNetwork = void 0;
            var targetBuffer = void 0;
            var lastActive = this.ui.last_active_buffers;

            for (var i = lastActive.length - 1; i >= 0; i--) {
                var network = this.getNetwork(lastActive[i].networkid);
                if (!network) {
                    continue;
                }

                var buffer = network.bufferByName(lastActive[i].bufferName);
                if (!buffer) {
                    continue;
                }

                targetNetwork = network;
                targetBuffer = buffer;

                lastActive.splice(i);
                break;
            }

            if (!targetBuffer) {
                var _network = this.getActiveNetwork() || this.networks[0];
                if (_network) {
                    targetNetwork = _network;
                    var _buffer = _network.buffers[1];
                    if (_buffer) {
                        targetBuffer = _buffer;
                    } else {
                        targetBuffer = _network.serverBuffer();
                    }
                }
            }

            if (targetBuffer) {
                this.setActiveBuffer(targetNetwork.id, targetBuffer.name);
            } else {
                this.setActiveBuffer();
            }
        },

        updateBufferLastRead: function updateBufferLastRead(networkid, bufferName) {
            var buffer = this.getBufferByName(networkid, bufferName);
            if (buffer) {
                buffer.last_read = Date.now();
                buffer.active_timeout = null;
            }
        },
        getOrAddBufferByName: function getOrAddBufferByName(networkid, bufferName) {
            var network = this.getNetwork(networkid);
            if (!network) {
                return null;
            }

            var toMatch = bufferName.toLowerCase();
            var buffer = _lodash2.default.find(network.buffers, function (b) {
                return b.name.toLowerCase() === toMatch;
            });

            if (!buffer) {
                buffer = this.addBuffer(networkid, bufferName);
            }

            return buffer;
        },
        getBufferByName: function getBufferByName(networkid, bufferName) {
            if (!bufferName) {
                return null;
            }

            var network = this.getNetwork(networkid);
            if (!network) {
                return null;
            }

            var toMatch = bufferName.toLowerCase();
            var buffer = _lodash2.default.find(network.buffers, function (b) {
                return b.name.toLowerCase() === toMatch;
            });

            return buffer;
        },
        addBuffer: function addBuffer(networkid, bufferName) {
            var buffer = this.getBufferByName(networkid, bufferName);
            if (buffer) {
                return buffer;
            }

            var network = this.getNetwork(networkid);
            if (!network) {
                return false;
            }

            buffer = new _BufferState2.default(bufferName, network.id, state, messages);
            network.buffers.push(buffer);

            var eventObj = { buffer: buffer };
            state.$emit('buffer.new', eventObj);

            return buffer;
        },
        removeBuffer: function removeBuffer(buffer) {
            var isActiveBuffer = this.getActiveBuffer() === buffer;

            var network = this.getNetwork(buffer.networkid);
            if (!network) {
                return;
            }

            var eventObj = { buffer: buffer };
            state.$emit('buffer.close', eventObj);

            var bufferIdx = network.buffers.indexOf(buffer);
            if (bufferIdx > -1) {
                network.buffers.splice(bufferIdx, 1);
            }

            var messageIdx = _lodash2.default.findIndex(messages, {
                networkid: network.id,
                buffer: buffer.name
            });
            if (messageIdx > -1) {
                messages.splice(messageIdx, 1);
            }

            if (buffer.isChannel() && buffer.joined) {
                network.ircClient.part(buffer.name);
            }

            if (buffer.isQuery()) {
                var remainingBuffers = state.getBuffersWithUser(network.id, buffer.name);
                if (remainingBuffers.length === 0) {
                    state.removeUser(network.d, {
                        nick: buffer.name
                    });
                }
            }

            if (isActiveBuffer) {
                this.openLastActiveBuffer();
            }

            (0, _keys2.default)(buffer.users).forEach(function (nick) {
                var user = buffer.users[nick];
                delete user.buffers[buffer.id];
            });
        },
        addMessage: function addMessage(buffer, message) {
            if (!buffer) {
                return;
            }

            var user = this.getUser(buffer.networkid, message.nick);
            var bufferMessage = new _Message2.default(message, user);
            if (user && user.ignore) {
                bufferMessage.ignore = true;
            }

            buffer.addMessage(bufferMessage);

            var includeAsActivity = false;
            var typesForActivty = ['privmsg', 'action', 'notice'];
            if (buffer.setting('traffic_as_activity') && message.type === 'traffic') {
                typesForActivty.push('traffic');
            }

            if (typesForActivty.indexOf(message.type) > -1) {
                includeAsActivity = true;
            }

            var isActiveBuffer = buffer.networkid === this.ui.active_network && buffer.name === this.ui.active_buffer;

            var network = buffer.getNetwork();
            var isNewMessage = message.time >= buffer.last_read;
            var isHighlight = !network ? false : Misc.mentionsNick(bufferMessage.message, network.ircClient.user.nick);

            var extraHighlights = (state.setting('highlights') || '').toLowerCase().split(' ');
            if (!isHighlight && extraHighlights.length > 0) {
                extraHighlights.forEach(function (word) {
                    if (!word) {
                        return;
                    }

                    if (bufferMessage.message.toLowerCase().indexOf(word) > -1) {
                        isHighlight = true;
                    }
                });
            }

            if (state.setting('teamHighlights')) {
                var m = bufferMessage.message;
                var patterns = {
                    everyone: /(^|\s)@everybody($|\s|[,.;])/,
                    channel: /(^|\s)@channel($|\s|[,.;])/,
                    here: /(^|\s)@here($|\s|[,.;])/
                };
                if (m.match(patterns.everyone) || m.match(patterns.channel)) {
                    isHighlight = true;
                }

                if (m.match(patterns.here) && network && !network.away) {
                    isHighlight = true;
                }
            }

            bufferMessage.isHighlight = isHighlight;

            if (isNewMessage && isActiveBuffer && state.ui.app_has_focus) {
                buffer.last_read = message.time;
            }

            if (isNewMessage && includeAsActivity && !isActiveBuffer && !bufferMessage.ignore) {
                buffer.incrementFlag('unread');
                if (isHighlight) {
                    buffer.flag('highlight', true);
                }
            }

            var settingAlertOn = buffer.setting('alert_on');
            var isSelf = !network ? false : message.nick === network.nick;
            if (isNewMessage && settingAlertOn !== 'never' && message.type !== 'nick' && message.type !== 'mode' && message.type !== 'traffic' && !buffer.isSpecial() && !bufferMessage.ignore && !isSelf) {
                var notifyTitle = '';
                var notifyMessage = message.nick ? message.nick + ': ' : '';
                notifyMessage += message.message;

                if (isHighlight) {
                    notifyTitle = 'You were mentioned in ' + buffer.name;
                } else if (settingAlertOn === 'message' && !isHighlight) {
                    notifyTitle = buffer.name;
                }

                if (notifyTitle) {
                    this.$emit('notification.show', notifyMessage, {
                        title: notifyTitle,
                        onclick: function onclick() {
                            state.setActiveBuffer(buffer.networkid, buffer.name);

                            if (parent && parent.focus) {
                                parent.focus();
                            }
                            if (window.focus) {
                                window.focus();
                            }
                        }
                    });
                }
            }

            if (isActiveBuffer && !state.ui.app_has_focus && message.type !== 'traffic' && (buffer.setting('flash_title') === 'message' || buffer.setting('flash_title') === 'highlight' && isHighlight)) {
                this.$emit('notification.title', true);
            }

            this.$emit('message.new', bufferMessage, buffer);
        },
        getUser: function getUser(networkid, nick, usersArr_) {
            var user = null;
            var users = usersArr_;

            if (!users) {
                var network = this.getNetwork(networkid);
                if (network) {
                    users = network.users;
                }
            }

            if (users) {
                user = users[nick.toLowerCase()];
            }

            return user;
        },
        usersTransaction: function usersTransaction(networkid, fn) {
            var network = this.getNetwork(networkid);
            if (!network) {
                return;
            }

            var users = _lodash2.default.clone(network.users);
            fn(users);
            network.users = users;
        },
        addUser: function addUser(networkid, user, usersArr_) {
            var network = null;

            if (typeof networkid === 'number') {
                network = this.getNetwork(networkid);
            } else {
                network = networkid;
            }

            if (!network) {
                return null;
            }

            var usersArr = usersArr_ || network.users;
            var userObj = null;

            if (!usersArr[user.nick.toLowerCase()]) {
                userObj = usersArr[user.nick.toLowerCase()] = new _UserState2.default(user);
            } else {
                userObj = state.getUser(network.id, user.nick, usersArr);
                _lodash2.default.each(user, function (val, prop) {
                    if (typeof val !== 'undefined') {
                        userObj[prop] = val;
                    }
                });
            }

            return userObj;
        },
        removeUser: function removeUser(networkid, user) {
            var network = this.getNetwork(networkid);
            if (!network) {
                return;
            }

            var buffers = state.getBuffersWithUser(networkid, user.nick);
            buffers.forEach(function (buffer) {
                state.removeUserFromBuffer(buffer, user.nick);
            });

            this.$delete(network.users, user.nick.toLowerCase());
        },
        addMultipleUsersToBuffer: function addMultipleUsersToBuffer(buffer, newUsers) {
            var _this2 = this;

            var network = this.getNetwork(buffer.networkid);
            var bufUsers = _lodash2.default.clone(buffer.users);

            state.usersTransaction(network.id, function (users) {
                newUsers.forEach(function (newUser) {
                    var user = newUser.user;
                    var modes = newUser.modes;
                    var userObj = state.getUser(network.id, user.nick, users);

                    if (!userObj) {
                        userObj = _this2.addUser(network, user, users);
                    }
                    bufUsers[userObj.nick.toLowerCase()] = userObj;

                    if (!userObj.buffers[buffer.id]) {
                        state.$set(userObj.buffers, buffer.id, {
                            modes: modes || [],
                            buffer: buffer
                        });
                    } else {
                        userObj.buffers[buffer.id].modes = modes || [];
                    }
                });
            });

            buffer.users = bufUsers;
        },
        addUserToBuffer: function addUserToBuffer(buffer, user, modes) {
            var network = this.getNetwork(buffer.networkid);
            var userObj = state.getUser(network.id, user.nick);

            if (!userObj) {
                userObj = this.addUser(network, user);
            } else {
                _lodash2.default.each(user, function (val, prop) {
                    if (userObj[prop] !== val) {
                        userObj[prop] = val;
                    }
                });
            }

            buffer.addUser(userObj);

            if (!userObj.buffers[buffer.id]) {
                state.$set(userObj.buffers, buffer.id, {
                    modes: modes || [],
                    buffer: buffer
                });
            } else {
                state.$set(userObj.buffers[buffer.id], 'modes', modes || []);
            }
        },
        removeUserFromBuffer: function removeUserFromBuffer(buffer, nick) {
            buffer.removeUser(nick);
        },
        getBuffersWithUser: function getBuffersWithUser(networkid, nick) {
            var network = this.getNetwork(networkid);
            if (!network) {
                return [];
            }

            var normalisedNick = nick.toLowerCase();
            var buffers = [];
            network.buffers.forEach(function (buffer) {
                if (buffer.users[normalisedNick] || normalisedNick === buffer.name.toLowerCase()) {
                    buffers.push(buffer);
                } else if (nick === network.nick && buffer.isQuery()) {
                    buffers.push(buffer);
                }
            });

            return buffers;
        },
        changeUserNick: function changeUserNick(networkid, oldNick, newNick) {
            var network = this.getNetwork(networkid);
            if (!network) {
                return;
            }

            var user = state.getUser(network.id, oldNick);
            if (!user) {
                return;
            }

            var normalisedNew = newNick.toLowerCase();
            var normalisedOld = oldNick.toLowerCase();

            user.nick = newNick;

            if (normalisedOld !== normalisedNew) {
                state.$set(network.users, normalisedNew, network.users[normalisedOld]);
                state.$delete(network.users, normalisedOld);

                (0, _keys2.default)(user.buffers).forEach(function (bufferId) {
                    var buffer = user.buffers[bufferId].buffer;
                    state.$set(buffer.users, normalisedNew, buffer.users[normalisedOld]);
                    state.$delete(buffer.users, normalisedOld);
                });
            }

            var buffer = this.getBufferByName(network.id, oldNick);
            if (buffer) {
                buffer.rename(newNick);
            }
        },
        getStartups: function getStartups() {
            return availableStartups;
        }
    }
});

exports.default = state;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["state"]
window._kiwi_exports.libs.state = exports.default ? exports.default : exports;


/***/ }),

/***/ "M3Oy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kiwiirccom_vue__ = __webpack_require__("QrdV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kiwiirccom_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kiwiirccom_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kiwiirccom_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kiwiirccom_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3943adf4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_kiwiirccom_vue__ = __webpack_require__("NZ2I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("LEol")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kiwiirccom_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3943adf4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_kiwiirccom_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3943adf4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_kiwiirccom_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "MMNQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _create = __webpack_require__("OvRC");

var _create2 = _interopRequireDefault(_create);

var _Logger = __webpack_require__("XNCV");

var _Logger2 = _interopRequireDefault(_Logger);

var _NicklistUser = __webpack_require__("41g1");

var _NicklistUser2 = _interopRequireDefault(_NicklistUser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = _Logger2.default.namespace('Nicklist');

var intlCollator = null;
if (global.Intl) {
    intlCollator = new Intl.Collator({}, { numeric: true });
}

function strCompare(a, b) {
    if (intlCollator) {
        return intlCollator.compare(a, b);
    }

    if (a === b) {
        return 0;
    }

    return a > b ? 1 : -1;
}

exports.default = {
    components: {
        NicklistUser: _NicklistUser2.default
    },
    props: ['network', 'buffer', 'sidebarState'],
    data: function data() {
        return {
            userbox_user: null,
            user_filter: '',
            filter_visible: false,
            self: this
        };
    },
    computed: {
        sortedUsers: function sortedUsers() {
            var netPrefixes = this.network.ircClient.network.options.PREFIX;
            var prefixOrders = (0, _create2.default)(null);
            netPrefixes.forEach(function (prefix, idx) {
                prefixOrders[prefix.mode] = idx;
            });

            var nickMap = (0, _create2.default)(null);
            var users = [];
            var bufferUsers = this.buffer.users;
            var nickFilter = this.user_filter.toLowerCase();

            for (var lowercaseNick in bufferUsers) {
                var user = bufferUsers[lowercaseNick];
                nickMap[user.nick] = lowercaseNick;
                if (!nickFilter || lowercaseNick.indexOf(nickFilter) !== -1) {
                    users.push(user);
                }
            }

            var bufferId = this.buffer.id;
            return users.sort(function (a, b) {
                var bufferA = a.buffers[bufferId];
                var bufferB = b.buffers[bufferId];

                if (!bufferA) {
                    var msg = 'Nicklist.sortedUsers() User A does not have the buffer in its list!';
                    log.error(msg, a.nick, a.buffers);
                    return -1;
                }
                if (!bufferB) {
                    var _msg = 'Nicklist.sortedUsers() User B does not have the buffer in its list!';
                    log.error(_msg, b.nick, b.buffers);
                    return 1;
                }

                var modesA = bufferA.modes;
                var modesB = bufferB.modes;

                if (modesA.length === 0 && modesB.length === 0) {
                    return strCompare(nickMap[a.nick], nickMap[b.nick]);
                }

                if (modesA.length > 0 && modesB.length === 0) {
                    return -1;
                }

                if (modesA.length === 0 && modesB.length > 0) {
                    return 1;
                }

                var aP = prefixOrders[modesA[0]];
                var bP = prefixOrders[modesB[0]];
                if (aP > bP) {
                    return 1;
                } else if (aP < bP) {
                    return -1;
                }

                return strCompare(nickMap[a.nick], nickMap[b.nick]);
            });
        },
        useColouredNicks: function useColouredNicks() {
            return this.buffer.setting('coloured_nicklist');
        }
    },
    methods: {
        userModePrefix: function userModePrefix(user) {
            return this.buffer.userModePrefix(user);
        },
        userMode: function userMode(user) {
            return this.buffer.userMode(user);
        },
        openQuery: function openQuery(user) {
            var buffer = this.$state.addBuffer(this.buffer.networkid, user.nick);
            this.$state.setActiveBuffer(buffer.networkid, buffer.name);
            if (this.$state.ui.is_narrow) {
                this.sidebarState.close();
            }
        },
        openUserbox: function openUserbox(user) {
            this.$state.$emit('userbox.show', user, {
                buffer: this.buffer
            });
        },
        toggleUserFilter: function toggleUserFilter() {
            var _this = this;

            this.filter_visible = !this.filter_visible;
            if (this.filter_visible) {
                this.$nextTick(function () {
                    return _this.$refs.user_filter.focus();
                });
            } else {
                this.user_filter = '';
            }
        },
        onFilterBlur: function onFilterBlur() {
            if (!this.user_filter) {
                this.filter_visible = false;
            }
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["Nicklist"]
window._kiwi_exports.components.Nicklist = exports.default ? exports.default : exports;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "MQvW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = [{ command: 'msg', alias: [], description: 'locale_id_command_msg' }, { command: 'action', alias: [], description: 'locale_id_command_action' }, { command: 'join', alias: [], description: 'locale_id_command_join' }, { command: 'part', alias: [], description: 'locale_id_command_part' }, { command: 'cycle', alias: [], description: 'locale_id_command_cycle' }, { command: 'nick', alias: [], description: 'locale_id_command_nick' }, { command: 'query', alias: [], description: 'locale_id_command_query' }, { command: 'invite', alias: [], description: 'locale_id_command_invite' }, { command: 'topic', alias: [], description: 'locale_id_command_topic' }, { command: 'notice', alias: [], description: 'locale_id_command_notice' }, { command: 'quote', alias: [], description: 'locale_id_command_quote' }, { command: 'kick', alias: [], description: 'locale_id_command_kick' }, { command: 'clear', alias: [], description: 'locale_id_command_clear' }, { command: 'ctcp', alias: [], description: 'locale_id_command_ctcp' }, { command: 'quit', alias: [], description: 'locale_id_command_quit' }, { command: 'server', alias: [], description: 'locale_id_command_server' }, { command: 'whois', alias: [], description: 'locale_id_command_whois' }, { command: 'whowas', alias: [], description: 'locale_id_command_whowas' }, { command: 'away', alias: [], description: 'locale_id_command_away' }, { command: 'back', alias: ['active'], description: 'locale_id_command_back' }, { command: 'encoding', alias: [], description: 'locale_id_command_encoding' }, { command: 'ignore', alias: [], description: 'locale_id_command_ignore' }, { command: 'unignore', alias: [], description: 'locale_id_command_unignore' }, { command: 'dice', alias: [], description: 'locale_id_command_dice' }];
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["res"]) window._kiwi_exports["res"] = {};
window._kiwi_exports["res"]["autocompleteCommands"]
window._kiwi_exports.res.autocompleteCommands = exports.default ? exports.default : exports;


/***/ }),

/***/ "MkT/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    components: {},
    props: ['buffer'],
    data: function data() {
        return {};
    },
    computed: {
        settingAlertOn: {
            get: function getSettingAlertOn() {
                return this.buffer.setting('alert_on');
            },
            set: function setSettingAlertOn(val) {
                return this.buffer.setting('alert_on', val);
            }
        },
        settingMuteSound: {
            get: function getSettingAlertOn() {
                return this.buffer.setting('mute_sound');
            },
            set: function setSettingAlertOn(val) {
                return this.buffer.setting('mute_sound', val);
            }
        },
        settingHideMessageCount: {
            get: function getsettingHideMessageCount() {
                return this.buffer.setting('hide_message_counts');
            },
            set: function setsettingHideMessageCount(val) {
                return this.buffer.setting('hide_message_counts', val);
            }
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["BufferSettings"]
window._kiwi_exports.components.BufferSettings = exports.default ? exports.default : exports;


/***/ }),

/***/ "N+TA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NetworkSettings_vue__ = __webpack_require__("hqyo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NetworkSettings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NetworkSettings_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NetworkSettings_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NetworkSettings_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28ef3444_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NetworkSettings_vue__ = __webpack_require__("oLET");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("2jZO")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NetworkSettings_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28ef3444_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NetworkSettings_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28ef3444_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NetworkSettings_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "NG5i":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _state = __webpack_require__("LnP8");

var _state2 = _interopRequireDefault(_state);

var _GlobalApi = __webpack_require__("Uvbb");

var _GlobalApi2 = _interopRequireDefault(_GlobalApi);

var _Html = __webpack_require__("Nbm2");

var _Html2 = _interopRequireDefault(_Html);

var _MessageParser = __webpack_require__("wXH7");

var _MessageParser2 = _interopRequireDefault(_MessageParser);

var _BufferSettings = __webpack_require__("5nmk");

var _BufferSettings2 = _interopRequireDefault(_BufferSettings);

var _ChannelInfo = __webpack_require__("n5Xi");

var _ChannelInfo2 = _interopRequireDefault(_ChannelInfo);

var _ChannelBanlist = __webpack_require__("wb7H");

var _ChannelBanlist2 = _interopRequireDefault(_ChannelBanlist);

var _AwayStatusIndicator = __webpack_require__("vV7l");

var _AwayStatusIndicator2 = _interopRequireDefault(_AwayStatusIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        BufferSettings: _BufferSettings2.default,
        ChannelInfo: _ChannelInfo2.default,
        ChannelBanlist: _ChannelBanlist2.default,
        AwayStatusIndicator: _AwayStatusIndicator2.default
    },
    props: ['buffer', 'sidebarState'],
    data: function data() {
        return {
            buffer_settings_open: false,
            pluginUiChannelElements: _GlobalApi2.default.singleton().channelHeaderPlugins,
            pluginUiQueryElements: _GlobalApi2.default.singleton().queryHeaderPlugins,
            prompts: {
                closeChannel: false
            }
        };
    },
    computed: {
        isJoined: function isJoined() {
            var buffer = this.buffer;
            return buffer.getNetwork().state === 'connected' && buffer.joined;
        },
        isConnected: function isConnected() {
            return this.buffer.getNetwork().state === 'connected';
        },
        formattedTopic: function formattedTopic() {
            var blocks = (0, _MessageParser2.default)(this.buffer.topic, { extras: false });
            var content = (0, _Html2.default)(blocks);
            return content;
        },
        network: function network() {
            return this.buffer.getNetwork();
        }
    },
    watch: {
        buffer: function watchBuffer() {
            this.buffer_settings_open = false;
        }
    },
    created: function created() {
        var _this = this;

        this.listen(_state2.default, 'document.clicked', function (e) {
            if (!_this.$el.contains(e.target)) {
                (0, _keys2.default)(_this.prompts).forEach(function (prompt) {
                    _this.prompts[prompt] = false;
                });
            }
        });
    },

    methods: {
        showPrompt: function showPrompt(prompt) {
            this.prompts[prompt] = true;
        },
        isChannel: function isChannel() {
            return this.buffer.isChannel();
        },
        isServer: function isServer() {
            return this.buffer.isServer();
        },
        isQuery: function isQuery() {
            return this.buffer.isQuery();
        },
        isSpecial: function isSpecial() {
            return this.buffer.isSpecial();
        },
        showNetworkSettings: function showNetworkSettings(network) {
            network.showServerBuffer('settings');
        },
        onConnectButtonClick: function onConnectButtonClick() {
            var network = this.buffer.getNetwork();
            if (!network.connection.server) {
                network.showServerBuffer('settings');
            } else {
                network.ircClient.connect();
            }
        },
        showSidebar: function showSidebar() {
            _state2.default.$emit('sidebar.toggle');
        },
        joinCurrentBuffer: function joinCurrentBuffer() {
            var network = this.buffer.getNetwork();
            this.buffer.enabled = true;
            network.ircClient.join(this.buffer.name);
        },
        closeCurrentBuffer: function closeCurrentBuffer() {
            _state2.default.removeBuffer(this.buffer);
        },
        onHeaderClick: function onHeaderClick(event) {
            var channelName = event.target.getAttribute('data-channel-name');
            if (channelName) {
                var network = this.buffer.getNetwork();
                _state2.default.addBuffer(this.buffer.networkid, channelName);
                network.ircClient.join(channelName);
            }
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["ContainerHeader"]
window._kiwi_exports.components.ContainerHeader = exports.default ? exports.default : exports;


/***/ }),

/***/ "NGf2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-serverselector",class:{'kiwi-serverselector--custom': _vm.presetServer === 'custom'}},[(_vm.usePreset && _vm.presetNetworks.length > 0)?_c('div',{staticClass:"kiwi-serverselector-presets"},[_c('label',[_c('span',[_vm._v(_vm._s(_vm.$t('server')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.presetServer),expression:"presetServer"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.presetServer=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"custom"}},[_vm._v("Custom Server")]),_vm._v(" "),_c('option',{attrs:{"disabled":""}},[_vm._v("-----------------")]),_vm._v(" "),_vm._l((_vm.presetNetworks),function(s){return _c('option',{key:s.name,domProps:{"value":_vm.toUri(s)}},[_vm._v(_vm._s(s.name))])})],2)])]):_vm._e(),_vm._v(" "),(_vm.showCustom || _vm.presetNetworks.length === 0 || !_vm.usePreset)?[_c('input-text',{directives:[{name:"focus",rawName:"v-focus"}],staticClass:"kiwi-networksettings-connection-address",attrs:{"label":_vm.$t('server')},model:{value:(_vm.connection.server),callback:function ($$v) {_vm.$set(_vm.connection, "server", $$v)},expression:"connection.server"}}),_vm._v(" "),_c('input-text',{staticClass:"kiwi-networksettings-connection-port",attrs:{"label":_vm.$t('settings_port'),"type":"number"},model:{value:(_vm.connection.port),callback:function ($$v) {_vm.$set(_vm.connection, "port", $$v)},expression:"connection.port"}},[_c('span',{staticClass:"fa-stack fa-lg kiwi-customserver-tls",class:{ 'kiwi-customserver-tls--enabled' : _vm.connection.tls },on:{"click":_vm.toggleTls}},[(_vm.connection.tls)?_c('i',{staticClass:"fa fa-lock fa-stack-1x kiwi-customserver-tls-lock"}):_c('i',{staticClass:"fa fa-unlock fa-stack-1x kiwi-customserver-tls-minus"})])])]:_vm._e()],2)}
var staticRenderFns = []


/***/ }),

/***/ "NHnr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _toConsumableArray2 = __webpack_require__("Gu7T");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var initState = function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var stateKey, persistLog, persist;
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        stateKey = _state2.default.settings.startupOptions.state_key;

                        if (typeof stateKey === 'undefined') {
                            stateKey = 'kiwi-state';
                        }

                        persistLog = _Logger2.default.namespace('StatePersistence');
                        persist = new _StatePersistence2.default(stateKey || '', _state2.default, Storage, persistLog);

                        persist.includeBuffers = !!_state2.default.settings.startupOptions.remember_buffers;

                        if (!stateKey) {
                            _context.next = 8;
                            break;
                        }

                        _context.next = 8;
                        return persist.loadStateIfExists();

                    case 8:

                        api.setState(_state2.default);

                    case 9:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function initState() {
        return _ref.apply(this, arguments);
    };
}();

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _vue = __webpack_require__("I3G/");

var _vue2 = _interopRequireDefault(_vue);

var _i18next = __webpack_require__("QCdE");

var _i18next2 = _interopRequireDefault(_i18next);

var _i18nextXhrBackend = __webpack_require__("OcWW");

var _i18nextXhrBackend2 = _interopRequireDefault(_i18nextXhrBackend);

var _vueI18next = __webpack_require__("Zvw3");

var _vueI18next2 = _interopRequireDefault(_vueI18next);

var _vueVirtualScroller = __webpack_require__("8jLZ");

var _vueVirtualScroller2 = _interopRequireDefault(_vueVirtualScroller);

__webpack_require__("03v1");

__webpack_require__("rplX");

__webpack_require__("p3C9");

var _available = __webpack_require__("/5ya");

var _available2 = _interopRequireDefault(_available);

var _enUs = __webpack_require__("gaEc");

var _enUs2 = _interopRequireDefault(_enUs);

var _App = __webpack_require__("EWfp");

var _App2 = _interopRequireDefault(_App);

var _StartupError = __webpack_require__("/k/S");

var _StartupError2 = _interopRequireDefault(_StartupError);

var _Logger = __webpack_require__("XNCV");

var _Logger2 = _interopRequireDefault(_Logger);

var _ConfigLoader = __webpack_require__("9myz");

var _ConfigLoader2 = _interopRequireDefault(_ConfigLoader);

var _state = __webpack_require__("LnP8");

var _state2 = _interopRequireDefault(_state);

var _ThemeManager = __webpack_require__("j/A4");

var _ThemeManager2 = _interopRequireDefault(_ThemeManager);

var _InputHandler = __webpack_require__("ADMw");

var _InputHandler2 = _interopRequireDefault(_InputHandler);

var _StatePersistence = __webpack_require__("tewY");

var _StatePersistence2 = _interopRequireDefault(_StatePersistence);

var _Local = __webpack_require__("3GM/");

var Storage = _interopRequireWildcard(_Local);

var _Misc = __webpack_require__("uN9+");

var Misc = _interopRequireWildcard(_Misc);

var _GlobalApi = __webpack_require__("Uvbb");

var _GlobalApi2 = _interopRequireDefault(_GlobalApi);

var _AudioManager = __webpack_require__("b30k");

var _SoundBleep = __webpack_require__("YX3V");

var _WindowTitle = __webpack_require__("7hSk");

var _WindowTitle2 = _interopRequireDefault(_WindowTitle);

var _configTemplates = __webpack_require__("29nj");

__webpack_require__("L52m");

__webpack_require__("JPz/");

__webpack_require__("YqxC");

__webpack_require__("Xv7q");

__webpack_require__("15pG");

__webpack_require__("AS6v");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueVirtualScroller2.default);

var logLevelMatch = window.location.href.match(/kiwi-loglevel=(\d)/);
if (logLevelMatch && logLevelMatch[1]) {
    _Logger2.default.setLevel(parseInt(logLevelMatch[1], 10));
}

var log = _Logger2.default.namespace('main');

var api = window.kiwi = _GlobalApi2.default.singleton();

function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (pair[0] === variable) {
            return pair[1];
        }
    }

    return false;
}

_vue2.default.mixin({
    beforeDestroy: function beforeDestroy() {
        (this.listeningEvents || []).forEach(function (fn) {
            return fn();
        });
    },
    methods: {
        listen: function listen(source, event, fn) {
            this.listeningEvents = this.listeningEvents || [];
            this.listeningEvents.push(function () {
                (source.removeEventListener || source.$off || source.off).call(source, event, fn);
            });
            (source.addEventListener || source.$on || source.on).call(source, event, fn);
        },
        listenOnce: function listenOnce(source, event, fn) {
            this.listeningEvents = this.listeningEvents || [];
            this.listeningEvents.push(function () {
                (source.removeEventListener || source.$off || source.off).call(source, event, fn);
            });

            if (source.addEventListener) {
                var onceFn = function onceFn() {
                    source.removeEventListener(event, onceFn);
                    fn.apply(undefined, arguments);
                };

                source.addEventListener(event, onceFn);
            } else {
                (source.$once || source.once).call(source, event, fn);
            }
        }
    }
});

_vue2.default.mixin({
    computed: {
        $state: function $state() {
            return _state2.default;
        }
    }
});

_vue2.default.directive('rawElement', {
    bind: function bind(el, binding) {
        if (binding.value.nodeName) {
            el.appendChild(binding.value);
        } else if (binding.value.el) {
            var rawEl = binding.value.el;
            el.appendChild(rawEl);

            if (binding.value.data) {
                (0, _keys2.default)(binding.value.data).forEach(function (key) {
                    rawEl.dataset[key] = binding.value.data[key];
                });
            }

            if (binding.value.props) {
                (0, _keys2.default)(binding.value.props).forEach(function (key) {
                    rawEl[key] = binding.value.props[key];
                });
            }
        }
    }
});

_vue2.default.directive('focus', {
    inserted: function inserted(el) {
        if (el.tagName === 'INPUT') {
            el.focus();
            return;
        }

        var input = el.getElementsByTagName('input')[0];
        if (input) {
            input.focus();
        }
    }
});

loadApp();

function loadApp() {
    var configFile = 'static/config.json';
    var configObj = null;

    if (getQueryVariable('config')) {
        configFile = 'static/config_' + getQueryVariable('config') + '.json';
    } else if (typeof window.kiwiConfig === 'function') {
        try {
            configObj = window.kiwiConfig();
        } catch (err) {
            log.error('Config file: ' + err.stack);
            showError();
        }
    } else if (document.querySelector('meta[name="kiwiconfig"]')) {
        configFile = document.querySelector('meta[name="kiwiconfig"]').content;
    } else if (document.querySelector('script[name="kiwiconfig"]')) {
        var configContents = document.querySelector('script[name="kiwiconfig"]').innerHTML;

        try {
            configObj = JSON.parse(configContents);
        } catch (parseErr) {
            log.error('Config file: ' + parseErr.stack);
            showError();
        }
    }

    var configLoader = new _ConfigLoader2.default();
    configLoader.addValueReplacement('protocol', window.location.protocol).addValueReplacement('hostname', window.location.hostname).addValueReplacement('host', window.location.hostname).addValueReplacement('host', window.location.host).addValueReplacement('port', window.location.port || 80).addValueReplacement('hash', (window.location.hash || '').substr(1)).addValueReplacement('query', (window.location.search || '').substr(1)).addValueReplacement('referrer', window.document.referrer);

    (configObj ? configLoader.loadFromObj(configObj) : configLoader.loadFromUrl(configFile)).then(applyConfig).then(initState).then(initInputCommands).then(initLocales).then(initThemes).then(loadPlugins).then(initSound).then(startApp).catch(showError);
}

function applyConfig(config) {
    Misc.dedotObject(config);

    if (_configTemplates.configTemplates[config.template]) {
        applyConfigObj(_configTemplates.configTemplates[config.template], _state2.default.settings);
    }
    applyConfigObj(config, _state2.default.settings);
}

function applyConfigObj(obj, target) {
    _lodash2.default.each(obj, function (val, key) {
        if ((typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)) === 'object') {
            if ((0, _typeof3.default)(target[key]) !== 'object') {
                var newVal = _lodash2.default.isArray(val) ? [] : {};

                _vue2.default.set(target, key, newVal);
            }
            applyConfigObj(val, target[key]);
        } else {
            _vue2.default.set(target, key, val);
        }
    });
}

function loadPlugins() {
    return new _promise2.default(function (resolve, reject) {
        var plugins = _state2.default.settings.plugins || [];
        var pluginIdx = -1;

        loadNextScript();

        function loadNextScript(sSrc, fOnload) {
            var plugin = plugins[++pluginIdx];

            if (!plugin) {
                resolve();
                return;
            }

            if (plugin.url.indexOf('.js') > -1) {
                var scr = document.createElement('script');
                scr.onerror = function () {
                    log.error('Error loading plugin \'' + plugin.name + '\' from \'' + plugin.url + '\'');
                    loadNextScript();
                };
                scr.onload = function () {
                    loadNextScript();
                };

                document.body.appendChild(scr);
                scr.src = plugin.url;
            } else {
                fetch(plugin.url).then(function (response) {
                    return response.text();
                }).then(function (pluginRaw) {
                    var el = document.createElement('div');
                    el.id = 'kiwi_plugin_' + plugin.name.replace(/[ "']/g, '');
                    el.style.display = 'none';
                    el.innerHTML = pluginRaw;

                    var scripts = [].concat((0, _toConsumableArray3.default)(el.querySelectorAll('script')));

                    scripts.forEach(function (limitedScr) {
                        limitedScr.parentElement.removeChild(limitedScr);
                        var scr = document.createElement('script');
                        scr.text = limitedScr.text;
                        el.appendChild(scr);
                    });

                    document.body.appendChild(el);
                    loadNextScript();
                }).catch(function () {
                    log.error('Error loading plugin \'' + plugin.name + '\' from \'' + plugin.url + '\'');
                    loadNextScript();
                });
            }
        }
    });
}

function initLocales() {
    _vue2.default.use(_vueI18next2.default);

    api.i18n = _i18next2.default;

    _i18next2.default.use(_i18nextXhrBackend2.default);
    _i18next2.default.init({
        whitelist: _available2.default.locales,
        fallbackLng: 'en-us',
        lowerCaseLng: true,
        backend: {
            loadPath: 'static/locales/{{lng}}.json',

            crossDomain: false,

            withCredentials: false
        },
        interpolation: {
            escapeValue: false
        }
    });

    _i18next2.default.addResourceBundle('en-us', 'translation', _enUs2.default);

    _vue2.default.mixin({
        computed: {
            $t: function $t() {
                var _this = this;

                return function (key, options) {
                    var val = _this.$i18n.i18next.t(key, options, _this.$i18n.i18nLoadedAt);
                    if (!val) {
                        var opts = options || {};
                        opts.lng = 'en-us';
                        val = _this.$i18n.i18next.t(key, opts, _this.$i18n.i18nLoadedAt);
                    }
                    return val;
                };
            }
        }
    });

    var setDefaultLanguage = function setDefaultLanguage() {
        var defaultLang = _state2.default.setting('language');
        var preferredLangs = _lodash2.default.clone(window.navigator && window.navigator.languages) || [];

        if (defaultLang) {
            preferredLangs.unshift(defaultLang);
        }

        _i18next2.default.changeLanguage('en-us');

        for (var idx = 0; idx < preferredLangs.length; idx++) {
            var lang = preferredLangs[idx];

            if (lang.length === 2) {
                preferredLangs.splice(idx + 1, 0, lang + '-' + lang);
            }

            if (_lodash2.default.includes(_available2.default.locales, lang.toLowerCase())) {
                _i18next2.default.changeLanguage(lang, function (err, t) {
                    if (err) {
                        _i18next2.default.changeLanguage('en-us');
                    }
                });
                break;
            }
        }
    };
    setDefaultLanguage();

    _state2.default.$watch('user_settings.language', function (lang) {
        if (!lang && !_state2.default.setting('language')) {
            setDefaultLanguage();
        } else {
            _i18next2.default.changeLanguage(lang || _state2.default.setting('language') || 'en-us');
        }
    });
}

function initThemes() {
    var themeMgr = _ThemeManager2.default.instance(_state2.default);
    api.setThemeManager(themeMgr);

    var argTheme = getQueryVariable('theme');
    if (argTheme) {
        themeMgr.setTheme(argTheme);
    }
}

function initSound() {
    var sound = new _SoundBleep.SoundBleep();
    var bleep = new _AudioManager.AudioManager(sound);

    bleep.listen(_state2.default);
    bleep.watchForMessages(_state2.default);
}

function initInputCommands() {
    new _InputHandler2.default(_state2.default);
}

function startApp() {
    new _WindowTitle2.default(_state2.default);

    api.emit('init');

    new _vue2.default({
        el: '#app',
        render: function render(h) {
            return h(_App2.default);
        },
        i18n: new _vueI18next2.default(_i18next2.default)
    });

    api.emit('ready');
}

function showError(err) {
    if (err) {
        log.error('Error starting Kiwi IRC:', err);
    } else {
        log.error('Unknown error starting Kiwi IRC');
    }

    new _vue2.default({
        el: '#app',
        render: function render(h) {
            return h(_StartupError2.default, { props: { error: err } });
        }
    });
}

/***/ }),

/***/ "NRRm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _AwayStatusIndicator = __webpack_require__("vV7l");

var _AwayStatusIndicator2 = _interopRequireDefault(_AwayStatusIndicator);

var _MessageInfo = __webpack_require__("ga3F");

var _MessageInfo2 = _interopRequireDefault(_MessageInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        AwayStatusIndicator: _AwayStatusIndicator2.default,
        MessageInfo: _MessageInfo2.default
    },
    props: ['ml', 'message', 'idx'],
    data: function data() {
        return {};
    },
    computed: {
        userColour: function userColour() {
            return this.ml.userColour(this.message.user);
        }
    },
    methods: {
        getNetwork: function getNetwork() {
            return this.ml.buffer.getNetwork();
        },
        isHoveringOverMessage: function isHoveringOverMessage(message) {
            return message.nick && message.nick.toLowerCase() === this.hover_nick.toLowerCase();
        },
        userMode: function userMode(user) {
            return this.ml.buffer.userMode(user);
        },
        userModePrefix: function userModePrefix(user) {
            return this.ml.buffer.userModePrefix(user);
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["MessageListMessageCompact"]
window._kiwi_exports.components.MessageListMessageCompact = exports.default ? exports.default : exports;


/***/ }),

/***/ "NZ2I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-personal"},[_c('h1',[_vm._v(_vm._s(_vm.$t('personal_client')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('personal_addjoin')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('personal_return')))]),_vm._v(" "),_c('button',{staticClass:"u-button u-button-primary",on:{"click":_vm.addNetwork}},[_vm._v("\n        "+_vm._s(_vm.$t('personal_add'))+"\n    ")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.networks.length>0)?_c('a',{staticClass:"u-link kiwi-personal-existing-networks",on:{"click":function($event){$event.stopPropagation();return _vm.toggleStateBrowser($event)}}},[_vm._v("\n        "+_vm._s(_vm.$t('personal_saved'))+"\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"kiwi-aboutnew-content",class:{'kiwi-aboutnew-content--open': _vm.about_open},domProps:{"innerHTML":_vm._s(_vm.aboutContent)}}),_vm._v(" "),_c('div',{staticClass:"kiwi-aboutnew"},[_c('div',{staticClass:"kiwi-aboutnew-sep"}),_vm._v(" "),_c('a',{staticClass:"u-link",on:{"click":function($event){_vm.about_open=!_vm.about_open}}},[_vm._v("\n            Link to your network / channel\n        ")]),_vm._v(" "),_c('div',{staticClass:"kiwi-aboutnew-help"},[_c('a',{on:{"click":function($event){_vm.about_open=!_vm.about_open}}},[_c('i',{staticClass:"fa fa-question-circle",attrs:{"aria-hidden":"true"}})])])])])}
var staticRenderFns = []


/***/ }),

/***/ "Nbm2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _lodash = __webpack_require__("M4fF");

var _state = __webpack_require__("LnP8");

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = render;


function render(blocks, renderEmoticons) {
    var emojiLocation = _state2.default.setting('emojiLocation');
    var showEmoticons = typeof renderEmoticons === 'undefined' ? _state2.default.setting('buffers.show_emoticons') : !!renderEmoticons;

    var retHtml = blocks.reduce(function (html, block, i) {
        var style = '';
        var classes = '';

        (0, _keys2.default)(block.styles).forEach(function (s) {
            if (s === 'underline') {
                style += 'text-decoration:underline;';
            } else if (s === 'bold') {
                style += 'font-weight:bold;';
            } else if (s === 'italic') {
                style += 'font-style:italic;';
            } else if (s === 'quote') {
                classes += 'kiwi-formatting-extras-quote ';
            } else if (s === 'block') {
                classes += 'kiwi-formatting-extras-block ';
            } else if (s === 'color') {
                classes += 'irc-fg-colour-' + block.styles[s] + ' ';
            } else if (s === 'background') {
                classes += 'irc-bg-colour-' + block.styles[s] + ' ';
            }
        });

        var content = void 0;
        switch (block.type) {
            case 'url':
                content = linkifyUrl(block, {
                    addHandle: true,
                    handleClass: 'fa fa-chevron-right kiwi-messagelist-message-linkhandle'
                });
                break;
            case 'user':
                content = linkifyUser(block);
                break;
            case 'channel':
                content = linkifyChannel(block);
                break;
            case 'emoji':
                content = addEmoji(block, blocks.length === 1, emojiLocation, showEmoticons);
                break;
            default:
                content = (0, _lodash.escape)(block.content);
        }

        return html + buildSpan(content, classes, style);
    }, '');

    return '' + retHtml;
}

function linkifyUrl(block, _opts) {
    var opts = _opts || {};
    var nice = '';

    if (block.content.length > 100) {
        nice = (0, _lodash.escape)(block.content.substr(0, 100)) + '...';
    } else {
        nice = (0, _lodash.escape)(block.content);
    }

    var href = block.meta.url.replace(/"/g, '%22');
    var out = '<a target="_blank" href="' + href + '" rel="noopener noreferrer">' + nice + '</a>';

    if (opts.addHandle) {
        var cssClass = opts.handleClass || '';
        var content = opts.handleContent || '';
        out += '<a data-url="' + (0, _lodash.escape)(block.meta.url) + '" class="' + cssClass + '">' + content + '</a>';
    }

    return out;
}

function linkifyUser(block) {
    var escaped = (0, _lodash.escape)(block.meta.user);
    var colour = block.meta.colour;

    return '<a class="kiwi-nick" data-nick="' + escaped + '"' + (colour ? ' style="color:' + colour + '"' : '') + ('>' + escaped + '</a>');
}

function linkifyChannel(block) {
    return '<a class="u-link kiwi-channel" data-channel-name="' + (0, _lodash.escape)(block.meta.channel) + '">' + (0, _lodash.escape)(block.content) + '</a>';
}

function addEmoji(block, isSingle, emojiLocation, showEmoticons) {
    if (!showEmoticons) {
        return block.content;
    }
    var emoji = block.meta.emoji;
    var classes = 'kiwi-messagelist-emoji' + (isSingle ? ' kiwi-messagelist-emoji--single' : '');
    var src = '' + emojiLocation + emoji + '.png';

    return '<img class="' + classes + '" src="' + src + '" alt="' + (0, _lodash.escape)(block.content) + '" title="' + (0, _lodash.escape)(block.content) + '" />';
}

function buildSpan(content, classes, style) {
    if (style === '' && classes === '') {
        return content;
    }

    return '<span' + (style !== '' ? ' style="' + style + '"' : '') + (classes !== '' ? ' class="' + classes + '"' : '') + ('>' + content + '</span>');
}

/***/ }),

/***/ "NhYT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.buffer.name,staticClass:"kiwi-messagelist",on:{"scroll":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.onThreadScroll($event)},"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.onListClick($event)}}},[(_vm.shouldShowChathistoryTools)?_c('div',{staticClass:"kiwi-messagelist-scrollback"},[_c('a',{staticClass:"u-link",on:{"click":function($event){return _vm.buffer.requestScrollback()}}},[_vm._v("\n            "+_vm._s(_vm.$t('messages_load'))+"\n        ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.filteredMessages),function(message,idx){return _c('div',{key:message.id,class:[
            'kiwi-messagelist-item',
            _vm.selectedMessages.has(message.id) ?
                'kiwi-messagelist-item--selected' :
                ''
        ]},[(_vm.shouldShowDateChangeMarker(idx))?_c('div',{staticClass:"kiwi-messagelist-seperator"},[_c('span',[_vm._v(_vm._s((new Date(message.time)).toDateString()))])]):_vm._e(),_vm._v(" "),(_vm.shouldShowUnreadMarker(idx))?_c('div',{staticClass:"kiwi-messagelist-seperator"},[_c('span',[_vm._v(_vm._s(_vm.$t('unread_messages')))])]):_vm._e(),_vm._v(" "),(message.render() && message.template && message.template.$el)?_c('div',{directives:[{name:"rawElement",rawName:"v-rawElement",value:(message.template.$el),expression:"message.template.$el"}]}):(_vm.listType === 'modern')?_c('message-list-message-modern',{attrs:{"message":message,"idx":idx,"ml":_vm.thisMl}}):(_vm.listType === 'inline')?_c('message-list-message-inline',{attrs:{"message":message,"idx":idx,"ml":_vm.thisMl}}):(_vm.listType === 'compact')?_c('message-list-message-compact',{attrs:{"message":message,"idx":idx,"ml":_vm.thisMl}}):_vm._e()],1)}),_vm._v(" "),_c('transition',{attrs:{"name":"kiwi-messagelist-joinloadertrans"}},[(_vm.shouldShowJoiningLoader)?_c('div',{staticClass:"kiwi-messagelist-joinloader"},[_c('LoadingAnimation')],1):_vm._e()]),_vm._v(" "),(_vm.shouldRequestChannelKey)?_c('buffer-key',{attrs:{"buffer":_vm.buffer,"network":_vm.buffer.getNetwork()}}):_vm._e()],2)}
var staticRenderFns = []


/***/ }),

/***/ "Nj28":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-aboutbuffer"},[_c('h3',[_vm._v(_vm._s(_vm.b.name))]),_vm._v(" "),_c('div',{staticClass:"kiwi-aboutbuffer-section",class:{'kiwi-aboutbuffer-section--closed': _vm.closedSections.about}},[_c('h4',{on:{"click":function($event){return _vm.toggleSection('about')}}},[_c('i',{staticClass:"fa fa-angle-right"}),_vm._v(" "+_vm._s(_vm.$t('about'))+"\n        ")]),_vm._v(" "),_c('div',[(_vm.b.topic)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.formattedTopic)}}):_c('p',[_vm._v(_vm._s(_vm.$t('no_topic_set')))]),_vm._v(" "),(_vm.b.created_at)?_c('p',[_vm._v("\n                "+_vm._s(_vm.$t('created_at', { when: new Intl.DateTimeFormat().format(_vm.b.created_at) }))+"\n            ")]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"kiwi-aboutbuffer-usercount"},[_c('a',{staticClass:"u-link ",on:{"click":function($event){return _vm.sidebarState.showNicklist()}}},[_vm._v("\n                    "+_vm._s(_vm.$t('person', {count: Object.keys(_vm.b.users || {}).length}))+"\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"kiwi-aboutbuffer-section",class:{'kiwi-aboutbuffer-section--closed': _vm.closedSections.highlights}},[_c('h4',{on:{"click":function($event){return _vm.toggleSection('highlights')}}},[_c('i',{staticClass:"fa fa-angle-right"}),_vm._v(" "+_vm._s(_vm.$t('highlights'))+"\n        ")]),_vm._v(" "),_c('div',[(_vm.highlights.length > 0)?_c('ul',_vm._l((_vm.highlights),function(msg){return _c('li',{key:msg.id,staticClass:"kiwi-aboutbuffer-highlight",on:{"click":function($event){return _vm.buffer.scrollToMessage(msg.id)}}},[_vm._v("\n                    "+_vm._s(msg.nick ? msg.nick + ': ' : '')),_c('span',{domProps:{"innerHTML":_vm._s(msg.html)}})])}),0):_c('p',[_vm._v(_vm._s(_vm.$t('nobody_mentioned_you')))])])]),_vm._v(" "),_vm._l((_vm.pluginUiSections),function(plugin){return _c('div',{key:plugin.id,staticClass:"kiwi-aboutbuffer-section",class:{'kiwi-aboutbuffer-section--closed': _vm.closedSections[plugin.id]}},[_c('h4',{on:{"click":function($event){return _vm.toggleSection(plugin.id)}}},[_c('i',{staticClass:"fa fa-angle-right"}),_vm._v(" "+_vm._s(plugin.args.title)+"\n        ")]),_vm._v(" "),_c('div',{directives:[{name:"rawElement",rawName:"v-rawElement",value:(plugin.el),expression:"plugin.el"}]})])})],2)}
var staticRenderFns = []


/***/ }),

/***/ "NxSI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OBOX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PxXf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QAaf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TextFormatting = __webpack_require__("15gS");

var _MessageInfo = __webpack_require__("ga3F");

var _MessageInfo2 = _interopRequireDefault(_MessageInfo);

var _MessageListAvatar = __webpack_require__("x8zS");

var _MessageListAvatar2 = _interopRequireDefault(_MessageListAvatar);

var _AwayStatusIndicator = __webpack_require__("vV7l");

var _AwayStatusIndicator2 = _interopRequireDefault(_AwayStatusIndicator);

var _TypingStatusIndicator = __webpack_require__("Qf21");

var _TypingStatusIndicator2 = _interopRequireDefault(_TypingStatusIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        MessageAvatar: _MessageListAvatar2.default,
        MessageInfo: _MessageInfo2.default,
        AwayStatusIndicator: _AwayStatusIndicator2.default,
        TypingStatusIndicator: _TypingStatusIndicator2.default
    },
    props: ['ml', 'message', 'idx'],
    data: function data() {
        return {};
    },
    computed: {
        showRealName: function showRealName() {
            if (!this.ml.buffer.setting('show_realnames')) {
                return false;
            }

            var client = this.ml.buffer.getNetwork().ircClient;
            if (!client.network.cap.isEnabled('extended-join')) {
                return false;
            }

            if (!this.message.user || !this.message.user.realname) {
                return false;
            }

            if (this.message.user.nick.toLowerCase() === this.message.user.realname.toLowerCase()) {
                return false;
            }

            if (_TextFormatting.urlRegex.test(this.message.user.realname)) {
                return false;
            }

            return true;
        },
        userColour: function userColour() {
            return this.ml.userColour(this.message.user);
        }
    },
    methods: {
        getNetwork: function getNetwork() {
            return this.ml.buffer.getNetwork();
        },
        isRepeat: function isRepeat() {
            var ml = this.ml;
            var idx = this.idx;
            var message = this.message;
            var prevMessage = ml.filteredMessages[idx - 1];

            return !!prevMessage && prevMessage.nick === message.nick && message.time - prevMessage.time < 60000 && prevMessage.type !== 'traffic' && message.type !== 'traffic';
        },
        isHoveringOverMessage: function isHoveringOverMessage(message) {
            return message.nick && message.nick.toLowerCase() === this.hover_nick.toLowerCase();
        },
        isMessage: function isMessage(message) {
            var types = ['privmsg', 'action', 'notice', 'message'];
            return types.indexOf(message.type) > -1;
        },
        displayAvatar: function displayAvatar(message) {
            if (!message.user) {
                return false;
            }

            if (this.ml.buffer.isServer() || this.ml.buffer.isSpecial()) {
                return false;
            }
            return true;
        },
        userMode: function userMode(user) {
            return this.ml.buffer.userMode(user);
        },
        userModePrefix: function userModePrefix(user) {
            return this.ml.buffer.userModePrefix(user);
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["MessageListMessageModern"]
window._kiwi_exports.components.MessageListMessageModern = exports.default ? exports.default : exports;


/***/ }),

/***/ "Qf21":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TypingStatusIndicator_vue__ = __webpack_require__("kkD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TypingStatusIndicator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TypingStatusIndicator_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TypingStatusIndicator_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TypingStatusIndicator_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48cb3874_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TypingStatusIndicator_vue__ = __webpack_require__("2Uqc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("ycf7")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TypingStatusIndicator_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48cb3874_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TypingStatusIndicator_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48cb3874_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TypingStatusIndicator_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "QrdV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _TextFormatting = __webpack_require__("15gS");

var TextFormatting = _interopRequireWildcard(_TextFormatting);

var _state = __webpack_require__("LnP8");

var _state2 = _interopRequireDefault(_state);

var _about = __webpack_require__("tpeZ");

var _about2 = _interopRequireDefault(_about);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var firstRun = true;

var ctor = {
    data: function data() {
        return {
            about_open: false
        };
    },
    computed: {
        networks: function networks() {
            return _state2.default.networks;
        },
        aboutContent: function aboutContent() {
            return _about2.default;
        }
    },
    methods: {
        addNetwork: function addNetwork() {
            var nick = 'Guest' + Math.floor(Math.random() * 100);
            var network = _state2.default.addNetwork(TextFormatting.t('new_network'), nick, {});
            network.showServerBuffer('settings');
        },
        toggleStateBrowser: function toggleStateBrowser() {
            _state2.default.$emit('statebrowser.show');
        },
        init: function init() {
            var _this = this;

            return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _state2.default.persistence.watchStateForChanges();
                                _this.$emit('start', {
                                    fallbackComponent: _this.constructor
                                });

                            case 2:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },
    created: function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            if (firstRun) {
                                this.init();
                                firstRun = false;
                            }

                        case 1:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function created() {
            return _ref.apply(this, arguments);
        }

        return created;
    }()
};

exports.default = ctor;

_state2.default.getStartups().kiwiirccom = ctor;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["thirdparty"]) window._kiwi_exports["thirdparty"] = {};
window._kiwi_exports["thirdparty"]["kiwiirccom"]
window._kiwi_exports.thirdparty.kiwiirccom = exports.default ? exports.default : exports;


/***/ }),

/***/ "Qyqn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _state = __webpack_require__("LnP8");

var _state2 = _interopRequireDefault(_state);

var _Misc = __webpack_require__("uN9+");

var Misc = _interopRequireWildcard(_Misc);

var _bufferTools = __webpack_require__("7DgK");

var bufferTools = _interopRequireWildcard(_bufferTools);

var _BufferSettings = __webpack_require__("5nmk");

var _BufferSettings2 = _interopRequireDefault(_BufferSettings);

var _AwayStatusIndicator = __webpack_require__("vV7l");

var _AwayStatusIndicator2 = _interopRequireDefault(_AwayStatusIndicator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        BufferSettings: _BufferSettings2.default,
        AwayStatusIndicator: _AwayStatusIndicator2.default
    },
    props: ['network', 'sidebarState'],
    data: function data() {
        return {
            collapsed: false,
            channel_filter: '',
            channel_filter_display: false,
            channel_add_display: false,
            channel_add_input_has_focus: false,
            channel_add_input: ''
        };
    },
    computed: {
        isActiveNetwork: function isActiveNetwork() {
            return _state2.default.getActiveNetwork() === this.network;
        },
        totalNetworkCount: function totalNetworkCount() {
            return _state2.default.networks.length;
        },
        filteredBuffers: function filteredBuffers() {
            var filter = this.channel_filter;
            var filtered = [];

            if (!filter) {
                filtered = this.network.buffers;
            } else {
                filtered = _lodash2.default.filter(this.network.buffers, function (buffer) {
                    var name = buffer.name.toLowerCase();
                    return name.indexOf(filter) > -1;
                });
            }

            return bufferTools.orderBuffers(filtered);
        }
    },
    methods: {
        onNewChannelInputFocus: function onNewChannelInputFocus() {
            if (!this.channel_add_input) {
                this.channel_add_input = '#';
            }

            this.channel_add_input_has_focus = true;
        },
        onNewChannelInputBlur: function onNewChannelInputBlur() {
            if (this.channel_add_input === '#') {
                this.channel_add_input = '';
            }

            if (!this.channel_add_input) {
                this.channel_add_display = false;
            }

            this.channel_add_input_has_focus = false;
        },
        submitNewChannelForm: function submitNewChannelForm() {
            var newChannelVal = this.channel_add_input;
            this.channel_add_input = '#';

            var network = this.network;
            var bufferObjs = Misc.extractBuffers(newChannelVal);

            var hasSwitchedActiveBuffer = false;
            bufferObjs.forEach(function (bufferObj) {
                var chanName = bufferObj.name;
                var ignoreNames = ['#0', '0', '&0'];
                if (ignoreNames.indexOf(chanName) > -1 || chanName.replace(/[#&]/g, '') === '') {
                    return;
                }

                var newBuffer = _state2.default.addBuffer(network.id, chanName);
                if (newBuffer && !hasSwitchedActiveBuffer) {
                    _state2.default.setActiveBuffer(network.id, newBuffer.name);
                    hasSwitchedActiveBuffer = true;
                }

                if (bufferObj.key) {
                    newBuffer.key = bufferObj.key;
                }

                if (network.isChannelName(chanName)) {
                    network.ircClient.join(chanName, bufferObj.key);
                }
            });
        },
        onChannelFilterInputBlur: function onChannelFilterInputBlur() {
            var _this = this;

            if (!this.channel_filter) {
                setTimeout(function () {
                    _this.closeFilterChannel();
                }, 200);
            }
        },
        closeBuffer: function closeBuffer(buffer) {
            _state2.default.removeBuffer(buffer);
        },
        awayNotifySupported: function awayNotifySupported() {
            return this.network.ircClient.network.cap.isEnabled('away-notify');
        },

        showMessageCounts: function showMessageCounts(buffer) {
            return !buffer.setting('hide_message_counts');
        },
        setActiveBuffer: function switchContainer(buffer) {
            _state2.default.$emit('active.component', null);
            _state2.default.setActiveBuffer(buffer.networkid, buffer.name);
            if (this.$state.ui.is_narrow) {
                _state2.default.$emit('statebrowser.hide');
            }
        },
        isActiveBuffer: function isActiveBuffer(buffer) {
            return buffer.networkid === _state2.default.ui.active_network && buffer.name === _state2.default.ui.active_buffer;
        },
        showNetworkSettings: function showNetworkSettings(network) {
            network.showServerBuffer('settings');
        },
        showNetworkChannels: function showNetworkChannels(network) {
            network.showServerBuffer('channels');
        },
        toggleAddChannel: function toggleAddChannel() {
            this.channel_add_display = !this.channel_add_display;
            this.channel_filter_display = false;
        },
        toggleFilterChannel: function toggleFilterChannel() {
            this.channel_filter_display = !this.channel_filter_display;
            this.channel_add_display = false;
        },
        closeFilterChannel: function closeFilterChannel() {
            this.channel_filter = '';
            this.channel_filter_display = false;
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["StateBrowserNetwork"]
window._kiwi_exports.components.StateBrowserNetwork = exports.default ? exports.default : exports;


/***/ }),

/***/ "RKgk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomServer_vue__ = __webpack_require__("8LRQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomServer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomServer_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomServer_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomServer_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_086d974a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomServer_vue__ = __webpack_require__("/GFh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("g1Es")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomServer_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_086d974a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomServer_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_086d974a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomServer_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "RL9m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SB1V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-messagelist-message kiwi-messagelist-message--compact",class:[
        _vm.ml.filteredMessages[_vm.idx-1] &&
            _vm.ml.filteredMessages[_vm.idx-1].nick === _vm.message.nick &&
            _vm.message.time - _vm.ml.filteredMessages[_vm.idx-1].time < 60000 &&
            _vm.ml.filteredMessages[_vm.idx-1].type !== 'traffic' &&
            _vm.message.type !== 'traffic' ?
                'kiwi-messagelist-message--authorrepeat' :
                '',
        'kiwi-messagelist-message-' + _vm.message.type,
        _vm.message.type_extra ?
            'kiwi-messagelist-message-' + _vm.message.type + '-' + _vm.message.type_extra :
            '',
        _vm.ml.isMessageHighlight(_vm.message) ?
            'kiwi-messagelist-message--highlight' :
            '',
        _vm.ml.isHoveringOverMessage(_vm.message) ?
            'kiwi-messagelist-message--hover' :
            '',
        _vm.ml.buffer.last_read && _vm.message.time > _vm.ml.buffer.last_read ?
            'kiwi-messagelist-message--unread' :
            '',
        _vm.message.nick.toLowerCase() === _vm.ml.ourNick.toLowerCase() ?
            'kiwi-messagelist-message--own' :
            '',
        _vm.ml.message_info_open === _vm.message ?
            'kiwi-messagelist-message--info-open' :
            '',
        _vm.ml.message_info_open && _vm.ml.message_info_open !== _vm.message ?
            'kiwi-messagelist-message--blur' :
            '',
        (_vm.message.user && _vm.userMode(_vm.message.user)) ?
            'kiwi-messagelist-message--user-mode-'+_vm.userMode(_vm.message.user) :
            ''
    ],attrs:{"data-message-id":_vm.message.id,"data-nick":(_vm.message.nick||'').toLowerCase()},on:{"click":function($event){return _vm.ml.onMessageClick($event, _vm.message)}}},[(_vm.ml.bufferSetting('show_timestamps'))?_c('div',{staticClass:"kiwi-messagelist-time",attrs:{"title":_vm.ml.formatTimeFull(_vm.message.time)}},[_vm._v("\n        "+_vm._s(_vm.ml.formatTime(_vm.message.time))+"\n    ")]):_vm._e(),_vm._v(" "),_c('div',{class:[
            'kiwi-messagelist-nick',
            (_vm.message.user && _vm.userMode(_vm.message.user)) ?
                'kiwi-messagelist-nick--mode-'+_vm.userMode(_vm.message.user) :
                ''
        ],style:({ 'color': _vm.userColour }),on:{"click":function($event){return _vm.ml.openUserBox(_vm.message.nick)},"mouseover":function($event){_vm.ml.hover_nick=_vm.message.nick.toLowerCase();},"mouseout":function($event){_vm.ml.hover_nick='';}}},[(_vm.message.user)?_c('away-status-indicator',{attrs:{"network":_vm.getNetwork(),"user":_vm.message.user,"toggle":false}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"kiwi-messagelist-nick--prefix"},[_vm._v("\n            "+_vm._s(_vm.message.user ? _vm.userModePrefix(_vm.message.user) : '')+"\n        ")]),_vm._v("\n        "+_vm._s(_vm.message.nick)+"\n    ")],1),_vm._v(" "),(_vm.message.bodyTemplate && _vm.message.bodyTemplate.$el)?_c('div',{directives:[{name:"rawElement",rawName:"v-rawElement",value:(_vm.message.bodyTemplate.$el),expression:"message.bodyTemplate.$el"}],staticClass:"kiwi-messagelist-body"}):_c('div',{staticClass:"kiwi-messagelist-body",domProps:{"innerHTML":_vm._s(_vm.ml.formatMessage(_vm.message))}}),_vm._v(" "),(_vm.ml.message_info_open===_vm.message)?_c('message-info',{attrs:{"message":_vm.message,"buffer":_vm.ml.buffer},on:{"close":function($event){return _vm.ml.toggleMessageInfo()}}}):_vm._e()],1)}
var staticRenderFns = []


/***/ }),

/***/ "TEdo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TZJg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-wrap kiwi-theme-bg",class:{
        'kiwi-wrap--statebrowser-drawopen': _vm.stateBrowserDrawOpen,
        'kiwi-wrap--monospace': _vm.$state.setting('useMonospace'),
        'kiwi-wrap--touch': _vm.$state.ui.is_touch,
    },attrs:{"data-activebuffer":_vm.buffer ? _vm.buffer.name.toLowerCase() : ''},on:{"click":_vm.emitDocumentClick,"!paste":function($event){return _vm.emitBufferPaste($event)}}},[_c('link',{attrs:{"href":_vm.themeUrl,"rel":"stylesheet","type":"text/css"}}),_vm._v(" "),(!_vm.hasStarted || (!_vm.fallbackComponent && _vm.networks.length === 0))?[_c(_vm.startupComponent,{tag:"component",on:{"start":_vm.startUp}})]:[_c('state-browser',{attrs:{"networks":_vm.networks,"sidebar-state":_vm.sidebarState}}),_vm._v(" "),_c('div',{staticClass:"kiwi-workspace",class:{
                'kiwi-workspace--disconnected': _vm.network && _vm.network.state !== 'connected'
            },on:{"click":function($event){_vm.stateBrowserDrawOpen = false}}},[_c('div',{staticClass:"kiwi-workspace-background"}),_vm._v(" "),(!_vm.activeComponent && _vm.network)?[_c('container',{attrs:{"network":_vm.network,"buffer":_vm.buffer,"sidebar-state":_vm.sidebarState},scopedSlots:_vm._u([(_vm.mediaviewerOpen)?{key:"before",fn:function(){return [_c('media-viewer',{attrs:{"url":_vm.mediaviewerUrl,"component":_vm.mediaviewerComponent,"is-iframe":_vm.mediaviewerIframe}})]},proxy:true}:null],null,true)}),_vm._v(" "),(_vm.buffer.show_input)?_c('control-input',{attrs:{"container":_vm.networks,"buffer":_vm.buffer}}):_vm._e()]:(!_vm.activeComponent)?_c(_vm.fallbackComponent,_vm._b({tag:"component"},'component',_vm.fallbackComponentProps,false)):_c(_vm.activeComponent,_vm._b({tag:"component"},'component',_vm.activeComponentProps,false))],2)]],2)}
var staticRenderFns = []


/***/ }),

/***/ "Ta7/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _create = __webpack_require__("OvRC");

var _create2 = _interopRequireDefault(_create);

var _state = __webpack_require__("LnP8");

var _state2 = _interopRequireDefault(_state);

var _NetworkProvider = __webpack_require__("EKUm");

var _NetworkProvider2 = _interopRequireDefault(_NetworkProvider);

var _GlobalApi = __webpack_require__("Uvbb");

var _GlobalApi2 = _interopRequireDefault(_GlobalApi);

var _StateBrowserNetwork = __webpack_require__("WDQw");

var _StateBrowserNetwork2 = _interopRequireDefault(_StateBrowserNetwork);

var _StateBrowserUsermenu = __webpack_require__("ceRT");

var _StateBrowserUsermenu2 = _interopRequireDefault(_StateBrowserUsermenu);

var _AppSettings = __webpack_require__("Aw+L");

var _AppSettings2 = _interopRequireDefault(_AppSettings);

var _BufferSettings = __webpack_require__("5nmk");

var _BufferSettings2 = _interopRequireDefault(_BufferSettings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var netProv = new _NetworkProvider2.default();

exports.default = {
    components: {
        BufferSettings: _BufferSettings2.default,
        StateBrowserNetwork: _StateBrowserNetwork2.default,
        StateBrowserUsermenu: _StateBrowserUsermenu2.default
    },
    props: ['networks', 'sidebarState'],
    data: function data() {
        return {
            show_provided_networks: false,
            provided_networks: (0, _create2.default)(null),
            pluginUiElements: _GlobalApi2.default.singleton().stateBrowserPlugins
        };
    },
    computed: {
        getNetwork: function getNetwork() {
            return _state2.default.getActiveNetwork();
        },

        isPersistingState: function isPersistingState() {
            return !!_state2.default.persistence;
        },
        isRestrictedServer: function isRestrictedServer() {
            return !!_state2.default.settings.restricted;
        },
        networksToShow: function networksToShow() {
            return this.networks.filter(function (net) {
                return !net.hidden;
            });
        }
    },
    created: function created() {
        var _this = this;

        netProv.on('networks', function (networks) {
            _this.provided_networks = networks;
        });
    },
    methods: {
        clickAddNetwork: function clickAddNetwork() {
            var nick = 'Guest' + Math.floor(Math.random() * 100);
            var network = _state2.default.getNetworkFromAddress('');
            if (typeof network === 'undefined') {
                network = _state2.default.addNetwork('Network', nick, {});
            }
            network.showServerBuffer('settings');
        },
        clickAppSettings: function clickAppSettings() {
            _state2.default.$emit('active.component.toggle', _AppSettings2.default);
        },
        hideStatebrowser: function hideStatebrowser() {
            _state2.default.$emit('statebrowser.hide');
        },
        connectProvidedNetwork: function connectProvidedNetwork(pNet) {
            var net = _state2.default.addNetwork(pNet.name, pNet.nick, {
                server: pNet.server,
                port: pNet.port,
                tls: pNet.tls,
                password: pNet.password
            });

            net.ircClient.connect();
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["StateBrowser"]
window._kiwi_exports.components.StateBrowser = exports.default ? exports.default : exports;


/***/ }),

/***/ "TbYc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _GlobalApi = __webpack_require__("Uvbb");

var _GlobalApi2 = _interopRequireDefault(_GlobalApi);

var _Html = __webpack_require__("Nbm2");

var _Html2 = _interopRequireDefault(_Html);

var _MessageParser = __webpack_require__("wXH7");

var _MessageParser2 = _interopRequireDefault(_MessageParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['network', 'buffer', 'sidebarState'],
    data: function data() {
        return {
            pluginUiSections: _GlobalApi2.default.singleton().aboutBufferPlugins,
            closedSections: {}
        };
    },

    computed: {
        b: function b() {
            return this.buffer || {};
        },
        formattedTopic: function formattedTopic() {
            var blocks = (0, _MessageParser2.default)(this.b.topic || '', { extras: false });
            var content = (0, _Html2.default)(blocks);
            return content;
        },
        highlights: function highlights() {
            var tmp = this.buffer.message_count;
            return this.buffer.getMessages().filter(function (m) {
                return m.isHighlight;
            }).filter(function (m) {
                return m.type !== 'traffic';
            }).filter(function (m) {
                return m.type !== 'topic';
            }).filter(function (m) {
                return m.type !== 'mode';
            }).filter(function (m) {
                return m.html;
            }).sort(function (a, b) {
                return b.time - a.time;
            });
        }
    },
    methods: {
        toggleSection: function toggleSection(section) {
            this.$set(this.closedSections, section, !this.closedSections[section]);
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["SidebarAboutBuffer"]
window._kiwi_exports.components.SidebarAboutBuffer = exports.default ? exports.default : exports;


/***/ }),

/***/ "Tddf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = batchedAdd;
function batchedAdd(singleFn, batchedFn) {
    var queue = [];
    var numInLastSec = 0;
    var isLooping = false;
    var loopInterval = 1000;

    function queueLoop() {
        numInLastSec = 0;
        if (queue.length) {
            var q = queue;
            queue = [];
            batchedFn(q);
            numInLastSec = 0;
            setTimeout(queueLoop, loopInterval);
        } else {
            isLooping = false;
        }
    }

    function maybeStartLoop() {
        if (isLooping) {
            return;
        }

        isLooping = true;
        setTimeout(queueLoop, loopInterval);
    }

    function resetAddCounter(doResetNum) {
        if (doResetNum) {
            numInLastSec = 0;
        }
        if (!isLooping) {
            setTimeout(resetAddCounter, 1000, true);
        }
    }

    function batchFn(item) {
        numInLastSec++;

        if (queue.length || numInLastSec > 3) {
            queue.push(item);
            maybeStartLoop();
        } else {
            singleFn(item);
            resetAddCounter();
        }
    }
    batchFn.queue = function getQueue() {
        return queue;
    };

    return batchFn;
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["batchedAdd"]
window._kiwi_exports.libs.batchedAdd = exports.default ? exports.default : exports;


/***/ }),

/***/ "TqUK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U+ER":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"u-tabbed-view"},[_c('div',{key:_vm.prefixID + _vm.a,staticClass:"u-tabbed-view-tabs"},_vm._l((_vm.tabs),function(c){return _c('a',{key:c.name || c.header,class:{
                'u-tabbed-view-tab': true,
                'u-tabbed-view-tab--active': c.active
            },on:{"click":function($event){return _vm.setActive(c)}}},[_vm._v(_vm._s(c.header))])}),0),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []


/***/ }),

/***/ "U6GM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _state = __webpack_require__("LnP8");

var _state2 = _interopRequireDefault(_state);

var _Misc = __webpack_require__("uN9+");

var Misc = _interopRequireWildcard(_Misc);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['ircinput'],
    data: function data() {
        return {
            location: _state2.default.setting('emojiLocation')
        };
    },
    computed: {
        emojis: function emojis() {
            var list = {};
            var available = _state2.default.setting('emojis');
            _lodash2.default.each(available, function (code, ascii) {
                list[code] = ascii;
            });
            return list;
        }
    },
    methods: {
        onImgClick: function onImgClick(event) {
            var url = window.getComputedStyle(event.target, null).getPropertyValue('background-image');

            url = Misc.extractURL(url);
            var code = event.target.dataset.code;
            this.ircinput.addImg(code, url);
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["inputtools"]) window._kiwi_exports["components"]["inputtools"] = {};
window._kiwi_exports["components"]["inputtools"]["Emoji"]
window._kiwi_exports.components.inputtools.Emoji = exports.default ? exports.default : exports;


/***/ }),

/***/ "UR+h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-channellist",class:{'kiwi-channellist-padding-top': !_vm.list.length}},[_c('div',{staticClass:"kiwi-channellist-content-container"},[_c('div',{staticClass:"kiwi-channellist-nav"},[_c('form',{staticClass:"u-form kiwi-channellist-search",on:{"submit":function($event){$event.preventDefault();}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"u-input",attrs:{"placeholder":_vm.$t('do_search')},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_c('a',{staticClass:"u-button kiwi-channellist-refresh",class:{
                        'u-button-primary': !_vm.isLoading,
                        'u-button-secondary': _vm.isLoading,
                    },on:{"click":_vm.maybeUpdateList}},[(!_vm.isLoading)?_c('i',{staticClass:"fa fa-refresh",attrs:{"aria-hidden":"true"}}):_c('i',{staticClass:"fa fa-refresh fa-spin",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),(_vm.list.length)?_c('div',{staticClass:"kiwi-channellist-pagination"},[_c('a',{on:{"click":_vm.prevPage}},[_c('i',{staticClass:"fa fa-step-backward",attrs:{"aria-hidden":"true"}})]),_vm._v("\n                "+_vm._s(_vm.page + 1)+" / "+_vm._s(_vm.maxPages + 1)+"\n                "),_c('a',{on:{"click":_vm.nextPage}},[_c('i',{staticClass:"fa fa-step-forward",attrs:{"aria-hidden":"true"}})])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"kiwi-channellist-table"},[(!_vm.isLoading && !_vm.noResults)?_c('table',{key:_vm.last_updated,attrs:{"width":"100%"}},[_c('tbody',_vm._l((_vm.paginated),function(channel){return _c('tr',{key:channel.channel},[_c('td',{staticClass:"kiwi-channellist-user-center"},[(channel.num_users >= 0)?_c('span',{staticClass:"kiwi-channellist-users"},[_c('i',{staticClass:"fa fa-user",attrs:{"aria-hidden":"true"}}),_vm._v("\n                                "+_vm._s(channel.num_users)+"\n                            ")]):_vm._e()]),_vm._v(" "),_c('td',[_c('a',{staticClass:"u-link",on:{"click":function($event){return _vm.joinChannel(channel.channel)}}},[_vm._v("\n                                "+_vm._s(channel.channel)+"\n                            ")])]),_vm._v(" "),_c('td',{staticClass:"kiwi-channellist-table-topic"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.formatAndTrimTopic(channel.topic))}})]),_vm._v(" "),_c('td',{staticClass:"kiwi-channellist-user-center"},[_c('a',{staticClass:"u-button u-button-primary",on:{"click":function($event){return _vm.joinChannel(channel.channel)}}},[_vm._v("\n                                "+_vm._s(_vm.$t('container_join'))+"\n                            ")])])])}),0)]):(_vm.noResults)?_c('div',{staticClass:"kiwi-channellist-info"},[_c('p',[_vm._v(_vm._s(_vm.$t('channel_list_nonefound')))])]):_c('div',{staticClass:"kiwi-channellist-info"},[_vm._v(_vm._s(_vm.$t('channel_list_fetch')))])])])])}
var staticRenderFns = []


/***/ }),

/***/ "Uvbb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__("Gu7T");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _create = __webpack_require__("OvRC");

var _create2 = _interopRequireDefault(_create);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _eventemitter = __webpack_require__("BzvE");

var _eventemitter2 = _interopRequireDefault(_eventemitter);

var _vue = __webpack_require__("I3G/");

var _vue2 = _interopRequireDefault(_vue);

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _compareVersions = __webpack_require__("u9Pu");

var _compareVersions2 = _interopRequireDefault(_compareVersions);

var _Misc = __webpack_require__("uN9+");

var Misc = _interopRequireWildcard(_Misc);

var _Logger = __webpack_require__("XNCV");

var _Logger2 = _interopRequireDefault(_Logger);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var singletonInstance = null;
var pluginsToInit = [];
var nextPluginId = 0;

var GlobalApi = function (_EventEmitter) {
    (0, _inherits3.default)(GlobalApi, _EventEmitter);

    function GlobalApi() {
        (0, _classCallCheck3.default)(this, GlobalApi);

        var _this = (0, _possibleConstructorReturn3.default)(this, (GlobalApi.__proto__ || (0, _getPrototypeOf2.default)(GlobalApi)).call(this));

        _this.version = '1.3.0';

        _this.Vue = _vue2.default;

        _this.state = null;

        _this.themes = null;
        _this.controlInputPlugins = [];
        _this.stateBrowserPlugins = [];
        _this.channelHeaderPlugins = [];
        _this.queryHeaderPlugins = [];
        _this.sideBarPlugins = [];
        _this.appSettingsPlugins = [];
        _this.serverViewPlugins = [];
        _this.aboutBufferPlugins = [];
        _this.tabs = (0, _create2.default)(null);
        _this.isReady = false;

        _this.exports = window._kiwi_exports || {};

        _this.on('init', function () {
            _this.isReady = true;
            _this.initPlugins();
        });
        return _this;
    }

    (0, _createClass3.default)(GlobalApi, [{
        key: 'versionMatches',
        value: function versionMatches(v) {
            return (0, _compareVersions2.default)(this.version, v) >= 0;
        }
    }, {
        key: 'plugin',
        value: function plugin(pluginName, fn) {
            var plugin = { name: pluginName, fn: fn };
            if (this.isReady) {
                this.initPlugin(plugin);
            } else {
                pluginsToInit.push(plugin);
            }
        }
    }, {
        key: 'initPlugins',
        value: function initPlugins() {
            var _this2 = this;

            pluginsToInit.forEach(function (plugin) {
                return _this2.initPlugin(plugin);
            });
            pluginsToInit = [];
        }
    }, {
        key: 'initPlugin',
        value: function initPlugin(plugin) {
            var pluginLogger = _Logger2.default.namespace('Plugin ' + plugin.name);
            try {
                plugin.fn(this, pluginLogger);
                this.state.$emit('plugin.loaded', { name: plugin.name });
            } catch (err) {
                pluginLogger.error(err.stack);
            }
        }
    }, {
        key: 'require',
        value: function require(modPath) {
            var path = modPath.replace(/\//g, '.');
            var mod = _lodash2.default.get(this.exports, path);
            if (typeof mod === 'undefined') {
                _Logger2.default.error('Module does not exist: ' + modPath);
            }

            return mod;
        }
    }, {
        key: 'setState',
        value: function setState(state) {
            var _this3 = this;

            this.state = state;

            var stateEmit = this.state.$emit;
            var thisEmit = this.emit;

            this.state.$emit = function () {
                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                try {
                    thisEmit.call.apply(thisEmit, [_this3, 'all', args[0]].concat((0, _toConsumableArray3.default)(args.slice(1))));
                    thisEmit.call.apply(thisEmit, [_this3].concat(args));
                } catch (err) {
                    _Logger2.default.error(err.stack);
                }

                return stateEmit.call.apply(stateEmit, [_this3.state].concat(args));
            };

            this.emit = function () {
                for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    args[_key2] = arguments[_key2];
                }

                stateEmit.call.apply(stateEmit, [_this3.state].concat(args));
                thisEmit.call.apply(thisEmit, [_this3].concat(args));
            };
        }
    }, {
        key: 'setThemeManager',
        value: function setThemeManager(themeManager) {
            this.themes = themeManager;
        }
    }, {
        key: 'logLevel',
        value: function logLevel(newLevel) {
            _Logger2.default.setLevel(newLevel);
        }
    }, {
        key: 'addUi',
        value: function addUi(type, element) {
            var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            var plugin = {
                el: element,
                id: nextPluginId++,
                args: args
            };

            switch (type) {
                case 'input':
                    this.controlInputPlugins.push(plugin);
                    break;
                case 'browser':
                    this.stateBrowserPlugins.push(plugin);
                    break;
                case 'header_channel':
                    this.channelHeaderPlugins.push(plugin);
                    break;
                case 'header_query':
                    this.queryHeaderPlugins.push(plugin);
                    break;
                case 'about_buffer':
                    this.aboutBufferPlugins.push(plugin);
                    break;
                default:
                    break;
            }
        }
    }, {
        key: 'addTab',
        value: function addTab(type, title, component, props) {
            var plugin = {
                id: nextPluginId++,
                title: title,
                component: component,
                props: props
            };

            switch (type) {
                case 'channel':
                    this.sideBarPlugins.push(plugin);
                    break;
                case 'settings':
                    this.appSettingsPlugins.push(plugin);
                    break;
                case 'server':
                    this.serverViewPlugins.push(plugin);
                    break;
                default:
                    break;
            }
        }
    }, {
        key: 'addView',
        value: function addView(name, component, props) {
            this.tabs[name] = {
                id: nextPluginId++,
                component: _vue2.default.extend(component),
                props: props || {}
            };
        }
    }, {
        key: 'showView',
        value: function showView(name) {
            var tab = this.tabs[name];
            if (tab) {
                this.state.$emit('active.component', tab.component, tab.props);
            } else {
                this.state.$emit('active.component', null);
            }
        }
    }, {
        key: 'showInSidebar',
        value: function showInSidebar(component) {
            this.state.$emit('sidebar.component', component);
        }
    }, {
        key: 'addStartup',
        value: function addStartup(name, ctor) {
            var startups = this.state.getStartups();
            startups[name] = ctor;
        }
    }, {
        key: 'replaceModule',
        value: function replaceModule(dest, source) {
            var mod = this.require(dest);
            if (!mod) {
                throw new Error('The module ' + dest + ' does not exist');
            }

            Misc.replaceObjectProps(mod, source);
        }
    }], [{
        key: 'singleton',
        value: function singleton() {
            singletonInstance = singletonInstance || new GlobalApi();
            return singletonInstance;
        }
    }]);
    return GlobalApi;
}(_eventemitter2.default);

exports.default = GlobalApi;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["GlobalApi"]
window._kiwi_exports.libs.GlobalApi = exports.default ? exports.default : exports;


/***/ }),

/***/ "VKy0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VRuw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-statebrowser-network",class:[
    _vm.isActiveNetwork ? 'kiwi-statebrowser-network--active' : '' ]},[_c('div',{staticClass:"kiwi-statebrowser-network-header"},[_c('a',{staticClass:"kiwi-statebrowser-network-name u-link",on:{"click":function($event){_vm.setActiveBuffer(_vm.network.serverBuffer())}}},[_vm._v("\n            "+_vm._s(_vm.network.name)+"\n        ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kiwi-network-name-options"},[(_vm.totalNetworkCount > 1)?_c('div',{staticClass:"kiwi-network-name-option kiwi-network-name-option-collapse",on:{"click":function($event){_vm.collapsed=!_vm.collapsed}}},[_c('i',{staticClass:"fa",class:[_vm.collapsed?'fa-plus-square-o':'fa-minus-square-o']})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"kiwi-network-name-option kiwi-network-name-option-channel",class:{ active: _vm.channel_add_display == true },on:{"click":function($event){return _vm.toggleAddChannel()}}},[_c('i',{staticClass:"fa fa-plus",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('div',{staticClass:"kiwi-network-name-option kiwi-network-name-option-chanfilter",class:{ active: _vm.channel_filter_display == true },on:{"click":function($event){return _vm.toggleFilterChannel()}}},[_c('i',{staticClass:"fa fa-search",attrs:{"aria-hidden":"true"}})])])]),_vm._v(" "),(_vm.channel_filter_display)?_c('div',{staticClass:"kiwi-statebrowser-channelfilter"},[_c('input',{directives:[{name:"focus",rawName:"v-focus"},{name:"model",rawName:"v-model",value:(_vm.channel_filter),expression:"channel_filter"}],attrs:{"placeholder":_vm.$t('filter_channels'),"type":"text"},domProps:{"value":(_vm.channel_filter)},on:{"blur":_vm.onChannelFilterInputBlur,"input":function($event){if($event.target.composing){ return; }_vm.channel_filter=$event.target.value}}}),_vm._v(" "),_c('p',[_c('a',{on:{"click":function($event){_vm.closeFilterChannel(); _vm.showNetworkChannels(_vm.network)}}},[_vm._v("\n                "+_vm._s(_vm.$t('find_more_channels'))+"\n            ")])])]):_vm._e(),_vm._v(" "),(_vm.channel_add_display)?_c('div',{staticClass:"kiwi-statebrowser-channels-info"},[_c('form',{staticClass:"kiwi-statebrowser-newchannel",on:{"submit":function($event){$event.preventDefault();return _vm.submitNewChannelForm($event)}}},[_c('div',{directives:[{name:"focus",rawName:"v-focus"}],staticClass:"kiwi-statebrowser-newchannel-inputwrap",class:[
                    _vm.channel_add_input_has_focus ?
                        'kiwi-statebrowser-newchannel-inputwrap--focus' :
                        ''
                ]},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.channel_add_input),expression:"channel_add_input"}],attrs:{"placeholder":_vm.$t('state_join'),"type":"text"},domProps:{"value":(_vm.channel_add_input)},on:{"focus":_vm.onNewChannelInputFocus,"blur":_vm.onNewChannelInputBlur,"input":function($event){if($event.target.composing){ return; }_vm.channel_add_input=$event.target.value}}})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"kiwi-statebrowser-network-toggable-area",class:[
        _vm.collapsed ? 'kiwi-statebrowser-network-toggable-area--collapsed' : '' ]},[_c('transition',{attrs:{"name":"kiwi-statebrowser-network-status-transition"}},[(_vm.network.state !== 'connected')?_c('div',{staticClass:"kiwi-statebrowser-network-status"},[(_vm.network.state_error)?[_c('i',{staticClass:"fa fa-exclamation-triangle",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('a',{staticClass:"u-link",on:{"click":function($event){return _vm.showNetworkSettings(_vm.network)}}},[_vm._v("\n                        "+_vm._s(_vm.$t('state_configure'))+"\n                    ")])]:(!_vm.network.connection.server)?[_c('a',{staticClass:"u-link",on:{"click":function($event){return _vm.showNetworkSettings(_vm.network)}}},[_vm._v("\n                        "+_vm._s(_vm.$t('state_configure'))+"\n                    ")])]:(_vm.network.state === 'disconnected')?[_vm._v("\n                    "+_vm._s(_vm.$t('state_disconnected'))+"\n                    "),_c('a',{staticClass:"u-link",on:{"click":function($event){return _vm.network.ircClient.connect()}}},[_vm._v("\n                        "+_vm._s(_vm.$t('connect'))+"\n                    ")])]:(_vm.network.state === 'connecting')?[_vm._v("\n                    "+_vm._s(_vm.$t('connecting'))+"\n                ")]:_vm._e()],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"kiwi-statebrowser-channels"},_vm._l((_vm.filteredBuffers),function(buffer){return _c('div',{key:buffer.name,staticClass:"kiwi-statebrowser-channel",class:{
                    'kiwi-statebrowser-channel-active': _vm.isActiveBuffer(buffer),
                    'kiwi-statebrowser-channel-notjoined': buffer.isChannel() && !buffer.joined
                },attrs:{"data-name":buffer.name.toLowerCase()}},[_c('div',{staticClass:"kiwi-statebrowser-channel-name",on:{"click":function($event){return _vm.setActiveBuffer(buffer)}}},[(buffer.isQuery() && _vm.awayNotifySupported())?_c('away-status-indicator',{attrs:{"network":_vm.network,"user":_vm.network.userByName(buffer.name)}}):_vm._e(),_vm._v(_vm._s(buffer.name)+"\n                ")],1),_vm._v(" "),_c('div',{staticClass:"kiwi-statebrowser-channel-labels"},[_c('transition',{attrs:{"name":"kiwi-statebrowser-channel-label-transition"}},[(buffer.flags.unread && _vm.showMessageCounts(buffer))?_c('div',{staticClass:"kiwi-statebrowser-channel-label",class:[
                                buffer.flags.highlight ?
                                    'kiwi-statebrowser-channel-label--highlight' :
                                    ''
                            ]},[_vm._v("\n                            "+_vm._s(buffer.flags.unread > 999 ? "999+": buffer.flags.unread)+"\n                        ")]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"kiwi-statebrowser-channel-leave",on:{"click":function($event){return _vm.closeBuffer(buffer)}}},[_c('i',{staticClass:"fa fa-times",attrs:{"aria-hidden":"true"}})])])}),0)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-network-name-hover-icon"},[_c('i',{staticClass:"fa fa-ellipsis-h",attrs:{"aria-hidden":"true"}})])}]


/***/ }),

/***/ "VSWv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _values = __webpack_require__("gRE1");

var _values2 = _interopRequireDefault(_values);

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _IrcdDiffs = __webpack_require__("1gJW");

var IrcdDiffs = _interopRequireWildcard(_IrcdDiffs);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function inviteListSorter(a, b) {
    var aMask = a.invited.toUpperCase();
    var bMask = b.invited.toUpperCase();

    if (aMask < bMask) {
        return -1;
    }
    if (aMask > bMask) {
        return 1;
    }

    return 0;
}

exports.default = {
    props: ['buffer'],
    data: function data() {
        return {
            inviteList: [],
            is_refreshing: false
        };
    },

    computed: {
        supportsAccounts: function supportsAccounts() {
            return !!this.extban;
        },
        extban: function extban() {
            return IrcdDiffs.extbanAccount(this.buffer.getNetwork());
        },
        inviteListAccounts: function inviteListAccounts() {
            var _this = this;

            var accounts = this.inviteList.filter(function (i) {
                return i.invited.indexOf(_this.extban) === 0;
            });
            accounts.sort(inviteListSorter);
            return accounts;
        },
        inviteListNonAccounts: function inviteListNonAccounts() {
            var _this2 = this;

            var invites = [];

            if (!this.supportsAccounts) {
                invites = this.inviteList;
            } else {
                invites = this.inviteList.filter(function (i) {
                    return i.invited.indexOf(_this2.extban) !== 0;
                });
            }

            invites.sort(inviteListSorter);
            return invites;
        },
        channelIsInviteOnly: function channelIsInviteOnly() {
            return typeof this.buffer.modes.i !== 'undefined';
        },
        anyRegisteredUserCanJoin: function anyRegisteredUserCanJoin() {
            if (!this.supportsAccounts) {
                return false;
            }

            if (!this.channelIsInviteOnly) {
                return false;
            }

            var extban = this.extban;

            return !!this.inviteListAccounts.find(function (invite) {
                return invite.invited === extban + ':';
            });
        },
        areWeAnOp: function areWeAnOp() {
            return this.buffer.isUserAnOp(this.buffer.getNetwork().nick);
        },
        knownAccounts: function knownAccounts() {
            var users = this.buffer.getNetwork().users;
            var extban = this.extban;
            var inviteAccountNames = this.inviteListAccounts.map(function (i) {
                var mask = i.invited;
                return mask.replace(extban + ':', '');
            });

            var accountUsers = [];
            (0, _values2.default)(users).forEach(function (user) {
                if (user.account && inviteAccountNames.indexOf(user.account) === -1) {
                    accountUsers.push(user);
                }
            });

            return _lodash2.default.orderBy(accountUsers, ['account', 'nick']);
        }
    },
    created: function created() {
        this.updateInvitelist();
    },

    methods: {
        displayMask: function displayMask(invite) {
            var display = invite.invited.replace(this.extban + ':', '');
            display = display || this.$t('invite_any_registered');
            return display;
        },
        updateInvitelist: function updateInvitelist() {
            var _this3 = this;

            if (this.buffer.getNetwork().state !== 'connected' || this.is_refreshing) {
                return;
            }
            var channelName = this.buffer.name;
            this.is_refreshing = true;
            this.buffer.getNetwork().ircClient.inviteList(channelName, function (inviteEvent) {
                if (inviteEvent) {
                    _this3.inviteList = inviteEvent.invites;
                } else {
                    _this3.inviteList = [];
                }

                _this3.is_refreshing = false;
            });
        },
        removeInvite: function removeInvite(mask) {
            var channelName = this.buffer.name;
            this.buffer.getNetwork().ircClient.removeInvite(channelName, mask);
            this.inviteList = this.inviteList.filter(function (invite) {
                return invite.invited !== mask;
            });
        },
        addAccountInvite: function addAccountInvite(accountName) {
            if (!accountName) {
                return;
            }

            var network = this.buffer.getNetwork();
            network.ircClient.addInvite(this.buffer.name, this.extban + ':' + accountName);
            this.updateInvitelist();
        },
        addInvite: function addInvite(mask) {
            var network = this.buffer.getNetwork();
            network.ircClient.addInvite(this.buffer.name, mask);
            this.updateInvitelist();
        },
        setInviteOnly: function setInviteOnly() {
            this.buffer.getNetwork().ircClient.mode(this.buffer.name, '+i');
        },
        removeInviteOnly: function removeInviteOnly() {
            this.buffer.getNetwork().ircClient.mode(this.buffer.name, '-i');
        }
    }
};

/***/ }),

/***/ "VfBa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['error']
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["StartupError"]
window._kiwi_exports.components.StartupError = exports.default ? exports.default : exports;


/***/ }),

/***/ "W+RY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _state = __webpack_require__("LnP8");

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['filter', 'buffer', 'items'],
    data: function data() {
        return {
            items_: [{ text: 'anick1', type: 'user' }, { text: 'anick2', type: 'user' }, { text: 'bnick3', type: 'user' }, { text: 'cnick4' }, { text: 'dnick5' }],
            selected_idx: 0
        };
    },
    computed: {
        filteredItems: function filteredItems() {
            var filterVal = (this.filter || '').toLowerCase();

            return (0, _lodash2.default)(this.items).filter(function (item) {
                var s = false;
                if (item.text.toLowerCase().indexOf(filterVal) === 0) {
                    s = true;
                }

                (item.alias || []).forEach(function (alias) {
                    if (alias.toLowerCase().indexOf(filterVal) === 0) {
                        s = true;
                    }
                });

                return s;
            }).sort(function (a, b) {
                return a.text.localeCompare(b.text);
            }).value();
        },
        filteredAndLimitedItems: function filteredAndLimitedItems() {
            var _this = this;

            return this.filteredItems.filter(function (item, itemIdx, items) {
                var numItems = items.length - 1;
                var idxFrom = _this.selected_idx - 3;
                var idxTo = _this.selected_idx + 3;
                var isInRange = false;

                if (idxFrom < 0) {
                    idxTo += -idxFrom;
                    idxFrom = 0;
                } else if (idxTo > numItems) {
                    idxFrom -= idxTo - numItems;
                    idxTo = numItems;
                }

                if (itemIdx >= idxFrom && itemIdx <= idxTo) {
                    isInRange = true;
                }

                item.idx = itemIdx;

                return isInRange;
            });
        },
        selectedItem: function selectedItem() {
            var item = this.filteredItems[this.selected_idx];
            return item || null;
        }
    },
    watch: {
        selected_idx: function watchSelectedIdx() {
            var _this2 = this;

            this.$nextTick(function () {
                var el = _this2.$el.querySelector('.kiwi-autocomplete-item--selected');
                if (!el) {
                    return;
                }

                _this2.$el.scrollTop = el.offsetTop - el.getBoundingClientRect().height * 2;
            });

            this.tempCurrentItem();
        },
        filter: function watchFilter() {
            var numItems = this.filteredAndLimitedItems.length - 1;
            if (this.selected_idx > numItems) {
                this.selected_idx = numItems;
            }
        }
    },
    mounted: function mounted() {
        this.tempCurrentItem();
    },
    methods: {
        handleOnKeyDown: function handleOnKeyDown(event) {
            var handled = false;

            var cancelKeyCodes = [13, 188, 190];

            if (cancelKeyCodes.indexOf(event.keyCode) > -1) {
                if (!this.selectedItem) {
                    this.cancel();
                } else {
                    this.selectCurrentItem();
                    if (event.keyCode === 13) {
                        event.preventDefault();
                    }
                    handled = true;
                }
            } else if (event.keyCode === 38 || event.keyCode === 9 && event.shiftKey) {
                if (this.selected_idx > 0) {
                    this.selected_idx--;
                } else {
                    this.selected_idx = this.filteredItems.length - 1;
                }

                event.preventDefault();
                handled = true;
            } else if (event.keyCode === 40 && !event.altKey || event.keyCode === 9) {
                if (this.selected_idx < this.filteredItems.length - 1) {
                    this.selected_idx++;
                } else {
                    this.selected_idx = 0;
                }

                event.preventDefault();
                handled = true;
            } else if (event.keyCode === 16) {
                handled = true;
            }

            return handled;
        },
        openQuery: function openQuery(nick) {
            var buffer = _state2.default.addBuffer(this.buffer.networkid, nick);
            _state2.default.setActiveBuffer(buffer.networkid, buffer.name);
            this.cancel();
        },
        tempCurrentItem: function tempCurrentItem() {
            var item = this.selectedItem;
            if (!item) {
                return;
            }
            this.$emit('temp', item.value || item.text, item);
        },
        selectCurrentItem: function selectCurrentItem() {
            var item = this.selectedItem;
            var value = '';

            if (item) {
                value = item.value || item.text;
            }

            this.$emit('selected', value, item);
        },
        cancel: function cancel() {
            this.$emit('cancel');
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["AutoComplete"]
window._kiwi_exports.components.AutoComplete = exports.default ? exports.default : exports;


/***/ }),

/***/ "WDQw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StateBrowserNetwork_vue__ = __webpack_require__("Qyqn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StateBrowserNetwork_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StateBrowserNetwork_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StateBrowserNetwork_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StateBrowserNetwork_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52793c54_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StateBrowserNetwork_vue__ = __webpack_require__("VRuw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("4wvX")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StateBrowserNetwork_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52793c54_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StateBrowserNetwork_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52793c54_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StateBrowserNetwork_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Wc5+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"u-input-text"},[(_vm.label)?_c('label',{attrs:{"for":_vm.inputId}},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"u-input-text-inputs",staticStyle:{"display":"flex"}},[(_vm.type==='password')?[((_vm.plainTextEnabled && !_vm.isEdgeBrowser() ? 'text' : 'password')==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"u-input",class:{'u-form-input-plaintext' : !_vm.isEdgeBrowser() && _vm.showPlainText},attrs:{"id":_vm.inputId,"autocomplete":"off","autocorrect":"off","autocapitalize":"off","spellcheck":"false","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.currentValue)?_vm._i(_vm.currentValue,null)>-1:(_vm.currentValue)},on:{"change":function($event){var $$a=_vm.currentValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.currentValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.currentValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.currentValue=$$c}}}}):((_vm.plainTextEnabled && !_vm.isEdgeBrowser() ? 'text' : 'password')==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"u-input",class:{'u-form-input-plaintext' : !_vm.isEdgeBrowser() && _vm.showPlainText},attrs:{"id":_vm.inputId,"autocomplete":"off","autocorrect":"off","autocapitalize":"off","spellcheck":"false","type":"radio"},domProps:{"checked":_vm._q(_vm.currentValue,null)},on:{"change":function($event){_vm.currentValue=null}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"u-input",class:{'u-form-input-plaintext' : !_vm.isEdgeBrowser() && _vm.showPlainText},attrs:{"id":_vm.inputId,"autocomplete":"off","autocorrect":"off","autocapitalize":"off","spellcheck":"false","type":_vm.plainTextEnabled && !_vm.isEdgeBrowser() ? 'text' : 'password'},domProps:{"value":(_vm.currentValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}),_vm._v(" "),(_vm.showPlainText && !_vm.isEdgeBrowser())?_c('i',{staticClass:"u-input-text-plaintext fa fa-eye",class:{'u-input-text-plaintext--active': _vm.plainTextEnabled},attrs:{"aria-hidden":"true"},on:{"click":function($event){_vm.plainTextEnabled = !_vm.plainTextEnabled}}}):_vm._e()]:(_vm.type==='number')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"u-input",attrs:{"id":_vm.inputId,"type":"number"},domProps:{"value":(_vm.currentValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):(_vm.type==='textarea')?_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"u-input",attrs:{"id":_vm.inputId},domProps:{"value":(_vm.currentValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"u-input",attrs:{"id":_vm.inputId,"autocomplete":"off","autocorrect":"off","autocapitalize":"off","spellcheck":"false"},domProps:{"value":(_vm.currentValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}),_vm._v(" "),(_vm.$slots.default)?_c('div',{staticClass:"u-input-text-c"},[_vm._t("default")],2):_vm._e()],2)])}
var staticRenderFns = []


/***/ }),

/***/ "WyJs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-settings-aliases"},[_c('form',{staticClass:"u-form"},[_c('a',{staticClass:"u-link kiwi-settings-aliases-showhelp",on:{"click":function($event){_vm.show_help=!_vm.show_help}}},[_vm._v("\n            "+_vm._s(_vm.$t('what_are_aliases'))+"\n        ")]),_vm._v(" "),(_vm.show_help)?_c('div',{staticClass:"kiwi-settings-aliases-help"},[_c('p',[_vm._v("Aliases let you rename existing IRC commands or even build entirely new ones.")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('h4',[_vm._v("Variables")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('h4',[_vm._v("Helper commands")]),_vm._v(" "),_vm._m(3)]):_vm._e(),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.aliasText),expression:"aliasText"}],staticClass:"kiwi-settings-aliases-input",domProps:{"value":(_vm.aliasText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.aliasText=$event.target.value}}})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n                They must be one per line and in the form of "),_c('em',[_vm._v("/name /what it should do")]),_vm._v(".\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n                There are several variables that may be used to refer to the current environment\n                such as the active channel or active nick.\n                "),_c('ul',[_c('li',[_c('em',[_vm._v("$server")]),_vm._v(" The current network name")]),_vm._v(" "),_c('li',[_c('em',[_vm._v("$channel / $destination")]),_vm._v(" The current channel / buffer name")]),_vm._v(" "),_c('li',[_c('em',[_vm._v("$nick")]),_vm._v(" The current nick")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n                You can also use variables to read input from the typed command. "),_c('br'),_vm._v(" "),_c('ul',[_c('li',[_c('em',[_vm._v("$0")]),_vm._v(" The command name")]),_vm._v(" "),_c('li',[_c('em',[_vm._v("$1")]),_vm._v(" The first argument from the typed input")]),_vm._v(" "),_c('li',[_c('em',[_vm._v("$2")]),_vm._v(" The second argument from the typed input")]),_vm._v(" "),_c('li',[_c('em',[_vm._v("$1+")]),_vm._v(" From the first argument to the last argument")])]),_vm._v(" "),_c('b',[_vm._v("Example 1:")]),_vm._v(" "),_c('em',[_vm._v("/greet /msg $1 Hello, $1!")]),_c('br'),_vm._v("\n                This creates an IRC command /greet that accepts one argument. Typing \"/greet\n                username\" will execute \"/msg username Hello, username!\". "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Example 2:")]),_vm._v(" "),_c('em',[_vm._v("/ban /quote mode $channel +b $1+")]),_c('br'),_vm._v("\n                This creates an IRC command /ban that does a few things. Typing \"/ban nick1\n                nick2\" will execute \"/quote mode #activechannel +b nick1 nick2\". $channel is\n                replaced with the active channel name, $1+ is replaced with all the typed input\n                from the first word to the end.\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('ul',[_c('li',[_c('em',[_vm._v("/echo")]),_c('br'),_vm._v("Sends a message to the active buffer without sending\n                        it to the IRC network. Eg, /echo Something happened\n                    ")]),_vm._v(" "),_c('li',[_c('em',[_vm._v("/lines")]),_c('br'),_vm._v("\n                        Similar to Mirc script, this lets you execute multiples lines of\n                        commands separated by a pipe, \"|\"."),_c('br'),_vm._v("\n                        Example: \"/lines /ban nick1 | /echo Banned user\" would first execute the\n                        /ban command, and then the /echo command. This comes in handy with\n                        creating short aliases such as the common \"/cycle\" command that parts\n                        and re-joins the active channel: \"/cycle /lines /part $channel | /join\n                        $channel\".\n                    ")])])])}]


/***/ }),

/***/ "XFo2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AliasRewriter = function () {
    function AliasRewriter() {
        (0, _classCallCheck3.default)(this, AliasRewriter);

        this.recursiveDepth = 3;

        this.depth = 0;

        this.aliases = {};
    }

    (0, _createClass3.default)(AliasRewriter, [{
        key: 'importFromString',
        value: function importFromString(str) {
            var _this = this;

            this.aliases = {};

            str.split('\n').forEach(function (line) {
                if (line[0] !== '/') {
                    return;
                }

                var spaceSep = line.indexOf(' ');
                if (spaceSep === -1) {
                    return;
                }

                var command = line.substring(0, spaceSep);
                var actions = line.substring(spaceSep + 1).trim();
                if (!actions) {
                    return;
                }

                _this.aliases[command.toLowerCase()] = actions;
            });
        }
    }, {
        key: 'processInput',
        value: function processInput(input, vars) {
            var words = input || [];
            var alias = this.aliases[words[0].toLowerCase()];
            var aliasLen = void 0;
            var currentAliasWord = '';
            var currentAliasWordLen = 0;
            var processedConditionals = false;
            var compiled = [];

            if (!alias) return input;

            alias = alias.split(' ');
            aliasLen = alias.length;

            for (var i = 0; i < aliasLen; i++) {
                currentAliasWord = alias[i];
                currentAliasWordLen = currentAliasWord.length;

                if (!processedConditionals && currentAliasWord[0] === '$' && currentAliasWord[currentAliasWordLen - 1] === '?') {
                    var checkVar = currentAliasWord.substr(1, currentAliasWordLen - 2);
                    if (!vars[checkVar]) {
                        compiled = [];
                        break;
                    } else {
                        continue;
                    }
                } else {
                    processedConditionals = true;
                }

                if (currentAliasWord[0] !== '$') {
                    compiled.push(currentAliasWord);
                    continue;
                }

                if ((currentAliasWord[1] || '').match(/\d/)) {
                    var num = currentAliasWord.match(/\$(\d+)(\+)?(\d+)?/);

                    if (!num || !words[num[1]]) continue;

                    if (num[2] === '+' && num[3]) {
                        compiled = compiled.concat(words.slice(parseInt(num[1], 10), parseInt(num[1], 10) + parseInt(num[3], 10)));
                    } else if (num[2] === '+') {
                        compiled = compiled.concat(words.slice(parseInt(num[1], 10)));
                    } else {
                        compiled.push(words[parseInt(num[1], 10)]);
                    }

                    continue;
                }

                if (typeof vars[currentAliasWord.substr(1)] !== 'undefined') {
                    compiled.push(vars[currentAliasWord.substr(1)]);

                    continue;
                }
            }

            return compiled;
        }
    }, {
        key: 'process',
        value: function process(input, vars) {
            var line = input || '';
            var words = line.split(' ');
            var firstWord = (words[0] || '').toLowerCase();

            this.depth++;
            if (this.depth >= this.recursiveDepth) {
                this.depth--;
                return line;
            }

            if (this.aliases[firstWord]) {
                words = this.processInput(words, vars);
                firstWord = (words[0] || '').toLowerCase();

                if (this.aliases[firstWord]) {
                    words = this.process(words.join(' '), vars).split(' ');
                }
            }

            this.depth--;
            return words.join(' ');
        }
    }]);
    return AliasRewriter;
}();

exports.default = AliasRewriter;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["AliasRewriter"]
window._kiwi_exports.libs.AliasRewriter = exports.default ? exports.default : exports;


/***/ }),

/***/ "XNCV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var defaultLogger = makeLogger();
exports.default = defaultLogger;


function makeLogger(label) {
    var LOG_INFO = false;
    var LOG_ERROR = true;

    function logger() {
        logger.info.apply(logger, arguments);
    }

    logger.info = function logInfo() {
        if (LOG_INFO) {
            var _window$console;

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            if (label) {
                args[0] = '[' + label + '] ' + args[0];
            }
            (_window$console = window.console).log.apply(_window$console, args);
        }
    };

    logger.error = function logError() {
        if (LOG_ERROR) {
            var _window$console2;

            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
            }

            if (label) {
                args[0] = '[' + label + '] ' + args[0];
            }

            (_window$console2 = window.console).error.apply(_window$console2, args);
        }
    };

    logger.assert = function assert(condition) {
        if (condition) {
            return;
        }

        for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
            args[_key3 - 1] = arguments[_key3];
        }

        this.error.apply(this, ['Assertion failed.'].concat(args));
    };

    logger.setLevel = function setLevel(newLevel) {
        if (newLevel === 0) {
            LOG_ERROR = false;
            LOG_INFO = false;
        } else if (newLevel === 1) {
            LOG_ERROR = true;
            LOG_INFO = false;
        } else if (newLevel === 2) {
            LOG_ERROR = true;
            LOG_INFO = true;
        }
    };

    logger.namespace = function namespace(newLabel) {
        var l = newLabel;
        if (label) {
            l = '[' + label + '][' + l + ']';
        }

        return makeLogger(l);
    };

    return logger;
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["Logger"]
window._kiwi_exports.libs.Logger = exports.default ? exports.default : exports;


/***/ }),

/***/ "Xjqi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChannelList_vue__ = __webpack_require__("bkMh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChannelList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChannelList_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChannelList_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChannelList_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dbc04f0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChannelList_vue__ = __webpack_require__("UR+h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("ajF+")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChannelList_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dbc04f0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChannelList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dbc04f0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChannelList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Xv7q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputPrompt_vue__ = __webpack_require__("jvBq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputPrompt_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputPrompt_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputPrompt_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputPrompt_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0930c8af_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputPrompt_vue__ = __webpack_require__("4plz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("OBOX")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputPrompt_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0930c8af_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputPrompt_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0930c8af_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputPrompt_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Y+EK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _eventemitter = __webpack_require__("BzvE");

var _eventemitter2 = _interopRequireDefault(_eventemitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IpcBroadcastChannel = function (_EventEmitter) {
    (0, _inherits3.default)(IpcBroadcastChannel, _EventEmitter);

    function IpcBroadcastChannel() {
        (0, _classCallCheck3.default)(this, IpcBroadcastChannel);

        var _this = (0, _possibleConstructorReturn3.default)(this, (IpcBroadcastChannel.__proto__ || (0, _getPrototypeOf2.default)(IpcBroadcastChannel)).call(this));

        _this.bc = new BroadcastChannel('kiwi-ipc');
        _this.bc.onmessage = _this.onmessage.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(IpcBroadcastChannel, [{
        key: 'send',
        value: function send(msg) {
            if (this.bc) {
                this.bc.postMessage(msg);
            }
        }
    }, {
        key: 'onmessage',
        value: function onmessage(msg) {
            this.emit('message', msg);
        }
    }]);
    return IpcBroadcastChannel;
}(_eventemitter2.default);

var IpcLocalStorage = function (_EventEmitter2) {
    (0, _inherits3.default)(IpcLocalStorage, _EventEmitter2);

    function IpcLocalStorage() {
        (0, _classCallCheck3.default)(this, IpcLocalStorage);

        var _this2 = (0, _possibleConstructorReturn3.default)(this, (IpcLocalStorage.__proto__ || (0, _getPrototypeOf2.default)(IpcLocalStorage)).call(this));

        window.addEventListener('storage', _this2.onmessage.bind(_this2));
        return _this2;
    }

    (0, _createClass3.default)(IpcLocalStorage, [{
        key: 'send',
        value: function send(msg) {
            localStorage.setItem('kiwi-ipc', (0, _stringify2.default)(msg));
            localStorage.removeItem('kiwi-ipc');
        }
    }, {
        key: 'onmessage',
        value: function onmessage(msg) {
            if (msg.key === 'kiwi-ipc' && msg.newValue) {
                try {
                    var parsedMsg = {
                        data: JSON.parse(msg.newValue)
                    };
                    this.emit('message', parsedMsg);
                } catch (e) {
                    this.emit('error');
                }
            }
        }
    }]);
    return IpcLocalStorage;
}(_eventemitter2.default);

exports.default = window.BroadcastChannel ? new IpcBroadcastChannel() : new IpcLocalStorage();
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["IPC"]
window._kiwi_exports.libs.IPC = exports.default ? exports.default : exports;


/***/ }),

/***/ "YT+L":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _GlobalApi = __webpack_require__("Uvbb");

var _GlobalApi2 = _interopRequireDefault(_GlobalApi);

var _MessageList = __webpack_require__("ib2o");

var _MessageList2 = _interopRequireDefault(_MessageList);

var _NetworkSettings = __webpack_require__("N+TA");

var _NetworkSettings2 = _interopRequireDefault(_NetworkSettings);

var _ChannelList = __webpack_require__("Xjqi");

var _ChannelList2 = _interopRequireDefault(_ChannelList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        MessageList: _MessageList2.default,
        NetworkSettings: _NetworkSettings2.default,
        ChannelList: _ChannelList2.default
    },
    props: ['network'],
    data: function data() {
        return {
            pluginUiElements: _GlobalApi2.default.singleton().serverViewPlugins
        };
    },
    computed: {
        hasMessages: function hasMessages() {
            return this.network.serverBuffer().getMessages().length > 0;
        },
        serverBuffer: function serverBuffer() {
            return this.network.serverBuffer();
        },
        restrictedServer: function restrictedServer() {
            return this.$state.setting('restricted');
        },
        networkConnected: function networkConnected() {
            return this.network.state === 'connected';
        }
    },
    watch: {
        networkConnected: function networkConnected() {
            var _this = this;

            this.$nextTick(function () {
                _this.$refs.tabs.a++;
            });
        }
    },
    created: function created() {
        var _this2 = this;

        this.listen(this.$state, 'server.tab.show', function (tabName) {
            _this2.showTab(tabName);
        });
    },

    methods: {
        showTab: function showTab(tabName) {
            this.$refs.tabs.setActiveByName(tabName);
        },
        tabChanged: function tabChanged(tabName) {
            this.serverBuffer.show_input = tabName === 'messages';
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["ServerView"]
window._kiwi_exports.components.ServerView = exports.default ? exports.default : exports;


/***/ }),

/***/ "YX3V":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SoundBleep = undefined;

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SoundBleep = exports.SoundBleep = function () {
    function SoundBleep() {
        (0, _classCallCheck3.default)(this, SoundBleep);

        this.audio = document.createElement('audio');
        var source = document.createElement('source');

        if (this.audio.canPlayType('audio/mpeg;')) {
            source.type = 'audio/mpeg';
            source.src = 'static/highlight.mp3';
        } else {
            source.type = 'audio/ogg';
            source.src = 'static/highlight.ogg';
        }

        this.audio.appendChild(source);
    }

    (0, _createClass3.default)(SoundBleep, [{
        key: 'play',
        value: function play() {
            this.audio.play();
        }
    }]);
    return SoundBleep;
}();

/***/ }),

/***/ "YqxC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IrcInput_vue__ = __webpack_require__("fGO0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IrcInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IrcInput_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IrcInput_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IrcInput_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ff2d6f2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IrcInput_vue__ = __webpack_require__("aw+U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("TEdo")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IrcInput_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ff2d6f2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IrcInput_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ff2d6f2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IrcInput_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ZFC3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZKMu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZfkH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _TextFormatting = __webpack_require__("15gS");

var TextFormatting = _interopRequireWildcard(_TextFormatting);

var _autocompleteCommands = __webpack_require__("MQvW");

var _autocompleteCommands2 = _interopRequireDefault(_autocompleteCommands);

var _state = __webpack_require__("LnP8");

var _state2 = _interopRequireDefault(_state);

var _GlobalApi = __webpack_require__("Uvbb");

var _GlobalApi2 = _interopRequireDefault(_GlobalApi);

var _AutoComplete = __webpack_require__("nObl");

var _AutoComplete2 = _interopRequireDefault(_AutoComplete);

var _TextStyle = __webpack_require__("9YrO");

var _TextStyle2 = _interopRequireDefault(_TextStyle);

var _Emoji = __webpack_require__("LSH7");

var _Emoji2 = _interopRequireDefault(_Emoji);

var _SelfUser = __webpack_require__("cl1K");

var _SelfUser2 = _interopRequireDefault(_SelfUser);

var _AwayStatusIndicator = __webpack_require__("vV7l");

var _AwayStatusIndicator2 = _interopRequireDefault(_AwayStatusIndicator);

var _TypingUsersList = __webpack_require__("haAC");

var _TypingUsersList2 = _interopRequireDefault(_TypingUsersList);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        AutoComplete: _AutoComplete2.default,
        AwayStatusIndicator: _AwayStatusIndicator2.default,
        SelfUser: _SelfUser2.default,
        TypingUsersList: _TypingUsersList2.default
    },
    props: ['container', 'buffer'],
    data: function data() {
        return {
            self: this,
            selfuser_open: false,
            autocomplete_open: false,
            autocomplete_items: [],
            autocomplete_filter: '',

            autocomplete_filtering: true,
            active_tool: null,
            active_tool_props: {},
            pluginUiElements: _GlobalApi2.default.singleton().controlInputPlugins,
            showPlugins: true,
            current_input_value: '',
            has_focus: false
        };
    },

    computed: {
        currentNick: function currentNick() {
            var activeNetwork = _state2.default.getActiveNetwork();
            return activeNetwork ? activeNetwork.nick : '';
        },
        networkState: function networkState() {
            var activeNetwork = _state2.default.getActiveNetwork();
            return activeNetwork ? activeNetwork.state : '';
        },
        shouldShowSendButton: function shouldShowSendButton() {
            return this.$state.ui.is_touch || this.$state.setting('showSendButton');
        },
        shouldShowEmojiPicker: function shouldShowEmojiPicker() {
            return this.$state.setting('showEmojiPicker') && !this.$state.ui.is_touch;
        },
        shouldShowColorPicker: function shouldShowColorPicker() {
            return this.$state.setting('showColorPicker');
        },
        shouldShowInputButtons: function shouldShowInputButtons() {
            if (this.pluginUiElements.length || this.shouldShowEmojiPicker || this.shouldShowColorPicker) {
                return true;
            }
            return false;
        },
        history: function history() {
            if (_state2.default.setting('buffers.shared_input')) {
                return this.$state.ui.input_history;
            }
            return this.buffer.input_history;
        },

        history_pos: {
            get: function get() {
                if (_state2.default.setting('buffers.shared_input')) {
                    return this.$state.ui.input_history_pos;
                }
                return this.buffer.input_history_pos;
            },
            set: function set(newVal) {
                if (_state2.default.setting('buffers.shared_input')) {
                    this.$state.ui.input_history_pos = newVal;
                } else {
                    this.buffer.input_history_pos = newVal;
                }
            }
        }
    },
    watch: {
        history_pos: function history_pos(newVal) {
            var val = this.history[this.history_pos];
            this.$refs.input.setValue(val || '');
        },
        buffer: function buffer() {
            if (!_state2.default.setting('buffers.shared_input')) {
                this.inputRestore();
            }

            this.autocomplete_open = false;
        }
    },
    created: function created() {
        var _this = this;

        this.typingTimer = null;
        this.lastTypingTime = 0;

        this.listen(_state2.default, 'document.keydown', function (ev) {
            if (!_this.$refs.input) {
                return;
            }

            if (ev.ctrlKey || ev.altKey || ev.metaKey) {
                return;
            }

            if (ev.keyCode === 16) {
                return;
            }

            if (ev.keyCode === 17) {
                return;
            }

            var arrowKeyCodes = [37, 38, 39, 40];
            if (ev.shiftKey && arrowKeyCodes.indexOf(ev.keyCode) !== -1) {
                return;
            }

            var elements = ['input', 'select', 'textarea', 'button', 'datalist', 'keygen'];
            var doNotRefocus = elements.indexOf(ev.target.tagName.toLowerCase()) > -1 || ev.target.getAttribute('contenteditable');

            if (doNotRefocus) {
                return;
            }

            _this.$refs.input.focus();
        });

        this.listen(this.$state, 'input.insertnick', function (nick) {
            if (!_this.$refs.input) {
                return;
            }

            var val = nick;
            if (_this.current_input_value === '') {
                val += ': ';
            } else {
                val += ' ';
            }

            _this.$refs.input.insertText(val);
        });

        this.listen(this.$state, 'input.tool', function (toolComponent) {
            _this.toggleInputTool(toolComponent);
        });
    },
    mounted: function mounted() {
        this.inputRestore();
    },

    methods: {
        inputUpdate: function inputUpdate(val) {
            this.current_input_value = val;

            if (_state2.default.setting('buffers.shared_input')) {
                _state2.default.ui.current_input = val;
            } else {
                this.buffer.current_input = val;
            }

            this.maybeHidePlugins();
        },
        inputRestore: function inputRestore() {
            var currentInput = _state2.default.setting('buffers.shared_input') ? _state2.default.ui.current_input : this.buffer.current_input;

            this.$refs.input.reset(currentInput);
            this.$refs.input.selectionToEnd();
        },
        toggleSelfUser: function toggleSelfUser() {
            if (this.networkState === 'connected') {
                this.selfuser_open = !this.selfuser_open;
            }
        },
        maybeHidePlugins: function maybeHidePlugins() {
            if (this.$state.ui.app_width < 500) {
                this.showPlugins = false;
            }
        },
        onToolClickTextStyle: function onToolClickTextStyle() {
            this.toggleInputTool(_TextStyle2.default);
        },
        onToolClickEmoji: function onToolClickEmoji() {
            this.toggleInputTool(_Emoji2.default);
        },
        closeInputTool: function closeInputTool() {
            this.active_tool = null;
        },
        toggleInputTool: function toggleInputTool(tool) {
            if (!tool || this.active_tool === tool) {
                this.active_tool = null;
            } else {
                this.active_tool_props = {
                    buffer: this.buffer,
                    ircinput: this.$refs.input
                };
                this.active_tool = tool;
            }
        },
        toggleBold: function toggleBold() {
            this.$refs.input.toggleBold();
        },
        toggleItalic: function toggleItalic() {
            this.$refs.input.toggleItalic();
        },
        toggleUnderline: function toggleUnderline() {
            this.$refs.input.toggleUnderline();
        },
        onAutocompleteCancel: function onAutocompleteCancel() {
            this.autocomplete_open = false;
        },
        onAutocompleteTemp: function onAutocompleteTemp(selectedValue, selectedItem) {
            if (!this.autocomplete_filtering) {
                this.$refs.input.setCurrentWord(selectedValue);
            }
        },
        onAutocompleteSelected: function onAutocompleteSelected(selectedValue, selectedItem) {
            var word = selectedValue;
            this.$refs.input.setCurrentWord(word);
            this.autocomplete_open = false;
        },
        inputKeyDown: function inputKeyDown(event) {
            var _this2 = this;

            var meta = false;

            if (navigator.appVersion.indexOf('Mac') !== -1) {
                meta = event.metaKey;
            } else {
                meta = event.ctrlKey;
            }

            if (this.autocomplete_open && this.$refs.autocomplete.handleOnKeyDown(event)) {
                return;
            }

            if (this.autocomplete_open && !this.autocomplete_filtering) {
                this.$refs.autocomplete.selectCurrentItem();
            }

            if (event.keyCode === 13) {
                event.preventDefault();
                this.submitForm();
            } else if (event.keyCode === 32) {
                if (_state2.default.setting('buffers.show_emoticons')) {
                    var currentWord = this.$refs.input.getCurrentWord();
                    var emojiList = _state2.default.setting('emojis');
                    if (emojiList.hasOwnProperty(currentWord.word)) {
                        var emoji = emojiList[currentWord.word];
                        var url = _state2.default.setting('emojiLocation') + emoji + '.png';
                        this.$refs.input.setCurrentWord('');
                        this.$refs.input.addImg(currentWord.word + ' ', url);
                    }
                }
            } else if (event.keyCode === 38) {
                event.preventDefault();
                this.historyBack();
                this.$nextTick(function () {
                    _this2.$refs.input.selectionToEnd();
                });
            } else if (event.keyCode === 40) {
                event.preventDefault();
                this.historyForward();
                this.$nextTick(function () {
                    _this2.$refs.input.selectionToEnd();
                });
            } else if (event.keyCode === 9 && !event.shiftKey && !event.altKey && !event.metaKey && !event.ctrlKey) {
                var _currentWord = this.$refs.input.getCurrentWord();
                var currentToken = _currentWord.word.substr(0, _currentWord.position);

                var items = this.buildAutoCompleteItems({
                    users: true,
                    buffers: true
                });
                this.openAutoComplete(items);
                this.autocomplete_filter = currentToken;

                this.autocomplete_filtering = false;
                event.preventDefault();
            } else if (meta && event.keyCode === 75) {
                this.toggleInputTool(_TextStyle2.default);
                event.preventDefault();
            } else if (meta && event.keyCode === 66) {
                this.toggleBold();
                event.preventDefault();
            } else if (meta && event.keyCode === 73) {
                this.toggleItalic();
                event.preventDefault();
            } else if (meta && event.keyCode === 85) {
                this.toggleUnderline();
                event.preventDefault();
            }
        },
        inputKeyUp: function inputKeyUp(event) {
            var inputVal = this.$refs.input.getRawText();
            var currentWord = this.$refs.input.getCurrentWord();
            var currentToken = currentWord.word.substr(0, currentWord.position);

            if (event.keyCode === 27 && this.autocomplete_open) {
                this.autocomplete_open = false;
            } else if (this.autocomplete_open && currentToken === '') {
                this.autocomplete_open = false;
            } else if (this.autocomplete_open) {
                if (currentToken[0] === '@') {
                    currentToken = currentToken.substr(1);
                }
            } else if (currentToken === '@') {
                this.openAutoComplete(this.buildAutoCompleteItems({ users: true }));
                this.autocomplete_filtering = true;
            } else if (inputVal === '/') {
                this.openAutoComplete(this.buildAutoCompleteItems({ commands: true }));
                this.autocomplete_filtering = true;
            } else if (currentToken === '#') {
                this.openAutoComplete(this.buildAutoCompleteItems({ buffers: true }));
                this.autocomplete_filtering = true;
            } else if (event.keyCode === 9 && !event.shiftKey && !event.altKey && !event.metaKey && !event.ctrlKey) {
                event.preventDefault();
            } else if (!event.key.match(/^(Shift|Control|Alt|Enter)/)) {
                if (inputVal.trim()) {
                    this.startTyping();
                } else {
                    this.stopTyping(true);
                }
            }

            if (this.autocomplete_open && this.autocomplete_filtering) {
                this.autocomplete_filter = currentToken;
            }
        },
        submitForm: function submitForm() {
            var rawInput = this.$refs.input.getValue();
            if (!rawInput) {
                return;
            }

            var ircText = this.$refs.input.buildIrcText();
            _state2.default.$emit('input.raw', ircText);

            this.history.push(rawInput);
            this.history.splice(0, this.history.length - 50);
            this.history_pos = this.history.length;

            this.$refs.input.reset();

            this.stopTyping(false);
        },
        historyBack: function historyBack() {
            if (this.history_pos > 0) {
                this.history_pos--;
            }
        },
        historyForward: function historyForward() {
            if (this.history_pos < this.history.length) {
                this.history_pos++;
            }
        },
        openAutoComplete: function openAutoComplete(items) {
            if (_state2.default.setting('showAutocomplete')) {
                this.autocomplete_items = items;
                this.autocomplete_open = true;
            }
        },
        buildAutoCompleteItems: function buildAutoCompleteItems(_opts) {
            var opts = _opts || {};
            var list = [];

            if (opts.users) {
                var userList = _lodash2.default.values(this.buffer.users).map(function (user) {
                    var item = {
                        text: user.nick,
                        type: 'user'
                    };
                    return item;
                });

                if (this.buffer.isQuery()) {
                    userList.push({
                        text: this.buffer.name,
                        type: 'user'
                    });
                }

                list = list.concat(userList);
            }

            if (opts.buffers) {
                var bufferList = [];
                this.buffer.getNetwork().buffers.forEach(function (buffer) {
                    if (buffer.isChannel()) {
                        bufferList.push({
                            text: buffer.name,
                            type: 'buffer'
                        });
                    }
                });

                list = list.concat(bufferList);
            }

            if (opts.commands) {
                var commandList = [];
                _autocompleteCommands2.default.forEach(function (command) {
                    var desc = command.description.indexOf('locale_id_') === 0 ? TextFormatting.t(command.description.substr(10)) : command.description;
                    commandList.push({
                        text: '/' + command.command,
                        description: desc,
                        type: 'command',

                        alias: (command.alias || []).map(function (c) {
                            return '/' + c;
                        })
                    });
                });

                list = list.concat(commandList);
            }

            return list;
        },
        startTyping: function startTyping() {
            if (!this.buffer.getNetwork().ircClient.network.cap.isEnabled('message-tags')) {
                return;
            }
            if (!this.buffer.setting('share_typing')) {
                return;
            }
            var buffer = this.buffer;
            var network = buffer.getNetwork();
            if (!buffer || !buffer.isChannel() && !buffer.isQuery()) {
                return;
            }
            if (this.typingTimer) {
                clearTimeout(this.typingTimer);
                this.typingTimer = null;
            }
            this.typingTimer = setTimeout(this.stopTyping, 3000);

            if (Date.now() < this.lastTypingTime + 3000) {
                return;
            }

            network.ircClient.typing.start(buffer.name);

            this.lastTypingTime = Date.now();
        },
        stopTyping: function stopTyping(sendStopPause) {
            if (!this.buffer.getNetwork().ircClient.network.cap.isEnabled('message-tags')) {
                return;
            }
            if (!this.buffer.setting('share_typing')) {
                return;
            }
            var buffer = this.buffer;
            var network = buffer.getNetwork();

            if (!buffer || !buffer.isChannel() && !buffer.isQuery()) {
                return;
            }

            if (this.typingTimer) {
                clearTimeout(this.typingTimer);
                this.typingTimer = null;
                this.lastTypingTime = 0;
            }

            if (!sendStopPause) {
                return;
            }

            this.$refs.input.getRawText().trim() ? network.ircClient.typing.pause(buffer.name) : network.ircClient.typing.stop(buffer.name);
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["ControlInput"]
window._kiwi_exports.components.ControlInput = exports.default ? exports.default : exports;


/***/ }),

/***/ "ZofN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

function generateComputedMode(mode) {
    return {
        get: function computedModeGet() {
            return this.modeVal(mode);
        },
        set: function computedModeSet(newVal) {
            return this.setMode((newVal ? '+' : '-') + mode);
        }
    };
}

function generateComputedModeWithParam(mode) {
    return {
        get: function computedModeWithParamGet() {
            var val = this.modeVal(mode);
            return val === false ? '' : val;
        },
        set: function computedModeWithParamSet(newVal) {
            if (newVal) {
                this.setMode('+' + mode, newVal);
            } else {
                this.setMode('-' + mode);
            }
        }
    };
}

exports.default = {
    props: ['buffer'],
    data: function data() {
        return {
            showPrevTopics: false
        };
    },
    computed: {
        modeM: generateComputedMode('m'),
        modeI: generateComputedMode('i'),
        modeT: generateComputedMode('t'),
        modeN: generateComputedMode('n'),
        modeK: generateComputedModeWithParam('k'),
        topic: {
            get: function computedTopicGet() {
                return this.buffer.topic;
            },
            set: function computedTopicSet(newVal) {
                var newTopic = newVal.replace('\n', ' ');

                if (!newTopic.trim()) {
                    this.buffer.getNetwork().ircClient.raw('TOPIC ' + this.buffer.name + ' :');
                } else {
                    this.buffer.getNetwork().ircClient.setTopic(this.buffer.name, newTopic);
                }
            }
        }
    },
    methods: {
        updateBanList: function updateBanList() {
            this.buffer.getNetwork().ircClient.raw('MODE', this.buffer.name, '+b');
        },
        setMode: function setMode(mode, param) {
            this.buffer.getNetwork().ircClient.raw('MODE', this.buffer.name, mode, param);
        },
        modeVal: function modeVal(mode) {
            var val = false;

            if (typeof this.buffer.modes[mode] === 'undefined') {
                val = false;
            } else if (!this.buffer.modes[mode]) {
                val = true;
            } else {
                val = this.buffer.modes[mode];
            }

            return val;
        },
        areWeAnOp: function areWeAnOp() {
            return this.buffer.isUserAnOp(this.buffer.getNetwork().nick);
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["ChannelInfo"]
window._kiwi_exports.components.ChannelInfo = exports.default ? exports.default : exports;


/***/ }),

/***/ "aJg0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-sidebar kiwi-theme-bg",class:['kiwi-sidebar-section-' + _vm.section]},[(!_vm.sidebarState.isOpen)?_c('span',{staticClass:"kiwi-sidebar-options"},[_c('div',{staticClass:"kiwi-sidebar-close",on:{"click":function($event){return _vm.sidebarState.close()}}},[_vm._v("\n            "+_vm._s(_vm.$t('close'))),_c('i',{staticClass:"fa fa-times",attrs:{"aria-hidden":"true"}})])]):_vm._e(),_vm._v(" "),(_vm.sidebarState.activeComponent)?[_c(_vm.sidebarState.activeComponent,{tag:"component",attrs:{"network":_vm.network,"buffer":_vm.buffer,"sidebar-state":_vm.sidebarState}})]:(_vm.buffer)?[(_vm.buffer.isChannel())?[(_vm.section === 'settings')?_c('div',{staticClass:"kiwi-sidebar-buffersettings",on:{"click":function($event){$event.stopPropagation();}}},[_c('tabbed-view',[_c('tabbed-tab',{attrs:{"header":_vm.$t('settings'),"focus":true}},[_c('h3',[_vm._v(_vm._s(_vm.$t('channel_settings')))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('channel-info',{attrs:{"buffer":_vm.buffer}}),_vm._v(" "),_c('div',{staticClass:"kiwi-sidebar-settings"},[_c('h3',[_vm._v(_vm._s(_vm.$t('side_settings')))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('form',{staticClass:"u-form"},[_c('label',{staticClass:"u-checkbox-wrapper"},[_c('span',[_vm._v(_vm._s(_vm.$t('side_joins')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settingShowJoinParts),expression:"settingShowJoinParts"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.settingShowJoinParts)?_vm._i(_vm.settingShowJoinParts,null)>-1:(_vm.settingShowJoinParts)},on:{"change":function($event){var $$a=_vm.settingShowJoinParts,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.settingShowJoinParts=$$a.concat([$$v]))}else{$$i>-1&&(_vm.settingShowJoinParts=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.settingShowJoinParts=$$c}}}})]),_vm._v(" "),_c('label',{staticClass:"u-checkbox-wrapper"},[_c('span',[_vm._v(_vm._s(_vm.$t('side_topics')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settingShowTopics),expression:"settingShowTopics"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.settingShowTopics)?_vm._i(_vm.settingShowTopics,null)>-1:(_vm.settingShowTopics)},on:{"change":function($event){var $$a=_vm.settingShowTopics,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.settingShowTopics=$$a.concat([$$v]))}else{$$i>-1&&(_vm.settingShowTopics=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.settingShowTopics=$$c}}}})]),_vm._v(" "),_c('label',{staticClass:"u-checkbox-wrapper"},[_c('span',[_vm._v(_vm._s(_vm.$t('side_nick_changes')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settingShowNickChanges),expression:"settingShowNickChanges"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.settingShowNickChanges)?_vm._i(_vm.settingShowNickChanges,null)>-1:(_vm.settingShowNickChanges)},on:{"change":function($event){var $$a=_vm.settingShowNickChanges,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.settingShowNickChanges=$$a.concat([$$v]))}else{$$i>-1&&(_vm.settingShowNickChanges=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.settingShowNickChanges=$$c}}}})]),_vm._v(" "),_c('label',{staticClass:"u-checkbox-wrapper"},[_c('span',[_vm._v(_vm._s(_vm.$t('side_mode_changes')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settingShowModeChanges),expression:"settingShowModeChanges"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.settingShowModeChanges)?_vm._i(_vm.settingShowModeChanges,null)>-1:(_vm.settingShowModeChanges)},on:{"change":function($event){var $$a=_vm.settingShowModeChanges,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.settingShowModeChanges=$$a.concat([$$v]))}else{$$i>-1&&(_vm.settingShowModeChanges=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.settingShowModeChanges=$$c}}}})]),_vm._v(" "),_c('label',{staticClass:"u-checkbox-wrapper"},[_c('span',[_vm._v(_vm._s(_vm.$t('side_formatting')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settingExtraFormatting),expression:"settingExtraFormatting"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.settingExtraFormatting)?_vm._i(_vm.settingExtraFormatting,null)>-1:(_vm.settingExtraFormatting)},on:{"change":function($event){var $$a=_vm.settingExtraFormatting,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.settingExtraFormatting=$$a.concat([$$v]))}else{$$i>-1&&(_vm.settingExtraFormatting=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.settingExtraFormatting=$$c}}}})]),_vm._v(" "),_c('label',{staticClass:"u-checkbox-wrapper"},[_c('span',[_vm._v(_vm._s(_vm.$t('side_colours')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settingColouredNicklist),expression:"settingColouredNicklist"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.settingColouredNicklist)?_vm._i(_vm.settingColouredNicklist,null)>-1:(_vm.settingColouredNicklist)},on:{"change":function($event){var $$a=_vm.settingColouredNicklist,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.settingColouredNicklist=$$a.concat([$$v]))}else{$$i>-1&&(_vm.settingColouredNicklist=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.settingColouredNicklist=$$c}}}})]),_vm._v(" "),_c('label',{staticClass:"u-checkbox-wrapper"},[_c('span',[_vm._v(_vm._s(_vm.$t('settings_share_typing')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settingShareTyping),expression:"settingShareTyping"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.settingShareTyping)?_vm._i(_vm.settingShareTyping,null)>-1:(_vm.settingShareTyping)},on:{"change":function($event){var $$a=_vm.settingShareTyping,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.settingShareTyping=$$a.concat([$$v]))}else{$$i>-1&&(_vm.settingShareTyping=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.settingShareTyping=$$c}}}})])])])],1),_vm._v(" "),_c('tabbed-tab',{attrs:{"header":_vm.$t('access')}},[_c('a',{staticClass:"u-link kiwi-sidebar-accesstab",class:{
                                'kiwi-sidebar-accesstab--active': _vm.accessTab === 'banlist'
                            },on:{"click":function($event){_vm.accessTab='banlist'}}},[_vm._v("\n                            "+_vm._s(_vm.$t('banned'))+"\n                        ")]),_vm._v(" "),_c('a',{staticClass:"u-link kiwi-sidebar-accesstab",class:{
                                'kiwi-sidebar-accesstab--active': _vm.accessTab === 'invitelist'
                            },on:{"click":function($event){_vm.accessTab='invitelist'}}},[_vm._v("\n                            "+_vm._s(_vm.$t('invited'))+"\n                        ")]),_vm._v(" "),(_vm.accessTab==='banlist')?_c('channel-banlist',{attrs:{"buffer":_vm.buffer}}):_vm._e(),_vm._v(" "),(_vm.accessTab==='invitelist')?_c('channel-invitelist',{attrs:{"buffer":_vm.buffer}}):_vm._e()],1),_vm._v(" "),_c('tabbed-tab',{attrs:{"header":_vm.$t('notifications')}},[_c('buffer-settings',{attrs:{"buffer":_vm.buffer}})],1),_vm._v(" "),_vm._l((_vm.pluginUiElements),function(item){return _c('tabbed-tab',{key:item.id,attrs:{"header":item.title}},[_c(item.component,_vm._b({tag:"div"},'div',item.props,false))],1)})],2)],1):(_vm.section === 'user')?_c('div',{staticClass:"kiwi-sidebar-userbox",on:{"click":function($event){$event.stopPropagation();}}},[_c('user-box',{attrs:{"user":_vm.sidebarState.sidebarUser,"buffer":_vm.buffer,"network":_vm.network}})],1):(_vm.section === 'nicklist')?_c('nicklist',{attrs:{"network":_vm.network,"buffer":_vm.buffer,"sidebar-state":_vm.sidebarState}}):(_vm.section === 'about')?_c('sidebar-about-buffer',{attrs:{"network":_vm.network,"buffer":_vm.buffer,"sidebar-state":_vm.sidebarState}}):_vm._e()]:(_vm.buffer.isQuery())?void 0:_vm._e()]:[_vm._v("\n        "+_vm._s(_vm.$t('side_buffer'))+"\n    ")]],2)}
var staticRenderFns = []


/***/ }),

/***/ "ajF+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "amxj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StateBrowser_vue__ = __webpack_require__("Ta7/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StateBrowser_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StateBrowser_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StateBrowser_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StateBrowser_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b7498ba_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StateBrowser_vue__ = __webpack_require__("2aDa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("nFCj")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StateBrowser_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b7498ba_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StateBrowser_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b7498ba_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StateBrowser_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "aw+U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-ircinput"},[_c('div',{ref:"editor",staticClass:"kiwi-ircinput-editor",attrs:{"placeholder":_vm.placeholder,"contenteditable":"true","role":"textbox","spellcheck":"true"},on:{"keypress":function($event){_vm.updateValueProps(); _vm.$emit('keypress', $event)},"keydown":function($event){_vm.updateValueProps(); _vm.$emit('keydown', $event)},"keyup":function($event){_vm.updateValueProps(); _vm.$emit('keyup', $event)},"textInput":function($event){_vm.updateValueProps(); _vm.onTextInput($event); _vm.$emit('textInput', $event)},"mouseup":function($event){return _vm.updateValueProps();},"click":function($event){return _vm.$emit('click', $event)},"paste":_vm.onPaste,"focus":function($event){return _vm.onFocus()},"blur":function($event){return _vm.$emit('blur', $event)}}})])}
var staticRenderFns = []


/***/ }),

/***/ "b30k":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AudioManager = undefined;

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AudioManager = exports.AudioManager = function () {
    function AudioManager(audio) {
        (0, _classCallCheck3.default)(this, AudioManager);

        this.lastPlayed = 0;
        this.audio = audio;
    }

    (0, _createClass3.default)(AudioManager, [{
        key: 'play',
        value: function play() {
            if (!this.lastPlayed || Date.now() - this.lastPlayed > 2000) {
                this.audio.play();
                this.lastPlayed = Date.now();
            }
        }
    }, {
        key: 'listen',
        value: function listen(state) {
            var _this = this;

            state.$on('audio.bleep', function () {
                _this.play();
            });
        }
    }, {
        key: 'watchForMessages',
        value: function watchForMessages(state) {
            var _this2 = this;

            state.$on('message.new', function (message, buffer) {
                if (buffer.setting('mute_sound')) {
                    return;
                }

                var ignoreTypes = ['connection', 'traffic', 'mode', 'nick'];
                if (ignoreTypes.indexOf(message.type) > -1) {
                    return;
                }

                if (message.ignore || buffer.isSpecial()) {
                    return;
                }

                var shouldBleep = buffer.getNetwork().nick !== message.nick && (message.isHighlight && buffer.setting('alert_on') === 'highlight' || buffer.setting('alert_on') === 'message');
                var isActiveBuffer = state.getActiveBuffer() === buffer;
                var inFocus = isActiveBuffer && state.ui.app_has_focus;

                if (shouldBleep || buffer.isQuery() && !inFocus) {
                    _this2.play();
                }
            });
        }
    }]);
    return AudioManager;
}();
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["AudioManager"]
window._kiwi_exports.libs.AudioManager = exports.default ? exports.default : exports;


/***/ }),

/***/ "bd+S":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TextFormatting = __webpack_require__("15gS");

var TextFormatting = _interopRequireWildcard(_TextFormatting);

var _state = __webpack_require__("LnP8");

var _state2 = _interopRequireDefault(_state);

var _AwayStatusIndicator = __webpack_require__("vV7l");

var _AwayStatusIndicator2 = _interopRequireDefault(_AwayStatusIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
    components: {
        AwayStatusIndicator: _AwayStatusIndicator2.default
    },
    props: ['network'],
    data: function data() {
        return {
            is_usermenu_open: false
        };
    },

    computed: {
        userInitial: function userInitial() {
            var initial = 'U';
            if (this.network && this.network.nick) {
                initial = this.network.nick.charAt(0).toUpperCase();
            }
            return initial;
        },
        networkName: function networkName() {
            var name = TextFormatting.t('no_network');
            if (this.network) {
                name = this.network.name;
            }
            return name;
        },
        getUser: function getUser() {
            return this.network ? this.network.currentUser() : null;
        },
        isConnected: function isConnected() {
            return this.network && this.network.state === 'connected';
        }
    },
    methods: {
        clickForget: function clickForget() {
            var msg = 'This will delete all stored networks and start fresh. Are you sure?';

            var confirmed = confirm(msg);
            if (!confirmed) {
                return;
            }

            _state2.default.persistence.forgetState();
            window.location.reload();
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["StateBrowserUsermenu"]
window._kiwi_exports.components.StateBrowserUsermenu = exports.default ? exports.default : exports;


/***/ }),

/***/ "bhYc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('startup-layout',{ref:"layout",staticClass:"kiwi-welcome-znc",scopedSlots:_vm._u([(!_vm.network || _vm.network.state === 'disconnected')?{key:"connection",fn:function(){return [_c('form',{staticClass:"u-form u-form--big kiwi-welcome-znc-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.greetingText)}}),_vm._v(" "),(_vm.network && (_vm.network.last_error || _vm.network.state_error))?_c('div',{staticClass:"kiwi-welcome-znc-error"},[_vm._v("\n                We couldn't connect to the server :(\n                "),_c('span',[_vm._v("\n                    "+_vm._s(_vm.network.last_error || _vm.readableStateError(_vm.network.state_error))+"\n                ")])]):_vm._e(),_vm._v(" "),(_vm.showUser)?_c('input-text',{staticClass:"kiwi-welcome-znc-nick",attrs:{"label":_vm.$t('username')},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}}):_vm._e(),_vm._v(" "),(_vm.showPass)?_c('input-text',{staticClass:"kiwi-welcome-znc-password",attrs:{"label":_vm.$t('password'),"type":"password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}):_vm._e(),_vm._v(" "),(_vm.showNetwork)?_c('input-text',{staticClass:"kiwi-welcome-znc-channel",attrs:{"label":_vm.$t('network')},model:{value:(_vm.znc_network),callback:function ($$v) {_vm.znc_network=$$v},expression:"znc_network"}}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"u-button u-button-primary u-submit kiwi-welcome-znc-start",attrs:{"disabled":!_vm.readyToStart,"type":"submit"},domProps:{"innerHTML":_vm._s(_vm.buttonText)}})],1)]},proxy:true}:(_vm.network.state !== 'connected')?{key:"connection",fn:function(){return [_c('i',{staticClass:"fa fa-spin fa-spinner",staticStyle:{"font-size":"2em","margin-top":"1em"}})]},proxy:true}:null],null,true)})}
var staticRenderFns = []


/***/ }),

/***/ "bhyE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _state = __webpack_require__("LnP8");

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            show_help: false
        };
    },
    computed: {
        aliasText: {
            get: function getAliasText() {
                return _state2.default.setting('aliases').trim();
            },
            set: function setAliasText(newVal) {
                _state2.default.setting('aliases', newVal.trim());
            }
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["SettingsAliases"]
window._kiwi_exports.components.SettingsAliases = exports.default ? exports.default : exports;


/***/ }),

/***/ "bkMh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _Html = __webpack_require__("Nbm2");

var _Html2 = _interopRequireDefault(_Html);

var _MessageParser = __webpack_require__("wXH7");

var _MessageParser2 = _interopRequireDefault(_MessageParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['network'],
    data: function data() {
        return {
            sidebarOpen: false,
            page: 0,
            page_size: 200,
            search: '',
            last_updated: 0
        };
    },
    computed: {
        noResults: function noResults() {
            return this.listState === 'updated' && this.filteredList.length === 0;
        },
        isLoading: function isLoading() {
            return this.listState === 'updating';
        },
        listState: function listState() {
            return this.network.channel_list_state;
        },
        list: function list() {
            return this.network.channel_list || [];
        },
        filteredList: function filteredList() {
            var _this = this;

            var list = [];

            if (this.search.length <= 2) {
                list = this.list;
            } else {
                list = this.list.filter(function (channel) {
                    var found = false;
                    if (channel.channel.toLowerCase().indexOf(_this.search) > -1) {
                        found = true;
                    }
                    if (channel.topic.toLowerCase().indexOf(_this.search) > -1) {
                        found = true;
                    }
                    return found;
                });
            }

            return _lodash2.default.sortBy(list, 'num_users').reverse();
        },
        paginated: function paginated() {
            var offset = this.page * this.page_size;
            var list = this.filteredList;
            var channels = [];
            for (var i = offset; i < offset + this.page_size; i++) {
                if (list[i]) {
                    channels.push(list[i]);
                }
            }

            return channels;
        },
        maxPages: function maxPages() {
            return Math.floor(this.filteredList.length / this.page_size);
        },
        canGoForward: function canGoForward() {
            return this.page * this.page_size >= this.filteredList.length;
        },
        canGoBackward: function canGoBackward() {
            return this.page > 0;
        }
    },
    watch: {
        search: function search() {
            this.page = 0;
        }
    },
    methods: {
        nextPage: function nextPage() {
            if (this.page < this.maxPages) {
                this.page++;
            }
        },
        prevPage: function prevPage() {
            if (this.page > 0) {
                this.page--;
            }
        },
        maybeUpdateList: function maybeUpdateList() {
            if (this.listState !== 'updating') {
                this.network.ircClient.raw('LIST');
            }
        },
        formatAndTrimTopic: function formatAndTrimTopic(rawTopic) {
            var showModes = this.$state.setting('showChanlistModes');

            var topic = showModes ? rawTopic : rawTopic.replace(/^\[([^\]]+)\] ?/, '');
            var blocks = (0, _MessageParser2.default)(topic, { extras: false });
            var content = (0, _Html2.default)(blocks);
            return content;
        },
        joinChannel: function joinChannel(channelName) {
            this.$state.addBuffer(this.network.id, channelName);
            this.network.ircClient.join(channelName);
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["ChannelList"]
window._kiwi_exports.components.ChannelList = exports.default ? exports.default : exports;


/***/ }),

/***/ "bsrY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-messageinfo",on:{"click":function($event){$event.stopPropagation();}}},[(_vm.message.mentioned_urls.length > 0)?_c('div',{staticClass:"kiwi-messageinfo-urls"},_vm._l((_vm.message.mentioned_urls),function(url){return _c('div',{key:url,staticClass:"kiwi-messageinfo-url"},[_c('a',{staticClass:"u-button u-button-secondary",on:{"click":function($event){return _vm.urlPreview(url)}}},[_vm._v("Preview")]),_vm._v(" "),_c('a',{staticClass:"u-link",attrs:{"href":url,"target":"_blank"}},[_vm._v("\n                "+_vm._s(url)+"\n            ")])])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"kiwi-messageinfo-actions",class:{'kiwi-messageinfo-actions--open': _vm.requestingInput}},[(!_vm.requestingInput)?_c('a',{staticClass:"u-link kiwi-messageinfo-reply",on:{"click":_vm.openQuery}},[_vm._v("\n            Reply in private\n        ")]):_vm._e(),_vm._v(" "),(_vm.areWeAnOp() && !_vm.isSelf())?_c('div',{staticClass:"kiwi-messageinfo-opbuttons"},[_c('input-prompt',{attrs:{"label":"Kick reason:"},on:{"submit":_vm.onKick,"cancel":function($event){_vm.requestingInput = false}}},[(!_vm.requestingInput)?_c('a',{staticClass:"u-link kiwi-messageinfo-kick-user",on:{"click":function($event){_vm.requestingInput = true}}},[_vm._v("\n                    Kick "+_vm._s(_vm.message.nick)+"\n                ")]):_vm._e()]),_vm._v(" "),_c('input-prompt',{attrs:{"label":"Ban reason:"},on:{"submit":_vm.onBan,"cancel":function($event){_vm.requestingInput = false}}},[(!_vm.requestingInput)?_c('a',{staticClass:"u-link kiwi-messageinfo-ban-user",on:{"click":function($event){_vm.requestingInput = true}}},[_vm._v("\n                    Ban "+_vm._s(_vm.message.nick)+"\n                ")]):_vm._e()])],1):_vm._e()])])}
var staticRenderFns = []


/***/ }),

/***/ "c0Nt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-inputtool-colours"},[_c('div',{staticClass:"kiwi-inputtool-colours-palette",on:{"mousedown":function($event){$event.preventDefault();},"click":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"kiwi-inputtools-colours-colour irc-bg-colour-white",attrs:{"data-code":"00"},on:{"click":_vm.onColourClick}}),_vm._v(" "),_c('div',{staticClass:"kiwi-inputtools-colours-colour irc-bg-colour-black",attrs:{"data-code":"01"},on:{"click":_vm.onColourClick}}),_vm._v(" "),_c('div',{staticClass:"kiwi-inputtools-colours-colour irc-bg-colour-blue",attrs:{"data-code":"02"},on:{"click":_vm.onColourClick}}),_vm._v(" "),_c('div',{staticClass:"kiwi-inputtools-colours-colour irc-bg-colour-green",attrs:{"data-code":"03"},on:{"click":_vm.onColourClick}}),_vm._v(" "),_c('div',{staticClass:"kiwi-inputtools-colours-colour irc-bg-colour-light-red",attrs:{"data-code":"04"},on:{"click":_vm.onColourClick}}),_vm._v(" "),_c('div',{staticClass:"kiwi-inputtools-colours-colour irc-bg-colour-brown",attrs:{"data-code":"05"},on:{"click":_vm.onColourClick}}),_vm._v(" "),_c('div',{staticClass:"kiwi-inputtools-colours-colour irc-bg-colour-purple",attrs:{"data-code":"06"},on:{"click":_vm.onColourClick}}),_vm._v(" "),_c('div',{staticClass:"kiwi-inputtools-colours-colour irc-bg-colour-orange",attrs:{"data-code":"07"},on:{"click":_vm.onColourClick}}),_vm._v(" "),_c('div',{staticClass:"kiwi-inputtools-colours-colour irc-bg-colour-yellow",attrs:{"data-code":"08"},on:{"click":_vm.onColourClick}}),_vm._v(" "),_c('div',{staticClass:"kiwi-inputtools-colours-colour irc-bg-colour-light-green",attrs:{"data-code":"09"},on:{"click":_vm.onColourClick}}),_vm._v(" "),_c('div',{staticClass:"kiwi-inputtools-colours-colour irc-bg-colour-cyan",attrs:{"data-code":"10"},on:{"click":_vm.onColourClick}}),_vm._v(" "),_c('div',{staticClass:"kiwi-inputtools-colours-colour irc-bg-colour-light-cyan",attrs:{"data-code":"11"},on:{"click":_vm.onColourClick}}),_vm._v(" "),_c('div',{staticClass:"kiwi-inputtools-colours-colour irc-bg-colour-light-blue",attrs:{"data-code":"12"},on:{"click":_vm.onColourClick}}),_vm._v(" "),_c('div',{staticClass:"kiwi-inputtools-colours-colour irc-bg-colour-pink",attrs:{"data-code":"13"},on:{"click":_vm.onColourClick}}),_vm._v(" "),_c('div',{staticClass:"kiwi-inputtools-colours-colour irc-bg-colour-grey",attrs:{"data-code":"14"},on:{"click":_vm.onColourClick}}),_vm._v(" "),_c('div',{staticClass:"kiwi-inputtools-colours-colour irc-bg-colour-light-grey",attrs:{"data-code":"15"},on:{"click":_vm.onColourClick}}),_vm._v(" "),_c('div',{staticClass:"kiwi-inputtools-colours-colour kiwi-inputtools-colours-reset",on:{"click":_vm.onResetClick}},[_c('i',{staticClass:"fa fa-ban",attrs:{"aria-hidden":"true"}})])])])}
var staticRenderFns = []


/***/ }),

/***/ "c8bq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _create = __webpack_require__("OvRC");

var _create2 = _interopRequireDefault(_create);

exports.default = parse;
exports.createNewBlock = createNewBlock;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tokens = (0, _create2.default)(null);

tokens['_'] = {
    token: '_',
    extra: true,
    fn: function parseToken(inp, pos, block, prevBlock, openToks) {
        if (openToks[this.token]) {
            delete block.styles.underline;
            openToks[this.token] = null;
            prevBlock.content += this.token;
            return null;
        }

        if (block.styles.underline === true) {
            return -1;
        }

        if (pos > 0 && inp[pos - 1] !== ' ') {
            return -1;
        }

        if (inp.substr(pos + 1).indexOf(this.token) === -1) {
            return -1;
        }

        openToks[this.token] = true;
        block.styles.underline = true;
        block.content += this.token;

        return null;
    }
};
tokens['*'] = {
    token: '*',
    extra: true,
    fn: function parseToken(inp, pos, block, prevBlock, openToks) {
        if (openToks[this.token]) {
            delete block.styles.bold;
            openToks[this.token] = null;
            prevBlock.content += this.token;
            return null;
        }

        if (block.styles.bold === true) {
            return -1;
        }

        if (inp[pos - 1] === ':') {
            return -1;
        }

        if (pos > 0 && inp[pos - 1] !== ' ') {
            return -1;
        }

        var remainingText = inp.substr(pos + 1);
        var nextPos = remainingText.indexOf(this.token);
        if (nextPos === -1 || nextPos < remainingText.length - 1 && remainingText[nextPos + 1] !== ' ') {
            return -1;
        }

        openToks[this.token] = true;
        block.styles.bold = true;
        block.content += this.token;

        return null;
    }
};
tokens['**'] = {
    token: '**',
    extra: true,
    fn: function parseToken(inp, pos, block, prevBlock, openToks) {
        if (openToks[this.token]) {
            delete block.styles.italic;
            openToks[this.token] = null;
            prevBlock.content += this.token;
            return null;
        }

        if (block.styles.italic === true) {
            return -1;
        }

        if (inp.substr(pos + 1).indexOf(this.token) === -1) {
            return -1;
        }

        openToks[this.token] = true;
        block.styles.italic = true;
        block.content += this.token;

        return null;
    }
};
tokens['`'] = {
    token: '`',
    extra: true,
    fn: function parseToken(inp, pos, block, prevBlock, openToks) {
        if (openToks[this.token]) {
            delete block.styles.quote;
            openToks[this.token] = null;
            prevBlock.content += this.token;
            return null;
        }

        var str = inp.substr(pos + 1);
        var endPos = str.indexOf(this.token);
        if (endPos === -1) {
            return -1;
        }

        openToks[this.token] = true;
        block.styles.quote = true;
        block.content += this.token + str.substr(0, endPos);
        block.containsContent = true;

        return pos + endPos + 1;
    }
};

tokens['\x02'] = {
    token: '\x02',
    extra: false,
    fn: function parseToken(inp, pos, block, prevBlock, openToks) {
        if (openToks[this.token]) {
            delete block.styles.bold;
            openToks[this.token] = null;
        } else {
            openToks[this.token] = true;
            block.styles.bold = true;
        }

        return null;
    }
};

tokens['\x1D'] = {
    token: '\x1D',
    extra: false,
    fn: function parseToken(inp, pos, block, prevBlock, openToks) {
        if (openToks[this.token]) {
            delete block.styles.italic;
            openToks[this.token] = null;
        } else {
            openToks[this.token] = true;
            block.styles.italic = true;
        }

        return null;
    }
};

tokens['\x1F'] = {
    token: '\x1F',
    extra: false,
    fn: function parseToken(inp, pos, block, prevBlock, openToks) {
        if (openToks[this.token]) {
            delete block.styles.underline;
            openToks[this.token] = null;
        } else {
            openToks[this.token] = true;
            block.styles.underline = true;
        }

        return null;
    }
};

tokens['\x0F'] = {
    token: '\x0F',
    extra: false,
    fn: function parseToken(inp, pos, block, prevBlock, openToks) {
        (0, _keys2.default)(block.styles).forEach(function (k) {
            return delete block.styles[k];
        });
        (0, _keys2.default)(openToks).forEach(function (k) {
            return delete openToks[k];
        });

        return null;
    }
};

tokens['\x03'] = {
    token: '\x03',
    extra: false,
    fn: function parseToken(inp, pos, block, prevBlock, openToks) {
        var colours = {
            0: 'white',
            1: 'black',
            2: 'blue',
            3: 'green',
            4: 'light-red',
            5: 'brown',
            6: 'purple',
            7: 'orange',
            8: 'yellow',
            9: 'light-green',
            10: 'cyan',
            11: 'light-cyan',
            12: 'light-blue',
            13: 'pink',
            14: 'grey',
            15: 'light-grey'
        };

        var colourMatchRegexp = /^\x03(([0-9][0-9]?)(,([0-9][0-9]?))?)/;
        var match = colourMatchRegexp.exec(inp.substr(pos, 6));
        if (match) {
            var fgColour = colours[parseInt(match[2], 10)];
            var bgColour = colours[parseInt(match[4], 10)];
            if (typeof fgColour !== 'undefined') {
                block.styles.color = fgColour;
            }
            if (typeof bgColour !== 'undefined') {
                block.styles.background = bgColour;
            }

            return pos + match[0].length;
        }

        delete block.styles.color;
        delete block.styles.background;

        return null;
    }
};

function parse(inp, _opts) {
    var opts = _opts || {};
    var block = createNewBlock();
    var blocks = [block];
    var openTokens = (0, _create2.default)(null);

    var pos = 0;
    var len = inp.length;

    while (pos < len) {
        var tok = findTokenAtPosition();
        if (!tok || !opts.extras && tok.extra) {
            block.content += inp[pos];
            block.containsContent = true;
            pos++;
            continue;
        }

        var newBlock = null;

        if (block.containsContent) {
            newBlock = createNewBlock();
        } else {
            newBlock = block;
        }

        (0, _assign2.default)(newBlock.styles, block.styles);
        var newPos = tok.fn(inp, pos, newBlock, block, openTokens);

        if (newPos === -1) {
            block.content += tok.token;
            block.containsContent = true;
            pos += tok.token.length;
            continue;
        }

        block = newBlock;

        if (blocks[blocks.length - 1] !== newBlock) {
            blocks.push(newBlock);
        }

        if (typeof newPos === 'number') {
            pos = newPos;
        } else {
            pos += tok.token.length;
        }
    }

    return blocks;

    function findTokenAtPosition() {
        var tok = tokens[inp.substr(pos, 2)] || tokens[inp[pos]];
        return tok;
    }
}

function createNewBlock() {
    var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'text';
    var meta = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    var newBlock = {
        styles: styles,
        content: content,
        containsContent: !!content,
        type: type,
        meta: meta
    };
    return newBlock;
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["MessageFormatter"]
window._kiwi_exports.libs.MessageFormatter = exports.default ? exports.default : exports;


/***/ }),

/***/ "c9hT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServerSelector_vue__ = __webpack_require__("kZ1f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServerSelector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServerSelector_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServerSelector_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServerSelector_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6af85c8f_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServerSelector_vue__ = __webpack_require__("NGf2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("jbL2")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServerSelector_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6af85c8f_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServerSelector_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6af85c8f_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServerSelector_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "cC0S":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TextFormatting = __webpack_require__("15gS");

var TextFormatting = _interopRequireWildcard(_TextFormatting);

var _AwayStatusIndicator = __webpack_require__("vV7l");

var _AwayStatusIndicator2 = _interopRequireDefault(_AwayStatusIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
    components: {
        AwayStatusIndicator: _AwayStatusIndicator2.default
    },
    props: {
        network: Object
    },
    data: function data() {
        return {
            new_nick: '',
            error_message: '',
            self_user_settings_open: false
        };
    },
    computed: {
        modeString: function modeString() {
            var str = '';
            this.network.ircClient.user.modes.forEach(function (mode) {
                str += mode;
            });

            if (str) {
                str = '+' + str;
            }

            return str;
        },
        netUser: function netUser() {
            return this.network.ircClient.user;
        },

        awayStatus: {
            get: function get() {
                return this.network.currentUser().away;
            },
            set: function set(val) {
                this.network.ircClient.raw('AWAY', val ? 'Currently away' : '');
            }
        }
    },
    created: function created() {
        var _this = this;

        this.listen(this.network.ircClient, 'nick in use', function (event) {
            _this.error_message = TextFormatting.t('error_nick_in_use', { nick: event.nick });
        });
    },

    methods: {
        openSelfActions: function openSelfActions() {
            this.self_user_settings_open = true;
        },
        closeSelfUser: function closeSelfUser() {
            this.$emit('close');
        },
        onNewNickSubmit: function onNewNickSubmit(newVal) {
            this.new_nick = newVal;
            this.changeNick();
        },
        changeNick: function changeNick() {
            var nick = this.new_nick.trim();
            if (nick.length === 0) {
                this.error_message = TextFormatting.t('error_empty_nick');
                return;
            }
            if (nick.match(/(^[0-9])|(\s)/)) {
                this.error_message = TextFormatting.t('error_no_number');
                return;
            }
            this.error_message = '';
            this.network.ircClient.changeNick(nick);
            this.userNameCancel();
        },
        userNameCancel: function userNameCancel() {
            this.self_user_settings_open = false;
        },
        networkSupportsAway: function networkSupportsAway() {
            return this.network.ircClient.network.cap.isEnabled('away-notify');
        },
        checkUserAway: function checkUserAway() {
            return !!this.network.currentUser().away;
        },
        getUserFromString: function getUserFromString(name) {
            return this.$state.getUser(this.network.id, name);
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["SelfUser"]
window._kiwi_exports.components.SelfUser = exports.default ? exports.default : exports;


/***/ }),

/***/ "cEaC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),

/***/ "cG7z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-channelbanlist"},[_c('form',{staticClass:"u-form kiwi-channelbanlist",on:{"submit":function($event){$event.preventDefault();}}},[_c('a',{staticClass:"u-link",on:{"click":_vm.updateBanlist}},[_vm._v(_vm._s(_vm.$t('bans_refresh')))]),_vm._v(" "),(_vm.banlist.length > 0)?_c('table',{staticClass:"kiwi-channelbanlist-table"},[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('bans_user')))]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th')]),_vm._v(" "),_vm._l((_vm.banlist),function(ban){return _c('tr',{key:ban.banned,attrs:{"title":'By ' + ban.banned_by}},[_c('td',{staticClass:"kiwi-channelbanlist-table-mask"},[_vm._v(_vm._s(ban.banned))]),_vm._v(" "),_c('td',{staticClass:"kiwi-channelbanlist-table-bannedat"},[_vm._v("\n                    "+_vm._s((new Date(ban.banned_at * 1000)).toDateString())+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"kiwi-channelbanlist-table-actions"},[_c('i',{staticClass:"fa fa-trash",attrs:{"aria-hidden":"true"},on:{"click":function($event){return _vm.removeBan(ban.banned)}}})])])})],2):(_vm.is_refreshing)?_c('div',[_vm._v("\n            "+_vm._s(_vm.$t('bans_refreshing'))+"\n        ")]):_c('div',{staticClass:"kiwi-channelbanlist-empty"},[_vm._v("\n            "+_vm._s(_vm.$t('bans_nobody'))+"\n        ")])])])}
var staticRenderFns = []


/***/ }),

/***/ "cX0g":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _state = __webpack_require__("LnP8");

var _state2 = _interopRequireDefault(_state);

var _ContainerHeader = __webpack_require__("/YbC");

var _ContainerHeader2 = _interopRequireDefault(_ContainerHeader);

var _Sidebar = __webpack_require__("lZ5c");

var _Sidebar2 = _interopRequireDefault(_Sidebar);

var _NotConnected = __webpack_require__("/1JH");

var _NotConnected2 = _interopRequireDefault(_NotConnected);

var _MessageList = __webpack_require__("ib2o");

var _MessageList2 = _interopRequireDefault(_MessageList);

var _ServerView = __webpack_require__("+QZa");

var _ServerView2 = _interopRequireDefault(_ServerView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        ContainerHeader: _ContainerHeader2.default,
        Sidebar: _Sidebar2.default,
        NotConnected: _NotConnected2.default,
        MessageList: _MessageList2.default,
        ServerView: _ServerView2.default
    },
    props: ['network', 'buffer', 'sidebarState'],
    data: function data() {
        return {};
    },
    computed: {
        bufferType: function bufferType() {
            var type = '';

            if (!this.buffer) {
                type = 'none';
            } else if (this.buffer.isServer()) {
                type = 'server';
            } else if (this.buffer.isChannel()) {
                type = 'channel';
            } else if (this.buffer.isQuery()) {
                type = 'query';
            }
            return type;
        },
        unreadMessages: function unreadMessages() {
            var count = 0;
            var highlight = false;
            _state2.default.networks.forEach(function (network) {
                network.buffers.forEach(function (buffer) {
                    count += buffer.flags.unread || 0;
                    if (buffer.flags.highlight) {
                        highlight = true;
                    }
                });
            });
            return { count: count, highlight: highlight };
        }
    },
    created: function created() {
        var _this = this;

        this.listen(_state2.default, 'sidebar.toggle', function () {
            _state2.default.$emit('sidebar.' + (_this.sidebarState.isDrawn ? 'hide' : 'show'));
        });
        this.listen(_state2.default, 'sidebar.show', function () {
            _this.sidebarState.showNicklist();
        });
        this.listen(_state2.default, 'sidebar.hide', function () {
            _this.sidebarState.close();
        });
        this.listen(_state2.default, 'userbox.show', function (user, opts) {
            _this.sidebarState.showUser(user);
        });
        this.listen(_state2.default, 'userbox.hide', function () {
            _this.sidebarState.close();
        });
        this.listen(_state2.default, 'document.keydown', function (ev) {
            if (ev.keyCode !== 33 && ev.keyCode !== 34) {
                return;
            }

            var messageList = _this.$el.querySelector('.kiwi-messagelist') || _this.$el.querySelector('.u-tabbed-content');

            if (!messageList) {
                return;
            }

            var scrollDistance = messageList.clientHeight - 0.1 * messageList.clientHeight;
            var scrollTop = messageList.scrollTop;
            var scrollMax = messageList.scrollHeight;

            if (ev.keyCode === 33) {
                scrollTop -= scrollDistance;
                if (scrollTop < 0) {
                    scrollTop = 0;
                }
            } else {
                scrollTop += scrollDistance;
                if (scrollTop > scrollMax) {
                    scrollTop = scrollMax;
                }
            }

            messageList.scrollTop = scrollTop;
        });
    },
    methods: {
        toggleStateBrowser: function toggleStateBrowser() {
            _state2.default.$emit('statebrowser.toggle');
        },
        toggleSidebar: function toggleSidebar() {
            if (this.buffer.isChannel()) {
                _state2.default.$emit('sidebar.toggle');
            }
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["Container"]
window._kiwi_exports.components.Container = exports.default ? exports.default : exports;


/***/ }),

/***/ "ceRT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StateBrowserUsermenu_vue__ = __webpack_require__("bd+S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StateBrowserUsermenu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StateBrowserUsermenu_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StateBrowserUsermenu_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StateBrowserUsermenu_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bc29730_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StateBrowserUsermenu_vue__ = __webpack_require__("6r9D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("qrBh")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StateBrowserUsermenu_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bc29730_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StateBrowserUsermenu_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bc29730_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StateBrowserUsermenu_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "cl1K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelfUser_vue__ = __webpack_require__("cC0S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelfUser_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelfUser_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelfUser_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelfUser_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25cf28df_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelfUser_vue__ = __webpack_require__("xB2o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("04gU")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelfUser_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25cf28df_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelfUser_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25cf28df_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelfUser_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "cmUn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),

/***/ "cyd1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dZBv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "droJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dy/S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eFgB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Personal_vue__ = __webpack_require__("3EQ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Personal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Personal_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Personal_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Personal_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36cebc1c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Personal_vue__ = __webpack_require__("CUIL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("CfcS")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Personal_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36cebc1c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Personal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36cebc1c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Personal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ecZp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _create = __webpack_require__("OvRC");

var _create2 = _interopRequireDefault(_create);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _vue = __webpack_require__("I3G/");

var _vue2 = _interopRequireDefault(_vue);

var _TextFormatting = __webpack_require__("15gS");

var TextFormatting = _interopRequireWildcard(_TextFormatting);

var _common = __webpack_require__("nlr4");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserState = function () {
    function UserState(user) {
        (0, _classCallCheck3.default)(this, UserState);

        this.nick = user.nick;
        this.host = user.host || '';
        this.username = user.username || '';
        this.realname = user.realname || '';
        this.modes = user.modes || '';
        this.away = user.away || '';
        this.colour = user.colour || '';
        this.account = user.account || '';
        this.buffers = (0, _create2.default)(null);
        this.hasWhois = false;
        this.typingState = (0, _create2.default)(null);
        this.ignore = false;

        _vue2.default.observable(this);

        (0, _common.def)(this, 'actual_host', '', true);
        (0, _common.def)(this, 'helpop', '', true);
        (0, _common.def)(this, 'bot', '', true);
        (0, _common.def)(this, 'server', '', true);
        (0, _common.def)(this, 'server_info', '', true);
        (0, _common.def)(this, 'operator', '', true);
        (0, _common.def)(this, 'channels', '', true);
        (0, _common.def)(this, 'modes', '', true);
        (0, _common.def)(this, 'idle', '', true);
        (0, _common.def)(this, 'logon', '', true);
        (0, _common.def)(this, 'registered_nick', '', true);
        (0, _common.def)(this, 'secure', '', true);
        (0, _common.def)(this, 'special', '', true);
    }

    (0, _createClass3.default)(UserState, [{
        key: 'getColour',
        value: function getColour() {
            if (!this.colour) {
                this.colour = TextFormatting.createNickColour(this.nick);
            }

            return this.colour === 'default' ? '' : this.colour;
        }
    }, {
        key: 'isAway',
        value: function isAway() {
            return !!this.away;
        }
    }, {
        key: 'typingStatus',
        value: function typingStatus(target, status) {
            var _this = this;

            if (!this.typingState[target.toLowerCase()]) {
                _vue2.default.set(this.typingState, target.toLowerCase(), { started: 0, status: '' });
            }

            var typing = this.typingState[target.toLowerCase()];

            if (!status) {
                return this.typingState[target.toLowerCase()] || { status: '' };
            }

            if (typing.timeout) {
                clearTimeout(typing.timeout);
                typing.timeout = null;
            }

            if (status === 'done') {
                _vue2.default.delete(this.typingState, target.toLowerCase());
                return null;
            }

            typing.started = Date.now();
            typing.status = status;

            var timeoutLen = status === 'paused' ? 30000 : 6000;

            typing.timeout = setTimeout(function () {
                return _this.typingStatus(target, 'done');
            }, timeoutLen);

            return typing;
        }
    }]);
    return UserState;
}();

exports.default = UserState;

/***/ }),

/***/ "evl8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommonLayout_vue__ = __webpack_require__("7Ud/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommonLayout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommonLayout_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommonLayout_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommonLayout_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e025e1c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommonLayout_vue__ = __webpack_require__("3vWw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("o3P4")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommonLayout_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e025e1c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommonLayout_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e025e1c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommonLayout_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "exRi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _state = __webpack_require__("LnP8");

var _state2 = _interopRequireDefault(_state);

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            filterString: '',
            ignoreKeys: ['emojis', 'themes', 'bnc', 'aliases', 'restricted', 'kiwiServer', 'hide_advanced', 'windowTitle', 'startupOptions', 'plugins', 'presetNetworks']
        };
    },
    computed: {
        filteredSettings: function filteredSettings() {
            var settings = this.settings;
            var filter = this.filterString.toLowerCase();
            var out = [];
            (0, _keys2.default)(settings).forEach(function (key) {
                var value = settings[key];
                if (value.key.toLowerCase().indexOf(filter) !== -1) {
                    out.push(value);
                }
            });
            return out;
        },
        settings: function settings() {
            var out = {};
            var base = [];
            this.buildTree(out, base, _state2.default.getSetting('settings'), false);
            this.buildTree(out, base, _state2.default.getSetting('user_settings'), true);

            return _lodash2.default.orderBy((0, _keys2.default)(out).map(function (key) {
                return out[key];
            }), [function (o) {
                return o.key.split('.').length - 1;
            }, 'key'], ['asc']);
        }
    },
    methods: {
        resetValue: function resetValue(event, settingKey) {
            var newVal = _state2.default.getSetting('settings.' + settingKey);
            if (!newVal) {
                newVal = null;
            }
            _state2.default.setting(settingKey, newVal);
        },
        updateSetting: function updateSetting(event, settingKey) {
            var target = event.target;
            var val = target.type === 'checkbox' ? target.checked : target.value;
            switch (target.type) {
                case 'checkbox':
                    val = target.checked;
                    break;
                case 'number':
                    val = parseInt(target.value, 10);
                    break;
                default:
                    val = target.value;
                    break;
            }
            if (_state2.default.setting(settingKey) === val) {
                return;
            }

            _state2.default.setting(settingKey, val);
        },
        buildTree: function buildTree(data, base, object, modified) {
            var _this = this;

            (0, _keys2.default)(object).forEach(function (key) {
                var value = object[key];
                var ourBase = base.concat([key]);
                if (['string', 'boolean', 'number'].indexOf(typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) !== -1) {
                    if (_this.ignoreKeys.indexOf(key) !== -1 || (ourBase[0] && _this.ignoreKeys.indexOf(ourBase[0])) !== -1) {
                        return;
                    }

                    if (!data[ourBase.join('.')] || data[ourBase.join('.')].val !== value) {
                        data[ourBase.join('.')] = {
                            key: ourBase.join('.'),
                            val: value,
                            type: typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value),
                            modified: modified
                        };
                    }
                } else if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === 'object' && value !== null) {
                    _this.buildTree(data, ourBase, value, modified);
                }
            });
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["SettingsAdvanced"]
window._kiwi_exports.components.SettingsAdvanced = exports.default ? exports.default : exports;


/***/ }),

/***/ "f866":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});


function md5cycle(x, k) {
    var a = x[0],
        b = x[1],
        c = x[2],
        d = x[3];

    a = ff(a, b, c, d, k[0], 7, -680876936);
    d = ff(d, a, b, c, k[1], 12, -389564586);
    c = ff(c, d, a, b, k[2], 17, 606105819);
    b = ff(b, c, d, a, k[3], 22, -1044525330);
    a = ff(a, b, c, d, k[4], 7, -176418897);
    d = ff(d, a, b, c, k[5], 12, 1200080426);
    c = ff(c, d, a, b, k[6], 17, -1473231341);
    b = ff(b, c, d, a, k[7], 22, -45705983);
    a = ff(a, b, c, d, k[8], 7, 1770035416);
    d = ff(d, a, b, c, k[9], 12, -1958414417);
    c = ff(c, d, a, b, k[10], 17, -42063);
    b = ff(b, c, d, a, k[11], 22, -1990404162);
    a = ff(a, b, c, d, k[12], 7, 1804603682);
    d = ff(d, a, b, c, k[13], 12, -40341101);
    c = ff(c, d, a, b, k[14], 17, -1502002290);
    b = ff(b, c, d, a, k[15], 22, 1236535329);

    a = gg(a, b, c, d, k[1], 5, -165796510);
    d = gg(d, a, b, c, k[6], 9, -1069501632);
    c = gg(c, d, a, b, k[11], 14, 643717713);
    b = gg(b, c, d, a, k[0], 20, -373897302);
    a = gg(a, b, c, d, k[5], 5, -701558691);
    d = gg(d, a, b, c, k[10], 9, 38016083);
    c = gg(c, d, a, b, k[15], 14, -660478335);
    b = gg(b, c, d, a, k[4], 20, -405537848);
    a = gg(a, b, c, d, k[9], 5, 568446438);
    d = gg(d, a, b, c, k[14], 9, -1019803690);
    c = gg(c, d, a, b, k[3], 14, -187363961);
    b = gg(b, c, d, a, k[8], 20, 1163531501);
    a = gg(a, b, c, d, k[13], 5, -1444681467);
    d = gg(d, a, b, c, k[2], 9, -51403784);
    c = gg(c, d, a, b, k[7], 14, 1735328473);
    b = gg(b, c, d, a, k[12], 20, -1926607734);

    a = hh(a, b, c, d, k[5], 4, -378558);
    d = hh(d, a, b, c, k[8], 11, -2022574463);
    c = hh(c, d, a, b, k[11], 16, 1839030562);
    b = hh(b, c, d, a, k[14], 23, -35309556);
    a = hh(a, b, c, d, k[1], 4, -1530992060);
    d = hh(d, a, b, c, k[4], 11, 1272893353);
    c = hh(c, d, a, b, k[7], 16, -155497632);
    b = hh(b, c, d, a, k[10], 23, -1094730640);
    a = hh(a, b, c, d, k[13], 4, 681279174);
    d = hh(d, a, b, c, k[0], 11, -358537222);
    c = hh(c, d, a, b, k[3], 16, -722521979);
    b = hh(b, c, d, a, k[6], 23, 76029189);
    a = hh(a, b, c, d, k[9], 4, -640364487);
    d = hh(d, a, b, c, k[12], 11, -421815835);
    c = hh(c, d, a, b, k[15], 16, 530742520);
    b = hh(b, c, d, a, k[2], 23, -995338651);

    a = ii(a, b, c, d, k[0], 6, -198630844);
    d = ii(d, a, b, c, k[7], 10, 1126891415);
    c = ii(c, d, a, b, k[14], 15, -1416354905);
    b = ii(b, c, d, a, k[5], 21, -57434055);
    a = ii(a, b, c, d, k[12], 6, 1700485571);
    d = ii(d, a, b, c, k[3], 10, -1894986606);
    c = ii(c, d, a, b, k[10], 15, -1051523);
    b = ii(b, c, d, a, k[1], 21, -2054922799);
    a = ii(a, b, c, d, k[8], 6, 1873313359);
    d = ii(d, a, b, c, k[15], 10, -30611744);
    c = ii(c, d, a, b, k[6], 15, -1560198380);
    b = ii(b, c, d, a, k[13], 21, 1309151649);
    a = ii(a, b, c, d, k[4], 6, -145523070);
    d = ii(d, a, b, c, k[11], 10, -1120210379);
    c = ii(c, d, a, b, k[2], 15, 718787259);
    b = ii(b, c, d, a, k[9], 21, -343485551);

    x[0] = add32(a, x[0]);
    x[1] = add32(b, x[1]);
    x[2] = add32(c, x[2]);
    x[3] = add32(d, x[3]);
}

function cmn(q, a, b, x, s, t) {
    a = add32(add32(a, q), add32(x, t));
    return add32(a << s | a >>> 32 - s, b);
}

function ff(a, b, c, d, x, s, t) {
    return cmn(b & c | ~b & d, a, b, x, s, t);
}

function gg(a, b, c, d, x, s, t) {
    return cmn(b & d | c & ~d, a, b, x, s, t);
}

function hh(a, b, c, d, x, s, t) {
    return cmn(b ^ c ^ d, a, b, x, s, t);
}

function ii(a, b, c, d, x, s, t) {
    return cmn(c ^ (b | ~d), a, b, x, s, t);
}

function md51(s) {
    var n = s.length,
        state = [1732584193, -271733879, -1732584194, 271733878],
        i;
    for (i = 64; i <= s.length; i += 64) {
        md5cycle(state, md5blk(s.substring(i - 64, i)));
    }
    s = s.substring(i - 64);
    var tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    for (i = 0; i < s.length; i++) {
        tail[i >> 2] |= s.charCodeAt(i) << (i % 4 << 3);
    }tail[i >> 2] |= 0x80 << (i % 4 << 3);
    if (i > 55) {
        md5cycle(state, tail);
        for (i = 0; i < 16; i++) {
            tail[i] = 0;
        }
    }
    tail[14] = n * 8;
    md5cycle(state, tail);
    return state;
}

function md5blk(s) {
    var md5blks = [],
        i;
    for (i = 0; i < 64; i += 4) {
        md5blks[i >> 2] = s.charCodeAt(i) + (s.charCodeAt(i + 1) << 8) + (s.charCodeAt(i + 2) << 16) + (s.charCodeAt(i + 3) << 24);
    }
    return md5blks;
}

var hex_chr = '0123456789abcdef'.split('');

function rhex(n) {
    var s = '',
        j = 0;
    for (; j < 4; j++) {
        s += hex_chr[n >> j * 8 + 4 & 0x0F] + hex_chr[n >> j * 8 & 0x0F];
    }return s;
}

function hex(x) {
    for (var i = 0; i < x.length; i++) {
        x[i] = rhex(x[i]);
    }return x.join('');
}

function md5(s) {
    return hex(md51(s));
}

function add32(a, b) {
    return a + b & 0xFFFFFFFF;
}

if (md5('hello') != '5d41402abc4b2a76b9719d911017c592') {
    var _add = function _add(x, y) {
        var lsw = (x & 0xFFFF) + (y & 0xFFFF),
            msw = (x >> 16) + (y >> 16) + (lsw >> 16);
        return msw << 16 | lsw & 0xFFFF;
    };
}

exports.md5 = md5;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["helpers"]) window._kiwi_exports["helpers"] = {};
window._kiwi_exports["helpers"]["Md5"]
window._kiwi_exports.helpers.Md5 = exports.default ? exports.default : exports;


/***/ }),

/***/ "f96R":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.State = undefined;

var _UserBox = __webpack_require__("+z04");

var _UserBox2 = _interopRequireDefault(_UserBox);

var _GlobalApi = __webpack_require__("Uvbb");

var _GlobalApi2 = _interopRequireDefault(_GlobalApi);

var _SidebarState = __webpack_require__("03Ga");

var _SidebarState2 = _interopRequireDefault(_SidebarState);

var _BufferSettings = __webpack_require__("5nmk");

var _BufferSettings2 = _interopRequireDefault(_BufferSettings);

var _ChannelInfo = __webpack_require__("n5Xi");

var _ChannelInfo2 = _interopRequireDefault(_ChannelInfo);

var _SidebarAboutBuffer = __webpack_require__("m3c/");

var _SidebarAboutBuffer2 = _interopRequireDefault(_SidebarAboutBuffer);

var _ChannelBanlist = __webpack_require__("wb7H");

var _ChannelBanlist2 = _interopRequireDefault(_ChannelBanlist);

var _ChannelInvitelist = __webpack_require__("xZQN");

var _ChannelInvitelist2 = _interopRequireDefault(_ChannelInvitelist);

var _Nicklist = __webpack_require__("0YW4");

var _Nicklist2 = _interopRequireDefault(_Nicklist);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.State = _SidebarState2.default;
exports.default = {
    components: {
        BufferSettings: _BufferSettings2.default,
        SidebarAboutBuffer: _SidebarAboutBuffer2.default,
        ChannelInfo: _ChannelInfo2.default,
        ChannelBanlist: _ChannelBanlist2.default,
        ChannelInvitelist: _ChannelInvitelist2.default,
        Nicklist: _Nicklist2.default,
        UserBox: _UserBox2.default
    },
    props: ['network', 'buffer', 'sidebarState'],
    data: function data() {
        return {
            pluginUiElements: _GlobalApi2.default.singleton().sideBarPlugins,
            accessTab: 'banlist'
        };
    },

    computed: {
        section: function section() {
            if (this.sidebarState.activeComponent) {
                return 'component';
            }

            return this.sidebarState.section() || 'nicklist';
        },

        settingShowJoinParts: {
            get: function get() {
                return this.buffer.setting('show_joinparts');
            },
            set: function set(newVal) {
                return this.buffer.setting('show_joinparts', newVal);
            }
        },
        settingShowTopics: {
            get: function get() {
                return this.buffer.setting('show_topics');
            },
            set: function set(newVal) {
                return this.buffer.setting('show_topics', newVal);
            }
        },
        settingShowNickChanges: {
            get: function get() {
                return this.buffer.setting('show_nick_changes');
            },
            set: function set(newVal) {
                return this.buffer.setting('show_nick_changes', newVal);
            }
        },
        settingShowModeChanges: {
            get: function get() {
                return this.buffer.setting('show_mode_changes');
            },
            set: function set(newVal) {
                return this.buffer.setting('show_mode_changes', newVal);
            }
        },
        settingColouredNicklist: {
            get: function get() {
                return this.buffer.setting('coloured_nicklist');
            },
            set: function set(newVal) {
                return this.buffer.setting('coloured_nicklist', newVal);
            }
        },
        settingExtraFormatting: {
            get: function get() {
                return this.buffer.setting('extra_formatting');
            },
            set: function set(newVal) {
                return this.buffer.setting('extra_formatting', newVal);
            }
        },
        settingShareTyping: {
            get: function getSettingShareTyping() {
                return this.buffer.setting('share_typing');
            },
            set: function setSettingShareTyping(newVal) {
                return this.buffer.setting('share_typing', newVal);
            }
        },
        bufferType: function bufferType() {
            var type = '';

            if (!this.buffer) {
                type = 'none';
            } else if (this.buffer.isServer()) {
                type = 'server';
            } else if (this.buffer.isChannel()) {
                type = 'channel';
            } else if (this.buffer.isQuery()) {
                type = 'query';
            }

            return type;
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["Sidebar"]
window._kiwi_exports.components.Sidebar = exports.default ? exports.default : exports;


/***/ }),

/***/ "fFqg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fGO0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__("Gu7T");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _create = __webpack_require__("OvRC");

var _create2 = _interopRequireDefault(_create);

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _htmlparser = __webpack_require__("Fruj");

var _htmlparser2 = _interopRequireDefault(_htmlparser);

var _Colours = __webpack_require__("3piF");

var Colours = _interopRequireWildcard(_Colours);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Vue = __webpack_require__("I3G/");

exports.default = Vue.component('irc-input', {
    props: ['placeholder'],
    data: function data() {
        return {
            last_known_value: '',
            text_value: '',
            current_el: null,
            current_el_pos: 0,
            default_colour: null,
            code_map: (0, _create2.default)(null)
        };
    },

    computed: {
        editor: function editor() {
            return this.$refs.editor;
        }
    },
    mounted: function mounted() {
        this.resetStyles();
    },

    methods: {
        onTextInput: function onTextInput(event) {
            if (event.data[event.data.length - 1] === '\n') {
                event.preventDefault();
                this.setCurrentWord(event.data.trim());
            }
        },
        onPaste: function onPaste(event) {
            var _this = this;

            event.preventDefault();
            if (typeof event.clipboardData !== 'undefined') {
                var ignoreThisPaste = false;
                var clpData = event.clipboardData;
                clpData.types.forEach(function (type) {
                    var ignoreTypes = ['Files', 'image'];
                    ignoreTypes.forEach(function (ig) {
                        if (type.indexOf(ig) > -1) {
                            ignoreThisPaste = true;
                        }
                    });
                });

                if (ignoreThisPaste) {
                    return;
                }

                document.execCommand('insertText', false, clpData.getData('text/plain'));
            } else {
                var clpText = window.clipboardData.getData('Text');
                if (!clpText) {
                    return;
                }

                var selection = window.getSelection();
                var range = selection.getRangeAt(0);
                if (range) {
                    range.deleteContents();
                    range.insertNode(document.createTextNode(clpText));
                }
            }

            setTimeout(function () {
                _this.updateValueProps();
            }, 0);
        },
        onFocus: function onFocus(event) {
            if (!this.getRawText() && this.default_colour) {
                this.setColour(this.default_colour.code, this.default_colour.colour);
            }

            this.$emit('focus', event);
        },
        updateValueProps: function updateValueProps() {
            var selection = window.getSelection();

            if (selection.rangeCount === 0) {
                return;
            }

            this.current_el_pos = selection.anchorOffset;
            this.current_el = selection.anchorNode;

            this.maybeEmitInput();
        },
        selectionToEnd: function selectionToEnd() {
            var el = this.$refs.editor.lastChild || this.$refs.editor;
            this.current_el = el;

            if (el.nodeType === 3) {
                this.current_el_pos = el.length;
            } else {
                this.current_el_pos = 0;
            }

            this.focus();
        },
        setValue: function setValue(newVal) {
            this.value = newVal;
            this.$refs.editor.innerHTML = newVal;
        },
        getValue: function getValue() {
            return this.$refs.editor.innerHTML;
        },
        maybeEmitInput: function maybeEmitInput() {
            var currentHtml = this.$refs.editor.innerHTML;
            if (this.last_known_value !== currentHtml) {
                this.$emit('input', currentHtml);
                this.last_known_value = currentHtml;
            }
        },
        buildIrcText: function buildIrcText() {
            var _this2 = this;

            var source = this.$refs.editor.innerHTML;
            var textValue = '';

            var toggles = [];
            function addToggle(t) {
                toggles[toggles.length - 1] += t;
            }
            function getToggles() {
                return toggles[toggles.length - 1];
            }

            var parser = new _htmlparser2.default.Parser({
                onopentag: function onopentag(name, attribs) {
                    toggles.push('');
                    var codeLookup = '';
                    if (attribs.style) {
                        var match = attribs.style.match(/color: ([^;]+)/);
                        if (match) {
                            codeLookup = match[1];
                            var mappedCode = _this2.code_map[codeLookup];
                            if (!mappedCode) {
                                var m = codeLookup.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
                                if (m) {
                                    var hex = Colours.rgb2hex({
                                        r: parseInt(m[1], 10),
                                        g: parseInt(m[2], 10),
                                        b: parseInt(m[3], 10)
                                    });
                                    mappedCode = _this2.code_map[hex];
                                }
                            }

                            if (mappedCode) {
                                textValue += '\x03' + mappedCode;
                                addToggle('\x03' + mappedCode);
                            }
                        }

                        if (attribs.style.indexOf('bold') > -1) {
                            textValue += '\x02';
                            addToggle('\x02');
                        }
                        if (attribs.style.indexOf('italic') > -1) {
                            textValue += '\x1d';
                            addToggle('\x1d');
                        }
                        if (attribs.style.indexOf('underline') > -1) {
                            textValue += '\x1f';
                            addToggle('\x1f');
                        }
                    } else if (attribs.color) {
                        var _mappedCode = _this2.code_map[attribs.color] || _this2.code_map[attribs.color.replace(/,/g, ', ')] || _this2.code_map[Colours.hex2rgb(attribs.color)];

                        if (_mappedCode) {
                            textValue += '\x03' + _mappedCode;
                            addToggle('\x03' + _mappedCode);
                        }
                    } else if (name === 'strong') {
                        textValue += '\x02';
                        addToggle('\x02');
                    } else if (name === 'em') {
                        textValue += '\x1d';
                        addToggle('\x1d');
                    } else if (name === 'u') {
                        textValue += '\x1f';
                        addToggle('\x1f');
                    }

                    if (attribs.src && _this2.code_map[attribs.src]) {
                        textValue += _this2.code_map[attribs.src];
                    }
                },
                ontext: function ontext(text) {
                    textValue += text;
                },
                onclosetag: function onclosetag(tagName) {
                    textValue += getToggles();
                    toggles.pop();
                }
            }, {
                decodeEntities: true
            });

            parser.write(source);
            parser.end();

            return textValue;
        },
        reset: function reset(rawHtml) {
            this.$refs.editor.innerHTML = rawHtml || '';

            this.current_el_pos = 0;
            this.current_el = this.$refs.editor;

            var br = this.$refs.editor.querySelector('br');
            if (br) {
                br.parentNode.removeChild(br);
            }

            if (this.default_colour) {
                this.focus();
                this.setColour(this.default_colour.code, this.default_colour.colour);
            }

            this.updateValueProps();
        },
        resetStyles: function resetStyles() {
            this.focus();
            document.execCommand('styleWithCSS', false, true);
            document.execCommand('selectAll', false, null);
            document.execCommand('removeFormat', false, null);
            this.default_colour = null;
        },
        setColour: function setColour(code, colour) {
            var range = window.getSelection().getRangeAt(0);
            if (range && range.collapsed) {
                this.default_colour = {
                    code: code,
                    colour: colour
                };
            }

            this.focus();
            document.execCommand('styleWithCSS', false, true);
            document.execCommand('foreColor', false, colour);

            this.code_map[colour] = code;
            this.updateValueProps();
        },
        toggleBold: function toggleBold() {
            document.execCommand('bold', false, null);
            this.updateValueProps();
        },
        toggleItalic: function toggleItalic() {
            document.execCommand('italic', false, null);
            this.updateValueProps();
        },
        toggleUnderline: function toggleUnderline() {
            document.execCommand('underline', false, null);
            this.updateValueProps();
        },
        addImg: function addImg(code, url) {
            this.focus();

            var existingImages = [].concat((0, _toConsumableArray3.default)(_lodash2.default.values(this.$refs.editor.querySelectorAll('img'))));

            document.execCommand('styleWithCSS', false, true);
            document.execCommand('insertImage', false, url);
            this.code_map[url] = code;

            var newImg = null;
            var images = [].concat((0, _toConsumableArray3.default)(_lodash2.default.values(this.$refs.editor.querySelectorAll('img'))));

            images.forEach(function (img) {
                if (existingImages.indexOf(img) === -1) {
                    newImg = img;
                }
            });

            var prevElCnt = 0;
            var el = newImg;
            while (el) {
                el = el.previousSibling;
                prevElCnt++;
            }

            this.current_el = this.$refs.editor;
            this.current_el_pos = prevElCnt;

            this.updateValueProps();
            this.focus();
        },
        insertText: function insertText(text) {
            this.focus();
            document.execCommand('insertText', false, text);
            this.updateValueProps();
            this.focus();
        },
        setCurrentWord: function setCurrentWord(text, keepPosition) {
            var el = this.current_el;
            var pos = this.current_el_pos;
            var val = el.textContent || '';

            var startVal = val.substr(0, pos);
            var space = startVal.lastIndexOf(' ');
            if (space === -1) {
                space = 0;
            } else {
                space++;
            }
            var startPos = space;

            var endVal = val.substr(pos);
            space = endVal.indexOf(' ');
            if (space === -1) space = endVal.length;
            var endPos = space;

            el.textContent = startVal.substr(0, startPos) + text + endVal.substr(endPos);

            var range = document.createRange();
            if (keepPosition) {
                range.setStart(el, pos);
                range.setEnd(el, pos);
            } else if (el.nodeType === 3) {
                range.setStart(el, startPos + text.length);
                range.setEnd(el, startPos + text.length);
            } else {
                range.setStart(el, 1);
                range.setEnd(el, 1);
            }

            var sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
            this.updateValueProps();
        },
        getCurrentWord: function getCurrentWord() {
            var el = this.current_el;
            var pos = this.current_el_pos;
            var val = el.textContent;

            var startVal = val.substr(0, pos);
            var space = startVal.lastIndexOf(' ');
            if (space === -1) {
                space = 0;
            } else {
                space++;
            }
            var startPos = space;

            space = val.indexOf(' ', startPos);
            if (space === -1) space = val.length;
            var endPos = space;

            return {
                word: val.substr(startPos, endPos),
                position: pos - startPos
            };
        },
        getRawText: function getRawText() {
            return this.$refs.editor.innerText;
        },
        focus: function focus() {
            var selection = window.getSelection();
            var range = document.createRange();
            range.setStart(this.current_el || this.$refs.editor, this.current_el_pos || 0);

            selection.removeAllRanges();
            selection.addRange(range);
        }
    }
});
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["utils"]) window._kiwi_exports["components"]["utils"] = {};
window._kiwi_exports["components"]["utils"]["IrcInput"]
window._kiwi_exports.components.utils.IrcInput = exports.default ? exports.default : exports;


/***/ }),

/***/ "fg1i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g1Es":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g1je":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__("I3G/");

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _vue2.default.extend({
    data: function data() {
        return {
            sidebarOpen: false,

            sidebarSection: '',
            sidebarUser: null,
            activeComponent: null
        };
    },

    computed: {
        isDrawn: function isDrawn() {
            return this.sidebarOpen && this.$state.ui.app_width <= 769;
        },
        isClosed: function isClosed() {
            return !this.sidebarOpen;
        },
        isOpen: function isOpen() {
            return this.sidebarOpen && this.$state.ui.app_width > 769;
        }
    },
    created: function created() {
        var _this = this;

        this.listen(this.$state, 'sidebar.component', function (component) {
            _this.activeComponent = component;
        });

        this.$nextTick(function () {
            var sidebarDefault = _this.$state.setting('sidebarDefault');
            if (sidebarDefault && _this.$state.ui.app_width > 769) {
                _this.sidebarSection = sidebarDefault;
                _this.sidebarOpen = true;
            }
        });
    },

    methods: {
        section: function section() {
            if (this.isClosed) {
                return '';
            }

            var section = this.sidebarSection;
            var isChannel = this.$state.getActiveBuffer().isChannel();

            if (section === 'settings' && isChannel) {
                return 'settings';
            } else if (section === 'user' && this.sidebarUser && isChannel) {
                return 'user';
            } else if (section === 'nicklist' && isChannel) {
                return 'nicklist';
            } else if (section === 'about') {
                return 'about';
            }

            return '';
        },
        close: function close() {
            this.sidebarOpen = false;
            this.sidebarSection = '';
            this.sidebarUser = null;
        },
        showUser: function showUser(user) {
            this.activeComponent = null;
            this.sidebarUser = user;
            this.sidebarOpen = true;
            this.sidebarSection = 'user';
        },
        showNicklist: function showNicklist() {
            this.activeComponent = null;
            this.sidebarOpen = true;
            this.sidebarSection = 'nicklist';
        },
        showBufferSettings: function showBufferSettings() {
            this.activeComponent = null;
            this.sidebarOpen = true;
            this.sidebarSection = 'settings';
        },
        showAbout: function showAbout() {
            this.activeComponent = null;
            this.sidebarOpen = true;
            this.sidebarSection = 'about';
        },
        toggleNicklist: function toggleNicklist() {
            this.sidebarSection === 'nicklist' ? this.close() : this.showNicklist();
        },
        toggleBufferSettings: function toggleBufferSettings() {
            this.sidebarSection === 'settings' ? this.close() : this.showBufferSettings();
        },
        toggleAbout: function toggleAbout() {
            this.sidebarSection === 'about' ? this.close() : this.showAbout();
        }
    }
});
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["SidebarState"]
window._kiwi_exports.components.SidebarState = exports.default ? exports.default : exports;


/***/ }),

/***/ "gKb+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gYtO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ga3F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageInfo_vue__ = __webpack_require__("10Te");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageInfo_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageInfo_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageInfo_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01d75174_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageInfo_vue__ = __webpack_require__("bsrY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Ig9r")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageInfo_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01d75174_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageInfo_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01d75174_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageInfo_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "gaEc":
/***/ (function(module, exports) {

module.exports = {"start_button":"Start","start_greeting":"Welcome to Kiwi IRC!","close":"Close","connect":"Connect","connecting":"Connecting...","connected":"Connected","settings":"Settings","kiwi_settings":"Kiwi Settings","channels":"Channels","access":"Access","banned":"Banned Users","invited":"Invited Users","notifications":"Notifications","username":"Username","password":"Password","password_have":"I have a password","server":"Server","nick":"Nick","channel":"Channel","messages":"Messages","network":"Network","znc":"ZNC","logging_in":"Logging in...","invalid_login":"Invalid login","do_search":"Search...","ok":"OK","cancel":"Cancel","yes":"Yes","no":"No","not_found":"Not found","warning":"Warning!","window_unload":"This will close all KiwiIRC conversations. Are you sure you want to close this window?","whois_realname":"Real name","whois_status":"Status","whois_status_available":"Is available","send_a_message":"Send a message","more_information":"More information","ignore_user":"Ignore user","connection_channel":"Channel","away":"Away","week":"{{count}} week","week_plural":"{{count}} weeks","day":"{{count}} day","day_plural":"{{count}} days","hour":"{{count}} hour","hour_plural":"{{count}} hours","minute":"{{count}} minute","minute_plural":"{{count}} minutes","second":"{{count}} second","second_plural":"{{count}} seconds","settings_general":"General","settings_language":"Language","settings_theme":"Theme","refresh_theme":"Refresh Theme","settings_themeurl":"Theme URL","settings_messagelayout":"Message Layout","settings_use_monospace":"Use monospace","settings_default_handler":"Use Kiwi as my default IRC client","settings_layout_compact":"Traditional IRC layout","settings_show_autocomplete":"Show autocomplete list","settings_messages_title":"Chat Messages","settings_timestamps":"Show timestamps","settings_24hour_timestamps":"Use 24-hour timestamps","settings_emoticons":"Show emoticons","settings_block_private":"Block new private messages","settings_scrollback":"Messages in scrollback","settings_formatting":"Extra formatting","settings_nick_colouring":"Colour nicknames in messages","settings_share_typing":"Share when I'm typing a message","settings_show_joinpart":"Include join/part messages as activity","settings_mute_sound":"Mute sound notifications","settings_highlight":"Highlight on words (space separated)","settings_aliases":"Aliases","what_are_aliases":"What are Aliases?","send_message":"Send Message","bufferkey_input":"Enter the channel key:","bufferkey_rejoin":"Rejoin {{channel}}","settings_notify":"Notify me when","settings_notify_all":"All messages","settings_notify_mentioned":"I am mentioned","settings_notify_never":"Never","settings_notify_mute":"Mute sounds","settings_show_message_counts":"Hide unread message count","operator_tools":"Operator Tools","settings_default_ban_mask":"Default ban mask","settings_default_kick_reason":"Default kick reason","settings_advanced_title":"Advanced Settings","settings_advanced_warning":"Monsters be here, only click this button if you know what you are doing","settings_advanced_button":"Enable Advanced Settings","settings_advanced_header":"Danger Zone: Changing some of these settings may break things!","settings_advanced_reset":"Reset","settings_advanced_filter":"Filter","bans_refresh":"Refresh banlist","bans_user":"Banned user","bans_by":"Banned by","bans_refreshing":"Refreshing banlist...","bans_nobody":"Nobody is banned!","invites_refresh":"Refresh invite list","invites_user":"Invited user","invites_by":"Invited by","invites_refreshing":"Refreshing invite list...","invites_nobody":"Nobody is invited!","invite_public_channel":"This is a public channel.","invite_private_channel":"Only invited users can join.","invite_set_private":"Only allow invited users","invite_set_public":"Allow anybody to join","invite_registered_only":"Only registered users can join","invite_add_invite":"Add invite","invite_any_registered":"(Any registered user)","channel_topic":"Topic","channel_moderated":"Moderated chat","channel_invite":"Invite only","channel_moderated_topic":"Only moderators can change the topic","channel_external":"Block messages from outside this channel","channel_list_fetch":"Click the refresh button to update the channel list","channel_list_nonefound":"No channels found, try again later","container_welcome":"Welcome to Kiwi IRC! Select a channel on the left.","container_statebrowser":"Show statebrowser","hide_topic":"Hide Topic","display_topic":"Display Topic","channel_settings":"Channel Settings","container_join":"Join Channel","container_notconnected":"Not Connected","container_privmsg":"Private conversation with {{user}}","prompt_leave_channel":"Really leave the channel?","input_placeholder":"Send a message...","media_loading":"Loading {{url}}...","messages_load":"Load previous messages","unread_messages":"Unread Messages","settings_server_details":"Server details","settings_port":"Port","settings_znc_other":"Other networks on this ZNC account will be listed in the network list","settings_your_details":"Your details","settings_nickname":"Nickname","settings_advanced":"Advanced","settings_encoding":"Encoding","settings_show_raw":"Show Raw","settings_use_websocket":"Direct websocket","settings_autorun":"Run commands when connected","settings_danger":"Danger Zone","settings_remove":"Remove network","person":"{{count}} person here","person_plural":"{{count}} people here","filter_users":"Filter users in channel","reconnect_channel":"Reconnect to join {{channel}}","reconnect_network":"Reconnect to {{network}} to start talking","reconnect_query":"Reconnect to continue talking with {{user}}","not_connected":"You are not currently connected!","reconnect_settings":"Connection settings","network_noconnect":"We couldn't connect to that server :(","network_connect":"Connect To Network","side_close":"Close options","side_options":"Channel options","side_settings":"Your settings","side_joins":"Show when people join","side_topics":"Show when channel topic changes","side_nick_changes":"Show when users change their nicks","side_mode_changes":"Show when users change channel modes","side_formatting":"Extra message formatting","side_colours":"Nick colours in the list","side_buffer":"No buffer set","no_topic_set":"There is no topic for this channel","about":"About","created_at":"Created at {{when}}","highlights":"Highlights","nobody_mentioned_you":"Nobody has mentioned you yet...","error_starting":"There was an error starting Kiwi IRC :(","error_installed":"Make sure you have installed Kiwi IRC correctly and the configurartion can be loaded","state_leave":"Leave {{name}}","state_account":"Your account","state_remembered":"Your settings and networks will be remembered on this computer.","state_forget":"Forget me","state_network":"No networks here yet.","state_add":"Add one?","state_available":"Available networks","add_network":"Add Network","new_network":"New Network","no_network":"No Network","state_configure":"Configure network","state_disconnected":"Not connected.","state_join":"Join new #channel","filter_channels":"Filter Channels","find_more_channels":"Find More Channels","change_nick":"Change nick","enter_new_nick":"Enter new nickname...","user_account":"Account name: {{user}}","user_realname":"Real name: {{realname}}","user_bot":"Is a bot","user_help":"Is available for help","user_op":"Is an operator","user_server":"Connected to {{server}} {{info}}","user_secure":"Securely connected via SSL/TLS","user_channels":"Also in channels {{channels}}","user_access":"Access level","user_normal":"Normal","user_kick":"Kick from the channel","user_ban":"Ban from the channel","user_kickban":"Ban and kick from the channel","error_no_channel_join":"Please specify a channel to join. eg /join #example","error_nick_in_use":"The nickname {{nick}} is already in use!","error_empty_nick":"You must enter a new nickname","error_no_number":"Nickname must not start with a number","modes_give_ops":"{{nick}} gives ops to {{target}}","modes_take_ops":"{{nick}} takes ops from {{target}}","modes_give_halfops":"{{nick}} gives half-ops to {{target}}","modes_take_halfops":"{{nick}} takes half-ops from {{target}}","modes_give_voice":"{{nick}} gives voice to {{target}}","modes_take_voice":"{{nick}} takes voice from {{target}}","modes_give_admin":"{{nick}} gives admin to {{target}}","modes_take_admin":"{{nick}} takes admin from {{target}}","modes_give_owner":"{{nick}} gives owner to {{target}}","modes_take_owner":"{{nick}} takes owner from {{target}}","modes_gives_ban":"{{nick}} has banned {{target}}","modes_takes_ban":"{{nick}} has unbanned {{target}}","modes_other":"{{nick}} sets {{mode}} on {{target}}","command_msg":"Send a message","command_action":"Do something physical","command_join":"Join a channel","command_part":"Leave a channel","command_cycle":"Leave, then re-join a channel","command_nick":"Change your nickname","command_query":"Start a private conversation with someone","command_invite":"Invite somebody into the channel","command_topic":"Set the topic for this channel","command_notice":"Send a notice","command_quote":"Send a raw command to the IRC server","command_kick":"Kick somebody from the channel","command_clear":"Clear all messages from this window","command_ctcp":"Send a CTCP command to somebody","command_quit":"Disconnect from the IRC server","command_server":"Connect to a new IRC network","command_whois":"Request information on somebody","command_whowas":"Request information on somebody that disconnected recently","command_away":"Mark yourself as away","command_back":"Set yourself as active","command_encoding":"Change your connection encoding","command_ignore":"Ignore messages from somebody","command_unignore":"Stop ignoring somebody","command_dice":"Roll a Dice","dice_roll":"Rolls a {{sides}} sided dice and gets {{number}}","personal_client":"Your IRC Client.","personal_addjoin":"Add your networks. Join your channels.","personal_return":"They will be here when you come back.","personal_add":"Add a Network","personal_connect_to":"You are trying to connect to {{network}}","personal_added_to_existing":"Network has been added to your existing Kiwi window.","personal_add_existing_tab":"Add network to existing Kiwi window","personal_connect_temporary":"Temporarily connect to this network","personal_saved":"Saved networks","rizon_title":"Kiwi IRC (next gen) - Rizon preview","rizon_websockets":"Direct websockets. No Kiwi server or webirc involved.","rizon_thanks":"(Thanks to Adam @Rizon for the development websocket server support!)","rizon_dev":"Give the developer version of Kiwi IRC a try!","disconnected":"Disconnected","connected_to":"Connected to {{network}}!","has_joined":"{{nick}} has joined","kicked_you_from":"{{nick}} kicked you from {{channel}}","was_kicked_from":"{{nick}} was kicked from {{channel}} by {{chanop}}","has_left":"{{nick}} has left","invited_you":"{{nick}} invited you to join {{channel}}","nick_in_use_retrying":"Nickname {{nick}} is already in use. Trying {{newnick}}...","now_known_as":"{{nick}} is now known as {{newnick}}","changed_topic_to":"{{nick}} changed the topic to: {{topic}}"}

/***/ }),

/***/ "hQWq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ZncLogin_vue__ = __webpack_require__("niD1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ZncLogin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ZncLogin_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ZncLogin_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ZncLogin_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1817c8c4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ZncLogin_vue__ = __webpack_require__("bhYc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("5Q5w")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ZncLogin_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1817c8c4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ZncLogin_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1817c8c4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ZncLogin_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "haAC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TypingUsersList_vue__ = __webpack_require__("6t4W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TypingUsersList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TypingUsersList_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TypingUsersList_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TypingUsersList_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13906cf7_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TypingUsersList_vue__ = __webpack_require__("H64e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("VKy0")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TypingUsersList_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13906cf7_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TypingUsersList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13906cf7_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TypingUsersList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "hfYN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _state = __webpack_require__("LnP8");

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var embedlyTagIncluded = false;

exports.default = {
    props: ['url', 'component', 'isIframe'],
    data: function data() {
        return {};
    },
    computed: {
        embedlyKey: function embedlyKey() {
            return _state2.default.settings.embedly.key;
        }
    },
    watch: {
        url: function watchUrl() {
            this.updateEmbed();
        },
        isIframe: function watchUrl() {
            this.updateEmbed();
        }
    },
    created: function created() {
        this.updateEmbed();
    },
    mounted: function mounted() {
        this.$nextTick(function () {
            _state2.default.$emit('mediaviewer.opened');
        });
    },
    methods: {
        updateEmbed: function updateEmbed() {
            var _this = this;

            var checkEmbedlyAndShowCard = function checkEmbedlyAndShowCard() {
                if (_this.isIframe) {
                    return;
                }

                if (typeof window.embedly !== 'function') {
                    setTimeout(checkEmbedlyAndShowCard, 100);
                    return;
                }
                window.embedly('card', { selector: '.kiwi-embedly-card' });
            };

            if (!embedlyTagIncluded) {
                var head = document.getElementsByTagName('head')[0];
                var script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = '//cdn.embedly.com/widgets/platform.js';
                head.appendChild(script);
                embedlyTagIncluded = true;
            }
            checkEmbedlyAndShowCard();
        },
        closeViewer: function closeViewer() {
            _state2.default.$emit('mediaviewer.hide', { source: 'user' });
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["MediaViewer"]
window._kiwi_exports.components.MediaViewer = exports.default ? exports.default : exports;


/***/ }),

/***/ "hnVO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-userbox"},[(_vm.isSelf)?_c('span',{staticClass:"kiwi-userbox-selfprofile"},[_vm._v("\n        This is you!\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"kiwi-userbox-header"},[_c('h3',[_c('away-status-indicator',{attrs:{"network":_vm.network,"user":_vm.user}}),_vm._v(" "+_vm._s(_vm.user.nick)+"\n            "),(_vm.userMode)?_c('span',{staticClass:"kiwi-userbox-modestring"},[_vm._v("+"+_vm._s(_vm.userMode))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"kiwi-userbox-usermask"},[_vm._v(_vm._s(_vm.user.username)+"@"+_vm._s(_vm.user.host))])]),_vm._v(" "),_c('div',{staticClass:"kiwi-userbox-basicinfo"},[_c('span',{staticClass:"kiwi-userbox-basicinfo-title"},[_vm._v(_vm._s(_vm.$t('whois_realname'))+":")]),_vm._v(" "),_c('span',{staticClass:"kiwi-userbox-basicinfo-data"},[_vm._v(_vm._s(_vm.user.realname)+" ")])]),_vm._v(" "),_c('p',{staticClass:"kiwi-userbox-actions"},[(!_vm.isSelf)?_c('a',{staticClass:"kiwi-userbox-action",on:{"click":_vm.openQuery}},[_c('i',{staticClass:"fa fa-comment-o",attrs:{"aria-hidden":"true"}}),_vm._v("\n            "+_vm._s(_vm.$t('send_a_message'))+"\n        ")]):_vm._e(),_vm._v(" "),(!_vm.whoisRequested)?_c('a',{staticClass:"kiwi-userbox-action",on:{"click":_vm.updateWhoisData}},[_c('i',{staticClass:"fa fa-question-circle",attrs:{"aria-hidden":"true"}}),_vm._v("\n            "+_vm._s(_vm.$t('more_information'))+"\n        ")]):_vm._e()]),_vm._v(" "),(!_vm.isSelf)?_c('form',{staticClass:"u-form kiwi-userbox-ignoreuser"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.ignore),expression:"user.ignore"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.user.ignore)?_vm._i(_vm.user.ignore,null)>-1:(_vm.user.ignore)},on:{"change":function($event){var $$a=_vm.user.ignore,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.user, "ignore", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.user, "ignore", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.user, "ignore", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t('ignore_user'))+" ")])])]):_vm._e(),_vm._v(" "),(_vm.whoisRequested)?_c('div',{staticClass:"kiwi-userbox-whois",class:[_vm.whoisLoading?'kiwi-userbox-whois--loading':'']},[(_vm.whoisLoading)?[_c('i',{staticClass:"fa fa-spinner",attrs:{"aria-hidden":"true"}})]:[_c('span',{staticClass:"kiwi-userbox-whois-line"},[_vm._v("\n                "+_vm._s(_vm.user.away ?
                    _vm.$t('whois_status') + ': ' + _vm.user.away :
                    _vm.$t('whois_status_available'))+"\n            ")]),_vm._v(" "),(_vm.user.account)?_c('span',{staticClass:"kiwi-userbox-whois-line"},[_vm._v("\n                "+_vm._s(_vm.$t('user_account', {user: _vm.user.account}))+"\n            ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"kiwi-userbox-whois-line"},[_vm._v("\n                "+_vm._s(_vm.$t('user_realname', {realname: _vm.user.realname}))+"\n            ")]),_vm._v(" "),(_vm.user.bot)?_c('span',{staticClass:"kiwi-userbox-whois-line"},[_vm._v(_vm._s(_vm.$t('user_bot')))]):_vm._e(),_vm._v(" "),(_vm.user.helpop)?_c('span',{staticClass:"kiwi-userbox-whois-line"},[_vm._v("\n                "+_vm._s(_vm.$t('user_help'))+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.user.operator)?_c('span',{staticClass:"kiwi-userbox-whois-line"},[_vm._v("\n                "+_vm._s(_vm.$t('user_op'))+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.user.server)?_c('span',{staticClass:"kiwi-userbox-whois-line"},[_vm._v("\n                "+_vm._s(_vm.$t('user_server', {
                    server: _vm.user.server,
                    info: (_vm.user.server_info ? ("(" + (_vm.user.server_info) + ")") : '')
                }))+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.user.secure)?_c('span',{staticClass:"kiwi-userbox-whois-line"},[_vm._v("\n                "+_vm._s(_vm.$t('user_secure'))+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.user.channels)?_c('span',{staticClass:"kiwi-userbox-whois-line",domProps:{"innerHTML":_vm._s(_vm.$t('user_channels', {channels: _vm.userChannels}))},on:{"click":function($event){return _vm.onChannelsClick($event)}}}):_vm._e()]],2):_vm._e(),_vm._v(" "),(_vm.buffer.isChannel() && _vm.areWeAnOp && !_vm.isSelf)?_c('div',{staticClass:"kiwi-userbox-opactions"},[_c('form',{staticClass:"u-form",on:{"submit":function($event){$event.preventDefault();}}},[(_vm.isUserOnBuffer)?_c('label',[_vm._v("\n                "+_vm._s(_vm.$t('user_access'))+" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.userMode),expression:"userMode"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.userMode=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_vm._l((_vm.availableChannelModes),function(mode){return _c('option',{key:mode.mode,domProps:{"value":mode.mode}},[_vm._v("\n                        "+_vm._s(mode.description)+"\n                    ")])}),_vm._v(" "),_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$t('user_normal')))])],2)]):_vm._e(),_vm._v(" "),(_vm.isUserOnBuffer)?_c('label',[_c('button',{staticClass:"u-button u-button-secondary\n                           kiwi-userbox-opaction-kick kiwi-userbox-opaction",on:{"click":_vm.kickUser}},[_c('i',{staticClass:"fa fa-sign-out",attrs:{"aria-hidden":"true"}}),_vm._v("\n                    "+_vm._s(_vm.$t('user_kick'))+"\n                ")])]):_vm._e(),_vm._v(" "),_c('label',[_c('button',{staticClass:"u-button u-button-secondary\n                           kiwi-userbox-opaction-ban kiwi-userbox-opaction",on:{"click":_vm.banUser}},[_c('i',{staticClass:"fa fa-ban",attrs:{"aria-hidden":"true"}}),_vm._v("\n                    "+_vm._s(_vm.$t('user_ban'))+"\n                ")])]),_vm._v(" "),(_vm.isUserOnBuffer)?_c('label',[_c('button',{staticClass:"u-button u-button-secondary\n                           kiwi-userbox-opaction-kickban kiwi-userbox-opaction",on:{"click":_vm.kickbanUser}},[_c('i',{staticClass:"fa fa-exclamation-triangle",attrs:{"aria-hidden":"true"}}),_vm._v("\n                    "+_vm._s(_vm.$t('user_kickban'))+"\n                ")])]):_vm._e()])]):_vm._e()])}
var staticRenderFns = []


/***/ }),

/***/ "hqyo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _isNan = __webpack_require__("MICi");

var _isNan2 = _interopRequireDefault(_isNan);

var _Misc = __webpack_require__("uN9+");

var Misc = _interopRequireWildcard(_Misc);

var _ServerSelector = __webpack_require__("c9hT");

var _ServerSelector2 = _interopRequireDefault(_ServerSelector);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        ServerSelector: _ServerSelector2.default
    },
    props: ['network'],
    data: function data() {
        return {
            server_type: 'network',
            znc_username: '',
            znc_network: '',
            znc_password: '',
            show_advanced: false,
            switch_tabs_on_connect: false,
            network_list: []
        };
    },

    computed: {
        settingShowRaw: {
            get: function get() {
                return this.network.setting('show_raw');
            },
            set: function set(val) {
                return this.network.setting('show_raw', val);
            }
        },
        directWs: {
            get: function get() {
                if (!this.network.connection.direct) {
                    return '';
                }

                var connection = this.network.connection;
                var addr = '';
                addr += connection.tls ? 'wss://' : 'ws://';
                addr += connection.server;

                var port = parseInt(connection.port, 10);
                if ((0, _isNan2.default)(port)) {
                    port = connection.tls ? 443 : 80;
                }

                if (connection.tls && port !== 443 || !connection.tls && port !== 80) {
                    addr += ':' + connection.port;
                }

                addr += connection.path;

                return addr;
            },
            set: function set(newVal) {
                var url = null;

                try {
                    url = new URL(newVal);
                } catch (e) {
                    return;
                }

                var connection = this.network.connection;
                connection.tls = url.protocol.toLowerCase() === 'wss:';
                connection.server = url.hostname;

                var port = parseInt(url.port, 10);
                if ((0, _isNan2.default)(port)) {
                    port = url.protocol.toLowerCase() === 'wss:' ? 433 : 80;
                }

                connection.port = port;
                var u = url.href.replace(url.protocol + '//', '');
                connection.path = u.substr(u.indexOf('/'));
            }
        }
    },
    watch: {
        znc_username: function znc_username() {
            this.setZncPass();
        },
        znc_network: function znc_network() {
            this.setZncPass();
        },
        znc_password: function znc_password() {
            this.setZncPass();
        },
        'network.state': function networkState() {
            if (!this.switch_tabs_on_connect) {
                return;
            }

            if (this.network.state === 'connected') {
                this.switch_tabs_on_connect = false;
                this.$state.$emit('server.tab.show', 'messages');
            } else if (this.network.state_error) {
                this.switch_tabs_on_connect = false;
            }
        }
    },
    created: function created() {
        var isZnc = !!(this.network.password || '').match(/^(.*)\/(.*):(.*)$/);
        this.server_type = isZnc ? 'znc' : 'network';
        if (isZnc) {
            var match = (this.network.password || '').match(/^(.*)\/(.*):(.*)$/);
            this.znc_username = match[1] || '';
            this.znc_network = match[2] || '';
            this.znc_password = match[3] || '';
        }

        this.network_list = this.$state.setting('presetNetworks') || [];
    },

    methods: {
        readableStateError: function readableStateError(err) {
            return Misc.networkErrorMessage(err);
        },
        connect: function connect() {
            this.switch_tabs_on_connect = true;
            this.network.ircClient.connect();
        },
        reconnect: function reconnect() {
            this.network.ircClient.connect();
        },
        removeNetwork: function removeNetwork() {
            var confirmed = confirm('Really remove this network? This cannot be undone!');
            if (!confirmed) {
                return;
            }

            this.$state.removeNetwork(this.network.id);
            this.$state.$emit('active.component');
        },
        setZncPass: function setZncPass() {
            var newPass = this.znc_username + '/' + this.znc_network + ':' + this.znc_password;
            this.network.password = newPass;
        },
        toggleTls: function toggleTls() {
            var connection = this.network.connection;
            connection.tls = !connection.tls;

            if (connection.tls && connection.port === 6667) {
                connection.port = 6697;
            } else if (!connection.tls && connection.port === 6697) {
                connection.port = 6667;
            }
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["NetworkSettings"]
window._kiwi_exports.components.NetworkSettings = exports.default ? exports.default : exports;


/***/ }),

/***/ "iE6S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsAdvanced_vue__ = __webpack_require__("exRi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsAdvanced_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsAdvanced_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsAdvanced_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsAdvanced_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc7b78a4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsAdvanced_vue__ = __webpack_require__("K/tP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("9doY")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsAdvanced_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc7b78a4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsAdvanced_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc7b78a4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsAdvanced_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "iHm7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ib2o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageList_vue__ = __webpack_require__("jejM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageList_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageList_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageList_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28fa8dc3_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageList_vue__ = __webpack_require__("NhYT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("C4uO")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageList_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28fa8dc3_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28fa8dc3_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ik/t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Container_vue__ = __webpack_require__("cX0g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Container_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Container_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Container_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Container_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e6cd0cb_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Container_vue__ = __webpack_require__("CXnl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("fFqg")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Container_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e6cd0cb_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Container_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e6cd0cb_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Container_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "j/A4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createdInstance = null;

var ThemeManager = function () {
    function ThemeManager(state) {
        (0, _classCallCheck3.default)(this, ThemeManager);

        this.state = state;
        this.listenForIrcEvents();
        this.varsEl = null;
    }

    (0, _createClass3.default)(ThemeManager, [{
        key: 'themeVar',
        value: function themeVar(varName) {
            if (!this.varsEl) {
                this.varsEl = document.querySelector('.kiwi-wrap');
            }

            var styles = window.getComputedStyle(this.varsEl);
            var v = styles.getPropertyValue('--kiwi-' + varName);
            return (v || '').trim();
        }
    }, {
        key: 'availableThemes',
        value: function availableThemes() {
            return this.state.settings.themes;
        }
    }, {
        key: 'currentTheme',
        value: function currentTheme() {
            var state = this.state;
            var currentThemeName = state.setting('theme');
            currentThemeName = currentThemeName.toLowerCase();

            var theme = _lodash2.default.find(state.settings.themes, function (t) {
                var isMatch = t.name.toLowerCase() === currentThemeName;
                return isMatch;
            });

            if (!theme) {
                theme = state.settings.themes[0];
            }

            return theme;
        }
    }, {
        key: 'setTheme',
        value: function setTheme(theme) {
            var theTheme = null;

            if (typeof theme === 'string') {
                theTheme = _lodash2.default.find(this.availableThemes(), function (t) {
                    var isMatch = t.name.toLowerCase() === theme.toLowerCase();
                    return isMatch;
                });

                if (!theTheme) {
                    return;
                }
            } else {
                theTheme = theme;
            }

            this.state.setting('theme', theTheme.name);
            this.state.$emit('theme.change');
        }
    }, {
        key: 'reload',
        value: function reload() {
            var theme = this.currentTheme();
            if (!theme) {
                return;
            }

            var url = theme.url;
            if (url.indexOf('cb=') > -1) {
                url = url.replace(/cb=[0-9]+/, function () {
                    return 'cb=' + Date.now();
                });
            } else if (url.indexOf('?') > -1) {
                url += '&cb=' + Date.now();
            } else {
                url += '?cb=' + Date.now();
            }

            theme.url = url;
            this.state.$emit('theme.change');
        }
    }, {
        key: 'setCustomThemeUrl',
        value: function setCustomThemeUrl(url) {
            var theme = _lodash2.default.find(ThemeManager.instance().availableThemes(), {
                name: 'custom'
            });

            if (theme) {
                theme.url = url;
            }

            if (theme.name === 'custom') {
                this.state.$emit('theme.change');
            }
        }
    }, {
        key: 'listenForIrcEvents',
        value: function listenForIrcEvents() {
            var _this = this;

            this.state.$on('irc.ctcp request', function (event, network) {
                var ctcpType = (event.type || '').toLowerCase();
                if (ctcpType === 'kiwi' && event.message.indexOf('theme reload') > -1) {
                    _this.reload();
                }
            });
        }
    }], [{
        key: 'themeUrl',
        value: function themeUrl(theme) {
            var parts = theme.url.split('?');
            var url = parts[0];
            var qs = parts[1] || '';

            if (url[url.length - 1] !== '/') {
                url += '/';
            }
            return url + 'theme.css' + (qs ? '?' + qs : '');
        }
    }]);
    return ThemeManager;
}();

exports.default = ThemeManager;


ThemeManager.instance = function instance(state) {
    if (!createdInstance) {
        createdInstance = new ThemeManager(state);
    }

    return createdInstance;
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["ThemeManager"]
window._kiwi_exports.libs.ThemeManager = exports.default ? exports.default : exports;


/***/ }),

/***/ "j6jx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['network', 'user', 'toggle'],
    computed: {
        isUserSelf: function isUserSelf() {
            if (this.toggle === false) {
                return false;
            }
            var user = this.$state.getUser(this.network.id, this.network.nick);
            return this.user === user;
        },
        shouldShowStatus: function shouldShowStatus() {
            if (!this.$state.setting('showAwayStatusIndicators')) {
                return false;
            }

            if (this.network.state !== 'connected') {
                return false;
            }

            var awayNotifyEnabled = this.network.ircClient.network.cap.isEnabled('away-notify');
            return this.$state.setting('buffers.who_loop') || awayNotifyEnabled;
        }
    },
    methods: {
        toggleSelfAway: function toggleSelfAway() {
            if (this.isUserSelf) {
                var val = this.user.isAway();
                this.network.ircClient.raw('AWAY', val ? '' : 'Currently away');
            }
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["AwayStatusIndicator"]
window._kiwi_exports.components.AwayStatusIndicator = exports.default ? exports.default : exports;


/***/ }),

/***/ "j7Zd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jNsU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.fee66e7.woff";

/***/ }),

/***/ "jbL2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jc+x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('startup-layout',{ref:"layout",staticClass:"kiwi-welcome-simple",class:{ 'kiwi-welcome-simple--recaptcha': _vm.recaptchaSiteId },scopedSlots:_vm._u([(!_vm.network || _vm.network.state === 'disconnected')?{key:"connection",fn:function(){return [_c('form',{staticClass:"u-form u-form--big kiwi-welcome-simple-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.greetingText)}}),_vm._v(" "),(_vm.network && (_vm.network.last_error || _vm.network.state_error))?_c('div',{staticClass:"kiwi-welcome-simple-error"},[_vm._v("\n                We couldn't connect to the server :(\n                "),_c('span',[_vm._v("\n                    "+_vm._s(_vm.network.last_error || _vm.readableStateError(_vm.network.state_error))+"\n                ")])]):_vm._e(),_vm._v(" "),_c('input-text',{attrs:{"label":_vm.$t('nick'),"type":"text"},model:{value:(_vm.nick),callback:function ($$v) {_vm.nick=$$v},expression:"nick"}}),_vm._v(" "),(_vm.showPass && _vm.toggablePass)?_c('div',{staticClass:"kiwi-welcome-simple-input-container"},[_c('label',{staticClass:"kiwi-welcome-simple-have-password"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.show_password_box),expression:"show_password_box"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.show_password_box)?_vm._i(_vm.show_password_box,null)>-1:(_vm.show_password_box)},on:{"change":function($event){var $$a=_vm.show_password_box,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.show_password_box=$$a.concat([$$v]))}else{$$i>-1&&(_vm.show_password_box=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.show_password_box=$$c}}}}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t('password_have'))+" ")])])]):_vm._e(),_vm._v(" "),(_vm.showPass && (_vm.show_password_box || !_vm.toggablePass))?_c('div',{staticClass:"kiwi-welcome-simple-input-container"},[_c('input-text',{directives:[{name:"focus",rawName:"v-focus"}],attrs:{"show-plain-text":true,"label":_vm.$t('password'),"type":"password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1):_vm._e(),_vm._v(" "),(_vm.showChannel)?_c('div',{staticClass:"kiwi-welcome-simple-input-container"},[_c('input-text',{attrs:{"label":_vm.$t('channel')},model:{value:(_vm.channel),callback:function ($$v) {_vm.channel=$$v},expression:"channel"}})],1):_vm._e(),_vm._v(" "),(_vm.recaptchaSiteId)?_c('div',{staticClass:"g-recaptcha",attrs:{"data-sitekey":_vm.recaptchaSiteId}}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"u-button u-button-primary u-submit kiwi-welcome-simple-start",attrs:{"disabled":!_vm.readyToStart,"type":"submit"},domProps:{"innerHTML":_vm._s(_vm.buttonText)}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.footerText)}})],1)]},proxy:true}:{key:"connection",fn:function(){return [_c('i',{staticClass:"fa fa-spin fa-spinner",attrs:{"aria-hidden":"true"}})]},proxy:true}],null,true)})}
var staticRenderFns = []


/***/ }),

/***/ "jejM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _set = __webpack_require__("lHA8");

var _set2 = _interopRequireDefault(_set);

var _strftime = __webpack_require__("Sgar");

var _strftime2 = _interopRequireDefault(_strftime);

var _Logger = __webpack_require__("XNCV");

var _Logger2 = _interopRequireDefault(_Logger);

var _BufferKey = __webpack_require__("GLlb");

var _BufferKey2 = _interopRequireDefault(_BufferKey);

var _MessageListMessageCompact = __webpack_require__("9VuB");

var _MessageListMessageCompact2 = _interopRequireDefault(_MessageListMessageCompact);

var _MessageListMessageModern = __webpack_require__("F/FP");

var _MessageListMessageModern2 = _interopRequireDefault(_MessageListMessageModern);

var _MessageListMessageInline = __webpack_require__("05ce");

var _MessageListMessageInline2 = _interopRequireDefault(_MessageListMessageInline);

var _LoadingAnimation = __webpack_require__("rwPc");

var _LoadingAnimation2 = _interopRequireDefault(_LoadingAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__("4eMz");

var log = _Logger2.default.namespace('MessageList.vue');

var BOTTOM_SCROLL_MARGIN = 30;

exports.default = {
    components: {
        BufferKey: _BufferKey2.default,
        MessageListMessageModern: _MessageListMessageModern2.default,
        MessageListMessageCompact: _MessageListMessageCompact2.default,
        MessageListMessageInline: _MessageListMessageInline2.default,
        LoadingAnimation: _LoadingAnimation2.default
    },
    props: ['buffer'],
    data: function data() {
        return {
            auto_scroll: true,
            chathistoryAvailable: true,
            hover_nick: '',
            message_info_open: null,
            timeToClose: false,
            startClosing: false,
            selectedMessages: new _set2.default()
        };
    },

    computed: {
        thisMl: function thisMl() {
            return this;
        },
        listType: function listType() {
            if (this.$state.setting('messageLayout')) {
                log.info('Deprecation Warning: The config option \'messageLayout\' has been moved to buffers.messageLayout');
            }
            return this.buffer.setting('messageLayout') || this.$state.setting('messageLayout');
        },
        useExtraFormatting: function useExtraFormatting() {
            return this.buffer.setting('extra_formatting');
        },
        shouldShowChathistoryTools: function shouldShowChathistoryTools() {
            if (this.buffer.getNetwork().state !== 'connected') {
                return false;
            }

            var isCorrectBufferType = this.buffer.isChannel() || this.buffer.isQuery();
            var isSupported = !!this.buffer.getNetwork().ircClient.chathistory.isSupported();
            return isCorrectBufferType && isSupported && this.buffer.flags.chathistory_available;
        },
        shouldRequestChannelKey: function shouldRequestChannelKey() {
            return this.buffer.getNetwork().state === 'connected' && this.buffer.isChannel() && this.buffer.flags.channel_badkey;
        },
        ourNick: function ourNick() {
            return this.buffer ? this.buffer.getNetwork().nick : '';
        },
        filteredMessages: function filteredMessages() {
            var network = this.buffer.getNetwork();
            var currentNick = network.nick;
            var bufferMessages = this.buffer.getMessages();

            var ignoredVar = this.buffer.message_count;

            var messages = bufferMessages.slice(0, bufferMessages.length);
            messages.sort(function (a, b) {
                if (a.time > b.time) {
                    return 1;
                } else if (b.time > a.time) {
                    return -1;
                }

                return 0;
            });

            var list = [];
            var maxSize = this.buffer.setting('scrollback_size');
            var showJoinParts = this.buffer.setting('show_joinparts');
            var showTopics = this.buffer.setting('show_topics');
            var showNickChanges = this.buffer.setting('show_nick_changes');
            var showModeChanges = this.buffer.setting('show_mode_changes');
            for (var i = messages.length - 1; i >= 0 && list.length < maxSize; i--) {
                if (!showJoinParts && messages[i].type === 'traffic') {
                    continue;
                }
                if (!showTopics && messages[i].type === 'topic') {
                    continue;
                }
                if (!showNickChanges && messages[i].type === 'nick') {
                    continue;
                }
                if (!showModeChanges && messages[i].type === 'mode') {
                    continue;
                }

                if (messages[i].ignore) {
                    continue;
                }

                if (messages[i].type === 'connection' && i === 0) {
                    continue;
                }

                if (messages[i].type === 'topic' && messages[i - 1] && messages[i - 1].type === 'traffic' && messages[i - 1].nick === currentNick) {
                    list.push(messages[i - 1]);
                    list.push(messages[i]);
                    i--;
                } else {
                    list.push(messages[i]);
                }
            }

            return list.reverse();
        },
        shouldShowJoiningLoader: function shouldShowJoiningLoader() {
            return this.buffer.isChannel() && this.buffer.enabled && !this.buffer.joined && this.buffer.getNetwork().state === 'connected';
        }
    },
    watch: {
        buffer: function buffer(newBuffer) {
            if (!newBuffer) {
                return;
            }

            this.message_info_open = null;

            if (this.buffer.getNetwork().state === 'connected') {
                newBuffer.flags.has_opened = true;
            }

            this.scrollToBottom();
        },
        'buffer.message_count': function bufferMessage_count() {
            var _this = this;

            this.$nextTick(function () {
                _this.maybeScrollToBottom();
            });
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        this.addCopyListeners();

        this.$nextTick(function () {
            _this2.scrollToBottom();
        });

        this.listen(this.$state, 'mediaviewer.opened', function () {
            _this2.$nextTick(_this2.maybeScrollToBottom.apply(_this2));
        });

        this.listen(this.$state, 'messagelist.scrollto', function (opt) {
            if (opt && opt.id) {
                _this2.maybeScrollToId(opt.id);
            }
        });
    },

    methods: {
        isHoveringOverMessage: function isHoveringOverMessage(message) {
            return message.nick && message.nick.toLowerCase() === this.hover_nick.toLowerCase();
        },
        toggleMessageInfo: function toggleMessageInfo(message) {
            if (!message) {
                this.message_info_open = null;
            } else if (this.message_info_open === message) {} else if (this.canShowInfoForMessage(message)) {
                var sel = window.getSelection();
                if (sel.rangeCount > 0) {
                    var range = sel.getRangeAt(0);
                    if (range && !range.collapsed) {
                        return;
                    }
                }

                this.message_info_open = message;
                this.$nextTick(this.maybeScrollToBottom.bind(this));
            }
        },
        shouldShowUnreadMarker: function shouldShowUnreadMarker(idx) {
            var previous = this.filteredMessages[idx - 1];
            var current = this.filteredMessages[idx];
            var lastRead = this.buffer.last_read;

            if (!lastRead) {
                return false;
            }

            if (previous && previous.time < lastRead && current.time > lastRead) {
                return true;
            }

            return false;
        },
        shouldShowDateChangeMarker: function shouldShowDateChangeMarker(idx) {
            var previous = this.filteredMessages[idx - 1];
            var current = this.filteredMessages[idx];

            if (!previous) {
                return false;
            }

            if (new Date(previous.time).getDay() !== new Date(current.time).getDay()) {
                return true;
            }

            return false;
        },
        canShowInfoForMessage: function canShowInfoForMessage(message) {
            var showInfoForTypes = ['privmsg', 'notice', 'action'];
            return showInfoForTypes.indexOf(message.type) > -1;
        },
        bufferSetting: function bufferSetting(key) {
            return this.buffer.setting(key);
        },
        formatTime: function formatTime(time) {
            return (0, _strftime2.default)(this.buffer.setting('timestamp_format') || '%T', new Date(time));
        },
        formatTimeFull: function formatTimeFull(time) {
            var format = this.buffer.setting('timestamp_full_format');
            return format ? (0, _strftime2.default)(format, new Date(time)) : new Date(time).toLocaleString();
        },
        formatMessage: function formatMessage(message) {
            return message.toHtml(this);
        },
        isMessageHighlight: function isMessageHighlight(message) {
            if (message.type === 'traffic') {
                return false;
            }

            return message.isHighlight;
        },
        userColour: function userColour(user) {
            if (user && this.bufferSetting('colour_nicknames_in_messages')) {
                return user.getColour();
            }
            return '';
        },
        openUserBox: function openUserBox(nick) {
            var user = this.$state.getUser(this.buffer.networkid, nick);
            if (user) {
                this.$state.$emit('userbox.show', user, {
                    buffer: this.buffer
                });
            }
        },
        onListClick: function onListClick(event) {
            this.toggleMessageInfo();
        },
        onMessageDblClick: function onMessageDblClick(event, message) {
            clearTimeout(this.messageClickTmr);

            var userNick = event.target.getAttribute('data-nick');
            if (userNick) {
                this.$state.$emit('input.insertnick', userNick);
            }
        },
        onMessageClick: function onMessageClick(event, message, delay) {
            if (delay && event.target.getAttribute('data-nick')) {
                clearTimeout(this.messageClickTmr);
                this.messageClickTmr = setTimeout(this.onMessageClick, 200, event, message, false);
                return;
            }

            var isLink = event.target.tagName === 'A';

            var channelName = event.target.getAttribute('data-channel-name');
            if (channelName && isLink) {
                var network = this.buffer.getNetwork();
                this.$state.addBuffer(this.buffer.networkid, channelName);
                network.ircClient.join(channelName);
                this.$state.setActiveBuffer(this.buffer.networkid, channelName);
                return;
            }

            var userNick = event.target.getAttribute('data-nick');
            if (userNick && isLink) {
                this.openUserBox(userNick);
                return;
            }

            var url = event.target.getAttribute('data-url');
            if (url && isLink) {
                this.$state.$emit('mediaviewer.show', url);
            }

            if (this.message_info_open && this.message_info_open !== message) {
                this.toggleMessageInfo();
                event.preventDefault();
                return;
            }

            if (this.$state.ui.is_touch && this.$state.setting('buffers.show_message_info')) {
                if (this.canShowInfoForMessage(message) && event.target.nodeName === 'A') {
                    event.preventDefault();
                }

                this.toggleMessageInfo(message);
            }
        },
        onThreadScroll: function onThreadScroll() {
            var el = this.$el;
            var scrolledUpByPx = el.scrollHeight - (el.offsetHeight + el.scrollTop);

            if (scrolledUpByPx > BOTTOM_SCROLL_MARGIN) {
                this.auto_scroll = false;
            } else {
                this.auto_scroll = true;
            }
        },
        scrollToBottom: function scrollToBottom() {
            this.$el.scrollTop = this.$el.scrollHeight;
        },
        maybeScrollToBottom: function maybeScrollToBottom() {
            if (this.auto_scroll) {
                this.$el.scrollTop = this.$el.scrollHeight;
            }
        },
        maybeScrollToId: function maybeScrollToId(id) {
            var messageElement = this.$el.querySelector('.kiwi-messagelist-message[data-message-id="' + id + '"]');
            if (messageElement && messageElement.offsetTop) {
                this.$el.scrollTop = messageElement.offsetTop;
                this.auto_scroll = false;
            }
        },
        restrictTextSelection: function restrictTextSelection() {
            document.querySelector('body').classList.add('kiwi-unselectable');
            this.$el.style.userSelect = 'text';
        },
        unrestrictTextSelection: function unrestrictTextSelection() {
            document.querySelector('body').classList.remove('kiwi-unselectable');
            this.$el.style.userSelect = 'auto';
        },
        removeSelections: function removeSelections() {
            var removeNative = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            this.selectedMessages = new _set2.default();

            var selection = document.getSelection();
            if (removeNative && selection) {
                selection.removeAllRanges();
            }
        },
        addCopyListeners: function addCopyListeners() {
            var _this3 = this;

            var LogFormatter = function LogFormatter(msg) {
                var text = '';

                switch (msg.type) {
                    case 'privmsg':
                        text = '<' + msg.nick + '> ' + msg.message;
                        break;
                    case 'nick':
                    case 'mode':
                    case 'action':
                    case 'traffic':
                        text = '' + msg.message;
                        break;
                    default:
                        text = msg.message;
                }
                if (text.length) {
                    return '[' + new Date(msg.time).toLocaleTimeString({ hour: '2-digit', minute: '2-digit', second: '2-digit' }) + '] ' + text;
                }
                return null;
            };

            var copyData = '';
            var selecting = false;

            this.listen(document, 'mouseup', function (e) {
                _this3.unrestrictTextSelection();
                if (selecting) {
                    e.preventDefault();
                }
                selecting = false;
            });

            this.listen(document, 'selectionchange', function (e) {
                if (!_this3.$el) {
                    return true;
                }

                copyData = '';

                var selection = document.getSelection();

                if (!selection || !selection.anchorNode || !selection.anchorNode.parentNode.closest('.' + _this3.$el.className)) {
                    _this3.unrestrictTextSelection();
                    _this3.removeSelections();
                    return true;
                }

                _this3.removeSelections();

                _this3.restrictTextSelection();
                if (selection.rangeCount > 0) {
                    selecting = true;
                    var firstRange = selection.getRangeAt(0);
                    var lastRange = selection.getRangeAt(selection.rangeCount - 1);

                    var startNode = firstRange.startContainer.parentNode.closest('[data-message-id]');
                    var endNode = lastRange.endContainer.parentNode.closest('[data-message-id]');
                    if (!endNode) {
                        endNode = _this3.$el.querySelector('.kiwi-messagelist-item:last-child');
                    }
                    if (!startNode || !endNode || startNode === endNode) {
                        return true;
                    }

                    var node = startNode;
                    var messages = [];
                    var allMessages = _this3.buffer.getMessages();

                    var finder = function finder(m) {
                        return m.id.toString() === node.attributes['data-message-id'].value;
                    };

                    var i = 0;
                    while (node) {
                        var msg = allMessages.find(finder);

                        _this3.selectedMessages.add(msg.id);
                        if (msg) {
                            messages.push(msg);
                        }
                        if (node === endNode) {
                            node = null;
                        } else {
                            var nextNode = node.closest('[data-message-id]').parentNode.nextElementSibling;
                            node = nextNode && nextNode.querySelector('[data-message-id]');
                        }
                    }

                    _this3.selectedMessages = new _set2.default(_this3.selectedMessages);

                    copyData = messages.sort(function (a, b) {
                        return a.time > b.time ? 1 : -1;
                    }).filter(function (m) {
                        return m.message.trim().length;
                    }).map(LogFormatter).join('\r\n');
                } else {
                    _this3.unrestrictTextSelection();
                }
                return false;
            });

            this.listen(document, 'copy', function (e) {
                if (!copyData || !copyData.length) {
                    return true;
                }

                if (navigator.clipboard) {
                    navigator.clipboard.writeText(copyData);
                } else {
                    var input = document.createElement('textarea');
                    document.body.appendChild(input);
                    input.innerHTML = copyData;
                    input.select();
                    document.execCommand('copy');
                    document.body.removeChild(input);
                }
                _this3.removeSelections(true);
                return true;
            });
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["MessageList"]
window._kiwi_exports.components.MessageList = exports.default ? exports.default : exports;


/***/ }),

/***/ "jnb6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _toConsumableArray2 = __webpack_require__("Gu7T");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.create = create;

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _strftime = __webpack_require__("Sgar");

var _strftime2 = _interopRequireDefault(_strftime);

var _ircFramework = __webpack_require__("k4vc");

var _ircFramework2 = _interopRequireDefault(_ircFramework);

var _TextFormatting = __webpack_require__("15gS");

var TextFormatting = _interopRequireWildcard(_TextFormatting);

var _IrcdDiffs = __webpack_require__("1gJW");

var IrcdDiffs = _interopRequireWildcard(_IrcdDiffs);

var _TypingMiddleware = __webpack_require__("wmYr");

var _TypingMiddleware2 = _interopRequireDefault(_TypingMiddleware);

var _ChathistoryMiddleware = __webpack_require__("G7fu");

var _ChathistoryMiddleware2 = _interopRequireDefault(_ChathistoryMiddleware);

var _ServerConnection = __webpack_require__("wyE3");

var ServerConnection = _interopRequireWildcard(_ServerConnection);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function create(state, network) {
    var networkid = network.id;

    var clientOpts = {
        host: network.connection.server,
        port: network.connection.port,
        tls: network.connection.tls,
        path: network.connection.path,
        password: network.password,
        nick: network.nick,
        username: network.username || network.nick,
        gecos: network.gecos || 'https://kiwiirc.com/',
        version: null,
        auto_reconnect: false,
        encoding: network.connection.encoding
    };

    var ircClient = new _ircFramework2.default.Client(clientOpts);
    ircClient.requestCap('znc.in/self-message');

    ircClient.requestCap('message-tags');
    ircClient.use((0, _ChathistoryMiddleware2.default)());
    ircClient.use(clientMiddleware(state, network));
    ircClient.use((0, _TypingMiddleware2.default)());

    var originalIrcClientConnect = ircClient.connect;
    ircClient.connect = function connect() {
        ircClient.options.host = network.connection.server;
        ircClient.options.port = network.connection.port;
        ircClient.options.tls = network.connection.tls;
        ircClient.options.path = network.connection.path;
        ircClient.options.password = network.password;
        ircClient.options.nick = network.connection.nick;
        ircClient.options.username = network.username || network.connection.nick;
        ircClient.options.gecos = network.gecos || 'https://kiwiirc.com/';
        ircClient.options.encoding = network.connection.encoding;

        state.$emit('network.connecting', { network: network });

        if (!network.connection.direct) {
            ircClient.options.transport = ServerConnection.createChannelConstructor(state.settings.kiwiServer, (window.location.hash || '').substr(1), networkid);
        } else {
            ircClient.options.transport = undefined;
        }

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        originalIrcClientConnect.apply(ircClient, args);
    };

    ircClient.on('raw', function (event) {
        if (!network.setting('show_raw') && !state.setting('showRaw')) {
            return;
        }

        var buffer = state.getOrAddBufferByName(networkid, '*raw');
        state.addMessage(buffer, {
            time: Date.now(),
            nick: '',
            message: (event.from_server ? '[S] ' : '[C] ') + event.line
        });
    });

    ircClient.on('typing', function (event) {
        var user = state.getUser(network.id, event.nick);
        if (user) {
            user.typingStatus(event.target, event.status);
        }
    });

    return ircClient;
}

function clientMiddleware(state, network) {
    var networkid = network.id;

    var numConnects = 0;
    var isRegistered = false;

    return function middlewareFn(client, rawEvents, parsedEvents) {
        parsedEvents.use(parsedEventsHandler);
        rawEvents.use(rawEventsHandler);

        client.on('connecting', function () {
            network.state_error = '';
            network.state = 'connecting';
            network.last_error = '';
            network.last_error_numeric = 0;
        });

        client.on('connected', function () {
            network.state_error = '';
            network.state = 'connected';

            network.buffers.forEach(function (buffer) {
                if (!buffer) {
                    return;
                }

                var messageBody = TextFormatting.formatText('network_connected', {
                    text: TextFormatting.t('connected')
                });

                state.addMessage(buffer, {
                    time: Date.now(),
                    nick: '',
                    message: messageBody,
                    type: 'connection',
                    type_extra: 'connected'
                });
            });
        });

        client.on('socket close', function (err) {
            isRegistered = false;
            network.state = 'disconnected';
            network.state_error = err || '';

            network.buffers.forEach(function (buffer) {
                if (!buffer) {
                    return;
                }

                buffer.joined = false;
                buffer.clearUsers();

                var messageBody = TextFormatting.formatText('network_disconnected', {
                    text: TextFormatting.t('disconnected')
                });

                state.addMessage(buffer, {
                    time: Date.now(),
                    nick: '',
                    message: messageBody,
                    type: 'connection',
                    type_extra: 'disconnected'
                });
            });
        });

        client.on('socket connected', function () {
            if (network.captchaResponse) {
                client.raw('CAPTCHA', network.captchaResponse);
            }
        });
    };

    function rawEventsHandler(command, event, rawLine, client, next) {
        if (command === '002') {
            var param = event.params[1] || '';
            var m = param.match(/running version (.*)$/);
            network.ircd = m ? m[1] : '';
        }

        state.$emit('irc.raw', command, event, network);
        state.$emit('irc.raw.' + command, command, event, network);

        if (command === '904') {
            if (state.setting('disconnectOnSaslFail')) {
                network.ircClient.connection.end();
                network.last_error = 'Invalid login';
            }

            var serverBuffer = network.serverBuffer();
            state.addMessage(serverBuffer, {
                time: Date.now(),
                nick: '*',
                message: 'Invalid login'
            });
        }

        if (command === 'CAP' && network.setting('show_raw_caps')) {
            var params = [].concat((0, _toConsumableArray3.default)(event.params));
            if (params[params.length - 1].indexOf(' ') > -1) {
                params[params.length - 1] = ':' + params[params.length - 1];
            }

            var buffer = network.serverBuffer();
            state.addMessage(buffer, {
                time: Date.now(),
                nick: '',
                message: event.command + ' ' + params.join(' ')
            });
        }

        next();
    }

    function parsedEventsHandler(command, event, client, next) {
        var ircEventObj = { handled: false };
        state.$emit('irc.' + command, event, network, ircEventObj);
        if (ircEventObj.handled) {
            next();
            return;
        }

        if (event && event.command === 'CONTROL') {
            next();
            return;
        }

        var eventTime = event && event.time ? network.ircClient.network.timeToLocal(event.time) : Date.now();
        var serverTime = event && event.time || 0;

        if (command === 'channel_redirect') {
            var b = network.bufferByName(event.from);
            if (b) {
                b.flags.redirect_to = event.to;
            }
        }

        if (command === 'registered') {
            isRegistered = true;
            network.nick = event.nick;
            state.addUser(networkid, { nick: event.nick, username: client.user.username });

            var serverBuffer = network.serverBuffer();
            state.addMessage(serverBuffer, {
                time: Date.now(),
                nick: '',
                message: TextFormatting.t('connected_to', { network: client.network.name })
            });

            client.raw('WHO ' + event.nick);

            if (network.auto_commands) {
                network.auto_commands.split('\n').forEach(function (line) {
                    state.$emit('input.raw', line[0] === '/' ? line : '/' + line);
                });
            }

            if (!network.connection.bncname) {
                network.buffers.forEach(function (buffer) {
                    if (buffer.isChannel() && buffer.enabled) {
                        client.join(buffer.name, buffer.key);
                    }
                });
            }

            numConnects++;
        }

        if (command === 'server options') {
            if (client.network.name !== 'Network') {
                network.name = client.network.name;
            }
        }

        if (command === 'unknown command') {
            if (event.command === '486') {
                var targetNick = event.params[1];
                var buffer = state.getOrAddBufferByName(network.id, targetNick);
                state.addMessage(buffer, {
                    time: Date.now(),
                    nick: '*',
                    message: event.params[2],
                    type: 'error'
                });
            } else {
                var _buffer = network.serverBuffer();
                var message = '';

                if (!event.command.match(/^\d+$/)) {
                    message += event.command + ' ';
                }

                var containsNick = event.params[0] === network.ircClient.user.nick;
                var isChannelMessage = network.isChannelName(event.params[1]);

                if (containsNick && isChannelMessage) {
                    var channelBuffer = network.bufferByName(event.params[1]);
                    if (channelBuffer) {
                        _buffer = channelBuffer;
                    }
                    message += event.params.slice(2).join(', ');
                } else if (containsNick) {
                    message += event.params.slice(1).join(', ');
                } else {
                    message += event.params.join(', ');
                }

                state.addMessage(_buffer, {
                    nick: '',
                    message: message
                });
            }
        }

        if (command === 'message') {
            var isPrivateMessage = false;
            var bufferName = event.from_server ? '*' : event.target;

            if (!event.from_server && event.target === client.user.nick) {
                isPrivateMessage = true;
                bufferName = event.nick;
            }

            if (event.nick.toLowerCase() === 'chanserv' && isPrivateMessage && event.message[0] === '[') {
                bufferName = event.message.substr(1, event.message.indexOf(']') - 1);
            }

            if (event.type === 'notice') {
                var existingBuffer = state.getBufferByName(networkid, bufferName);
                var noticeActiveBuffer = state.setting('noticeActiveBuffer');
                var activeBuffer = state.getActiveBuffer();
                var hasActiveBuffer = activeBuffer && activeBuffer.networkid === networkid;

                if (!existingBuffer) {
                    if (noticeActiveBuffer && hasActiveBuffer) {
                        bufferName = activeBuffer.name;
                    } else {
                        bufferName = '*';
                    }
                }
            }

            var PM_BLOCK_BLOCKED = false;

            var PM_BLOCK_REQUIRES_CHECK = null;

            var pmBlock = network.isNickExemptFromPmBlocks(event.nick);
            var blockNewPms = state.setting('buffers.block_pms');
            var _buffer2 = state.getBufferByName(networkid, bufferName);

            var textFormatType = 'privmsg';
            if (event.type === 'action') {
                textFormatType = 'action';
            } else if (event.type === 'notice') {
                textFormatType = 'notice';
            }

            var messageBody = TextFormatting.formatText(textFormatType, {
                nick: event.nick,
                username: event.ident,
                host: event.hostname,
                text: event.message
            });

            var _message = {
                time: eventTime,
                server_time: serverTime,
                nick: event.nick,
                message: messageBody,
                type: event.type,
                tags: event.tags || {}
            };

            if (blockNewPms && isPrivateMessage && !_buffer2 && pmBlock === PM_BLOCK_BLOCKED) {
                return;
            }

            if (blockNewPms && isPrivateMessage && !_buffer2 && pmBlock === PM_BLOCK_REQUIRES_CHECK) {
                var awaitingWhois = !!_lodash2.default.find(network.pendingPms, { nick: event.nick });
                network.pendingPms.push({ bufferName: bufferName, message: _message });

                if (awaitingWhois) {
                    return;
                }

                network.ircClient.whois(event.nick, event.nick, function (whoisData) {
                    network.pendingPms.forEach(function (pm, idx, obj) {
                        var nickLower = pm.message.nick.toLowerCase();
                        if (nickLower === whoisData.nick.toLowerCase()) {
                            if (whoisData.operator) {
                                _buffer2 = state.getOrAddBufferByName(network.id, pm.bufferName);
                                state.addMessage(_buffer2, pm.message);
                            }
                            obj.splice(idx, 1);
                        }
                    });
                });

                return;
            }

            if (!_buffer2) {
                _buffer2 = state.getOrAddBufferByName(networkid, bufferName);
            }
            state.addMessage(_buffer2, _message);
        }

        if (command === 'wallops') {
            var _buffer3 = state.getOrAddBufferByName(networkid, '*');
            var _messageBody = TextFormatting.formatText('wallops', {
                text: event.message
            });

            state.addMessage(_buffer3, {
                time: eventTime,
                server_time: serverTime,
                nick: event.nick,
                message: _messageBody,
                type: 'wallops'
            });
        }

        if (command === 'join') {
            if (event.nick === client.user.nick) {
                network.buffers.forEach(function (b) {
                    if ((b.flags.redirect_to || '').toLowerCase() === event.channel.toLowerCase()) {
                        state.$delete(b.flags, 'redirect_to');
                        b.rename(event.channel);
                    }
                });
            }

            var _buffer4 = state.getOrAddBufferByName(networkid, event.channel);

            if (_buffer4.name !== event.channel) {
                _buffer4.rename(event.channel);
            }

            state.addUserToBuffer(_buffer4, {
                nick: event.nick,
                username: event.ident,
                host: event.hostname,
                realname: event.gecos,
                account: event.account || ''
            });

            if (event.nick === client.user.nick) {
                _buffer4.enabled = true;
                _buffer4.joined = true;
                _buffer4.flags.channel_badkey = false;
                network.ircClient.raw('MODE', event.channel);
                network.ircClient.who(event.channel);
            }

            var nick = _buffer4.setting('show_hostnames') ? TextFormatting.formatUserFull(event) : TextFormatting.formatUser(event);

            var _messageBody2 = TextFormatting.formatAndT('channel_join', null, 'has_joined', { nick: nick });

            state.addMessage(_buffer4, {
                time: Date.now(),
                nick: event.nick,
                message: _messageBody2,
                type: 'traffic',
                type_extra: 'join'
            });
        }
        if (command === 'kick') {
            var _buffer5 = state.getOrAddBufferByName(networkid, event.channel);
            state.removeUserFromBuffer(_buffer5, event.kicked);

            var _messageBody3 = '';

            if (event.kicked === client.user.nick) {
                _buffer5.joined = false;
                _buffer5.clearUsers();

                _messageBody3 = TextFormatting.formatAndT('channel_selfkick', { reason: event.message }, 'kicked_you_from', {
                    nick: TextFormatting.formatUser(event),
                    channel: event.channel
                });
            } else {
                _messageBody3 = TextFormatting.formatAndT('channel_kicked', { reason: event.message }, 'was_kicked_from', {
                    nick: event.kicked,
                    channel: event.channel,
                    chanop: TextFormatting.formatUser(event.nick)
                });
            }

            state.addMessage(_buffer5, {
                time: Date.now(),
                nick: event.nick,
                message: _messageBody3,
                type: 'traffic',
                type_extra: 'kick'
            });
        }
        if (command === 'part') {
            var _buffer6 = state.getBufferByName(networkid, event.channel);
            if (!_buffer6) {
                return;
            }

            state.removeUserFromBuffer(_buffer6, event.nick);
            if (event.nick === client.user.nick) {
                _buffer6.joined = false;
                _buffer6.enabled = false;
                _buffer6.clearUsers();
            }

            var remainingBuffers = state.getBuffersWithUser(networkid, event.nick);
            if (remainingBuffers.length === 0) {
                state.removeUser(networkid, {
                    nick: event.nick
                });
            }

            var _nick = _buffer6.setting('show_hostnames') ? TextFormatting.formatUserFull(event) : TextFormatting.formatUser(event);

            var _messageBody4 = TextFormatting.formatAndT('channel_part', { reason: event.message }, 'has_left', { nick: _nick });

            state.addMessage(_buffer6, {
                time: Date.now(),
                nick: event.nick,
                message: _messageBody4,
                type: 'traffic',
                type_extra: 'part'
            });
        }
        if (command === 'quit') {
            var buffers = state.getBuffersWithUser(networkid, event.nick);

            buffers.forEach(function (buffer) {
                if (!buffer) {
                    return;
                }

                if (event.nick === client.user.nick) {
                    buffer.joined = false;
                    buffer.clearUsers();
                }

                var nick = buffer.setting('show_hostnames') ? TextFormatting.formatUserFull(event) : TextFormatting.formatUser(event);

                var messageBody = TextFormatting.formatAndT('channel_quit', { reason: event.message }, 'has_left', { nick: nick });

                state.addMessage(buffer, {
                    time: Date.now(),
                    nick: event.nick,
                    message: messageBody,
                    type: 'traffic',
                    type_extra: 'quit'
                });
            });

            state.removeUser(networkid, {
                nick: event.nick
            });
        }

        if (command === 'invite') {
            var _buffer7 = network.serverBuffer();
            state.addMessage(_buffer7, {
                nick: '*',
                message: TextFormatting.t('invited_you', {
                    nick: event.nick,
                    channel: event.channel
                })
            });
        }

        if (command === 'account') {
            state.addUser(networkid, { nick: event.nick, account: event.account || '' });
        }

        if (command === 'whois') {
            var obj = {
                nick: event.nick,
                host: event.hostname,
                username: event.ident,
                away: event.away || '',
                realname: event.real_name,
                hasWhois: true
            };

            ['actual_host', 'helpop', 'bot', 'server', 'server_info', 'operator', 'channels', 'modes', 'idle', 'logon', 'registered_nick', 'account', 'secure', 'special'].forEach(function (prop) {
                if (typeof event[prop] !== 'undefined') {
                    obj[prop] = event[prop];
                }
            });

            state.addUser(networkid, obj);
        }

        if (command === 'away') {
            state.addUser(networkid, {
                nick: event.nick,
                away: event.message || ''
            });
            var _buffer8 = state.getActiveBuffer();
            if (_buffer8 && event.nick === network.nick) {
                network.away = 'away';
                state.addMessage(_buffer8, {
                    time: eventTime,
                    server_time: serverTime,
                    nick: '*',
                    type: 'presence',
                    message: event.message
                });
            }
        }

        if (command === 'back') {
            state.addUser(networkid, {
                nick: event.nick,
                away: ''
            });
            var _buffer9 = state.getActiveBuffer();
            if (_buffer9 && event.nick === network.nick) {
                network.away = '';
                state.addMessage(_buffer9, {
                    time: eventTime,
                    server_time: serverTime,
                    nick: '*',
                    type: 'presence',
                    message: event.message
                });
            }
        }

        if (command === 'wholist') {
            state.usersTransaction(networkid, function (users) {
                event.users.forEach(function (user) {
                    var userObj = {
                        nick: user.nick,
                        host: user.hostname || undefined,
                        username: user.ident || undefined,
                        away: user.away ? 'Away' : '',
                        realname: user.real_name,
                        account: user.account || undefined
                    };
                    state.addUser(networkid, userObj, users);
                });
            });
        }

        if (command === 'channel list start') {
            network.channel_list_cache = [];
            network.channel_list_state = 'updating';
        }
        if (command === 'channel list') {
            network.channel_list_state = 'updating';

            var filteredEvent = _lodash2.default.filter(event, function (o) {
                return o.channel !== '*';
            });

            network.channel_list_cache = (network.channel_list_cache || []).concat(filteredEvent);
        }
        if (command === 'channel list end') {
            network.channel_list = network.channel_list_cache || [];
            network.channel_list_state = 'updated';
            delete network.channel_list_cache;
        }

        if (command === 'motd') {
            var _buffer10 = network.serverBuffer();
            var _messageBody5 = TextFormatting.formatText('motd', {
                text: event.motd
            });
            state.addMessage(_buffer10, {
                time: eventTime,
                server_time: serverTime,
                nick: '',
                message: _messageBody5,
                type: 'motd'
            });
        }

        if (command === 'nick in use' && !client.connection.registered) {
            var newNick = client.user.nick + rand(1, 100);
            var _messageBody6 = TextFormatting.formatAndT('nickname_alreadyinuse', null, 'nick_in_use_retrying', { nick: client.user.nick, newnick: newNick });

            network.buffers.forEach(function (b) {
                state.addMessage(b, {
                    time: Date.now(),
                    nick: '',
                    message: _messageBody6,
                    type: 'error'
                });
            });

            client.changeNick(newNick);
        }

        if (command === 'nick in use' && client.connection.registered) {
            var _buffer11 = state.getActiveBuffer();
            _buffer11 && state.addMessage(_buffer11, {
                time: Date.now(),
                nick: '',
                type: 'error',
                message: 'The nickname \'' + event.nick + '\' is already in use!'
            });
        }

        if (command === 'nick') {
            if (event.nick === client.user.nick) {
                network.nick = event.new_nick;
            }

            state.changeUserNick(networkid, event.nick, event.new_nick);

            var _messageBody7 = TextFormatting.formatAndT('nick_changed', null, 'now_known_as', { nick: event.nick, newnick: event.new_nick });

            var _buffers = state.getBuffersWithUser(networkid, event.new_nick);
            _buffers.forEach(function (buffer) {
                state.addMessage(buffer, {
                    time: eventTime,
                    server_time: serverTime,
                    nick: '',
                    message: _messageBody7,
                    type: 'nick'
                });
            });
        }

        if (command === 'userlist') {
            var _buffer12 = state.getOrAddBufferByName(networkid, event.channel);
            var hadExistingUsers = (0, _keys2.default)(_buffer12.users).filter(function (u) {
                return u !== network.ircClient.user.nick;
            }).length > 0;
            var users = [];
            event.users.forEach(function (user) {
                users.push({
                    user: {
                        nick: user.nick,
                        username: user.ident,
                        hostname: user.hostname
                    },
                    modes: user.modes
                });
            });
            state.addMultipleUsersToBuffer(_buffer12, users);

            if (!hadExistingUsers && network.ircClient.chathistory.isSupported()) {
                var correctBuffer = _buffer12.isChannel() || _buffer12.isQuery();

                if (correctBuffer) {
                    _buffer12.requestLatestScrollback();
                }
            }
        }

        if (command === 'channel info') {
            var _buffer13 = network.bufferByName(event.channel);
            if (!_buffer13) {
                return;
            }

            if (event.modes) {
                var modeStrs = [];

                event.modes.forEach(function (mode) {
                    var adding = mode.mode[0] === '+';
                    var modeChar = mode.mode.substr(1);

                    if (adding) {
                        state.$set(_buffer13.modes, modeChar, mode.param);
                    } else if (!adding) {
                        state.$delete(_buffer13.modes, modeChar);
                    }

                    modeStrs.push(mode.mode + (mode.param ? ' ' + mode.param : ''));
                });

                if (_buffer13.flags.requested_modes) {
                    state.addMessage(_buffer13, {
                        time: eventTime,
                        server_time: serverTime,
                        nick: '*',
                        message: _buffer13.name + ' ' + modeStrs.join(', ')
                    });
                }
            }

            if (event.created_at) {
                _buffer13.created_at = new Date(event.created_at * 1000);
            }

            if (event.created_at && _buffer13.flags.requested_modes) {
                var tFormat = _buffer13.setting('timestamp_full_format');
                var timeCreated = tFormat ? (0, _strftime2.default)(tFormat, new Date(event.created_at * 1000)) : new Date(event.created_at * 1000).toLocaleString();

                state.addMessage(_buffer13, {
                    time: eventTime,
                    server_time: serverTime,
                    nick: '*',
                    message: _buffer13.name + ' ' + timeCreated
                });
            }
        }

        if (command === 'mode') {
            var _buffer14 = network.bufferByName(event.target);
            var _modeStrs = {};
            if (_buffer14) {
                event.modes.forEach(function (mode) {
                    _modeStrs[mode.mode] = _modeStrs[mode.mode] || [];

                    var prefix = _lodash2.default.find(network.ircClient.network.options.PREFIX, {
                        mode: mode.mode[1]
                    });

                    if (prefix) {
                        var user = state.getUser(network.id, mode.param);
                        if (user) {
                            var adding = mode.mode[0] === '+';
                            var modes = user.buffers[_buffer14.id].modes;
                            var modeIdx = modes.indexOf(prefix.mode);

                            if (adding && modeIdx === -1) {
                                modes.push(prefix.mode);
                            } else if (!adding && modeIdx > -1) {
                                modes.splice(modeIdx, 1);
                            }
                        }

                        _modeStrs[mode.mode].push({ target: mode.param });
                    } else {
                        var _adding = mode.mode[0] === '+';
                        var modeChar = mode.mode.substr(1);

                        if (_adding) {
                            state.$set(_buffer14.modes, modeChar, mode.param);
                        } else if (!_adding) {
                            state.$delete(_buffer14.modes, modeChar);
                        }

                        _modeStrs[mode.mode].push({ target: _buffer14.name, param: mode.param });
                    }
                });

                var modeLocaleIds = {
                    '+o': 'modes_give_ops',
                    '-o': 'modes_take_ops',
                    '+h': 'modes_give_halfops',
                    '-h': 'modes_take_halfops',
                    '+v': 'modes_give_voice',
                    '-v': 'modes_take_voice',
                    '+a': 'modes_give_admin',
                    '-a': 'modes_take_admin',
                    '+q': 'modes_give_owner',
                    '-q': 'modes_take_owner',
                    '+b': 'modes_gives_ban',
                    '-b': 'modes_takes_ban'
                };

                if (!IrcdDiffs.isQChannelModeOwner(network)) {
                    delete modeLocaleIds['+q'];
                    delete modeLocaleIds['-q'];
                }
                if (!IrcdDiffs.isAChannelModeAdmin(network)) {
                    delete modeLocaleIds['+a'];
                    delete modeLocaleIds['-a'];
                }
                if (!IrcdDiffs.supportsHalfOp(network)) {
                    delete modeLocaleIds['+h'];
                    delete modeLocaleIds['-h'];
                }

                var modeLocaleDataBuilders = {
                    default: function _default(targets, mode) {
                        return {
                            mode: mode + (targets[0].param ? ' ' + targets[0].param : ''),
                            target: targets.map(function (t) {
                                return t.target;
                            }).join(', '),
                            nick: event.nick
                        };
                    },
                    b: function b(targets, mode) {
                        return {
                            mode: mode,
                            target: targets[0].param ? targets[0].param : '',
                            nick: event.nick
                        };
                    }
                };

                _lodash2.default.each(_modeStrs, function (targets, mode) {
                    var builders = modeLocaleDataBuilders;
                    var localeDataFn = builders[mode[1]] || builders.default;
                    var localeData = localeDataFn(targets, mode);

                    var localeKey = modeLocaleIds[mode] || 'modes_other';
                    var text = TextFormatting.t(localeKey, localeData);

                    var messageBody = TextFormatting.formatText('mode', {
                        nick: event.nick,
                        username: event.ident,
                        host: event.hostname,
                        target: targets.map(function (t) {
                            return t.target;
                        }).join(', '),
                        text: text
                    });
                    state.addMessage(_buffer14, {
                        time: eventTime,
                        server_time: serverTime,
                        nick: '',
                        message: messageBody,
                        type: 'mode'
                    });
                });
            } else {
                var modeslines = {};

                event.modes.forEach(function (mode) {
                    if (mode.param) {
                        modeslines[mode.mode] = ' ' + mode.param;
                    } else if (mode.mode[0] === '-') {
                        if (!modeslines['-']) {
                            modeslines['-'] = '';
                        }
                        modeslines['-'] += mode.mode.slice(1);
                    } else {
                        if (!modeslines['+']) {
                            modeslines['+'] = '';
                        }
                        if (mode.mode[0] === '+') {
                            modeslines['+'] += mode.mode.slice(1);
                        } else {
                            modeslines['+'] += mode.mode;
                        }
                    }
                });

                var _serverBuffer = network.serverBuffer();
                _lodash2.default.each(modeslines, function (mode, value) {
                    var text = TextFormatting.t('modes_other', {
                        nick: event.nick,
                        target: event.target,
                        mode: value + mode
                    });
                    var messageBody = TextFormatting.formatText('mode', {
                        nick: event.nick,
                        username: event.ident,
                        host: event.hostname,
                        target: event.target,
                        text: text
                    });
                    state.addMessage(_serverBuffer, {
                        time: Date.now(),
                        nick: '',
                        message: messageBody,
                        type: 'mode'
                    });
                });
            }
        }

        if (command === 'banlist') {
            var _buffer15 = state.getBufferByName(networkid, event.channel);
            if (_buffer15 && _buffer15.flags.requested_banlist) {
                if (!event.bans || event.bans.length === 0) {
                    state.addMessage(_buffer15, {
                        time: eventTime,
                        server_time: serverTime,
                        nick: '',
                        message: TextFormatting.t('bans_nobody'),
                        type: 'banlist'
                    });
                } else {
                    var banText = '';
                    _lodash2.default.each(event.bans, function (ban) {
                        var dateStr = new Date(ban.banned_at * 1000).toDateString();
                        banText += '+b ' + ban.banned + ' [by ' + ban.banned_by + ', ' + dateStr + ']\n';
                    });

                    state.addMessage(_buffer15, {
                        time: eventTime,
                        server_time: serverTime,
                        nick: '*',
                        message: banText,
                        type: 'banlist'
                    });
                }
                _buffer15.flags.requested_banlist = false;
            }
        }

        if (command === 'topic') {
            var _buffer16 = state.getOrAddBufferByName(networkid, event.channel);
            _buffer16.topic = event.topic || '';

            var _messageBody8 = '';

            if (event.nick) {
                _messageBody8 = TextFormatting.formatAndT('channel_topic', null, 'changed_topic_to', { nick: event.nick, topic: event.topic });
            } else if (_buffer16.topic.trim()) {
                _messageBody8 = TextFormatting.formatText('channel_topic', _buffer16.topic);
            }

            if (_messageBody8) {
                state.addMessage(_buffer16, {
                    time: eventTime,
                    server_time: serverTime,
                    nick: '',
                    message: _messageBody8,
                    type: 'topic'
                });
            }
        }

        if (command === 'ctcp response' || command === 'ctcp request') {
            var _buffer17 = network.bufferByName(event.target) || network.serverBuffer();
            var textFormatId = command === 'ctcp response' ? 'ctcp_response' : 'ctcp_request';
            var _messageBody9 = TextFormatting.formatText(textFormatId, {
                nick: event.nick,
                message: event.message,
                type: event.type
            });

            state.addMessage(_buffer17, {
                time: eventTime,
                server_time: serverTime,
                nick: '',
                message: _messageBody9,
                type: 'error'
            });

            if (command === 'ctcp request' && event.type === 'VERSION') {
                client.ctcpResponse(event.nick, 'VERSION', 'Kiwi IRC');
            }
        }

        if (command === 'nick invalid') {
            var _messageBody10 = TextFormatting.formatText('general_error', {
                text: event.reason
            });
            var _buffer18 = state.getActiveBuffer();
            state.addMessage(_buffer18, {
                time: eventTime,
                server_time: serverTime,
                nick: '',
                message: _messageBody10,
                type: 'error'
            });

            if (!isRegistered) {
                network.last_error_numeric = 432;
                network.last_error = event.reason;
                network.ircClient.quit();
            }
        }

        if (command === 'irc error') {
            var _buffer19 = void 0;
            if (event.channel || event.nick) {
                _buffer19 = state.getOrAddBufferByName(network.id, event.channel || event.nick);
            }
            if (!_buffer19) {
                _buffer19 = network.serverBuffer();
            }

            if (!_buffer19) {
                return;
            }

            if (event.error === 'bad_channel_key') {
                _buffer19.flags.channel_badkey = true;
            }

            if (event.reason && network.last_error_numeric !== 432) {
                if (!isRegistered) {
                    network.last_error = event.reason;
                }
                var _messageBody11 = TextFormatting.formatText('general_error', {
                    text: event.reason || event.error
                });
                state.addMessage(_buffer19, {
                    time: eventTime,
                    server_time: serverTime,
                    nick: '',
                    message: _messageBody11,
                    type: 'error'
                });
            }

            if (_buffer19.isChannel() && !_buffer19.joined) {
                _buffer19.enabled = false;
            }
        }

        next();
    }
}

function rand(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["IrcClient"]
window._kiwi_exports.libs.IrcClient = exports.default ? exports.default : exports;


/***/ }),

/***/ "jvBq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var Vue = __webpack_require__("I3G/");

exports.default = Vue.component('input-prompt', {
    props: ['label', 'hideCancel', 'noprompt', 'block'],
    data: function data() {
        return {
            value: '',
            state: 'pre'
        };
    },
    created: function created() {
        if (this.noprompt) {
            this.prompt();
        }
    },

    methods: {
        prompt: function prompt() {
            var _this = this;

            this.state = 'prompt';
            this.$nextTick(function () {
                _this.$el.querySelector('input').focus();
            });
        },
        complete: function complete() {
            this.$emit('submit', this.value);
            this.state = 'pre';
        },
        cancel: function cancel() {
            this.$emit('cancel');
            this.state = 'pre';
        }
    }
});
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["utils"]) window._kiwi_exports["components"]["utils"] = {};
window._kiwi_exports["components"]["utils"]["InputPrompt"]
window._kiwi_exports.components.utils.InputPrompt = exports.default ? exports.default : exports;


/***/ }),

/***/ "kQCM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kSJ/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _slicedToArray2 = __webpack_require__("d7EF");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _create = __webpack_require__("OvRC");

var _create2 = _interopRequireDefault(_create);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _Logger = __webpack_require__("XNCV");

var _Logger2 = _interopRequireDefault(_Logger);

var _BouncerMiddleware = __webpack_require__("2j2C");

var _BouncerMiddleware2 = _interopRequireDefault(_BouncerMiddleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = _Logger2.default.namespace('BouncerProvider.js');

var BouncerProvider = function () {
    function BouncerProvider(state) {
        (0, _classCallCheck3.default)(this, BouncerProvider);

        this.state = state;

        this.controllerNetwork = null;

        this.bnc = {
            enabled: false,
            username: '',
            password: '',
            server: '',
            port: 6667,
            tls: false,
            direct: false,
            path: '',
            registered: false
        };

        this.rewriteConnections = true;

        this.networksSnapshot = (0, _create2.default)(null);

        state.$on('irc.motd', this.onNetworkMotd.bind(this));
    }

    (0, _createClass3.default)(BouncerProvider, [{
        key: 'enable',
        value: function enable(server, port, tls, direct, path) {
            this.bnc.server = server;
            this.bnc.port = port || 6667;
            this.bnc.tls = !!tls;
            this.bnc.direct = !!direct;
            this.bnc.path = path || '';
            this.bnc.enabled = true;

            this.listenToState();
        }
    }, {
        key: 'getController',
        value: function getController() {
            if (this.controllerNetwork && this.controllerNetwork.state === 'connected') {
                return this.controllerNetwork;
            }

            this.controllerNetwork = null;
            for (var i = 0; i < this.state.networks.length; i++) {
                var network = this.state.networks[i];
                var client = network.ircClient;
                if (network.state === 'connected' && client.network.cap.isEnabled('bouncer')) {
                    this.controllerNetwork = network;
                    break;
                }
            }

            return this.controllerNetwork;
        }
    }, {
        key: 'onNetworkMotd',
        value: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(event, network) {
                var client, _network$password$spl, _network$password$spl2, username, password;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                client = network.ircClient;

                                if (this.bnc.enabled) {
                                    _context.next = 3;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 3:
                                if (client.network.cap.isEnabled('bouncer')) {
                                    _context.next = 5;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 5:
                                if (client.bnc.hasNetwork() && !network.connection.bncname) {
                                    network.connection.bncname = client.bnc.tags().network;
                                }

                                if (!this.bnc.username) {
                                    _network$password$spl = network.password.split(':'), _network$password$spl2 = (0, _slicedToArray3.default)(_network$password$spl, 2), username = _network$password$spl2[0], password = _network$password$spl2[1];

                                    username = username.split('/')[0];
                                    this.bnc.username = username;
                                    this.bnc.password = password;
                                }

                                if (!client.bnc.hasNetwork()) {
                                    _context.next = 10;
                                    break;
                                }

                                _context.next = 10;
                                return this.syncBncNetwork(network);

                            case 10:
                                _context.next = 12;
                                return this.initAndAddNetworks(network);

                            case 12:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function onNetworkMotd(_x, _x2) {
                return _ref.apply(this, arguments);
            }

            return onNetworkMotd;
        }()
    }, {
        key: 'initAndAddNetworks',
        value: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(network) {
                var _this = this;

                var client, bncNetworks;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                client = network.ircClient;


                                this.bnc.registered = true;

                                if (!network.ircClient.bnc.hasNetwork()) {
                                    network.hidden = true;
                                } else {
                                    network.hidden = false;
                                }

                                _context2.next = 5;
                                return client.bnc.getNetworks();

                            case 5:
                                bncNetworks = _context2.sent;

                                bncNetworks.forEach(function (bncNet) {
                                    return _this.addNetworkToState(bncNet);
                                });

                                this.monitorNetworkChanges();

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function initAndAddNetworks(_x3) {
                return _ref2.apply(this, arguments);
            }

            return initAndAddNetworks;
        }()
    }, {
        key: 'syncBncNetwork',
        value: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(bncNetwork) {
                var _this2 = this;

                var client, buffers;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                client = bncNetwork.ircClient;
                                _context3.next = 3;
                                return client.bnc.getBuffers(bncNetwork.connection.bncname);

                            case 3:
                                buffers = _context3.sent;

                                buffers.forEach(function (buffer) {
                                    var newBuffer = _this2.state.addBuffer(bncNetwork.id, buffer.name);
                                    if (buffer.joined) {
                                        newBuffer.enabled = true;
                                        newBuffer.joined = true;
                                    } else {
                                        newBuffer.enabled = false;
                                        newBuffer.joined = false;
                                    }
                                    if (buffer.seen) {
                                        newBuffer.last_read = new Date(buffer.seen).getTime();
                                    }

                                    newBuffer.topic = buffer.topic || '';

                                    if (bncNetwork.state === 'connected' && newBuffer.isChannel() && newBuffer.joined) {
                                        client.raw('NAMES ' + newBuffer.name);
                                    }
                                });

                                bncNetwork.buffers.forEach(function (clientBuffer) {
                                    if (!clientBuffer.isChannel() && !clientBuffer.isQuery()) {
                                        return;
                                    }

                                    var existingBuffers = buffers.filter(function (bncBuffer) {
                                        return bncBuffer.name.toLowerCase() === clientBuffer.name.toLowerCase();
                                    });

                                    if (existingBuffers.length === 0) {
                                        _this2.state.removeBuffer(clientBuffer);
                                    }
                                });

                            case 6:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function syncBncNetwork(_x4) {
                return _ref3.apply(this, arguments);
            }

            return syncBncNetwork;
        }()
    }, {
        key: 'addNetworkToState',
        value: function () {
            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(network) {
                var net;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                net = this.state.getNetworkFromBncName(network.name);

                                if (!net) {
                                    net = this.state.addNetwork(network.name, network.nick || '', {
                                        server: network.host,
                                        port: network.port,
                                        tls: network.tls,
                                        password: network.password,
                                        bncname: network.name,
                                        username: network.user
                                    });
                                }

                                _context4.next = 4;
                                return this.syncBncNetwork(net);

                            case 4:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function addNetworkToState(_x5) {
                return _ref4.apply(this, arguments);
            }

            return addNetworkToState;
        }()
    }, {
        key: 'snapshotCurrentNetworks',
        value: function snapshotCurrentNetworks() {
            var _this3 = this;

            this.networksSnapshot = (0, _create2.default)(null);

            this.state.networks.forEach(function (network) {
                if (!network.connection.bncname) {
                    return;
                }

                _this3.networksSnapshot[network.connection.bncname] = {
                    name: network.connection.bncname,
                    host: network.connection.server,
                    port: network.connection.port,
                    tls: network.connection.tls,
                    password: network.password,
                    nick: network.connection.nick,
                    username: network.username
                };
            });
        }
    }, {
        key: 'saveState',
        value: function saveState() {
            var _this4 = this;

            var controller = this.getController();
            if (!controller) {
                log('No controller available to save networks');
                return;
            }

            this.state.networks.forEach(function (network) {
                if (_this4.getController() === network && !network.ircClient.bnc.hasNetwork()) {
                    return;
                }

                var bncName = network.connection.bncname;
                var snapshot = _this4.networksSnapshot[bncName] || {};
                var tags = {};

                if (network.connection.server !== snapshot.host) {
                    tags.host = network.connection.server;
                }
                if (network.connection.port !== snapshot.port) {
                    tags.port = network.connection.port;
                }
                if (network.connection.tls !== snapshot.tls) {
                    tags.tls = network.connection.tls;
                }
                if (network.password !== snapshot.password) {
                    tags.password = network.password;
                }
                if (network.connection.nick !== snapshot.nick) {
                    tags.nick = network.connection.nick;
                }
                if (network.username !== snapshot.username) {
                    tags.user = network.username;
                }

                if (!snapshot.name && tags.host && tags.port && tags.nick) {
                    network.connection.bncname = network.name;
                    controller.ircClient.bnc.addNetwork(network.name, tags.host, tags.port, tags.tls, tags.nick, tags.user, tags.password);
                } else if (snapshot.name) {
                    controller.ircClient.bnc.saveNetwork(bncName, tags);
                }
            });

            this.snapshotCurrentNetworks();
        }
    }, {
        key: 'monitorNetworkChanges',
        value: function monitorNetworkChanges() {
            this.snapshotCurrentNetworks();

            var debouncedSaveState = _lodash2.default.debounce(this.saveState.bind(this), 2000);
            this.state.$watch('networks', debouncedSaveState, { deep: true });
        }
    }, {
        key: 'listenToState',
        value: function listenToState() {
            var _this5 = this;

            var state = this.state;

            state.$on('network.connecting', function (event) {
                var network = event.network;
                if (_this5.bnc.enabled && _this5.rewriteConnections) {
                    var netname = network.connection.bncname;

                    var ircClient = network.ircClient;
                    ircClient.options.host = _this5.bnc.server;
                    ircClient.options.port = _this5.bnc.port;
                    ircClient.options.tls = _this5.bnc.tls;

                    if (_this5.bnc.password) {
                        var password = _this5.bnc.username + '/' + netname + ':' + _this5.bnc.password;
                        ircClient.options.password = password;
                    }

                    network.connection.direct = _this5.bnc.direct;
                    ircClient.options.path = _this5.bnc.path;
                }
            });
            state.$on('network.connecting', function (event) {
                var controller = _this5.getController();
                if (!controller) {
                    log('No controller available to save network states');
                    return;
                }

                _this5.saveState();

                var network = event.network;

                if (network.connection.bncname) {
                    controller.ircClient.raw('BOUNCER connect ' + network.connection.bncname);
                }
            });
            state.$on('irc.motd', function (event, network) {
                network.buffers.forEach(function (buffer) {
                    if (buffer.isChannel() && buffer.enabled && buffer.joined) {
                        network.ircClient.who(buffer.name);
                    }
                });
            });

            state.$on('network.new', function (event) {
                var network = event.network;

                network.ircClient.use((0, _BouncerMiddleware2.default)());

                if (!network.connection.bncname) {
                    var currentNum = 1;
                    var existingNet = true;
                    while (existingNet) {
                        existingNet = _lodash2.default.find(state.networks, {
                            name: 'Network' + currentNum
                        });
                        existingNet = existingNet || _lodash2.default.find(state.networks, {
                            connection: { bncname: 'Network' + currentNum }
                        });

                        if (!existingNet || network === existingNet) {
                            network.name = 'Network' + currentNum;
                            existingNet = null;
                        }

                        currentNum++;
                    }
                }
            });

            state.$on('network.removed', function (event) {
                var controller = _this5.getController();
                if (!controller) {
                    log('No controller available to save network states');
                    return;
                }

                if (event.network.connection.bncname) {
                    controller.ircClient.bnc.removeNetwork(event.network.connection.bncname);
                }
            });

            state.$on('buffer.close', function (event) {
                var buffer = event.buffer;
                var network = event.buffer.getNetwork();
                var bncName = network.connection.bncname;

                var controller = _this5.getController();
                if (!controller) {
                    log('No controller available to save buffer states');
                    return;
                }

                if (bncName) {
                    controller.ircClient.bnc.closeBuffer(bncName, buffer.name);
                }
            });
        }
    }]);
    return BouncerProvider;
}();

exports.default = BouncerProvider;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["BouncerProvider"]
window._kiwi_exports.libs.BouncerProvider = exports.default ? exports.default : exports;


/***/ }),

/***/ "kZ1f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        usePreset: {
            type: Boolean,
            default: true
        },
        networkList: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        connection: {
            type: Object,
            default: function _default() {}
        }
    },
    data: function data() {
        return {
            name: '',
            presetNetworks: [],
            showCustom: true,
            willEmit: false
        };
    },
    computed: {
        presetServer: {
            set: function set(newVal) {
                if (newVal === 'custom') {
                    this.name = '';
                    this.connection.server = '';
                    this.connection.port = 6667;
                    this.connection.tls = false;

                    this.showCustom = true;
                } else {
                    var addr = this.parseFormatted(newVal);
                    this.name = addr.name;
                    this.connection.server = addr.server;
                    this.connection.port = addr.port;
                    this.connection.tls = addr.tls;

                    this.showCustom = false;
                }
            },
            get: function get() {
                return this.showCustom ? 'custom' : this.toUri(this.connection);
            }
        }
    },
    created: function created() {
        if (this.networkList) {
            this.importUris(this.networkList);
        }

        var con = this.connection;
        if (_lodash2.default.find(this.presetNetworks, function (s) {
            var match = s.server === con.server && s.port === con.port && s.tls === con.tls;
            return match;
        })) {
            this.showCustom = false;
        }
    },

    methods: {
        toUri: function toUri(s) {
            return s.server + ':' + (s.tls ? '+' : '') + s.port;
        },
        toggleTls: function toggleTls() {
            this.connection.tls = !this.connection.tls;

            if (this.connection.tls && this.connection.port === 6667) {
                this.connection.port = 6697;
            } else if (!this.connection.tls && this.connection.port === 6697) {
                this.connection.port = 6667;
            }
        },
        parseFormatted: function parseFormatted(input) {
            var ret = {
                name: '',
                server: '',
                port: 6667,
                tls: false
            };

            var val = input;

            var pipePos = val.indexOf('|');
            if (pipePos > -1) {
                ret.name = val.substr(0, pipePos);
                val = val.substr(pipePos + 1);
            }

            var colonPos = val.indexOf(':');
            if (colonPos === -1) {
                ret.server = val;
                val = '';
            } else {
                ret.server = val.substr(0, colonPos);
                val = val.substr(colonPos + 1);
            }

            if (val[0] === '+') {
                ret.tls = true;
                val = val.substr(1);
            }

            if (val.length > 0) {
                ret.port = parseInt(val, 10);
                val = '';
            }

            if (!ret.name) {
                ret.name = ret.server;
            }

            return ret;
        },
        importUris: function importUris(serverList) {
            var _this = this;

            var servers = serverList.map(function (s) {
                return _this.parseFormatted(s);
            });
            this.$set(this, 'presetNetworks', servers);
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["ServerSelector"]
window._kiwi_exports.components.ServerSelector = exports.default ? exports.default : exports;


/***/ }),

/***/ "kkD8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['user', 'buffer'],
    computed: {
        status: function status() {
            if (!this.user || !this.buffer) {
                return '';
            }

            return this.user.typingStatus(this.buffer.name).status;
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["TypingStatusIndicator"]
window._kiwi_exports.components.TypingStatusIndicator = exports.default ? exports.default : exports;


/***/ }),

/***/ "kyKn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TextFormatting = __webpack_require__("15gS");

var TextFormatting = _interopRequireWildcard(_TextFormatting);

var _IrcdDiffs = __webpack_require__("1gJW");

var IrcdDiffs = _interopRequireWildcard(_IrcdDiffs);

var _AwayStatusIndicator = __webpack_require__("vV7l");

var _AwayStatusIndicator2 = _interopRequireDefault(_AwayStatusIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
    components: {
        AwayStatusIndicator: _AwayStatusIndicator2.default
    },
    props: ['buffer', 'network', 'user'],
    data: function data() {
        return {
            whoisRequested: false,
            whoisLoading: false
        };
    },
    computed: {
        availableChannelModes: function availableChannelModes() {
            var availableModes = [];
            var prefixes = this.network.ircClient.network.options.PREFIX;
            var knownPrefix = {
                q: 'Owner',
                a: 'Admin',
                o: 'Operator',
                h: 'Half-Operator',
                v: 'Voice'
            };

            if (!IrcdDiffs.isAChannelModeAdmin(this.network)) {
                delete knownPrefix.a;
            }
            if (!IrcdDiffs.isQChannelModeOwner(this.network)) {
                delete knownPrefix.q;
            }
            if (!IrcdDiffs.supportsHalfOp(this.network)) {
                delete knownPrefix.h;
            }

            prefixes.forEach(function (prefix) {
                var mode = prefix.mode;
                if (knownPrefix[mode]) {
                    availableModes.push({
                        mode: mode,
                        description: knownPrefix[mode]
                    });
                }
            });

            return availableModes;
        },
        areWeAnOp: function areWeAnOp() {
            if (!this.buffer) {
                return false;
            }

            return this.buffer.isUserAnOp(this.buffer.getNetwork().nick);
        },
        isUserOnBuffer: function isUserOnBuffer() {
            if (!this.buffer) {
                return false;
            }

            if (!this.user.buffers[this.buffer.id]) {
                return false;
            }

            return true;
        },
        userMode: {
            get: function getUserMode() {
                if (!this.buffer) {
                    return '';
                }

                var userBufferInfo = this.user.buffers[this.buffer.id];
                if (!userBufferInfo) {
                    return '';
                }

                var modes = userBufferInfo.modes;
                return modes.length > 0 ? modes[0] : '';
            },

            set: function setUserMode(newVal) {
                var client = this.network.ircClient;
                var oldVal = this.userMode;

                var changes = [];
                var targets = [];

                if (oldVal) {
                    changes.push('-' + oldVal);
                    targets.push(this.user.nick);
                }
                if (newVal) {
                    changes.push('+' + newVal);
                    targets.push(this.user.nick);
                }

                var params = ['MODE', this.buffer.name, changes.join('')].concat(targets);
                client.raw(params);
            }
        },
        userChannels: function userChannels() {
            var channels = this.user.channels.trim().split(' ');
            for (var i = 0; i < channels.length; i++) {
                channels[i] = TextFormatting.linkifyChannels(channels[i]);
            }
            return channels.join(' ');
        },
        isSelf: function isSelf() {
            return this.user === this.network.currentUser();
        }
    },
    watch: {
        user: function watchUser() {
            this.whoisRequested = false;
            this.whoisLoading = false;
        }
    },
    methods: {
        userModeOnThisBuffer: function userModeOnBuffer(user) {
            if (!this.buffer) {
                return '';
            }

            var userBufferInfo = user.buffers[this.buffer.id];
            var modes = userBufferInfo.modes;
            return modes.length > 0 ? modes[0] : '';
        },
        openQuery: function openQuery() {
            var buffer = this.$state.addBuffer(this.network.id, this.user.nick);
            this.$state.setActiveBuffer(this.network.id, buffer.name);
            if (this.$state.ui.is_narrow) {
                this.$state.$emit('userbox.hide');
            }
        },
        onChannelsClick: function onChannelsClick(event) {
            var channelName = event.target.getAttribute('data-channel-name');
            if (channelName) {
                var network = this.buffer.getNetwork();
                this.$state.addBuffer(this.buffer.networkid, channelName);
                network.ircClient.join(channelName);
            }
        },

        updateWhoisData: function updateWhoisData() {
            var _this = this;

            this.whoisRequested = true;
            this.whoisLoading = true;
            this.network.ircClient.whois(this.user.nick, function () {
                _this.whoisLoading = false;
            });
        },
        kickUser: function kickUser() {
            var reason = this.$state.setting('buffers.default_kick_reason');
            this.network.ircClient.raw('KICK', this.buffer.name, this.user.nick, reason);
        },
        createBanMask: function banMask() {
            var mask = this.$state.setting('buffers.default_ban_mask');
            mask = mask.replace('%n', this.user.nick);
            mask = mask.replace('%i', this.user.username);
            mask = mask.replace('%h', this.user.host);

            return mask;
        },
        banUser: function banUser() {
            if (!this.user.username || !this.user.host) {
                return;
            }

            var banMask = this.createBanMask();
            this.network.ircClient.raw('MODE', this.buffer.name, '+b', banMask);
        },
        kickbanUser: function kickbanuser() {
            if (!this.user.username || !this.user.host) {
                return;
            }

            var banMask = this.createBanMask();
            var reason = this.$state.setting('buffers.default_kick_reason');
            this.network.ircClient.raw('MODE', this.buffer.name, '+b', banMask);
            this.network.ircClient.raw('KICK', this.buffer.name, this.user.nick, reason);
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["UserBox"]
window._kiwi_exports.components.UserBox = exports.default ? exports.default : exports;


/***/ }),

/***/ "kzSW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-messagelist-message kiwi-messagelist-message--modern",class:[
        _vm.isRepeat() ?
            'kiwi-messagelist-message--authorrepeat' :
            'kiwi-messagelist-message--authorfirst',
        'kiwi-messagelist-message-' + _vm.message.type,
        _vm.message.type_extra ?
            'kiwi-messagelist-message-' + _vm.message.type + '-' + _vm.message.type_extra :
            '',
        _vm.ml.isMessageHighlight(_vm.message) ?
            'kiwi-messagelist-message--highlight' :
            '',
        _vm.ml.isHoveringOverMessage(_vm.message) ?
            'kiwi-messagelist-message--hover' :
            '',
        _vm.ml.buffer.last_read && _vm.message.time > _vm.ml.buffer.last_read ?
            'kiwi-messagelist-message--unread' :
            '',
        _vm.message.nick.toLowerCase() === _vm.ml.ourNick.toLowerCase() ?
            'kiwi-messagelist-message--own' :
            '',
        _vm.ml.message_info_open === _vm.message ?
            'kiwi-messagelist-message--info-open' :
            '',
        _vm.ml.message_info_open && _vm.ml.message_info_open !== _vm.message ?
            'kiwi-messagelist-message--blur' :
            '',
        (_vm.message.user && _vm.userMode(_vm.message.user)) ?
            'kiwi-messagelist-message--user-mode-'+_vm.userMode(_vm.message.user) :
            ''
    ],attrs:{"data-message-id":_vm.message.id,"data-nick":(_vm.message.nick||'').toLowerCase()},on:{"click":function($event){return _vm.ml.onMessageClick($event, _vm.message, true)},"dblclick":function($event){return _vm.ml.onMessageDblClick($event, _vm.message)}}},[_c('div',{staticClass:"kiwi-messagelist-modern-left"},[(_vm.isMessage(_vm.message) && _vm.displayAvatar(_vm.message))?_c('message-avatar',{attrs:{"message":_vm.message,"data-nick":_vm.message.nick}}):_vm._e(),_vm._v(" "),(_vm.message.user && !_vm.isRepeat())?_c('away-status-indicator',{staticClass:"kiwi-messagelist-awaystatus",attrs:{"network":_vm.getNetwork(),"user":_vm.message.user,"toggle":false}}):_vm._e(),_vm._v(" "),(_vm.message.user)?_c('typing-status-indicator',{staticClass:"kiwi-messagelist-typingstatus",attrs:{"network":_vm.getNetwork(),"user":_vm.message.user}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"kiwi-messagelist-modern-right"},[_c('div',{staticClass:"kiwi-messagelist-top"},[_c('div',{class:[
                    'kiwi-messagelist-nick',
                    (_vm.message.user && _vm.userMode(_vm.message.user)) ?
                        'kiwi-messagelist-nick--mode-'+_vm.userMode(_vm.message.user) :
                        ''
                ],style:({ 'color': _vm.userColour }),on:{"click":function($event){return _vm.ml.openUserBox(_vm.message.nick)},"mouseover":function($event){_vm.ml.hover_nick=_vm.message.nick.toLowerCase();},"mouseout":function($event){_vm.ml.hover_nick='';}}},[_c('span',{staticClass:"kiwi-messagelist-nick-prefix"},[_vm._v(_vm._s(_vm.message.user ?
                        _vm.userModePrefix(_vm.message.user) :
                        ''))]),_vm._v(_vm._s(_vm.message.nick)+"\n            ")]),_vm._v(" "),(_vm.showRealName)?_c('div',{staticClass:"kiwi-messagelist-realname",on:{"click":function($event){return _vm.ml.openUserBox(_vm.message.nick)},"mouseover":function($event){_vm.ml.hover_nick=_vm.message.nick.toLowerCase();},"mouseout":function($event){_vm.ml.hover_nick='';}}},[_vm._v("\n                "+_vm._s(_vm.message.user.realname)+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.isMessage(_vm.message) && _vm.ml.bufferSetting('show_timestamps'))?_c('div',{staticClass:"kiwi-messagelist-time",attrs:{"title":_vm.ml.formatTimeFull(_vm.message.time)}},[_vm._v("\n                "+_vm._s(_vm.ml.formatTime(_vm.message.time))+"\n            ")]):_vm._e()]),_vm._v(" "),(_vm.message.bodyTemplate && _vm.message.bodyTemplate.$el)?_c('div',{directives:[{name:"rawElement",rawName:"v-rawElement",value:(_vm.message.bodyTemplate.$el),expression:"message.bodyTemplate.$el"}],staticClass:"kiwi-messagelist-body"}):_c('div',{staticClass:"kiwi-messagelist-body",domProps:{"innerHTML":_vm._s(_vm.ml.formatMessage(_vm.message))}}),_vm._v(" "),(_vm.ml.message_info_open===_vm.message)?_c('message-info',{attrs:{"message":_vm.message,"buffer":_vm.ml.buffer},on:{"close":function($event){return _vm.ml.toggleMessageInfo()}}}):_vm._e()],1)])}
var staticRenderFns = []


/***/ }),

/***/ "l/27":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ControlInput_vue__ = __webpack_require__("ZfkH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ControlInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ControlInput_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ControlInput_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ControlInput_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c29ab52_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ControlInput_vue__ = __webpack_require__("qrDz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("vj9m")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ControlInput_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c29ab52_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ControlInput_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c29ab52_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ControlInput_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "lZ5c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__("f96R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d6ebcf8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__("aJg0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("TqUK")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d6ebcf8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d6ebcf8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "m1o2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m3c/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarAboutBuffer_vue__ = __webpack_require__("TbYc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarAboutBuffer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarAboutBuffer_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarAboutBuffer_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarAboutBuffer_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be315f00_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarAboutBuffer_vue__ = __webpack_require__("Nj28");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("RL9m")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarAboutBuffer_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be315f00_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarAboutBuffer_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be315f00_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarAboutBuffer_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "mRrz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-buffersettings"},[_c('div',{staticClass:"kiwi-buffersettings-alerts"},[_c('h3',[_vm._v(_vm._s(_vm.$t('settings_notify')))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('form',{staticClass:"u-form"},[_c('label',{staticClass:"u-checkbox-wrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settingAlertOn),expression:"settingAlertOn"}],attrs:{"type":"radio","name":"alert_on","value":"message"},domProps:{"checked":_vm._q(_vm.settingAlertOn,"message")},on:{"change":function($event){_vm.settingAlertOn="message"}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('settings_notify_all')))])]),_vm._v(" "),_c('label',{staticClass:"u-checkbox-wrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settingAlertOn),expression:"settingAlertOn"}],attrs:{"type":"radio","name":"alert_on","value":"highlight"},domProps:{"checked":_vm._q(_vm.settingAlertOn,"highlight")},on:{"change":function($event){_vm.settingAlertOn="highlight"}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('settings_notify_mentioned')))])]),_vm._v(" "),_c('label',{staticClass:"u-checkbox-wrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settingAlertOn),expression:"settingAlertOn"}],attrs:{"type":"radio","name":"alert_on","value":"never"},domProps:{"checked":_vm._q(_vm.settingAlertOn,"never")},on:{"change":function($event){_vm.settingAlertOn="never"}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('settings_notify_never')))])])]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.$t('settings')))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('form',{staticClass:"u-form"},[_c('label',[_c('span',[_vm._v(_vm._s(_vm.$t('settings_notify_mute')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settingMuteSound),expression:"settingMuteSound"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.settingMuteSound)?_vm._i(_vm.settingMuteSound,null)>-1:(_vm.settingMuteSound)},on:{"change":function($event){var $$a=_vm.settingMuteSound,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.settingMuteSound=$$a.concat([$$v]))}else{$$i>-1&&(_vm.settingMuteSound=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.settingMuteSound=$$c}}}})]),_vm._v(" "),_c('label',[_c('span',[_vm._v(_vm._s(_vm.$t('settings_show_message_counts')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settingHideMessageCount),expression:"settingHideMessageCount"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.settingHideMessageCount)?_vm._i(_vm.settingHideMessageCount,null)>-1:(_vm.settingHideMessageCount)},on:{"change":function($event){var $$a=_vm.settingHideMessageCount,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.settingHideMessageCount=$$a.concat([$$v]))}else{$$i>-1&&(_vm.settingHideMessageCount=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.settingHideMessageCount=$$c}}}})])])])])}
var staticRenderFns = []


/***/ }),

/***/ "mV8s":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__("iGtm");

var _cssVarsPonyfill = __webpack_require__("rZ6J");

var _cssVarsPonyfill2 = _interopRequireDefault(_cssVarsPonyfill);

__webpack_require__("Ct1V");

var _tinycon = __webpack_require__("pqBX");

var _tinycon2 = _interopRequireDefault(_tinycon);

var _Welcome = __webpack_require__("Bt23");

var _Welcome2 = _interopRequireDefault(_Welcome);

var _ZncLogin = __webpack_require__("hQWq");

var _ZncLogin2 = _interopRequireDefault(_ZncLogin);

var _CustomServer = __webpack_require__("RKgk");

var _CustomServer2 = _interopRequireDefault(_CustomServer);

var _KiwiBnc = __webpack_require__("xoWl");

var _KiwiBnc2 = _interopRequireDefault(_KiwiBnc);

var _Personal = __webpack_require__("eFgB");

var _Personal2 = _interopRequireDefault(_Personal);

var _StateBrowser = __webpack_require__("amxj");

var _StateBrowser2 = _interopRequireDefault(_StateBrowser);

var _AppSettings = __webpack_require__("Aw+L");

var _AppSettings2 = _interopRequireDefault(_AppSettings);

var _Container = __webpack_require__("ik/t");

var _Container2 = _interopRequireDefault(_Container);

var _ControlInput = __webpack_require__("l/27");

var _ControlInput2 = _interopRequireDefault(_ControlInput);

var _MediaViewer = __webpack_require__("3nVL");

var _MediaViewer2 = _interopRequireDefault(_MediaViewer);

var _Sidebar = __webpack_require__("lZ5c");

var _Notifications = __webpack_require__("0R7g");

var Notifications = _interopRequireWildcard(_Notifications);

var _bufferTools = __webpack_require__("7DgK");

var bufferTools = _interopRequireWildcard(_bufferTools);

var _ThemeManager = __webpack_require__("j/A4");

var _ThemeManager2 = _interopRequireDefault(_ThemeManager);

var _Logger = __webpack_require__("XNCV");

var _Logger2 = _interopRequireDefault(_Logger);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = _Logger2.default.namespace('App.vue');

exports.default = {
    components: {
        StateBrowser: _StateBrowser2.default,
        Container: _Container2.default,
        ControlInput: _ControlInput2.default,
        MediaViewer: _MediaViewer2.default
    },
    data: function data() {
        return {
            startupComponent: null,
            hasStarted: false,

            stateBrowserDrawOpen: false,

            activeComponent: null,
            activeComponentProps: {},

            fallbackComponent: null,
            fallbackComponentProps: {},
            mediaviewerOpen: false,
            mediaviewerUrl: '',
            mediaviewerComponent: null,
            mediaviewerIframe: false,
            themeUrl: '',
            sidebarState: new _Sidebar.State()
        };
    },

    computed: {
        networks: function networks() {
            return this.$state.networks;
        },
        network: function network() {
            return this.$state.getActiveNetwork();
        },
        buffer: function buffer() {
            return this.$state.getActiveBuffer();
        }
    },
    created: function created() {
        var _this = this;

        this.listenForActiveComponents();
        this.watchForThemes();
        this.initStateBrowser();
        this.initMediaviewer();
        this.configureFavicon();

        document.addEventListener('keydown', function (event) {
            return _this.onKeyDown(event);
        }, false);
        window.addEventListener('focus', function (event) {
            return _this.onFocus(event);
        }, false);
        window.addEventListener('blur', function (event) {
            return _this.onBlur(event);
        }, false);
        window.addEventListener('touchstart', function (event) {
            return _this.onTouchStart(event);
        });
    },
    mounted: function mounted() {
        var startupScreens = {
            welcome: _Welcome2.default,
            customServer: _CustomServer2.default,
            kiwiBnc: _KiwiBnc2.default,
            znc: _ZncLogin2.default,
            personal: _Personal2.default
        };
        var extraStartupScreens = this.$state.getStartups();

        var startupName = this.$state.settings.startupScreen || 'personal';
        var startup = extraStartupScreens[startupName] || startupScreens[startupName];

        if (!startup) {
            _Logger2.default.error('Startup screen "' + startupName + '" does not exist');
        } else {
            this.startupComponent = startup;
        }
        this.trackWindowDimensions();
    },

    methods: {
        startUp: function startUp(opts) {
            log('startUp()');
            if (opts && opts.fallbackComponent) {
                this.fallbackComponent = opts.fallbackComponent;
            }
            if (opts && opts.fallbackComponentProps) {
                this.fallbackComponentProps = opts.fallbackComponentProps;
            }

            if (!this.hasStarted) {
                this.warnOnPageClose();
                Notifications.requestPermission();
                Notifications.listenForNewMessages(this.$state);
            }

            this.hasStarted = true;
        },
        listenForActiveComponents: function listenForActiveComponents() {
            var _this2 = this;

            this.listen(this.$state, 'active.component', function (component, props) {
                _this2.activeComponent = null;
                if (component) {
                    _this2.activeComponentProps = props;
                    _this2.activeComponent = component;
                }
            });
            this.listen(this.$state, 'active.component.toggle', function (component, props) {
                if (component === _this2.activeComponent) {
                    _this2.activeComponent = null;
                } else if (component) {
                    _this2.activeComponentProps = props;
                    _this2.activeComponent = component;
                }
            });
        },
        watchForThemes: function watchForThemes() {
            var _this3 = this;

            var themes = _ThemeManager2.default.instance();
            this.themeUrl = _ThemeManager2.default.themeUrl(themes.currentTheme());
            this.$nextTick(function () {
                return (0, _cssVarsPonyfill2.default)();
            });
            this.listen(this.$state, 'theme.change', function () {
                _this3.themeUrl = _ThemeManager2.default.themeUrl(themes.currentTheme());
                _this3.$nextTick(function () {
                    return (0, _cssVarsPonyfill2.default)();
                });
            });
        },
        initStateBrowser: function initStateBrowser() {
            var _this4 = this;

            this.listen(this.$state, 'statebrowser.toggle', function () {
                _this4.stateBrowserDrawOpen = !_this4.stateBrowserDrawOpen;
            });
            this.listen(this.$state, 'statebrowser.show', function () {
                _this4.stateBrowserDrawOpen = true;
            });
            this.listen(this.$state, 'statebrowser.hide', function () {
                _this4.stateBrowserDrawOpen = false;
            });
        },
        initMediaviewer: function initMediaviewer() {
            var _this5 = this;

            this.listen(this.$state, 'mediaviewer.show', function (url) {
                var opts = {};

                if (typeof url === 'string') {
                    opts = { url: url };
                } else {
                    opts = url;
                }

                _this5.mediaviewerUrl = opts.url;
                _this5.mediaviewerComponent = opts.component;
                _this5.mediaviewerIframe = opts.iframe;
                _this5.mediaviewerOpen = true;
            });

            this.listen(this.$state, 'mediaviewer.hide', function () {
                _this5.mediaviewerOpen = false;
            });
        },
        configureFavicon: function configureFavicon() {
            var _this6 = this;

            _tinycon2.default.setOptions({
                width: 7,
                height: 9,
                color: '#ffffff',
                background: '#b32d2d',
                fallback: true
            });

            this.$state.$watch('ui.favicon_counter', function (newVal) {
                if (newVal) {
                    _tinycon2.default.setBubble(newVal);
                } else {
                    _tinycon2.default.reset();
                }
            });

            this.listen(this.$state, 'message.new', function (message) {
                if (!message.isHighlight || message.ignore || _this6.$state.ui.app_has_focus) {
                    return;
                }

                _this6.$state.ui.favicon_counter++;
            });
        },
        trackWindowDimensions: function trackWindowDimensions() {
            var _this7 = this;

            var trackWindowDims = function trackWindowDims() {
                _this7.$state.ui.app_width = _this7.$el.clientWidth;
                _this7.$state.ui.app_height = _this7.$el.clientHeight;
                _this7.$state.ui.is_narrow = _this7.$el.clientWidth <= 769;
            };
            window.addEventListener('resize', trackWindowDims);
            trackWindowDims();
        },
        warnOnPageClose: function warnOnPageClose() {
            var _this8 = this;

            window.onbeforeunload = function () {
                if (_this8.$state.setting('warnOnExit')) {
                    return _this8.$t('window_unload');
                }

                return undefined;
            };
        },
        emitBufferPaste: function emitBufferPaste(event) {
            if (!this.$state.getActiveBuffer() || this.activeComponent !== null) {
                return;
            }

            if (event.target instanceof HTMLInputElement || event.target instanceof HTMLSelectElement || event.target instanceof HTMLTextAreaElement) {
                return;
            }

            this.$state.$emit('buffer.paste', event);
        },
        emitDocumentClick: function emitDocumentClick(event) {
            this.$state.$emit('document.clicked', event);
        },
        onTouchStart: function onTouchStart(event) {
            this.$state.ui.is_touch = true;
        },
        onBlur: function onBlur(event) {
            this.$state.ui.app_has_focus = false;
        },
        onFocus: function onFocus(event) {
            this.$state.ui.app_has_focus = true;
            var buffer = this.$state.getActiveBuffer();
            if (buffer) {
                buffer.markAsRead(true);
            }

            this.$state.ui.favicon_counter = 0;
        },
        onKeyDown: function onKeyDown(event) {
            this.$state.$emit('document.keydown', event);

            var meta = false;

            if (navigator.appVersion.indexOf('Mac') !== -1) {
                meta = event.metaKey;
            } else {
                meta = event.ctrlKey && !event.altKey;
            }

            if (meta && event.keyCode === 221) {
                var buffer = bufferTools.getNextBuffer();
                if (buffer) {
                    this.$state.setActiveBuffer(buffer.networkid, buffer.name);
                }
                event.preventDefault();
            } else if (meta && event.keyCode === 219) {
                var _buffer = bufferTools.getPreviousBuffer();
                if (_buffer) {
                    this.$state.setActiveBuffer(_buffer.networkid, _buffer.name);
                }
                event.preventDefault();
            } else if (meta && event.keyCode === 79) {
                this.$state.$emit('active.component.toggle', _AppSettings2.default);
                event.preventDefault();
            } else if (meta && event.keyCode === 83) {
                var network = this.$state.getActiveNetwork();
                if (network) {
                    network.showServerBuffer('settings');
                }
                event.preventDefault();
            }
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["App"]
window._kiwi_exports.components.App = exports.default ? exports.default : exports;


/***/ }),

/***/ "mfvC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n5Xi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChannelInfo_vue__ = __webpack_require__("ZofN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChannelInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChannelInfo_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChannelInfo_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChannelInfo_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_162c7d9e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChannelInfo_vue__ = __webpack_require__("rN/E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("ZKMu")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChannelInfo_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_162c7d9e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChannelInfo_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_162c7d9e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChannelInfo_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "nFCj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nObl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AutoComplete_vue__ = __webpack_require__("W+RY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AutoComplete_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AutoComplete_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AutoComplete_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AutoComplete_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40d07712_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AutoComplete_vue__ = __webpack_require__("+LjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("iHm7")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AutoComplete_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40d07712_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AutoComplete_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40d07712_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AutoComplete_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "niD1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _Misc = __webpack_require__("uN9+");

var Misc = _interopRequireWildcard(_Misc);

var _state = __webpack_require__("LnP8");

var _state2 = _interopRequireDefault(_state);

var _CommonLayout = __webpack_require__("evl8");

var _CommonLayout2 = _interopRequireDefault(_CommonLayout);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        StartupLayout: _CommonLayout2.default
    },
    data: function data() {
        return {
            network: null,
            network_extras: null,
            username: '',
            password: '',
            znc_network: '',
            showNetwork: true,
            showPass: true,
            showUser: true,
            show_password_box: false
        };
    },
    computed: {
        greetingText: function greetingText() {
            var greeting = _state2.default.settings.startupOptions.greetingText;
            return typeof greeting === 'string' ? greeting : this.$t('start_greeting');
        },
        buttonText: function buttonText() {
            var greeting = _state2.default.settings.startupOptions.buttonText;
            return typeof greeting === 'string' ? greeting : this.$t('start_button');
        },
        readyToStart: function readyToStart() {
            return this.username && (this.password || this.showPass === false);
        },
        infoContent: function infoContent() {
            return _state2.default.settings.startupOptions.infoContent || '';
        }
    },
    created: function created() {
        var options = _state2.default.settings.startupOptions;

        this.username = options.username || '';
        this.password = options.password || '';
        this.znc_network = window.location.hash.substr(1) || options.network || '';
        this.showNetwork = typeof options.showNetwork === 'boolean' ? options.showNetwork : true;
        this.showUser = typeof options.showUser === 'boolean' ? options.showUser : true;
        this.showPass = typeof options.showPass === 'boolean' ? options.showPass : true;

        if (options.autoConnect && this.username && this.password) {
            this.startUp();
        }
    },
    methods: {
        readableStateError: function readableStateError(err) {
            return Misc.networkErrorMessage(err);
        },

        formSubmit: function formSubmit() {
            if (this.readyToStart) {
                this.startUp();
            }
        },
        addNetwork: function addNetwork(netName) {
            var options = _state2.default.settings.startupOptions;
            var password = this.username;
            if (netName) {
                password += '/' + netName;
            }
            password += ':' + this.password;

            var net = _state2.default.addNetwork(netName, 'ZNC', {
                server: _lodash2.default.trim(options.server),
                port: options.port,
                tls: options.tls,
                password: password
            });
            return net;
        },
        startUp: function startUp() {
            var _this = this;

            if (this.network) {
                _state2.default.removeNetwork(this.network.id);
            }

            var netList = _lodash2.default.compact(this.znc_network.split(','));
            if (netList.length === 0) {
                netList.push('');
            }

            var net = this.network = this.addNetwork(netList.shift());
            this.network_extras = netList;

            var onRegistered = function onRegistered() {
                _state2.default.setActiveBuffer(net.id, net.serverBuffer().name);
                net.ircClient.off('registered', onRegistered);
                net.ircClient.off('close', onClosed);
                _this.network_extras.forEach(function (netName, idx) {
                    var extraNet = _this.addNetwork(_lodash2.default.trim(netName));
                    extraNet.ircClient.connect();
                });
                _this.$refs.layout.close();
            };
            var onClosed = function onClosed() {
                net.ircClient.off('registered', onRegistered);
                net.ircClient.off('close', onClosed);
            };
            net.ircClient.once('registered', onRegistered);
            net.ircClient.once('close', onClosed);
            net.ircClient.connect();
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["startups"]) window._kiwi_exports["components"]["startups"] = {};
window._kiwi_exports["components"]["startups"]["ZncLogin"]
window._kiwi_exports.components.startups.ZncLogin = exports.default ? exports.default : exports;


/***/ }),

/***/ "nlr4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty = __webpack_require__("C4MV");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

exports.def = def;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function def(target, key, value, canSet) {
    var val = value;

    var definition = {
        get: function get() {
            return val;
        }
    };

    if (canSet) {
        definition.set = function set(newVal) {
            var oldVal = val;
            val = newVal;
            if (typeof canSet === 'function') {
                canSet(newVal, oldVal);
            }
        };
    }

    (0, _defineProperty2.default)(target, key, definition);

    if (typeof canSet === 'function') {
        canSet(val);
    }
}

/***/ }),

/***/ "nt8X":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _Misc = __webpack_require__("uN9+");

var Misc = _interopRequireWildcard(_Misc);

var _state = __webpack_require__("LnP8");

var _state2 = _interopRequireDefault(_state);

var _Logger = __webpack_require__("XNCV");

var _Logger2 = _interopRequireDefault(_Logger);

var _BouncerProvider = __webpack_require__("kSJ/");

var _BouncerProvider2 = _interopRequireDefault(_BouncerProvider);

var _CommonLayout = __webpack_require__("evl8");

var _CommonLayout2 = _interopRequireDefault(_CommonLayout);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = _Logger2.default.namespace('Welcome.vue');

exports.default = {
    components: {
        StartupLayout: _CommonLayout2.default
    },
    data: function data() {
        return {
            network: null,
            channel: '',
            nick: '',
            password: '',
            showChannel: true,
            showPass: true,
            toggablePass: true,
            showNick: true,
            show_password_box: false,
            recaptchaSiteId: '',
            recaptchaResponseCache: '',
            connectWithoutChannel: false,
            showPlainText: false
        };
    },
    computed: {
        greetingText: function greetingText() {
            var greeting = _state2.default.settings.startupOptions.greetingText;
            return typeof greeting === 'string' ? greeting : this.$t('start_greeting');
        },
        footerText: function footerText() {
            var footer = _state2.default.settings.startupOptions.footerText;
            return typeof footer === 'string' ? footer : '';
        },
        buttonText: function buttonText() {
            var greeting = _state2.default.settings.startupOptions.buttonText;
            return typeof greeting === 'string' ? greeting : this.$t('start_button');
        },
        readyToStart: function readyToStart() {
            var ready = !!this.nick;

            if (!this.connectWithoutChannel && !this.channel) {
                ready = false;
            }

            if (!this.toggablePass && !this.password) {
                ready = false;
            }

            var nickPatternStr = this.$state.setting('startupOptions.nick_format');
            var nickPattern = '';
            if (!nickPatternStr) {
                nickPattern = /^[a-z_\\[\]{}^`|][a-z0-9_\-\\[\]{}^`|]*$/i;
            } else {
                var pattern = '';
                var flags = '';
                if (nickPatternStr[0] === '/') {
                    var pos = nickPatternStr.lastIndexOf('/');
                    pattern = nickPatternStr.substring(1, pos);
                    flags = nickPatternStr.substr(pos + 1);
                } else {
                    pattern = _lodash2.default.escapeRegExp(nickPatternStr);
                    flags = 'i';
                }

                try {
                    nickPattern = new RegExp(pattern, flags);
                } catch (error) {
                    log.error('Nick format error: ' + error.message);
                    return false;
                }
            }

            if (!this.nick.match(nickPattern)) {
                ready = false;
            }

            return ready;
        }
    },
    created: function created() {
        var options = _state2.default.settings.startupOptions;

        var previousNet = null;
        if (options.server.trim()) {
            previousNet = _state2.default.getNetworkFromAddress(options.server.trim());
        }

        if (Misc.queryStringVal('nick')) {
            this.nick = Misc.queryStringVal('nick');
        } else if (previousNet && previousNet.connection.nick) {
            this.nick = previousNet.connection.nick;
        } else {
            this.nick = options.nick;
        }

        this.nick = this.processNickRandomNumber(this.nick || '');
        this.password = options.password || '';
        this.channel = decodeURIComponent(window.location.hash) || options.channel || '';
        this.showChannel = typeof options.showChannel === 'boolean' ? options.showChannel : true;
        this.showNick = typeof options.showNick === 'boolean' ? options.showNick : true;
        this.showPass = typeof options.showPassword === 'boolean' ? options.showPassword : true;
        this.toggablePass = typeof options.toggablePassword === 'boolean' ? options.toggablePassword : true;

        this.connectWithoutChannel = !!options.allowNoChannel;

        if (options.bouncer) {
            this.toggablePass = false;
            this.showPass = true;
            this.showChannel = false;
            this.connectWithoutChannel = true;

            var bouncer = new _BouncerProvider2.default(this.$state);
            bouncer.enable(options.server, options.port, options.tls, options.direct, options.path);
        }

        if (options.autoConnect && this.nick && (this.channel || this.connectWithoutChannel)) {
            this.startUp();
        }

        this.recaptchaSiteId = options.recaptchaSiteId || '';
    },
    mounted: function mounted() {
        if (this.recaptchaSiteId) {
            var scr = document.createElement('script');
            scr.src = 'https://www.google.com/recaptcha/api.js';
            this.$el.appendChild(scr);
        }
    },

    methods: {
        captchaSuccess: function captchaSuccess() {
            if (!this.recaptchaSiteId) {
                return true;
            }

            return !!this.captchaResponse();
        },
        captchaResponse: function captchaResponse() {
            if (this.recaptchaResponseCache) {
                return this.recaptchaResponseCache;
            }

            var gEl = this.$el.querySelector('#g-recaptcha-response');
            this.recaptchaResponseCache = gEl ? gEl.value : '';

            return this.recaptchaResponseCache;
        },
        readableStateError: function readableStateError(err) {
            return Misc.networkErrorMessage(err);
        },

        formSubmit: function formSubmit() {
            if (this.readyToStart) {
                this.startUp();
            }
        },
        startUp: function startUp() {
            var _this = this;

            var options = (0, _assign2.default)({}, _state2.default.settings.startupOptions);

            options.server = options.server || 'default';
            options.port = options.port || 6667;

            if (!this.captchaSuccess()) {
                return;
            }

            var netAddress = _lodash2.default.trim(options.server);

            var net = this.network || _state2.default.getNetworkFromAddress(netAddress);

            var password = this.password;
            if (options.bouncer) {
                password = this.nick + ':' + this.password;
            }

            net = net || _state2.default.addNetwork('Network', this.nick, {
                server: netAddress,
                port: options.port,
                tls: options.tls,
                password: password,
                encoding: _lodash2.default.trim(options.encoding),
                direct: !!options.direct,
                path: options.direct_path || '',
                gecos: options.gecos
            });

            net.connection.nick = this.nick;
            net.password = password;

            if (_lodash2.default.trim(options.encoding || '')) {
                net.connection.encoding = _lodash2.default.trim(options.encoding);
            }

            if (!this.network && options.recaptchaSiteId) {
                net.captchaResponse = this.captchaResponse();
            }
            this.network = net;

            var hasSwitchedActiveBuffer = false;
            var bufferObjs = Misc.extractBuffers(this.channel);
            bufferObjs.forEach(function (bufferObj) {
                var newBuffer = _state2.default.addBuffer(net.id, bufferObj.name);
                newBuffer.enabled = true;

                if (newBuffer && !hasSwitchedActiveBuffer) {
                    _state2.default.setActiveBuffer(net.id, newBuffer.name);
                    hasSwitchedActiveBuffer = true;
                }

                if (bufferObj.key) {
                    newBuffer.key = bufferObj.key;
                }
            });

            if (!hasSwitchedActiveBuffer) {
                _state2.default.setActiveBuffer(net.id, net.serverBuffer().name);
            }

            net.ircClient.connect();
            var onRegistered = function onRegistered() {
                if (_this.$refs.layout) {
                    _this.$refs.layout.close();
                }
                net.ircClient.off('registered', onRegistered);
                net.ircClient.off('close', onClosed);
            };
            var onClosed = function onClosed() {
                net.ircClient.off('registered', onRegistered);
                net.ircClient.off('close', onClosed);
            };
            net.ircClient.once('registered', onRegistered);
            net.ircClient.once('close', onClosed);
        },
        processNickRandomNumber: function processNickRandomNumber(nick) {
            var tmp = (nick || '').replace(/\?/g, function () {
                return Math.floor(Math.random() * 100).toString();
            });
            return _lodash2.default.trim(tmp);
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["startups"]) window._kiwi_exports["components"]["startups"] = {};
window._kiwi_exports["components"]["startups"]["Welcome"]
window._kiwi_exports.components.startups.Welcome = exports.default ? exports.default : exports;


/***/ }),

/***/ "o3P4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o60X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-wrap kiwi-wrap-error"},[_c('h2',[_vm._v("Kiwi IRC could not start :(")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.error))])])}
var staticRenderFns = []


/***/ }),

/***/ "oCvS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsAliases_vue__ = __webpack_require__("bhyE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsAliases_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsAliases_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsAliases_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsAliases_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80134fe2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsAliases_vue__ = __webpack_require__("WyJs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("gYtO")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsAliases_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80134fe2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsAliases_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80134fe2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsAliases_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "oLET":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-networksettings"},[_c('form',{staticClass:"u-form"},[_c('div',{staticClass:"kiwi-title"},[_vm._v(_vm._s(_vm.$t('settings_server_details')))]),_vm._v(" "),_c('div',{staticClass:"kiwi-networksettings-section-block"},[(_vm.network.state_error)?_c('div',{staticClass:"kiwi-networksettings-error"},[_vm._v("\n                "+_vm._s(_vm.$t('network_noconnect'))+"\n                "),_c('span',[_vm._v(_vm._s(_vm.readableStateError(_vm.network.state_error)))])]):(_vm.network.last_error)?_c('div',{staticClass:"kiwi-networksettings-error"},[_vm._v("\n                "+_vm._s(_vm.$t('network_noconnect'))+"\n                "),_c('span',[_vm._v(_vm._s(_vm.network.last_error))])]):_vm._e(),_vm._v(" "),_c('server-selector',{attrs:{"connection":_vm.network.connection,"network-list":_vm.network_list}}),_vm._v(" "),_c('div',{staticClass:"kiwi-networksettings-connection-password"},[(_vm.server_type==='network')?[_c('input-text',{attrs:{"show-plain-text":true,"label":_vm.$t('password'),"type":"password"},model:{value:(_vm.network.password),callback:function ($$v) {_vm.$set(_vm.network, "password", $$v)},expression:"network.password"}})]:[_c('input-text',{attrs:{"label":_vm.$t('username')},model:{value:(_vm.znc_username),callback:function ($$v) {_vm.znc_username=$$v},expression:"znc_username"}}),_vm._v(" "),_c('input-text',{attrs:{"label":_vm.$t('network')},model:{value:(_vm.znc_network),callback:function ($$v) {_vm.znc_network=$$v},expression:"znc_network"}}),_vm._v(" "),_c('input-text',{attrs:{"label":_vm.$t('password'),"type":"password"},model:{value:(_vm.znc_password),callback:function ($$v) {_vm.znc_password=$$v},expression:"znc_password"}})]],2),_vm._v(" "),_c('div',{staticClass:"kiwi-networksettings-server-types"},[(_vm.server_type==='znc')?_c('div',{staticClass:"kiwi-networksettings-server-types-info"},[_vm._v("\n                    "+_vm._s(_vm.$t('settings_znc_other'))+"\n                ")]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"u-link kiwi-network-type-button",class:{
                        'kiwi-networksettings-server-type-active':
                            _vm.server_type==='network'
                    },on:{"click":function($event){_vm.server_type='network'}}},[_vm._v("\n                    "+_vm._s(_vm.$t('network'))+"\n                ")]),_vm._v(" "),_c('a',{staticClass:"u-link kiwi-network-type-button",class:{
                        'kiwi-networksettings-server-type-active': _vm.server_type==='znc'
                    },on:{"click":function($event){_vm.server_type='znc'}}},[_vm._v("\n                    "+_vm._s(_vm.$t('znc'))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"kiwi-networksettings-user"},[_c('input-text',{attrs:{"label":_vm.$t('settings_nickname')},model:{value:(_vm.network.connection.nick),callback:function ($$v) {_vm.$set(_vm.network.connection, "nick", $$v)},expression:"network.connection.nick"}})],1),_vm._v(" "),_c('h4',{staticClass:"kiwi-show-advanced-title",on:{"click":function($event){_vm.show_advanced=!_vm.show_advanced}}},[_vm._v("\n                "+_vm._s(_vm.$t('settings_advanced'))+"\n                "),_c('i',{staticClass:"fa",class:['fa-caret-'+(_vm.show_advanced?'up':'down')],attrs:{"aria-hidden":"true"}})]),_vm._v(" "),(_vm.show_advanced)?_c('div',{staticClass:"kiwi-networksettings-advanced"},[[_c('input-text',{attrs:{"label":_vm.$t('settings_encoding')},model:{value:(_vm.network.connection.encoding),callback:function ($$v) {_vm.$set(_vm.network.connection, "encoding", $$v)},expression:"network.connection.encoding"}}),_vm._v(" "),_c('label',[_c('span',{staticClass:"kiwi-appsettings-showraw-label"},[_vm._v("\n                            "+_vm._s(_vm.$t('settings_show_raw'))+"\n                        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settingShowRaw),expression:"settingShowRaw"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.settingShowRaw)?_vm._i(_vm.settingShowRaw,null)>-1:(_vm.settingShowRaw)},on:{"change":function($event){var $$a=_vm.settingShowRaw,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.settingShowRaw=$$a.concat([$$v]))}else{$$i>-1&&(_vm.settingShowRaw=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.settingShowRaw=$$c}}}})]),_vm._v(" "),_c('label',[_c('span',{staticClass:"kiwi-appsettings-showraw-label"},[_vm._v("\n                            "+_vm._s(_vm.$t('settings_use_websocket'))+"\n                        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.network.connection.direct),expression:"network.connection.direct"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.network.connection.direct)?_vm._i(_vm.network.connection.direct,null)>-1:(_vm.network.connection.direct)},on:{"change":function($event){var $$a=_vm.network.connection.direct,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.network.connection, "direct", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.network.connection, "direct", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.network.connection, "direct", $$c)}}}}),_vm._v(" "),(_vm.network.connection.direct)?_c('input-text',{model:{value:(_vm.directWs),callback:function ($$v) {_vm.directWs=$$v},expression:"directWs"}}):_vm._e()],1),_vm._v(" "),_c('label',{staticClass:"u-form-block"},[_c('input-text',{attrs:{"label":_vm.$t('settings_autorun'),"type":"textarea"},model:{value:(_vm.network.auto_commands),callback:function ($$v) {_vm.$set(_vm.network, "auto_commands", $$v)},expression:"network.auto_commands"}})],1)]],2):_vm._e(),_vm._v(" "),(_vm.network.state === 'disconnected')?_c('div',{staticClass:"u-button kiwi-connect-to-newnetwork",on:{"click":function($event){return _vm.connect()}}},[_vm._v("\n                "+_vm._s(_vm.$t('network_connect'))+"\n            ")]):(_vm.network.state === 'connecting')?_c('div',{staticClass:"u-button kiwi-connect-to-newnetwork"},[_vm._v("\n                "+_vm._s(_vm.$t('connecting'))+"\n            ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"kiwi-dangerzone"},[_c('h3',[_vm._v(_vm._s(_vm.$t('settings_danger')))]),_vm._v(" "),_c('a',{staticClass:"u-button u-button-warning",on:{"click":_vm.removeNetwork}},[_c('i',{staticClass:"fa fa-times",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.$t('settings_remove'))+"\n            ")])])])])}
var staticRenderFns = []


/***/ }),

/***/ "of+2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.af7ae50.woff2";

/***/ }),

/***/ "ox6C":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _setImmediate2 = __webpack_require__("YQ7m");

var _setImmediate3 = _interopRequireDefault(_setImmediate2);

var _create = __webpack_require__("OvRC");

var _create2 = _interopRequireDefault(_create);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _vue = __webpack_require__("I3G/");

var _vue2 = _interopRequireDefault(_vue);

var _common = __webpack_require__("nlr4");

var _IrcClient = __webpack_require__("jnb6");

var IrcClient = _interopRequireWildcard(_IrcClient);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NetworkState = function () {
    function NetworkState(id, appState, userDict, bufferDict) {
        var _this = this;

        (0, _classCallCheck3.default)(this, NetworkState);

        this.id = id;
        this.name = '';

        this.state = 'disconnected';
        this.state_error = '';

        this.last_error = '';
        this.auto_commands = '';
        this.is_znc = false;
        this.hidden = false;
        this.channel_list = [];
        this.channel_list_state = '';

        this.ircd = '';
        this.connection = {
            server: '',
            port: 6667,
            tls: false,
            path: '',
            password: '',
            direct: false,
            encoding: 'utf8',
            bncname: '',
            nick: ''
        };
        this.settings = {
            show_raw_caps: false
        };
        this.nick = '';
        this.username = '';
        this.gecos = '';
        this.password = '';
        this.away = '';

        _vue2.default.observable(this);

        (0, _common.def)(this, 'appState', appState, false);
        (0, _common.def)(this, 'userDict', userDict, false);
        (0, _common.def)(this, 'bufferDict', bufferDict, false);
        (0, _common.def)(this, 'frameworkClient', null, true);

        (0, _common.def)(this, 'users', (0, _create2.default)(null), function (newVal) {
            appState.$set(userDict.networks, _this.id, newVal);
        });

        (0, _common.def)(this, 'pendingPms', [], false);

        bufferDict.$set(bufferDict.networks, this.id, []);
    }

    (0, _createClass3.default)(NetworkState, [{
        key: 'connect',
        value: function connect() {
            var _ircClient;

            (_ircClient = this.ircClient).connect.apply(_ircClient, arguments);
        }
    }, {
        key: 'bufferByName',
        value: function bufferByName(name) {
            return this.appState.getBufferByName(this.id, name);
        }
    }, {
        key: 'serverBuffer',
        value: function serverBuffer() {
            return this.appState.getBufferByName(this.id, '*');
        }
    }, {
        key: 'setting',
        value: function setting(name, val) {
            if (typeof val !== 'undefined') {
                this.appState.$set(this.settings, name, val);
                return val;
            }

            return this.settings[name];
        }
    }, {
        key: 'isChannelName',
        value: function isChannelName(input) {
            if (typeof input !== 'string' || !input) {
                return false;
            }

            var chanPrefixes = this.ircClient.network.supports('CHANTYPES') || '#&';
            return chanPrefixes.indexOf(input[0]) > -1;
        }
    }, {
        key: 'showServerBuffer',
        value: function showServerBuffer(tabName) {
            var _this2 = this;

            this.appState.$emit('active.component', null);
            this.appState.setActiveBuffer(this.id, this.serverBuffer().name);

            (0, _setImmediate3.default)(function () {
                _this2.appState.$emit('server.tab.show', tabName || 'settings');
            });
        }
    }, {
        key: 'isNickExemptFromPmBlocks',
        value: function isNickExemptFromPmBlocks(nick) {
            var buffers = this.appState.getBuffersWithUser(this.id, nick);
            for (var i = 0; i < buffers.length; i++) {
                var buffer = buffers[i];
                if (buffer.isUserAnOp(nick)) {
                    return true;
                }
            }

            var user = this.appState.getUser(this.indexOf, nick);
            if (!user || !user.hasWhois) {
                return null;
            }

            if (user.operator) {
                return true;
            }
            return false;
        }
    }, {
        key: 'currentUser',
        value: function currentUser() {
            return this.appState.getUser(this.id, this.nick);
        }
    }, {
        key: 'userByName',
        value: function userByName(nick) {
            return this.appState.getUser(this.id, nick);
        }
    }, {
        key: 'ircClient',
        get: function get() {
            if (!this.frameworkClient) {
                this.frameworkClient = IrcClient.create(this.appState, this);
            }

            return this.frameworkClient;
        }
    }, {
        key: 'buffers',
        get: function get() {
            return this.bufferDict.networks[this.id];
        }
    }]);
    return NetworkState;
}();

exports.default = NetworkState;

/***/ }),

/***/ "pnnM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qrBh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qrDz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-controlinput kiwi-theme-bg",class:{
        'kiwi-controlinput-selfuser--open': _vm.selfuser_open,
        'kiwi-controlinput--focus': _vm.has_focus,
    }},[_c('div',{staticClass:"kiwi-controlinput-selfuser"},[_c('transition',{attrs:{"name":"kiwi-selfuser-trans"}},[(_vm.networkState==='connected'
                && _vm.selfuser_open === true)?_c('self-user',{attrs:{"network":_vm.buffer.getNetwork()},on:{"close":function($event){_vm.selfuser_open=false}}}):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"kiwi-controlinput-inner"},[(_vm.buffer.getNetwork() && _vm.buffer.getNetwork().state === 'connected')?_c('away-status-indicator',{attrs:{"network":_vm.buffer.getNetwork(),"user":_vm.buffer.getNetwork().currentUser()}}):_vm._e(),_vm._v(" "),(_vm.currentNick)?_c('div',{staticClass:"kiwi-controlinput-user",on:{"click":_vm.toggleSelfUser}},[_c('span',{staticClass:"kiwi-controlinput-user-nick"},[_vm._v(_vm._s(_vm.currentNick))]),_vm._v(" "),_c('i',{staticClass:"fa",class:[_vm.selfuser_open ? 'fa-caret-down' : 'fa-caret-up'],attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),_c('form',{staticClass:"kiwi-controlinput-form",on:{"submit":function($event){$event.preventDefault();return _vm.submitForm($event)},"click":_vm.maybeHidePlugins}},[(_vm.autocomplete_open)?_c('auto-complete',{ref:"autocomplete",attrs:{"items":_vm.autocomplete_items,"filter":_vm.autocomplete_filter,"buffer":_vm.buffer},on:{"temp":_vm.onAutocompleteTemp,"selected":_vm.onAutocompleteSelected,"cancel":_vm.onAutocompleteCancel}}):_vm._e(),_vm._v(" "),(_vm.buffer.setting('share_typing'))?_c('typing-users-list',{attrs:{"buffer":_vm.buffer}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"kiwi-controlinput-input-wrap"},[_c('irc-input',{ref:"input",staticClass:"kiwi-controlinput-input",attrs:{"placeholder":_vm.$t('input_placeholder'),"wrap":"off"},on:{"input":_vm.inputUpdate,"keydown":function($event){return _vm.inputKeyDown($event)},"keyup":function($event){return _vm.inputKeyUp($event)},"click":_vm.closeInputTool,"focus":function($event){_vm.has_focus = true},"blur":function($event){_vm.has_focus = false}}})],1),_vm._v(" "),(_vm.shouldShowSendButton)?_c('button',{staticClass:"kiwi-controlinput-send fa fa-paper-plane",attrs:{"type":"submit"}}):_vm._e()],1),_vm._v(" "),(_vm.shouldShowInputButtons)?_c('div',{ref:"plugins",staticClass:"kiwi-controlinput-tools"},[_c('div',{staticClass:"kiwi-controlinput-tools-container-expand",class:{'kiwi-controlinput-tools-container-expand--inverse': !_vm.showPlugins},on:{"click":function($event){_vm.showPlugins=!_vm.showPlugins}}},[_c('i',{staticClass:"fa fa-bars",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('transition',{attrs:{"name":"kiwi-plugin-ui-trans"}},[(_vm.showPlugins)?_c('div',{staticClass:"kiwi-controlinput-tools-container"},[(_vm.shouldShowColorPicker)?_c('a',{staticClass:"kiwi-controlinput-tool",on:{"click":function($event){$event.preventDefault();return _vm.onToolClickTextStyle($event)}}},[_c('i',{staticClass:"fa fa-adjust",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.shouldShowEmojiPicker)?_c('a',{staticClass:"kiwi-controlinput-tool",on:{"click":function($event){$event.preventDefault();return _vm.onToolClickEmoji($event)}}},[_c('i',{staticClass:"fa fa-smile-o",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),_vm._l((_vm.pluginUiElements),function(plugin){return _c('div',{directives:[{name:"rawElement",rawName:"v-rawElement",value:({
                            el: plugin.el,
                            props: {
                                controlinput: _vm.self,
                            }
                        }),expression:"{\n                            el: plugin.el,\n                            props: {\n                                controlinput: self,\n                            }\n                        }"}],key:plugin.id,staticClass:"kiwi-controlinput-tool"})})],2):_vm._e()])],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"kiwi-controlinput-active-tool"},[_c(_vm.active_tool,_vm._b({tag:"component"},'component',_vm.active_tool_props,false))],1)])}
var staticRenderFns = []


/***/ }),

/***/ "rN/E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-channelinfo"},[_c('form',{staticClass:"u-form kiwi-channelinfo-basicmodes",on:{"submit":function($event){$event.preventDefault();}}},[_c('label',{staticClass:"kiwi-channelinfo-topic"},[_c('span',[_vm._v(_vm._s(_vm.$t('channel_topic')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.topic),expression:"topic",modifiers:{"lazy":true}}],attrs:{"rows":"2"},domProps:{"value":(_vm.topic)},on:{"change":function($event){_vm.topic=$event.target.value}}})]),_vm._v(" "),(_vm.buffer.topics.length > 1)?_c('div',{staticClass:"kiwi-channelinfo-previoustopics"},[_c('a',{staticClass:"u-link",on:{"click":function($event){_vm.showPrevTopics = !_vm.showPrevTopics}}},[_vm._v("\n                Previous topics\n                "),_c('i',{class:'fa fa-caret-' + (_vm.showPrevTopics ? 'up' : 'down')})]),_vm._v(" "),(_vm.showPrevTopics)?_c('ul',_vm._l((_vm.buffer.topics),function(topic,idx){return (topic.trim())?_c('li',{key:idx},[_c('span',[_vm._v(_vm._s(topic))])]):_vm._e()}),0):_vm._e()]):_vm._e(),_vm._v(" "),_c('label',{staticClass:"u-checkbox-wrapper"},[_c('span',[_vm._v(_vm._s(_vm.$t('channel_moderated')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modeM),expression:"modeM"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.modeM)?_vm._i(_vm.modeM,null)>-1:(_vm.modeM)},on:{"change":function($event){var $$a=_vm.modeM,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.modeM=$$a.concat([$$v]))}else{$$i>-1&&(_vm.modeM=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.modeM=$$c}}}})]),_vm._v(" "),_c('label',{staticClass:"u-checkbox-wrapper"},[_c('span',[_vm._v(_vm._s(_vm.$t('channel_invite')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modeI),expression:"modeI"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.modeI)?_vm._i(_vm.modeI,null)>-1:(_vm.modeI)},on:{"change":function($event){var $$a=_vm.modeI,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.modeI=$$a.concat([$$v]))}else{$$i>-1&&(_vm.modeI=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.modeI=$$c}}}})]),_vm._v(" "),_c('label',{staticClass:"u-checkbox-wrapper"},[_c('span',[_vm._v(_vm._s(_vm.$t('channel_moderated_topic')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modeT),expression:"modeT"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.modeT)?_vm._i(_vm.modeT,null)>-1:(_vm.modeT)},on:{"change":function($event){var $$a=_vm.modeT,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.modeT=$$a.concat([$$v]))}else{$$i>-1&&(_vm.modeT=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.modeT=$$c}}}})]),_vm._v(" "),_c('label',{staticClass:"u-checkbox-wrapper"},[_c('span',[_vm._v(_vm._s(_vm.$t('channel_external')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modeN),expression:"modeN"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.modeN)?_vm._i(_vm.modeN,null)>-1:(_vm.modeN)},on:{"change":function($event){var $$a=_vm.modeN,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.modeN=$$a.concat([$$v]))}else{$$i>-1&&(_vm.modeN=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.modeN=$$c}}}})]),_vm._v(" "),_c('label',[_c('span',[_vm._v(_vm._s(_vm.$t('password')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.modeK),expression:"modeK",modifiers:{"lazy":true}}],staticClass:"u-input",attrs:{"type":"text"},domProps:{"value":(_vm.modeK)},on:{"change":function($event){_vm.modeK=$event.target.value}}})])])])}
var staticRenderFns = []


/***/ }),

/***/ "rPJe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['buffer'],
    data: function data() {
        return {
            banlist: [],
            is_refreshing: false
        };
    },
    created: function created() {
        this.updateBanlist();
    },
    methods: {
        updateBanlist: function updateBanlist() {
            var _this = this;

            if (this.buffer.getNetwork().state !== 'connected' || this.is_refreshing) {
                return;
            }

            var channelName = this.buffer.name;
            this.is_refreshing = true;
            this.buffer.getNetwork().ircClient.banlist(channelName, function (banEvent) {
                _this.banlist = banEvent.bans;
                _this.is_refreshing = false;
            });
        },
        removeBan: function removeBan(mask) {
            var channelName = this.buffer.name;
            this.buffer.getNetwork().ircClient.unban(channelName, mask);
            this.banlist = this.banlist.filter(function (ban) {
                return ban.banned !== mask;
            });
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["ChannelBanlist"]
window._kiwi_exports.components.ChannelBanlist = exports.default ? exports.default : exports;


/***/ }),

/***/ "rdYF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rwPc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingAnimation_vue__ = __webpack_require__("HpWa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingAnimation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingAnimation_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingAnimation_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingAnimation_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bad49a1_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingAnimation_vue__ = __webpack_require__("E4HS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("dZBv")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingAnimation_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bad49a1_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingAnimation_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bad49a1_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingAnimation_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "sOme":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var Vue = __webpack_require__("I3G/");

Vue.component('tabbed-tab', {
    props: {
        header: { status: String },
        focus: { status: Boolean },
        name: { status: String }
    },
    data: function data() {
        return { active: false };
    },
    template: '<div v-if="active" class="u-tabbed-content"><slot></slot></div>'
});

exports.default = Vue.component('tabbed-view', {
    data: function data() {
        return {
            a: 1,
            prefixID: Math.floor(Math.random() * 100000).toString(36)
        };
    },
    computed: {
        tabs: function computedtabs() {
            return this.$children;
        }
    },
    mounted: function mounted() {
        this.setActiveCheck();
    },

    methods: {
        getActive: function getActive() {
            var foundChild = null;
            this.$children.forEach(function (child) {
                if (child.active) {
                    foundChild = child;
                }
            });

            return foundChild;
        },
        setActive: function setActive(c) {
            this.$children.forEach(function (child) {
                if (child !== c) {
                    child.active = false;
                }
            });
            c.active = true;

            this.a++;
            this.$emit('changed', c.name);
        },
        setActiveByName: function setActiveByName(name) {
            var _this = this;

            this.$children.forEach(function (child) {
                if (child.name === name) {
                    _this.setActive(child);
                }
            });
        },
        setActiveCheck: function setActiveCheck() {
            var _this2 = this;

            this.$children.forEach(function (t) {
                if (t.focus) {
                    _this2.setActive(t);
                }
            });
        }
    }
});
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["utils"]) window._kiwi_exports["components"]["utils"] = {};
window._kiwi_exports["components"]["utils"]["TabbedView"]
window._kiwi_exports.components.utils.TabbedView = exports.default ? exports.default : exports;


/***/ }),

/***/ "t8YU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-inputtool-emoji"},[_c('div',{staticClass:"kiwi-inputtool-emoji-palette",on:{"mousedown":function($event){$event.preventDefault();},"click":function($event){$event.preventDefault();}}},_vm._l((_vm.emojis),function(text,eCode){return _c('div',{key:eCode,staticClass:"kiwi-inputtool-emoji-emoji",style:({'background-image':("url(" + _vm.location + eCode + ".png)")}),attrs:{"data-code":text + ' '},on:{"click":_vm.onImgClick}})}),0)])}
var staticRenderFns = []


/***/ }),

/***/ "tewY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatePersistence = function () {
    function StatePersistence(storageKey, state, storage, logger) {
        (0, _classCallCheck3.default)(this, StatePersistence);

        this.storageKey = storageKey;
        this.state = state;
        this.storage = storage;
        this.logger = logger;
        this.isPersisting = false;
        this.includeBuffers = true;

        this.state.persistence = this;
    }

    (0, _createClass3.default)(StatePersistence, [{
        key: 'loadStateIfExists',
        value: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var storedState;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (this.storageKey) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:
                                _context.next = 4;
                                return this.storage.get(this.storageKey);

                            case 4:
                                storedState = _context.sent;

                                if (storedState) {
                                    if (this.logger) {
                                        this.logger('Importing state', storedState);
                                    }

                                    this.state.importState(storedState);
                                }

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function loadStateIfExists() {
                return _ref.apply(this, arguments);
            }

            return loadStateIfExists;
        }()
    }, {
        key: 'watchStateForChanges',
        value: function watchStateForChanges() {
            var _this = this;

            if (!this.storageKey) {
                return;
            }

            var debouncedSaveState = _lodash2.default.debounce(function () {
                if (_this.logger) {
                    _this.logger('State updated, setting localStorage');
                }

                _this.storage.set(_this.storageKey, _this.state.exportState(_this.includeBuffers));
            }, 1000);

            this.state.$watch('networks', debouncedSaveState, { deep: true });
            this.state.$watch('user_settings', debouncedSaveState, { deep: true });

            var bufferWatchers = [];
            var watchBuffers = function watchBuffers() {
                bufferWatchers.forEach(function (w) {
                    return w();
                });
                bufferWatchers = [];

                _this.state.networks.forEach(function (network) {
                    var bufferNames = network.buffers.map(function (b) {
                        return b.name;
                    }).join(',');

                    network.buffers.forEach(function (buffer) {
                        var unwatch = _this.state.$watch(function () {
                            var val = (0, _stringify2.default)([bufferNames, buffer.name, buffer.settings, buffer.joined, buffer.enabled, buffer.last_read]);

                            return val;
                        }, debouncedSaveState);

                        bufferWatchers.push(unwatch);
                    });
                });

                setTimeout(watchBuffers, 2000);
            };

            setTimeout(watchBuffers, 2000);

            this.isPersisting = true;
        }
    }, {
        key: 'forgetState',
        value: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                this.state.resetState();
                                _context2.next = 3;
                                return this.storage.set(this.storageKey, null);

                            case 3:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function forgetState() {
                return _ref2.apply(this, arguments);
            }

            return forgetState;
        }()
    }]);
    return StatePersistence;
}();

exports.default = StatePersistence;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["StatePersistence"]
window._kiwi_exports.libs.StatePersistence = exports.default ? exports.default : exports;


/***/ }),

/***/ "tpeZ":
/***/ (function(module, exports) {

module.exports = "<h3>Linking to your network /channel</h3>\n\n<p>Some quick examples on how you can link directly to your network or channels. Even better, embed them into an iframe directly on your website.</p>\n<ul>\n\t<li><a target=\"_blank\" href=\"https://kiwiirc.com/nextclient/irc.server.com/#channel\">https://kiwiirc.com/nextclient/irc.server.com/#channel</a></li>\n\t<li><a target=\"_blank\" href=\"https://kiwiirc.com/nextclient/irc.server.com/#channel,#channel2\">https://kiwiirc.com/nextclient/irc.server.com/#channel,#channel2</a></li>\n\t<li><a target=\"_blank\" href=\"https://kiwiirc.com/nextclient/#irc://irc.server.com/#channel,#channel2\">https://kiwiirc.com/nextclient/#irc://irc.server.com/#channel,#channel2</a></li>\n</ul>\n\n<p>As a bonus, you can link to multiple IRC networks at the same time:</p>\n<ul>\n\t<li><a target=\"_blank\" href=\"https://kiwiirc.com/nextclient/#irc://irc.server.com/#channel;irc://irc.exmaple.net/#channel\">https://kiwiirc.com/nextclient/#irc://irc.server.com/#channel;irc://irc.exmaple.net/#channel</a></li>\n</ul>\n\n<p>Or maybe you host a ZNC server and want to link to it:</p>\n<ul>\n\t<li><a target=\"_blank\" href=\"https://kiwiirc.com/nextclient/#irc://irc.server.com/#channel?type=znc&nick=username\">https://kiwiirc.com/nextclient/#irc://irc.server.com/#channel?type=znc&nick=username</a></li>\n</ul>\n\n<hr style=\"margin:4em 0;\" />\n\n<h3>What's new in Kiwi Next?</h3>\n\n<h4>Networks and settings remembered</h4>\n<p>All your settings and networks will be remembered for when you come back. You won't need to be re-entering your favourite networks every time you open Kiwi anymore.</p>\n\n<h4>Mobile and tablet support</h4>\n<p>Now that over 50% of internet usage is now on mobile, Kiwi has complete mobile support with new layouts and messages. Everything is accessible with just your fingers.</p>\n\n<h4>Embedded images and videos</h4>\n<p>Opening photos and videos within Kiwi now gets pinned at the bottom of the screen. This lets you switch channels, keep talking without it going off-screen, and have that permenant youtube video playing while you're talking.</p>\n\n<h4>ZNC integration</h4>\n<p>When connecting to a ZNC server, Kiwi will now automatically detect it and look for any other networks in your ZNC account. If any are found then they are shown in a list - just one click away from connecting to it.</p>\n\n<h4>Aliases editor</h4>\n<p>A full alias editor to create command aliases to handle users in your channel, administrate your network or project, or even join multiple commands into a single helpful command. Created by a simple text editor that lets you copy/paste/share your aliases wherever you please.</p>\n\n<h4>Raw IRC power</h4>\n<p>If you're a power IRC user or like to get indepth, Kiwi now uses the raw IRC protocol directly in the browser. Look at the raw IRC messages going back and forth, send raw commands, or use it's scripting to test out new protocol ideas and experiments.</p>\n\n<h4>The most IRCv3 compliant open source web IRC client</h4>\n<p>IRC is being pushed forward by the <a href=\"http://ircv3.net\" target=\"_blank\">IRCv3 working group</a> which brings us new features that any IRC client can be using. Not only taking part, but Kiwi is one of the most IRCv3 complete web clients that exists.</p>\n";

/***/ }),

/***/ "uN9+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

var _create = __webpack_require__("OvRC");

var _create2 = _interopRequireDefault(_create);

exports.extractBuffers = extractBuffers;
exports.extractURL = extractURL;
exports.splitHost = splitHost;
exports.stripStyles = stripStyles;
exports.mentionsNick = mentionsNick;
exports.queryStringVal = queryStringVal;
exports.networkErrorMessage = networkErrorMessage;
exports.parseIrcUri = parseIrcUri;
exports.dedotObject = dedotObject;
exports.replaceObjectProps = replaceObjectProps;
exports.dateIso = dateIso;

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _strftime = __webpack_require__("Sgar");

var _strftime2 = _interopRequireDefault(_strftime);

var _TextFormatting = __webpack_require__("15gS");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var strftimeUTC = _strftime2.default.timezone('+0');
function extractBuffers(str) {
    var spaceIdx = str.indexOf(' ');
    if (spaceIdx === -1) spaceIdx = str.length;

    var bufferNames = str.substr(0, spaceIdx).split(',');
    var keys = str.substr(spaceIdx + 1).split(',');

    var buffers = [];
    bufferNames.forEach(function (bufferName, idx) {
        if (!bufferName.trim()) {
            return;
        }
        buffers.push({
            name: bufferName,
            key: keys[idx] || ''
        });
    });

    return buffers;
}

function extractURL(str) {
    var matches = str.match(_TextFormatting.urlRegex);
    return matches ? matches[0] : '';
}

function splitHost(uri) {}

function stripStyles(str) {
    return str.replace(/(\x03[0-9]{0,2})?([\x02\x16\x1d\x1f]+)?/g, '');
}

function mentionsNick(input, nick) {
    if (input.toLowerCase().indexOf(nick.toLowerCase()) === -1) {
        return false;
    }
    var punc = '\\s,.!:;+()\\[\\]?¿\\/<>@-';
    var escapedNick = _lodash2.default.escapeRegExp(nick);
    var stylesStrippedInput = stripStyles(input);
    var r = new RegExp('(^|[' + punc + '])' + escapedNick + '([' + punc + ']|$)', 'i');
    return r.test(stylesStrippedInput);
}

function queryStringVal(_name, _url) {
    var url = _url || window.location.href;
    var name = _lodash2.default.escapeRegExp(_name);
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    var results = regex.exec(url);

    if (!results) {
        return null;
    }
    if (!results[2]) {
        return '';
    }

    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function networkErrorMessage(err) {
    var errs = {
        err_unknown_host: 'Unknown domain name or host',
        err_forbidden: 'Forbidden to connect',
        err_timeout: 'Took too long to connect',
        err_refused: 'The server refused the connection',
        err_tls: 'Could not connect securely',
        err_proxy: 'The Kiwi IRC server had an error'
    };

    return errs[err] || 'Unknown error';
}

function parseIrcUri(str) {
    var reg = /(?:(ircs?):\/\/)?([a-z.0-9-]+)(?::(?:(\+)?([0-9]+)))?(?:\/([^?]*))?(?:\?(.*))?/;
    var connections = [];
    str.split(';').forEach(function (connectionString) {
        if (!connectionString) {
            return;
        }

        var m = connectionString.match(reg);

        if (!m) {
            return;
        }

        var tls = m[1] === 'ircs' || !!m[3];
        var params = (0, _create2.default)(null);
        (m[6] || '').split('&').forEach(function (p) {
            var parts = p.split('=');
            if (parts.length === 2) {
                params[parts[0].toLowerCase()] = parts[1];
            }
        });

        var channels = m[5] || params.channel || '';
        channels = (0, _lodash2.default)(channels.split(',')).compact().map(function (_channelName) {
            var hasPrefix = _channelName[0] === '#' || _channelName[0] === '&';

            var channelName = hasPrefix ? _channelName : '#' + _channelName;

            return channelName;
        });

        connections.push({
            tls: tls,
            server: m[2],
            port: parseInt(m[4] || (tls ? 6697 : 6667), 10),
            channels: channels,
            nick: params.nick || '',
            encoding: params.encoding || 'utf8',
            params: params
        });
    });

    return connections;
}

function dedotObject(confObj, _place) {
    var place = _place || [];
    var regex = /\w\.\w/;

    _lodash2.default.each(confObj, function (val, key) {
        var ourPlace = place.concat([key]);
        if ((typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)) === 'object') {
            dedotObject(confObj[key], ourPlace);
            return;
        }
        if (regex.test(key)) {
            delete confObj[key];
            _lodash2.default.set(confObj, ourPlace.join('.'), val);
        }
    });
}

function replaceObjectProps(target, source) {
    (0, _keys2.default)(target).forEach(function (prop) {
        return delete target[prop];
    });
    (0, _keys2.default)(source).forEach(function (prop) {
        target[prop] = source[prop];
    });
}

function dateIso(date) {
    var d = date || new Date();
    return strftimeUTC('%Y-%m-%dT%H:%M:%S.%LZ', d);
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["helpers"]) window._kiwi_exports["helpers"] = {};
window._kiwi_exports["helpers"]["Misc"]
window._kiwi_exports.helpers.Misc = exports.default ? exports.default : exports;


/***/ }),

/***/ "vM24":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var Vue = __webpack_require__("I3G/");

exports.default = Vue.component('input-text', {
    props: ['value', 'label', 'type', 'showPlainText'],
    data: function data() {
        return {
            plainTextEnabled: false,
            inputIdCache: ''
        };
    },
    computed: {
        inputId: function inputId() {
            if (!this.inputIdCache) {
                this.inputIdCache = 'inp_' + Math.floor(Math.random() * 1e17).toString(36);
            }

            return this.inputIdCache;
        },

        currentValue: {
            get: function getCurrentValue() {
                return this.value;
            },
            set: function setCurrentValue(newVal) {
                this.$emit('input', newVal);
            }
        }
    },
    methods: {
        updateValue: function updateValue(newValue) {
            this.$emit('input', newValue);
        },
        isEdgeBrowser: function isEdgeBrowser() {
            return navigator.appVersion.indexOf('Edge') > -1;
        }
    }
});
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["utils"]) window._kiwi_exports["components"]["utils"] = {};
window._kiwi_exports["components"]["utils"]["InputText"]
window._kiwi_exports.components.utils.InputText = exports.default ? exports.default : exports;


/***/ }),

/***/ "vV7l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AwayStatusIndicator_vue__ = __webpack_require__("j6jx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AwayStatusIndicator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AwayStatusIndicator_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AwayStatusIndicator_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AwayStatusIndicator_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b54850fc_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AwayStatusIndicator_vue__ = __webpack_require__("zkxe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("droJ")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AwayStatusIndicator_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b54850fc_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AwayStatusIndicator_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b54850fc_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AwayStatusIndicator_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "vj9m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wXH7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = parseMessage;

var _lodash = __webpack_require__("M4fF");

var _state = __webpack_require__("LnP8");

var _state2 = _interopRequireDefault(_state);

var _MessageFormatter = __webpack_require__("c8bq");

var _MessageFormatter2 = _interopRequireDefault(_MessageFormatter);

var _TextFormatting = __webpack_require__("15gS");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function parseMessage(message) {
    var formatOpts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var userList = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    var emojiList = _state2.default.setting('emojis');

    var blocks = (0, _MessageFormatter2.default)(message, formatOpts);
    var formatedBlocks = blocks.reduce(function (acc, block, i) {
        return acc.concat(processBlock(block, userList, emojiList));
    }, []);

    return formatedBlocks;
}

function processBlock(block, userList, emojiList) {
    var wordsRegex = /\S+/g;

    var wordMatch = void 0;
    var word = void 0;
    var specialMatches = [];

    while ((wordMatch = wordsRegex.exec(block.content)) !== null) {

        word = wordMatch[0];

        var match = matchChannel(word) || matchUrl(word) || matchUser(word, userList) || matchEmoji(word, emojiList);

        if (match) {
            specialMatches.push({
                index: wordMatch.index + match.index,
                match: match.match,
                block: (0, _MessageFormatter.createNewBlock)(match.match, block.styles, match.type, match.meta)
            });
        }
    }

    if (specialMatches.length === 0) {
        return [block];
    }

    return mergeMatches(block, specialMatches);
}

function matchChannel(word) {
    var channelMatch = _TextFormatting.channelRegex.exec(word);


    if (channelMatch === null) {
        return false;
    }

    return {
        index: channelMatch[1].length + channelMatch[2].length,
        match: channelMatch[3],
        type: 'channel',
        meta: {
            channel: channelMatch[3]
        }
    };
}

function matchUrl(word) {
    var urlMatch = _TextFormatting.urlRegex.exec(word);

    if (urlMatch === null) {
        return false;
    }

    var url = urlMatch[0];

    if (url.match(/^javascript:/i)) {
        return false;
    }

    if (url.indexOf('(') === -1 && url[url.length - 1] === ')') {
        url = url.substr(0, url.length - 1);
    }

    var urlText = url;
    if (urlText.match(/^www\./i)) {
        urlText = 'http://' + url;
    }

    return {
        index: urlMatch.index,
        match: url,
        matchText: urlText,
        type: 'url',
        meta: {
            url: urlText
        }
    };
}

function matchUser(word, userList) {
    if (!userList) {
        return false;
    }

    var user = null;
    var punc = ',.!:;-+)]?¿\\/<>@';
    var hasProp = Object.prototype.hasOwnProperty;
    var nickIdx = 0;

    var trimWord = (0, _lodash.trim)(word, punc);
    var normWord = trimWord.toLowerCase();

    if (hasProp.call(userList, normWord)) {
        user = userList[normWord];
        nickIdx = word.indexOf(trimWord);
    } else {
        return false;
    }

    return {
        index: nickIdx,
        match: trimWord,
        type: 'user',
        meta: {
            user: trimWord,
            colour: user.colour
        }
    };
}

function matchEmoji(word, emojiList) {
    if (emojiList.hasOwnProperty && !emojiList.hasOwnProperty(word)) {
        return false;
    }

    return {
        index: 0,
        match: word,
        type: 'emoji',
        meta: {
            emoji: emojiList[word]
        }
    };
}

function mergeMatches(block, specialMatches) {
    var resultBlocks = [];
    var lastProcessedIndex = 0;

    specialMatches.forEach(function (specialMatch, index) {
        var beforeMatchContent = block.content.substr(lastProcessedIndex, specialMatch.index - lastProcessedIndex);

        if (beforeMatchContent) {
            resultBlocks.push({
                content: beforeMatchContent,
                styles: (0, _extends3.default)({}, block.styles),
                containsContent: !!beforeMatchContent
            });
        }

        resultBlocks.push(specialMatch.block);

        lastProcessedIndex = specialMatch.index + specialMatch.match.length;
    });

    if (lastProcessedIndex < block.content.length) {
        resultBlocks.push({
            content: block.content.substr(lastProcessedIndex),
            styles: (0, _extends3.default)({}, block.styles),
            containsContent: !!block.content.substr(lastProcessedIndex)
        });
    }

    return resultBlocks;
}

/***/ }),

/***/ "wb7H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChannelBanlist_vue__ = __webpack_require__("rPJe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChannelBanlist_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChannelBanlist_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChannelBanlist_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChannelBanlist_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff1b8590_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChannelBanlist_vue__ = __webpack_require__("cG7z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("PxXf")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChannelBanlist_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff1b8590_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChannelBanlist_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff1b8590_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChannelBanlist_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "wmYr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _create = __webpack_require__("OvRC");

var _create2 = _interopRequireDefault(_create);

exports.default = typingMiddleware;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function typingMiddleware() {
    return function middleware(client, rawEvents, parsedEvents) {
        addFunctionsToClient(client);
        rawEvents.use(theMiddleware);
    };

    function theMiddleware(command, message, rawLine, client, next) {
        if (!(command === 'TAGMSG' && message.tags['+draft/typing']) && !(command === 'PRIVMSG' && message.nick)) {
            next();
            return;
        }

        var target = message.params[0].toLowerCase() === client.user.nick.toLowerCase() ? message.nick : message.params[0];

        var status = message.tags['+draft/typing'] || 'done';

        client.emit('typing', {
            target: target,
            nick: message.nick,
            ident: message.ident,
            hostname: message.hostname,
            status: status
        });

        next();
    }
}

function addFunctionsToClient(client) {
    var typing = client.typing = {};
    var activeTyping = (0, _create2.default)(null);

    function isEnabled() {
        return client.network.cap.isEnabled('message-tags');
    }

    typing.start = function start(target) {
        if (!isEnabled()) {
            return;
        }

        var lastSentStatus = activeTyping[target.toLowerCase()];
        if (lastSentStatus && lastSentStatus > Date.now() - 3000) {
            return;
        }

        activeTyping[target.toLowerCase()] = Date.now();

        var message = new client.Message('TAGMSG', target);
        message.tags['+draft/typing'] = 'active';
        client.raw(message);
    };

    typing.pause = function pause(target) {
        if (!isEnabled()) {
            return;
        }

        var message = new client.Message('TAGMSG', target);
        message.tags['+draft/typing'] = 'paused';
        client.raw(message);
    };

    typing.stop = function stop(target) {
        if (!isEnabled()) {
            return;
        }

        var message = new client.Message('TAGMSG', target);
        message.tags['+draft/typing'] = 'done';
        client.raw(message);

        delete activeTyping[target.toLowerCase()];
    };
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["TypingMiddleware"]
window._kiwi_exports.libs.TypingMiddleware = exports.default ? exports.default : exports;


/***/ }),

/***/ "wy/0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _MessageInfo = __webpack_require__("ga3F");

var _MessageInfo2 = _interopRequireDefault(_MessageInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        MessageInfo: _MessageInfo2.default
    },
    props: ['ml', 'message', 'idx'],
    data: function data() {
        return {};
    },

    computed: {
        displayNick: function displayNick() {
            var suffix = this.message.nick ? ':' : '';

            return this.message.nick + suffix;
        },
        userColour: function userColour() {
            return this.ml.userColour(this.message.user);
        }
    },
    methods: {
        userMode: function userMode(user) {
            return this.ml.buffer.userMode(user);
        },
        userModePrefix: function userModePrefix(user) {
            return this.ml.buffer.userModePrefix(user);
        }
    }
};

/***/ }),

/***/ "wyE3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _create = __webpack_require__("OvRC");

var _create2 = _interopRequireDefault(_create);

exports.createChannelConstructor = createChannelConstructor;

var _sockjsClient = __webpack_require__("O3w4");

var _sockjsClient2 = _interopRequireDefault(_sockjsClient);

var _eventemitter = __webpack_require__("BzvE");

var _eventemitter2 = _interopRequireDefault(_eventemitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var serverConnections = (0, _create2.default)(null);
var createdChannels = (0, _create2.default)(null);
var controlChannel = '0';

function createChannelConstructor(_addr, sessionId, _socketChannel) {
    var addr = _addr.toLowerCase();

    if (!serverConnections[addr]) {
        serverConnections[addr] = createNewConnection(addr, sessionId);
    }

    var socketChannel = _socketChannel;
    if (!socketChannel) {
        socketChannel = serverConnections[addr].nextChannelId++;
    }

    return createChannelOnConnection(serverConnections[addr], socketChannel);
}

function createNewConnection(wsAddr, sessionId) {
    var connection = new _eventemitter2.default();
    connection.sessionId = '';

    serverConnections[wsAddr] = connection;

    connection.nextChannelId = 1;
    connection.connected = false;

    connection.reconnect = connection.connect = function connect() {
        if (connection.ws) {
            try {
                connection.ws.close();
            } catch (err) {}

            connection.ws = null;
        }
        connection.ws = new _sockjsClient2.default(wsAddr);
        connection.ws.onopen = function () {
            var connectStr = sessionId ? 'CONTROL SESSION ' + sessionId : 'CONTROL START';
            connection.ws.send(':' + controlChannel + ' ' + connectStr);
            connection.connected = true;
            connection.emit('open');
        };
        connection.ws.onclose = function () {
            connection.connected = false;
            connection.ws = null;
            connection.emit('close');
        };
        connection.ws.onmessage = function (event) {
            connection.emit('message', event);

            if (event.data[0] === ':') {
                var message = event.data;
                var spacePos = message.indexOf(' ');

                if (spacePos === -1) {
                    connection.emit('open.' + message.substr(1));
                    return;
                }

                var channelId = message.substr(1, spacePos - 1);
                event.data = message.substr(spacePos + 1);
                connection.emit('message.' + channelId, event);
            } else {
                var parts = event.data.split(' ');

                if (parts[0] === 'SESSION') {
                    connection.sessionId = parts[1];
                }
            }
        };
    };

    connection.connect();
    return connection;
}

function createChannelOnConnection(connection, channelId) {
    return function ConnectionChannelWrapper(options) {
        if (!createdChannels[channelId]) {
            createdChannels[channelId] = new ConnectionChannel(options);
        } else if (connection.connected) {
            createdChannels[channelId].initChannel();
        }

        return createdChannels[channelId];
    };

    function ConnectionChannel(options) {
        var sendControlBuffer = [];
        var encoding = 'utf8';
        var channel = new _eventemitter2.default();
        channel.id = channelId;
        channel.isOpen = false;
        channel.state = 0;
        channel.remoteState = 0;

        connection.on('open', function () {
            connection.ws.send(':' + channelId);
        });

        connection.on('open.' + channelId, function () {
            channel.isOpen = true;

            if (sendControlBuffer.length) {
                sendControlBuffer.forEach(function (line) {
                    channel.sendControl(line);
                });
                sendControlBuffer = [];
            }

            channel.setEncoding(encoding);

            channel.remoteState = 1;
            channel.emit('open');
        });
        connection.on('close', function () {
            channel.state = 3;
            channel.remoteState = 0;
            channel.isOpen = false;
            channel.emit('close');
        });
        connection.on('message.' + channelId, function (event) {
            if (event.data.indexOf('control ') === 0) {
                if (event.data.indexOf('control connected') === 0) {
                    channel.remoteState = 1;
                }

                if (event.data.indexOf('control closed') === 0) {
                    var err = event.data.split(' ')[2];
                    channel.remoteState = 0;
                    channel.emit('close', err);
                }
            }

            if (channel.remoteState === 1) {
                channel.emit('line', event.data);
            }
        });

        channel.sendControl = function writeTarget(data) {
            if (channel.isOpen) {
                connection.ws.send(':' + channelId + ' ' + data);
            } else {
                sendControlBuffer.push(data);
            }
        };

        channel.writeLine = function writeTarget(data) {
            if (channel.remoteState >= 1) {
                connection.ws.send(':' + channelId + ' ' + data);
            }
        };

        channel.connect = function connect() {
            sendControlBuffer = [];

            if (!connection.ws) {
                connection.reconnect();
            }

            var host = options.host;
            var port = options.port;
            var tls = options.tls || options.ssl;
            channel.sendControl('HOST ' + host + ':' + (tls ? '+' : '') + port);
        };

        channel.close = function close() {
            if (channel.remoteState >= 1) {
                connection.ws.send(':' + channelId);
            }
        };

        channel.setEncoding = function setEncoding(newEncoding) {
            encoding = newEncoding;
            if (connection.connected) {
                connection.ws.send(':' + channelId + ' ENCODING ' + newEncoding);
            }
            return true;
        };

        channel.initChannel = function initChannel() {
            connection.ws.send(':' + channelId);
        };

        if (connection.connected) {
            channel.initChannel();
        }

        return channel;
    }
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["ServerConnection"]
window._kiwi_exports.libs.ServerConnection = exports.default ? exports.default : exports;


/***/ }),

/***/ "x8zS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageListAvatar_vue__ = __webpack_require__("D2nl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageListAvatar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageListAvatar_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageListAvatar_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageListAvatar_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42aa5c5e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageListAvatar_vue__ = __webpack_require__("FlBN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("m1o2")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageListAvatar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42aa5c5e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageListAvatar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42aa5c5e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageListAvatar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "xB2o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-selfuser kiwi-theme-bg"},[(!_vm.self_user_settings_open)?_c('div',{staticClass:"kiwi-selfuser-mask"},[_c('span',{staticClass:"kiwi-selfuser-nick"},[_c('away-status-indicator',{attrs:{"network":_vm.network,"user":_vm.network.currentUser()}}),_vm._v("\n            "+_vm._s(_vm.network.nick)+"\n            "),_c('i',{staticClass:"fa fa-times",attrs:{"aria-hidden":"true"},on:{"click":function($event){return _vm.closeSelfUser()}}}),_vm._v(" "),_c('i',{staticClass:"fa fa-pencil",attrs:{"aria-hidden":"true"},on:{"click":function($event){return _vm.openSelfActions()}}})],1),_vm._v(" "),_c('span',{staticClass:"kiwi-selfuser-host"},[_vm._v("\n            "+_vm._s(_vm.netUser.username)+"@"+_vm._s(_vm.netUser.host)+" ( "+_vm._s(_vm.modeString)+" )\n        ")]),_vm._v(" "),(_vm.networkSupportsAway())?_c('div',{staticClass:"u-form kiwi-away-checkbox-form"},[_c('label',{staticClass:"kiwi-selfuser-away-label"},[_c('span',[_vm._v(_vm._s(_vm.$t('away')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.awayStatus),expression:"awayStatus"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.awayStatus)?_vm._i(_vm.awayStatus,null)>-1:(_vm.awayStatus)},on:{"change":function($event){var $$a=_vm.awayStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.awayStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.awayStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.awayStatus=$$c}}}})])]):_vm._e()]):_c('div',{staticClass:"kiwi-selfuser-actions"},[_c('form',{staticClass:"u-form",on:{"submit":function($event){$event.preventDefault();return _vm.changeNick($event)},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.self_user_settings_open = false}}},[_c('input-prompt',{directives:[{name:"focus",rawName:"v-focus"}],attrs:{"label":_vm.$t('enter_new_nick'),"noprompt":true,"block":true},on:{"submit":_vm.onNewNickSubmit,"cancel":function($event){_vm.self_user_settings_open = false}}})],1),_vm._v(" "),(_vm.error_message)?_c('div',{staticClass:"kiwi-selfuser-error-message"},[_vm._v(_vm._s(_vm.error_message))]):_vm._e()])])}
var staticRenderFns = []


/***/ }),

/***/ "xZQN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChannelInvitelist_vue__ = __webpack_require__("VSWv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChannelInvitelist_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChannelInvitelist_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChannelInvitelist_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChannelInvitelist_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04074d7a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChannelInvitelist_vue__ = __webpack_require__("y+z8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("rdYF")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChannelInvitelist_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04074d7a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChannelInvitelist_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04074d7a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChannelInvitelist_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "xoWl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KiwiBnc_vue__ = __webpack_require__("2SpE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KiwiBnc_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KiwiBnc_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KiwiBnc_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KiwiBnc_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82f6a808_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KiwiBnc_vue__ = __webpack_require__("CI3C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("yYIx")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__exports_loader_babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KiwiBnc_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82f6a808_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KiwiBnc_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82f6a808_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KiwiBnc_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "y+z8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-invitelist"},[_c('form',{staticClass:"u-form kiwi-invitelist",on:{"submit":function($event){$event.preventDefault();}}},[_c('a',{staticClass:"u-link",on:{"click":_vm.updateInvitelist}},[_vm._v(_vm._s(_vm.$t('invites_refresh')))]),_vm._v(" "),(!_vm.channelIsInviteOnly)?_c('div',{staticClass:"kiwi-invitelist-inviteonly-status"},[_vm._v("\n            "+_vm._s(_vm.$t('invite_public_channel'))+"\n            "),(_vm.areWeAnOp)?_c('a',{staticClass:"u-link",on:{"click":_vm.setInviteOnly}},[_vm._v(_vm._s(_vm.$t('invite_set_private')))]):_vm._e()]):_c('div',{staticClass:"kiwi-invitelist-inviteonly-status"},[_vm._v("\n            "+_vm._s(_vm.$t('invite_private_channel'))+"\n            "),(_vm.areWeAnOp)?_c('a',{staticClass:"u-link",on:{"click":_vm.removeInviteOnly}},[_vm._v(_vm._s(_vm.$t('invite_set_public')))]):_vm._e()]),_vm._v(" "),(_vm.anyRegisteredUserCanJoin)?_c('span',[_vm._v(_vm._s(_vm.$t('invite_registered_only')))]):_vm._e(),_vm._v(" "),_c('div',[(_vm.supportsAccounts && _vm.areWeAnOp)?_c('div',[(_vm.knownAccounts.length > 0)?[_c('select',{ref:"addInviteList"},_vm._l((_vm.knownAccounts),function(user){return _c('option',{key:user.nick,domProps:{"value":user.account}},[_vm._v(_vm._s(user.account))])}),0),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.addAccountInvite(_vm.$refs.addInviteList.value)}}},[_vm._v("\n                        "+_vm._s(_vm.$t('invite_add_invite'))+"\n                    ")])]:_vm._e()],2):_vm._e(),_vm._v(" "),(!_vm.supportsAccounts && _vm.areWeAnOp)?_c('div',{staticClass:"kiwi-invitelist-addmask"},[_c('input',{ref:"addInviteText",staticClass:"u-input",attrs:{"type":"text"}}),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.addInvite(_vm.$refs.addInviteText.value)}}},[_vm._v("\n                    "+_vm._s(_vm.$t('invite_add_invite'))+"\n                ")])]):_vm._e(),_vm._v(" "),(_vm.inviteList.length > 0)?_c('table',{staticClass:"kiwi-invitelist-table"},[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('invites_user')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('invites_by')))]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th')]),_vm._v(" "),_vm._l((_vm.inviteListAccounts),function(invite){return _c('tr',{key:invite.invited},[_c('td',{staticClass:"kiwi-invitelist-table-mask"},[_vm._v("\n                        "+_vm._s(_vm.displayMask(invite))+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"kiwi-invitelist-table-invitedby"},[_vm._v("\n                        "+_vm._s(invite.invited_by)+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"kiwi-invitelist-table-invitedat"},[_vm._v("\n                        "+_vm._s((new Date(invite.invited_at * 1000)).toDateString())+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"kiwi-invitelist-table-actions"},[(_vm.areWeAnOp)?_c('i',{staticClass:"fa fa-trash",attrs:{"aria-hidden":"true"},on:{"click":function($event){return _vm.removeInvite(invite.invited)}}}):_vm._e()])])}),_vm._v(" "),_vm._l((_vm.inviteListNonAccounts),function(invite){return _c('tr',{key:invite.invited},[_c('td',{staticClass:"kiwi-invitelist-table-mask"},[_vm._v("\n                        "+_vm._s(_vm.displayMask(invite))+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"kiwi-invitelist-table-invitedby"},[_vm._v("\n                        "+_vm._s(invite.invited_by)+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"kiwi-invitelist-table-invitedat"},[_vm._v("\n                        "+_vm._s((new Date(invite.invited_at * 1000)).toDateString())+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"kiwi-invitelist-table-actions"},[(_vm.areWeAnOp)?_c('i',{staticClass:"fa fa-trash",attrs:{"aria-hidden":"true"},on:{"click":function($event){return _vm.removeInvite(invite.invited)}}}):_vm._e()])])})],2):_vm._e()]),_vm._v(" "),(_vm.is_refreshing)?_c('div',[_vm._v("\n            "+_vm._s(_vm.$t('invites_refreshing'))+"\n        ")]):_vm._e()])])}
var staticRenderFns = []


/***/ }),

/***/ "yQGf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-nicklist",class:{'kiwi-nicklist--filtering': _vm.filter_visible }},[_c('div',{staticClass:"kiwi-nicklist-usercount",on:{"click":_vm.toggleUserFilter}},[_c('span',[_vm._v("\n            "+_vm._s(_vm.filter_visible ?
                    _vm.sortedUsers.length :
                    _vm.$t('person', {count: _vm.sortedUsers.length}))+"\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user_filter),expression:"user_filter"}],ref:"user_filter",attrs:{"placeholder":_vm.$t('filter_users')},domProps:{"value":(_vm.user_filter)},on:{"blur":_vm.onFilterBlur,"input":function($event){if($event.target.composing){ return; }_vm.user_filter=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"fa fa-search"})]),_vm._v(" "),_c('DynamicScroller',{staticClass:"kiwi-nicklist-users",attrs:{"items":_vm.sortedUsers,"min-item-size":26,"key-field":'nick'},scopedSlots:_vm._u([{key:"default",fn:function(ref){
                    var item = ref.item;
                    var index = ref.index;
                    var active = ref.active;
return [_c('DynamicScrollerItem',{attrs:{"item":item,"active":active,"size-dependencies":[],"data-index":index}},[_c('nicklist-user',{key:item.nick,attrs:{"user":item,"nicklist":_vm.self,"network":_vm.network}})],1)]}}])})],1)}
var staticRenderFns = []


/***/ }),

/***/ "yYIx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ycf7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zkxe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldShowStatus)?_c('span',{staticClass:"kiwi-awaystatusindicator",class:{ 'kiwi-awaystatusindicator--away': _vm.user && _vm.user.isAway(),
              'kiwi-awaystatusindicator--self': _vm.isUserSelf },on:{"click":function($event){return _vm.toggleSelfAway()}}}):_vm._e()}
var staticRenderFns = []


/***/ }),

/***/ "zsPz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/app.67e460f6deec7911b2fd.js